/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module
	 */
	__webpack_require__(1);
	
	/**
	 * Constants
	 */
	__webpack_require__(2);
	
	/**
	 * Directives
	 */
	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(5);
	__webpack_require__(6);
	__webpack_require__(7);
	__webpack_require__(8);
	__webpack_require__(9);
	__webpack_require__(10);
	__webpack_require__(11);
	__webpack_require__(12);
	__webpack_require__(31);
	__webpack_require__(32);
	__webpack_require__(33);
	__webpack_require__(34);
	__webpack_require__(35);
	__webpack_require__(36);
	__webpack_require__(37);
	__webpack_require__(38);
	
	/**
	 * FILLER PER FXC
	 */
	__webpack_require__(39);
	
	/**
	 * Components
	 */
	__webpack_require__(13);
	__webpack_require__(14);
	__webpack_require__(15);
	__webpack_require__(16);
	__webpack_require__(40);
	__webpack_require__(41);
	__webpack_require__(42);
	__webpack_require__(17);
	__webpack_require__(18);
	__webpack_require__(19);
	__webpack_require__(20);
	__webpack_require__(43);
	__webpack_require__(44);
	__webpack_require__(45);
	
	/**
	 * Services
	 */
	__webpack_require__(21);
	__webpack_require__(22);
	__webpack_require__(23);
	__webpack_require__(24);
	__webpack_require__(25);
	__webpack_require__(26);
	__webpack_require__(27);
	__webpack_require__(28);
	__webpack_require__(29);
	__webpack_require__(46);
	__webpack_require__(47);
	__webpack_require__(48);
	__webpack_require__(49);
	__webpack_require__(50);
	__webpack_require__(51);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(38);
	__webpack_require__(47);
	/**
	 * Run
	 */
	__webpack_require__(30);
	
	/**
	 * Config
	 */
	__webpack_require__(56);

/***/ },
/* 1 */
/***/ function(module, exports) {

	/**
	 * @ngdoc overview
	 * @name cbl.finanza.mf
	 * @description Modulo funzionale dell'applicazione Consulenza
	 */
	(function() {
		"use strict";
		angular.module("cbl.finanza.mf", [
			'cbl.ssocore',
			'ui.grid',
			'ui.grid.autoResize',
			'ui.grid.cellNav',
			'ui.grid.edit',
			'ui.grid.exporter',
			'ui.grid.grouping',
			'ui.grid.pagination',
			'ui.grid.resizeColumns',
			'ui.grid.rowEdit',
			'ui.grid.selection',
			'ui.grid.treeView',
			'ui.router',
			'ui.select',
			'ngSanitize',
			'cbl.finanza.mf.directives',
			'cbl.common'
		]);
	}())

/***/ },
/* 2 */
/***/ function(module, exports) {

	(function (window, undefined) {
	  'use strict';
	  var scripts = document.getElementsByTagName('script');
	  var baseRoot = 'CBL-FINANZA-MF';
	  for (var el in scripts) {
	    if (scripts[el].src && scripts[el].src.indexOf('FINANZA') > -1) {
	      baseRoot = scripts[el].src.split('/')[3];
	    }
	  }
	  angular.module('cbl.finanza.mf').constant('FIN_CONSTANTS', {
	    ABILITAZIONI: {
	      ACCETTA_RACCOMANDAZIONE: 'ACCETTARACCOMAN',
	      VALUTA_PRATICA: 'VALUTAPRATICA',
	      VISUALIZZA_PARAMETRI_BLOCCATI: 'visibilita_parametri_bloccati',
	      FILTRA_RACCOMANDAZIONI: 'filtra_raccomandazioni',
	      TABELLA_RACCOMNDAZIONI_ESTESA: 'tabella_raccomandazioni_estesa',
	      COPIA_RACCOMANDAZIONE: 'copia_raccomandazione',
	      VERIFICA_PROPOSTE: 'verifica_proposte',
	      MIFID: 'MifidAlertType',
	      ESG_CONSULENZA_ATTIVA: 'EsgConsulenzaAttiva',
	      MODALITA_ESPOSIZIONE_ESG_STRUMENTO: 'ModalitaEsposzioneEsgStrumento',
	      ATTIVA_LIQUIDITA_AGGIUNTIVA: 'AttivaLiquiditaAggiuntiva',
	      RICONTRATTUALIZZAZIONE: 'Ricontrattualizzazione'
	    },
	    OPERAZIONI: {
	      RIMODULAZIONE_PIANO: 'P',
	      ACQUISTO: 'A',
	      VENDITA: 'D',
	      SWITCH: 'S'
	    },
	    BASE_ROOT: '/' + baseRoot + '/app/',
	    REST_ROOT: '/' + baseRoot + '/services/api-',
	    CABEL_CUSTOMER: '/MSF-CUSTOMERDATA-MF/api/',
	    REST_CUSTOMER: '/' + baseRoot + '/services/api-',
	    COMPONENTS_PATH: 'components/',
	    MOCK_ROOT: '/' + baseRoot + '/app/mocks/',
	    MOCK_REST: {
	      MENU: 'menu.json',
	      RACCOMANDAZIONI: 'listaRaccomandazioni.json',
	      PROPOSTE: 'listaProposte.json',
	      LISTA_DOSSIER: 'listaDossier.json',
	      LISTA_RICHIESTE: 'listaRichiesteOrdine.json',
	      SALDO_PORTAFOGLIO: 'listaPortafoglio.json',
	      TIPOLOGIA_STRUMENTO: 'tipologiaStrumento.json',
	      CHECK_RACCOMANDAZIONE: 'checkRaccomandazione.json',
	      STATO_RACCOMANDAZIONE: 'statoRaccomandazione.json',
	      INSERISCI_RACCOMANDAZIONE: 'inserisciRaccomandazione.json',
	      INSERISCI_PROPOSTA: 'inserisciProposta.json',
	      LISTA_RICHIESTE2: 'listaRichieste.json'
	    },
	
	    FUNA: {},
	
	    STATO_RACCOMANDAZIONE: {
	      ND: 'ND',
	      BOZZA: 'BOZZA',
	      CONSOLIDATA: 'CONSOLIDATA',
	      PRESENTATA: 'PRESENTATA',
	      DA_REVISIONARE: 'DAREVISIONARE',
	      ACCETTATA: 'ACCETTATA',
	      RIFIUTATA: 'RIFIUTATA',
	      ANNULLATA: 'ANNULLATA',
	      PRE_CONTRATTO: 'PRECONTRATTO',
	      VALIDATA: 'VALIDATA',
	      FINANZIATA: 'FINANZIATA',
	      IN_CORSO: 'INCORSO',
	      DEFINITA: 'DEFINITA',
	      PLAFOND: 'PLAFOND',
	      DAPAGARE: 'DAPAGARE',
	      CONCLUSA: 'CONCLUSA',
	      SOSPESA: 'SOSPESA',
	      IN_DELIBERA_PAC: 'INDELIBERAPAC',
	      IN_PRE_DELIBERA_PAC: 'INPREDELIBERAPAC',
	      APPROVAZIONE_DEROGA: 'APPROVAZIONEDEROGA',
	      CONTRO_PROPOSTA_DEROGA: 'CONTROPROPOSTADEROGA'
	    },
	
	    TIPO_RACCOMANDAZIONE: {
	      INSERIMENTO: 'INSERIMENTO'
	    },
	
	    REST: {
	      GENERAL: {
	        LABEL: 'generale/label',
	        FUNA: 'generale/funa',
	        TAB: 'generale/tab',
	        USER: 'generale/utente',
	        LOG: 'generale/log',
	        DOMAIN: 'generale/dominio'
	      },
	      WORKFLOW: {},
	      DOCUMENTI_SERVICE: {},
	      MENU: 'generale/menu',
	      DOSSIER: 'dossier/',
	      RACCOMANDAZIONE: 'raccomandazione/',
	      PROPOSTA: 'proposta/',
	      STRUMENTO: 'strumento/',
	      ANAGRAFICA: 'anagrafica/',
	      RICHIESTA: 'richiesta/',
	      PARAMETRI: 'parametri/',
	      CUSTOMER_DOSSIER: 'strumento/getDossier',
	      RICONTRATTUALIZZAZIONE_DOSSIER: 'dossier/ricontrattualizzazione/',
	      COMPOSIZIONE: 'dossier/GetDossierComposition',
	      MOVEMENTS: 'portafoglio/ricercaDettaglioMovimenti',
	      CHART: 'portafoglio/ricercaSaldiPeriodo',
	      PORTAFOGLIO: 'portafoglio/recuperaEstrattoContoFiscale',
	      TOTALI_CONTI: 'portafoglio/ricercaTotaliConti',
	      REPORT: 'report',
	      CUT_OFF: 'richiesta/bloccoOrdine'
	    },
	
	    MODALITA: {
	      VISUALIZZA: 'visualizza',
	      MODIFICA: 'modifica',
	      NUOVA: 'nuova',
	      VALUTAZIONE: 'valutazione'
	    }
	  });
	})(window);


/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 *
	 */
	(function () {
	  'use strict';
	  angular.module('cbl.finanza.mf.directives', ['cbl.common']);
	})();


/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 *
	 */
	(function () {
	  'use strict';
	  angular.module('cbl.finanza.mf.directives').directive('finCalendar', [
	    'FIN_CONSTANTS',
	    function (CONSTANTS) {
	      return {
	        restrict: 'E',
	        require: 'ngModel',
	        scope: {
	          value: '=ngModel',
	          placeholder: '=',
	          ngRequired: '=',
	          ngDisabled: '=',
	          minDate: '=?',
	          maxDate: '=?',
	          ngClass: '=',
	          cblChange: '=',
	          name: '='
	        },
	        templateUrl:
	          CONSTANTS.BASE_ROOT + 'widgets/finCalendar/finCalendar.html',
	        controller: [
	          '$scope',
	          function ($scope) {
	            if ($scope.minDate == undefined) {
	              $scope.minDate = null;
	            }
	            if ($scope.maxDate == undefined) {
	              $scope.maxDate = null;
	            }
	          }
	        ],
	        link: link
	      };
	
	      function link(scope, element, attr, ctrls) {}
	    }
	  ]);
	})();


/***/ },
/* 5 */
/***/ function(module, exports) {

	(function() {
		"use strict";
		angular.module("cbl.finanza.mf.directives").directive("finSpinnerDrct", [ 'FIN_CONSTANTS', function(CONSTANTS) {
			var link = function (scope, elem, attrs, model) {};
			
			var controller = function($scope, brioSrvc) {
				
				this.brioSrvc = brioSrvc;
				
				var self = this;
				
				this.getSpinnerUrl = function() {
		            var url = null;
		            var currentScope = $scope;
		            do {
		                url = currentScope.srcSpinner;
		                currentScope = currentScope.$parent;
		            } while((url === undefined) && (currentScope !== null));
		            return url;
				};
	
			};
			
			controller.$inject = ['$scope', 'FinBrioSrvc'];
			return {
				restrict : "E",
				scope : { },
				templateUrl : CONSTANTS.BASE_ROOT + "widgets/finSpinner/finSpinner.html",
				controller : controller,
				controllerAs : 'spinner',
				link : link
			};
		}]);
	}());

/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * 
	 */
	(function() {
		"use strict";
		angular.module("cbl.finanza.mf").directive(
				"finFuna",
				[
						'FinFunaSrvc',
						'FinLabelSrvc',
						'FinLoggerSrvc',
						'FIN_CONSTANTS',
						function(funaSrvc, labelSrvc, loggerSrvc, CONSTANTS) {
							var link = function(scope, elem, attrs, ctrl) {
	
							};
	
							var controller = function($scope) {
								$scope.funa = funaSrvc;
								$scope.msg = labelSrvc;
								$scope.getKey = function(funa) {
									return "funa.label." + funa.codice;
								};
							};
	
							controller.$inject = [ "$scope" ];
	
							return {
								restrict : "E",
								scope : {
									rightAlign : "=",
									finDisabled : "=?"
								},
								link : link,
								transclude : true,
								controller : controller,
								templateUrl : CONSTANTS.BASE_ROOT + "widgets/finFuna/finFuna.html"
							};
						} ]);
	}());

/***/ },
/* 7 */
/***/ function(module, exports) {

	/**
	 * 
	 */
	;
	(function(window, undefined) {
		"use strict";
		angular.module("cbl.finanza.mf").service("FinFunaSrvc",
				[ '$http', '$q', 'FinMessaggiFctr', 'FinLabelSrvc', 'FinLoggerSrvc', 'FIN_CONSTANTS', function($http, $q, messaggiFctr, labelSrvc, loggerSrvc, CONSTANTS) {
					// Esempio Driver
					this.driverFuna = {
						codForm : null,
						codAttivita : null,
						codAttributo : null,
						codStato : null,
						accessoFunzione : null,
						flRichiamato : null
					};
	
					this.openConfirm = false;
					this.confirmText = "";
					this.angForm = {};
					this.sottomesso = false;
					this.inEsecuzione = false;
	
					this.funaList = [];
					this.funaMap = {};
	
					this.executePreRelease = function(funa, params) {
					};
					this.executePostRelease = function(funa, fromPre) {
					};
					this.messagesConfirm = function(funa) {
					};
	
					this.setUpFuna = function(angForm, form, accesso, executePreRelease, executePostRelease, messagesConfirm, task, level) {
	
						this.reset(level);
	
						var defer = $q.defer();
						var driverFuna = {
							codForm : form,
							codAttivita : task ? task.codAttivita : null,
							flRichiamato : (task && task.richiamato !== null) ? task.richiamato === '1' : null,
							codStato : task ? task.stato : null,
							codAttributo : task ? task.attributo : null,
							accessoFunzione : accesso
						}
	
						var funaTask = {
							codAttivita : task.codAttivita,
							codProcesso : task.codProcesso,
							idAttivita : task.idAttivita,
							idTecnico : task.id
						};
						this.angForm = angForm;
						this.openConfirm = false;
						this.funaList[level] = [];
						executePreRelease = executePreRelease && typeof executePreRelease === "function" ? executePreRelease : this.executePreRelease;
						executePostRelease = executePostRelease && typeof executePostRelease === "function" ? executePostRelease : this.executePostRelease;
						messagesConfirm = messagesConfirm && typeof messagesConfirm === "function" ? messagesConfirm : this.messagesConfirm;
	
						var self = this;
						$http({
							method : "POST",
							url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.FUNA,
							data : driverFuna
						}).then(function(response) {
							if (messaggiFctr.processaResponse(response)) {
								return;
							}
							self.funaList[level] = response.data.result;
							for ( var i in self.funaList[level]) {
								self.funaList[level][i].task = funaTask;
								if (self.hasFunction(self.funaList[level][i].codice)) {
									// ERRORE!!!
									messaggiFctr.addMessage({
										type : "E",
										message : "Funzione duplicata! (" + self.funaList[level][i].codice + ")"
									});
									defer.reject(false);
									return;
								}
								self.funaList[level][i]["bean"] = {
									angForm : angForm,
									executePreRelease : executePreRelease,
									executePostRelease : executePostRelease,
									messagesConfirm : messagesConfirm
								}
								self.funaMap[self.funaList[level][i].codice] = self.funaList[level][i];
							}
							defer.resolve(true);
						}, function(reason) {
							messaggiFctr.processaResponse(reason);
							defer.resolve(false);
						});
						return defer.promise;
					};
	
					this.executeFuna = function(funa) {
						this.annullaFuna();
						this.sottomesso = true;
						messaggiFctr.resetMessages();
						if (!funa.noCheck && !messaggiFctr.processaForm(funa.bean.angForm)) {
							return;
						}
	
						if (funa.noCheck && !messaggiFctr.validaForm(funa.bean.angForm)) {
							return;
						}
	
						var params = {
							causale : "",
							pagamenti : [],
							params : []
						};
						var funaSelf = this;
						try {
							funaSelf.inEsecuzione = true;
							var fromPre = funa.bean.executePreRelease(funa, params);
							if (!fromPre) {
								fromPre = $q.when("");
							}
							fromPre.then(function(response) {
								var deferred = $q.defer();
								if (funa.outcome && funa.outcome.cod && funa.outcome.cod !== '') {
									funa.task.esito = funa.outcome.cod;
									funa.task.causale = params.causale;
									funa.task.pagamenti = params.pagamenti;
									$http({
										method : "POST",
										url : CONSTANTS.REST_ROOT + CONSTANTS.REST.WORKFLOW.TASK_EXECUTE,
										data : funa.task
									}).then(function(response) {
										if (messaggiFctr.processaResponse(response)) {
											deferred.reject("Errore registrato nel rilascio task");
											return;
										}
										funa.task.id = response.data.result;
										deferred.resolve(true);
									}, function(reason) {
										messaggiFctr.processaResponse(reason);
										deferred.reject("Errore (non registrato) nel rilascio task. Status chiamata: " + JSON.stringify(reason));
									});
								} else {
									deferred.resolve(true);
								}
								deferred.promise.then(function(funaResponse) {
									var fromPost = funa.bean.executePostRelease(funa, response);
									if (!fromPost) {
										fromPost = $q.when("");
									}
									fromPost.then(function(postResponse) {
										// END funa
										funaSelf.inEsecuzione = false;
									}, function(reason) {
										var e = {
											message : funa.codice + ": funzione post rilascio fallita! Errore: " + reason
										};
										loggerSrvc.log("FinFunaSrvc", loggerSrvc.SEVERE, e.message);
										funaSelf.inEsecuzione = false;
										throw e;
									})
								}, function(reason) {
									var e = {
										message : funa.codice + ": rilascio task con esito [" + funa.outcome.cod + "] fallito! Errore: " + reason
									};
									loggerSrvc.log("FinFunaSrvc", loggerSrvc.SEVERE, e.message);
									funaSelf.inEsecuzione = false;
									throw e;
								})
							}, function(reason) {
								var e = {
									message : funa.codice + ": funzione pre rilascio fallita! Errore: " + reason
								};
								loggerSrvc.log("FinFunaSrvc", loggerSrvc.SEVERE, e.message);
								funaSelf.inEsecuzione = false;
								throw e;
							})
	
						} catch (e) {
							loggerSrvc.log("FinFunaSrvc", loggerSrvc.SEVERE, e.message);
							funaSelf.inEsecuzione = false;
						}
					};
	
					this.openConfirmFuna = function(funa) {
						this.openConfirm = funa;
						this.sottomesso = true;
						messaggiFctr.resetMessages();
						if (funa.noCheck && messaggiFctr.processaForm(funa.bean.angForm)) {
							return;
						}
						if (!funa.noCheck && messaggiFctr.validaForm(funa.bean.angForm)) {
							return;
						}
						this.confirmText = funa.bean.messagesConfirm(funa);
						if (!this.confirmText) {
							this.confirmText = labelSrvc.getLabel("funa.confirm.default");
						}
						angular.element("#funaModal").modal("show");
					};
	
					this.hasFunction = function(codice) {
						return this.funaMap.hasOwnProperty(codice); // this.funaMap[codice] != null && this.funaMap[codice] != undefined;
					};
	
					this.executeButtonFuna = function(codice) {
						return this.executeFuna(this.funaMap[codice]);
					};
	
					this.annullaFuna = function() {
						this.openConfirm = false;
						angular.element("#funaModal").modal("hide");
					};
	
					this.getFunzioni = function() {
						var funcArray = [];
						for ( var i in this.funaList) {
							funcArray = funcArray.concat(this.funaList[i]);
						}
						return funcArray;
					};
	
					this.reset = function(level) {
						this.sottomesso = false;
						if (!level) {
							level = 0;
						}
						if (!this.funaList) {
							// Service non ancora inizializzato
							this.funaList = [];
							return;
						}
						if (this.funaList.length < level) {
							// Il livello non è presente
							return;
						}
						this.funaList.splice((level), (this.funaList.length - level));
						// Reset della mappa sulle liste rimaste
						this.funaMap = {};
						for ( var i in this.funaList) {
							var funaList = this.funaList[i];
							for ( var j in funaList) {
								this.funaMap[funaList[j].codice] = funaList[j];
							}
						}
					}
	
				} ]);
	}(window));

/***/ },
/* 8 */
/***/ function(module, exports) {

	/**
	 *
	 */
	(function(window, undefined) {
		"use strict";
	
		angular.module("cbl.finanza.mf.directives").directive("finNessunRisultatoDrct", ['FIN_CONSTANTS', function(CONSTANTS) {
			var link = function (scope, elem, attrs, model) {
	
			};
	
			var controller = function($scope, labelSrvc) {
				$scope.msg = labelSrvc.getLabel;
			};
	
			controller.$inject = ['$scope', 'FinLabelSrvc'];
	
			return {
				restrict: "E",
				scope: {
					msgCustom: '@',
					topMargin: '@'
				},
				controller: controller,
				controllerAs: "finNessunRisultatoCtrl",
				templateUrl: CONSTANTS.BASE_ROOT + "widgets/finNessunRisultato/finNessunRisultato.html",
				link: link
			};
		}]);
	}(window));

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 *@ngdoc directive
	 *@name cbl.finanza.mf.directives.directive:finTable
	 *@restrict E
	 *@scope
	 *@description Direttiva utilizzata per contenere lo ui-grid
	 *@param {Object} data - Oggetto contenente i dati della tabella
	 *@param {Object} label - Oggetto contenente i parametri di configurazione della tabella
	 *@param {String} [messaggioCustom] - Messaggio personalizzato da far visualizzare al post odi quello standard
	 *@param {Function} [modificaRaccomandazione] - Funzione di callback per la modifica di una raccomandazione
	 *@param {Function} [visualizzaRaccomandazione] - Funzione di callback per la visualizzazione di una raccomandazione
	 *@param {Function} [eliminaRaccomandazione] - Funzione di callback per l'eliminazione di una raccomandazione
	 *@param {Function} [valutazioneRaccomandazione] - Funzione di callback per la valutazione di una raccomandazione
	 *@param {Function} [eliminaProposta] - Funzione di callback per la rimozione di una proposta
	 *@param {Function} [modificaProposta] - Funzione di callback per la modifica di una proposta
	 *@param {Function} [modificaRichiesta] - Funzione di callback per la modifica di una richiesta
	 *@param {Function} [visualizzaRichiesta] - Funzione di callback per la visualizzazione di una richiesta
	 *@param {Function} [gestioneOrdine] - Funzione di callback per la gestione di un ordine
	 *@param {Function} [visualizzaOrdine] - Funzione di callback per la visualizzazione di un ordine
	 *@param {Function} [acquista] - Funzione di callback per l'aggiunta di una nuova proposta dopo la pressione del tasto (più) sulla tabella portafoglio
	 *@param {Function} [vendita] - Funzione di callback per l'aggiunta di una nuova proposta dopo la pressione del tasto (meno) sulla tabella portafoglio
	 *@param {Function} [cambio] - Funzione di callback per l'aggiunta di una nuova proposta dopo la pressione del tasto (switch) sulla tabella portafoglio
	 *@param {Function} [apriPagina] - Funzione di callback utilizzata per aprire la pagina
	 *@param {Boolean} [clickRiga] - Se true abilita il click sulla riga
	 *@param {Boolean} [paginazioneEsterna] - Variabile di tipo booleana per indicare alla tabella se utilizzare la paginazione backend o meno
	 *@param {Function} [cambioPagina] - Funzione di callback richiamata quando si cambia pagina, da utilizzare quando paginazioneEsterna è true
	 *@param {Number} [totalItems] - Numero di elementi totali della tabella, da utilizzare quando paginazioneEsterna è true
	 *@param {Number} [itemsPerPage] - Numero di elementi da mostrare per ogni pagina
	 *@param {Number} [pageNumber] - Numero di pagina da utilizzare quando si usa la paginazione esterna
	 *@param {Function} [abilitaConsulenza] - Funzione di callback richiamata quando si vuole andare nella schermata di abilitaConsulenza su un Dossierù
	 *@param {Function} [inserisciOrdine] -Funzione per inserire direttamente l'ordine dalla pagina gestioneOrdine
	 *@param {Function} [visualizzaOrdine]- Funzione per visualizzare la pratica dopo aver generato l'ordine alla fine della creazione di una raccomandazione
	 *@param {String} [raccomandazioneState]- Variabile per gestire la visualizzazione dei pulsanti della pagina gestione-ordine in raccomandazioni
	 */
	(function () {
	  'use strict';
	  angular.module('cbl.finanza.mf.directives').directive('finTable', [
	    'FIN_CONSTANTS',
	    function (CONSTANTS) {
	      var link = function (scope, elem, attrs, model) {};
	
	      var controller = function (
	        $scope,
	        $state,
	        $stateParams,
	        labelSrvc,
	        uiGridConstants,
	        userSrvc
	      ) {
	        $scope.msg = labelSrvc.getLabel;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.uiGridConstants = uiGridConstants;
	        $scope.userSrvc = userSrvc;
	        var self = this;
	        if (!$scope.rowHeight) {
	          $scope.rowHeight = 30;
	        }
	
	        $scope.itemsPerPage = $scope.itemsPerPage ? $scope.itemsPerPage : 10;
	
	        if (Array.isArray($scope.data) && $scope.data.length > 0) {
	          this.gridOptions = {
	            enableSorting: true,
	            enableColumnMenus: false,
	            enableGrouping: false,
	            enableFiltering: true,
	            treeRowHeaderAlwaysVisible: false,
	            useExternalPagination: $scope.paginazioneEsterna ? true : false,
	            paginationPageSizes: [10, 25, 50],
	            paginationPageSize: $scope.itemsPerPage,
	            paginationCurrentPage: $scope.pageNumber ? $scope.pageNumber : 1,
	            totalItems: $scope.totalItems,
	            enableRowSelection: $scope.clickAbilitato || false,
	            multiSelect: false,
	            enableRowHeaderSelection: false,
	            enableRowHashing: false,
	            showGridFooter: false,
	            enableVerticalScrollbar: this.uiGridConstants.scrollbars.NEVER,
	            columnDefs: $scope.label,
	            data: $scope.data,
	            rowHeight: $scope.rowHeight,
	            onRegisterApi: function (gridApi) {
	              self.gridApi = gridApi;
	              if ($scope.paginazioneEsterna) {
	                self.gridApi.pagination.on.paginationChanged(
	                  $scope,
	                  function (newPage, pageSize) {
	                    $scope.cambioPagina({
	                      pageNumber: newPage,
	                      itemsPerPage: pageSize
	                    });
	                  }
	                );
	              }
	              self.gridApi.selection.on.rowSelectionChanged(
	                $scope,
	                function (row, evt) {
	                  if (evt.target.tagName === 'BUTTON') {
	                    return;
	                  }
	                  if ($scope.clickAbilitato) {
	                    $scope.apriPagina({ row: row.entity });
	                  }
	                }
	              );
	              self.gridApi.core.on.filterChanged($scope, function () {
	                if ($scope.paginazioneEsterna) {
	                  $scope.applicaFiltri({ columns: this.grid.columns });
	                }
	              });
	            }
	          };
	        }
	
	        this.showButtonRaccomandazioni = function (stato, operazione) {
	          if (
	            stato === CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO &&
	            (operazione === 'modifica' || operazione === 'elimina')
	          ) {
	            return true;
	          }
	          if (
	            stato === CONSTANTS.STATO_RACCOMANDAZIONE.CONSOLIDATA &&
	            operazione === 'valutazione'
	          ) {
	            return true;
	          }
	          if (operazione === 'copia') {
	            return true;
	          }
	          return false;
	        };
	        this.getTableHeight = function () {
	          return {
	            height: 120 + $scope.itemsPerPage * $scope.rowHeight + 'px'
	          };
	        };
	      };
	
	      controller.$inject = [
	        '$scope',
	        '$state',
	        '$stateParams',
	        'FinLabelSrvc',
	        'uiGridConstants',
	        'FinUserSrvc'
	      ];
	
	      return {
	        restrict: 'E',
	        scope: {
	          data: '=',
	          label: '=',
	          messaggioCustom: '@?',
	          modificaRaccomandazione: '&?',
	          visualizzaRaccomandazione: '&?',
	          eliminaRaccomandazione: '&?',
	          valutazioneRaccomandazione: '&?',
	          eliminaProposta: '&?',
	          modificaProposta: '&?',
	          visualizzaProposta: '&?',
	          modificaRichiesta: '&?',
	          visualizzaRichiesta: '&?',
	          cambioPiano: '&?',
	          gestioneOrdine: '&?',
	          visualizzaOrdine: '&?',
	          acquista: '&?',
	          vendita: '&?',
	          cambio: '&?',
	          apriPagina: '&?',
	          clickAbilitato: '=?',
	          paginazioneEsterna: '=?',
	          cambioPagina: '&?',
	          totalItems: '=?',
	          itemsPerPage: '=?',
	          pageNumber: '=?',
	          applicaFiltri: '&?',
	          abilitaConsulenza: '&?',
	          copiaRaccomandazione: '&?',
	          segnalazioniProposte: '=?',
	          leggiAlert: '&?',
	          abilitatoConsulenza: '<',
	          abilitatoCollocamento: '<',
	          rowHeight: '<?',
	          inserisciOrdine:'&?'
	        },
	        controller: controller,
	        controllerAs: 'finTableCtrl',
	        templateUrl: CONSTANTS.BASE_ROOT + 'widgets/finTable/finTable.html',
	        link: link
	      };
	    }
	  ]);
	})();


/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 *@ngdoc directive
	 *@name cbl.finanza.mf.directives.directive:finRicercaStrumento
	 *@restrict E
	 *@scope
	 *@description Direttiva utilizzata per effettuare la ricerca dello strumento finanziario
	 *@apram {Function} callback - Funzione richiamata dopo aver selezionato il titolo in tabella
	 */
	(function(window, undefined) {
		"use strict";
		angular.module("cbl.finanza.mf.directives").directive("finRicercaStrumento", ['FIN_CONSTANTS', function(CONSTANTS) {
			var link = function (scope, elem, attrs, model) {};
	
			var controller = function($scope,$rootScope, $q, $http, $stateParams, userSrvc, messaggiFctr, uiGridConstants,$timeout) {
				this.$http = $http;
				this.$stateParams = $stateParams;
				this.messaggiFctr = messaggiFctr;
				this.uiGridConstants = uiGridConstants;
				this.$timeout = $timeout;
				this.userSrvc = userSrvc;
				this.modalitaEsposizioneESG = null;
				this.esposizioneRatingESG = false;
	        	this.esposizioneScoreESG = true;
				this.esgConsulenzaAttiva = false;
				this.tipologiaStrumento = [];
				//Doppio slider
				this.lowerSlider = null;
				this.upperSlider = null;
				this.lowerVal = null;
				this.upperVal = null;
				this.sliderMaxValue = null;
				this.sliderMinValue = null;
				this.selectedAll = false;
	
				this.searchFilters = {
					isin: null,
					descrizione: null,
					categoria: null,
					listaRatingEsg:[],
					listaClassificazioneSfrd:[],
					pai:null,
					tassonomia:null,
					esgA:null,
					esgDa:null
				};
	
				this.spinner = {
					ricercaStrumento: false,
					recuperaDomini:false
				};
				
				this.dominiEsgStrumento = {
					dominioScoreEsg:null,
					dominioRatingEsg:null,
					dominioClassificazioneSfdr:null,
					dominioPai:null,
					dominioTassonomia:null
				};
	
				this.sfdrChecklist =null;
				this.ratingEsgCheckList = null;
				this.strumenti = null;
				this.selectedStrumento = null;
				this.validUpperInput = true;
				this.validLowerInput = true;
				var self = this;
				
				/* 
		    	 * -------------------------------------
		    	 * START METODI PROMISE PER SERVIZI REST
		    	 * -------------------------------------
		    	 */
				
				/**
		    	 * @ngdoc method
		    	 * @name promiseRicercaStrumento
		    	 * @methodOf cbl.finanza.mf.directive:finRicercaStrumento
		    	 * @description Effettua la chiamata per la ricerca strumento
				 * @return {Promise} - Ritorna una promise contenente la lista degli strumenti trovati
		    	 */
				this.promiseRicercaStrumento = function() {
					return self.$http({
						method: 'PUT',
						url: CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'ricercaStrumenti',
						data: {
							parametri: {
								isin: self.searchFilters.isin || null,
								descrizione: self.searchFilters.descrizione || null,
								listaCategorie: {
									categorie: self.searchFilters.categoria ? new Array(self.searchFilters.categoria) : null
								},
								pai:!!self.searchFilters.pai ? self.searchFilters.pai.toString().trim() : null,
								tassonomia: !!self.searchFilters.tassonomia ? self.searchFilters.tassonomia.toString().trim() : null,
								listaClassificazioneSfrd: !!self.searchFilters.listaClassificazioneSfrd ? self.searchFilters.listaClassificazioneSfrd : null,
								scoreEsgA:self.searchFilters.esgA !== null ? parseFloat(self.searchFilters.esgA.toString().replace(',','.')) : null,
								scoreEsgDa:self.searchFilters.esgDa !== null ? parseFloat(self.searchFilters.esgDa.toString().replace(',','.')) : null,
								listaRatingEsg:self.searchFilters.listaRatingEsg
							},
							iniziativa: self.$stateParams.finIniziativa,
							idRaccomandazione: self.$stateParams.finIdRaccomandazione,
						}
					});
				};
				/* 
		    	 * -----------------------------------
		    	 * END METODI PROMISE PER SERVIZI REST
		    	 * -----------------------------------
		    	 */
				
				/* 
		    	 * -----------------------
		    	 * START METODI CONTROLLER
		    	 * -----------------------
		    	 */
				
				/**
				 * @ngdoc method
				 * @name clear
				 * @methodOf cbl.finanza.mf.directives.directive:finRicercaStrumento
				 * @description Svuota i campi della ricerca strumento
				 */
				this.clear = function() {
					self.searchFilters.isin = null;
					self.searchFilters.decrizione = null;
					self.searchFilters.categoria = null;
					self.searchFilters.tassonomia = null;
					self.searchFilters.pai = null;
					self.lowerVal = parseInt(self.sliderMinValue.slice(0,-4));
					self.upperVal = parseInt(self.sliderMaxValue.slice(0,-4));
	
					self.sliderMaxValue = self.dominiEsgStrumento.dominioScoreEsg !== null ? self.dominiEsgStrumento.dominioScoreEsg.find(function(dominio){return dominio.descrizione === 'MAX'}).codice : 100;
					self.sliderMinValue = self.dominiEsgStrumento.dominioScoreEsg ? self.dominiEsgStrumento.dominioScoreEsg.find(function(dominio){return dominio.descrizione === 'MIN'}).codice : 0;
	
					self.upperSlider.value = parseInt(self.sliderMaxValue.slice(0,-4));
					self.lowerSlider.value = parseInt(self.sliderMinValue.slice(0,-4));
	
					if(self.dominiEsgStrumento.dominioClassificazioneSfdr !== null && self.dominiEsgStrumento.dominioRatingEsg !== undefined)
					{self.dominiEsgStrumento.dominioClassificazioneSfdr.forEach(function(dominio) {
						dominio.selected = false
					});}
					if(self.dominiEsgStrumento.dominioRatingEsg !== null && self.dominiEsgStrumento.dominioRatingEsg !== undefined)
					{self.dominiEsgStrumento.dominioRatingEsg.forEach(function(dominio) {
						dominio.selected = false
					});}
	
					self.selectedAll = false;
					$rootScope.$apply();
				};
				
				/**
				 * @ngdoc method
				 * @name ricercaStrumento
				 * @methodOf cbl.finanza.mf.directives.directive:finRicercaStrumento
				 * @description Effettua la ricerca dello strumento
				 */
				this.ricercaStrumento = function() {
					self.spinner.ricercaStrumento = true;
					self.searchFilters.listaRatingEsg = self.elaboraDominiRatinEsg(self.dominiEsgStrumento.dominioRatingEsg);
					self.searchFilters.listaClassificazioneSfrd = self.elaboraDominiSfdr(self.dominiEsgStrumento.dominioClassificazioneSfdr);
					if(self.lowerVal!== null){
						self.searchFilters.esgDa = self.lowerVal;
					}
					if(self.upperVal !== null){
						self.searchFilters.esgA = self.upperVal;
					}
					self.promiseRicercaStrumento().then(function(response) {
						if (self.messaggiFctr.processaResponse(response)) {
							self.gridOptions.data = [];
							return;
						}
						self.gridOptions.data = response.data.result;
						self.strumenti = response.data.result;
					}, function(reason) {
						self.messaggiFctr.processaResponse(reason);
						self.gridOptions.data = [];
					}).finally(function() {
						self.spinner.ricercaStrumento = false;
					});
				};
	
				/**
				 * @description Apre la dropdown della classificazione sfdr
				 */
				this.toggleDropDownSfdr = function(){
					if (self.sfdrChecklist.classList.contains('visible'))
						self.sfdrChecklist.classList.remove('visible');
					else self.sfdrChecklist.classList.add('visible');
				};
	
				/**
				 * @description Apre la dropdown del rating esg
				 */
				this.toggleDropDownRatingEsg = function(){
					if (self.ratingEsgCheckList.classList.contains('visible'))
						self.ratingEsgCheckList.classList.remove('visible');
					else self.ratingEsgCheckList.classList.add('visible');
				};
	
				/**
				 * @returns NULL
				 * @description Aggiunge i campi selected agli ai domini classificazione sfdr e rating-esg
				 */
				this.elaboraResponse = function(response){
					if(!response){
						return;
					}
					response.dominioClassificazioneSfdr.forEach(function(element) {
						Object.assign(element,{selected:false})
					});
					if(self.esposizioneRatingESG){
						response.dominioRatingEsg.forEach(function(dominio){
							Object.assign(dominio,{selected:false})});
					}
				};
				/**
				 * @description Recupera la modalita di esposizione Esg e inizializza il doppio slider
				 */
				this.recuperaModalitaEsposizioneESG = function() {
					self.lowerSlider = document.querySelector('#lower');
					self.upperSlider = document.querySelector('#upper');
	
					self.lowerVal = parseInt(self.sliderMinValue);
					self.upperVal = parseInt(self.sliderMaxValue);
	
					self.upperSlider.oninput = function() {
					self.lowerVal = parseInt(self.lowerSlider.value);
					self.upperVal = parseInt(self.upperSlider.value);
					console.log(self.upperVal);
	
					if (self.upperVal < self.lowerVal + 1) {
						self.lowerSlider.value = self.upperVal - 1;
					}
	
					$rootScope.$apply();
					};
			
					self.lowerSlider.oninput = function() {
					self.lowerVal = parseInt(self.lowerSlider.value);
					self.upperVal = parseInt(self.upperSlider.value);
					console.log(self.lowerVal);
					if (self.lowerVal > self.upperVal - 1) {
						self.upperSlider.value = self.lowerVal + 1;	
						}
					$rootScope.$apply();
					};
	
					self.esgConsulenzaAttiva = userSrvc.abilitato(CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA);
					console.log('Esg consulenza attiva '+ self.esgConsulenzaAttiva);
					self.modalitaEsposizioneESG =
					self.userSrvc.configurazioni[CONSTANTS.ABILITAZIONI.MODALITA_ESPOSIZIONE_ESG_STRUMENTO];
					console.log('Modalita esposizione esg '+ self.modalitaEsposizioneESG);
					
					switch (self.modalitaEsposizioneESG) {
						case 'RATING':
							self.esposizioneRatingESG = true;
							self.esposizioneScoreESG = false;
							break;
						case 'SCORE':
							self.esposizioneRatingESG = false;
							self.esposizioneScoreESG = true;
							break;
						case 'ALL':
							self.esposizioneRatingESG = true;
							self.esposizioneScoreESG = true;
							break;
					}
					// Se il tipo di esposizione esg è rating aggiungo la colonna nella tabella
				if(self.esposizioneRatingESG){
	
					//TODO:rimettere qunado sarà stabilito con CABEL
					//self.gridOptions.columnDefs.splice(5,0,
						// {
						//  displayName: 'Rating ESG',
						//  field: 'esgStrumento.ratingSintetico',
						//  cellTemplate:'<div class="ui-grid-cell-contents center">'+
						// 	'<span>{{row.entity.esgStrumento.ratingSintetico }}</span>'+
						// 	'<a' +
						// 	'  href="javascript:;"' +
						// 	'  class="dropdown-toggle titolo-menu-cliente ng-scope"' +
						// 	'  data-toggle="dropdown"' +
						// 	'  aria-haspopup="true"' +
						// 	'  aria-expanded="false"' +
						// 	'  ng-if="row.entity.esgStrumento.tipoVisualizzazioneEsg === \'D\' && !!row.entity.esgStrumento.ratingSintetico "' +
						// 	'>' +
						// 	'  <span' +
						// 	'    ><i' +
						// 	'      class="fa fa-info-circle"' +
						// 	'      aria-hidden="true"' +
						// 	'      style="cursor: pointer"' +
						// 	'	   ng-click="grid.appScope.ricercaCtrl.infoRatingClicked($event,rowRenderIndex,row.entity);"'+
						// 	'    ></i' +
						// 	'  ></span>' +
						// 	'</a>' +
						// 	'</div>',
						//  	width: '12%'
						// }
						//)
						self.gridOptions.columnDefs.splice(6,0,{
							displayName: 'Rating ESG',
							field: 'esgStrumento.ratingSintetico',
							cellClass:'right',
							width: '12%',
						});
				}
				//Se il tipo di esposizione esg è score aggiungo la colonna nella tabella
				if(self.esposizioneScoreESG){
					// self.gridOptions.columnDefs.splice(6,0,{
					// displayName: 'Score ESG',
					// field: 'esgStrumento.scoreSintetico',
					// type:'number',
					// cellTemplate:'<div class="ui-grid-cell-contents center">'+
					// 	'<span>{{row.entity.esgStrumento.scoreSintetico | number:2}}</span>'+
					// 	'<a' +
					// 	'  href="javascript:;"' +
					// 	'  class="dropdown-toggle titolo-menu-cliente ng-scope"' +
					// 	'  data-toggle="dropdown"' +
					// 	'  aria-haspopup="true"' +
					// 	'  aria-expanded="false"' +
					// 	'  ng-if="row.entity.esgStrumento.tipoVisualizzazioneEsg === \'D\' && !!row.entity.esgStrumento.scoreSintetico "' +
					// 	'>' +
					// 	'  <span' +
					// 	'    ><i' +
					// 	'      class="fa fa-info-circle"' +
					// 	'      aria-hidden="true"' +
					// 	'      style="cursor: pointer"' +
					// 	'	   ng-click="grid.appScope.ricercaCtrl.infoScoreClicked($event,rowRenderIndex,row.entity);"'+
					// 	'    ></i' +
					// 	'  ></span>' +
					// 	'</a>' +
					// 	'</div>',
					// width: '12%'})
					self.gridOptions.columnDefs.splice(6,0,{
						displayName: 'Score ESG',
						field: 'esgStrumento.scoreSintetico',
						type:'number',
						cellFilter: 'number : 2',
						cellClass:'right',
						width: '12%'})
				}
				};
	
				/**
				 * @description Filtra le classificazioni sfdr che hanno il campo selected a true e poi rimuove il campo selected
				 * @param {*} classificazioniSfdr
				 */
				this.elaboraDominiSfdr = function(classificazioniSfdr){
					var classificazioniSelezionate = null;
					if(!!classificazioniSfdr){
						classificazioniSelezionate = classificazioniSfdr.filter(function(dominio){
							return dominio.selected
						}).map(function(dominio){
							return dominio.codice
						});
					return classificazioniSelezionate
				}
				}
				/**
				 * @description description Filtra i rating esg che hanno il campo selected a true e poi rimuove il campo selected
				 * @param {*} dominiRatingEsg 
				 */
				this.elaboraDominiRatinEsg = function(dominiRatingEsg){
					var ratingSelezionati = null;
					if(!!dominiRatingEsg){
						 ratingSelezionati = dominiRatingEsg.filter(function(dominio){
							return dominio.selected
						}).map(function(dominio){
							return dominio.codice.trim();
						});
					}
					return ratingSelezionati
				}
				
	
				/**
				 * @description Seleziona tutte le classificazioni sdfr
				 */
				this.selectAll = function(){
					self.dominiEsgStrumento.dominioClassificazioneSfdr.forEach(function(elements) {
						elements.selected = !!self.selectedAll ? true : false;
					})
				}
				
				/**
				 * 
				 * @param {*} event 
				 * @param {*} index 
				 * @param {*} entity 
				 * @description gestisci il click sull'info-point nella colonna score per poi aprire la infobox
				 */
				this.infoScoreClicked = function(event,index,entity){
					event.stopPropagation();
					self.selectedStrumento = self.strumenti.find(function(elem){
						return elem.isin === entity.isin;
					});
	
					$('#score_esg_modal').modal('show')
				}
	
				/**
				 * 
				 * @param {*} event 
				 * @param {*} index 
				 * @param {*} entity 
				 * @description gestisci il click sull'info-point nella colonna rating per poi aprire la infobox
				 */
				this.infoRatingClicked = function(event,index,entity){
					event.stopPropagation();
					self.selectedStrumento = self.strumenti.find(function(elem){
						return elem.isin === entity.isin;
					});
	
					$('#rating_esg_modal').modal('show')
				}
	
				/**
				 * 
				 * @param {*} event 
				 * @param {*} input 
				 * @description verifica che i valori passati tramite input nello score ESG siano un numero e sostituisce le virgole con i punti
				 */
				this.convalidaInput = function(event,input){
					event.target.value = event.target.value.replace(',','.');
					
					if(isNaN(event.target.value)){
						if(input === 'upperInput'){
							self.validUpperInput = false;
						}else if (input === 'lowerInput'){
							self.validLowerInput = false;
						}
					}else{
						self.validUpperInput = true;
						self.validLowerInput = true;
					}
				}
				/* 
		    	 * ---------------------
		    	 * END METODI CONTROLLER
		    	 * ---------------------
		    	 */
				
				/*
				 * ----------------------------
				 * START METODI INIT CONTROLLER
				 * ----------------------------
				 */
				$timeout(function(){
					self.recuperaModalitaEsposizioneESG();
				});
	
				this.$http({
					method:'GET',
					url:CONSTANTS.REST_ROOT+CONSTANTS.REST.STRUMENTO+'dominiEsgStrumento',
				}).then(function(response){
					if (self.messaggiFctr.processaResponse(response)) {
						return;
					}
					//Aggiungo a dominioClassificazioneSfdr il campo selected per usarlo come ngmodel nella checkbox
					self.elaboraResponse(response.data.result);
					self.dominiEsgStrumento = response.data.result;
					self.sfdrChecklist = document.getElementById('list1');
					self.ratingEsgCheckList = document.getElementById('list2');
	
					self.sliderMaxValue = self.dominiEsgStrumento.dominioScoreEsg !== null ? self.dominiEsgStrumento.dominioScoreEsg.find(function(dominio){return dominio.descrizione === 'MAX'}).codice : 100;
					self.sliderMinValue = self.dominiEsgStrumento.dominioScoreEsg ? self.dominiEsgStrumento.dominioScoreEsg.find(function(dominio){return dominio.descrizione === 'MIN'}).codice : 0;
	
					document.getElementById("upperInput").value = self.sliderMaxValue.slice(0,-4);
					document.getElementById("lowerInput").value = self.sliderMinValue.slice(0,-4);
	
					self.searchFilters.esgDa = parseInt(self.sliderMinValue.slice(0,-4));
					self.searchFilters.esgA = parseInt(self.sliderMaxValue.slice(0,-4));
	
					console.log('max '+self.sliderMaxValue+' min: '+self.sliderMinValue);
				},function(reason) {
					self.messaggiFctr.processaResponse(reason);
				});
	
				this.$http({
					method : 'GET',
					url: CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'categoriaStrumenti'
				}).then(function(response) {
					if (self.messaggiFctr.processaResponse(response)) {
						return;
					}
					self.tipologiaStrumento = response.data.result;
				}, function(reason) {
					self.messaggiFctr.processaResponse(reason);
				});
	
				this.gridOptions = {
					enableSorting: true,
		            enableColumnMenus: false,
		            enableGrouping: false,
		            enableFiltering: false,
		            treeRowHeaderAlwaysVisible: false,
		            paginationPageSizes: [10, 25, 50],
		            paginationPageSize: 10,
		            paginationCurrentPage: 1,
		            multiSelect: false,
		            enableRowHeaderSelection: false,
		            enableRowSelection: true,
		            showGridFooter: false,
		            enableVerticalScrollbar: this.uiGridConstants.scrollbars.NEVER,
		            enableColumnResizing: false,
		            onRegisterApi: function (gridApi) {
		            	gridApi.selection.on.rowSelectionChanged($scope, function (row) {
	                        $scope.callback({callbackResult: row.entity});
	                    });
		            }
				};
				
				this.gridOptions.columnDefs = [
					{displayName: 'Isin', field: 'isin', width: '12%'},
					{displayName: 'Tipo', field: 'categoriaStrumento.descrizione', width: '10%'},
					{displayName: 'Descrizione', field: 'descrizione', width: '18%'},
					{displayName: 'Prezzo', cellFilter: 'number : 2', cellClass: 'right', field: 'quotazioneUltimoPrezzoStorico.prezzo', width: '10%'},
					{displayName: 'Quantita\' minima', cellFilter: self.userSrvc.doppiaPrecisioneQuantita ? 'number : 6' : 'number : 3', cellClass: 'right', field: 'qtaMinimaTrattabile', width: '10%'},
					{displayName: 'Divisa', field: 'divisa', width: '10%'},
					{displayName: 'Data Inizio Sottoscrizione', field: 'dataInizioSottoscrizione', cellFilter : 'date: "dd/MM/yyyy"', width: '10%'},
					{displayName: 'Data Fine Sottoscrizione', field: 'dataFineSottoscrizione', cellFilter : 'date: "dd/MM/yyyy"', width: '10%'},
					{displayName: 'Quantita disponibile', cellFilter: self.userSrvc.doppiaPrecisioneQuantita ? 'number : 6' : 'number : 3', cellClass: 'right', field: 'disponibilita', width: '10%'}
				];
				//Se esgConsulenzaAttiva è true aggiungo queste colonne
				if(!self.esgConsulenzaAttiva){
					self.gridOptions.columnDefs.splice(6,0,{displayName: 'Classificazione SFDR', field: 'esgStrumento.classificazioneSfdr.descrizione', width: '12%'});
					self.gridOptions.columnDefs.splice(7,0,{displayName: 'Considera PAI', field: 'esgStrumento.pai.descrizione', width: '12%'});
					self.gridOptions.columnDefs.splice(8,0,{displayName: 'Allineamento Tassonomia EU', field: 'esgStrumento.tassonomia.descrizione', width: '15%',headerTooltip: 'Allineamento tassonomia EU'});
				}
				
				/*
				 * --------------------------
				 * END METODI INIT CONTROLLER
				 * --------------------------
				 */
			
			};
			controller.$inject = ['$scope','$rootScope', '$q', '$http', '$stateParams', 'FinUserSrvc', 'FinMessaggiFctr', 'uiGridConstants','$timeout'];
	
			return {
				restrict: "E",
				scope: {
					callback: '&',
					isFromGestioneProposta:'<'
				},
				controller: controller,
				controllerAs: "ricercaCtrl",
				templateUrl: CONSTANTS.BASE_ROOT + "widgets/finRicercaStrumento/finRicercaStrumento.html",
				link: link
			};
		}]);
	}(window));

/***/ },
/* 11 */
/***/ function(module, exports) {

	/**
	 * 
	 */
	(function() {
		"use strict";
		angular.module("cbl.common").directive(
				"finNumeric",
				[
						'$parse',
						'$filter',
						function($parse, $filter) {
							return {
								restrict : "A",
								require : 'ngModel',
								link : function(scope, elem, attrs, ctrl) {
									var maxValue = attrs.cblMax;
									var minValue = attrs.cblMin;
									var isPrezzoInput = attrs.cblPrezzo === 'true' ? true : false;
									var precision = attrs.cblPrecision ? attrs.cblPrecision.split(",") : null;
									if (precision) {
										if (precision.length < 2 || parseFloat(precision[0]) === NaN || parseFloat(precision[1]) === NaN) {
											precision = null;
										}
									}
	
									// For DOM -> model validation
									ctrl.$parsers
											.unshift(function(value) {
												if (!value || value === '') {
													return value;
												}
												value = manipolaNumerico(value);
												// comma to decimal
												value = (value) ? value.toString().trim().replace('.', '').replace(",", ".") : null;
												if (maxValue) {
													maxValue = maxValue.replace(",", ".");
													// controllo su valore massimo
													ctrl.$setValidity("cblMax", !(parseFloat(value) > parseFloat(maxValue)));
												}
												if (minValue) {
													minValue = minValue.replace(",", ".");
													// controllo su valore minimo
													ctrl.$setValidity("cblMin", !(parseFloat(value) < parseFloat(minValue)));
												}
												if (precision) {
													// controllo di precisione
													var valPrecision = value.indexOf(".");
													var segno = value.indexOf("-") + 1;
													if (valPrecision === -1) {
														// controllo scala non
														// necessario
														ctrl.$setValidity("cblPrecisione",
																(value.length - segno) <= (parseFloat(precision[0]) - parseFloat(precision[1])));
													} else {
														ctrl.$setValidity("cblPrecisione",
																(valPrecision - segno) <= (parseFloat(precision[0]) - parseFloat(precision[1]))
																		&& ((value.length - segno) - valPrecision - 1) <= parseFloat(precision[1])
																		&& valPrecision < (value.length - 1));
													}
												}
												return parseFloat(value);
											});
	
									// For model -> DOM validation
									ctrl.$formatters
											.unshift(function(value) {
												if (!value || value === '') {
													return value;
												}
												// decimal to comma
												value = (value) ? value.toString().replace(".", ",") : null;
												value = manipolaNumerico(value);
												if (maxValue) {
													maxValue = maxValue.replace(".", ",");
													// controllo su valore massimo
													ctrl.$setValidity("cblMax", !(parseFloat(value) > parseFloat(maxValue)));
												}
												if (minValue) {
													minValue = minValue.replace(".", ",");
													// controllo su valore minimo
													ctrl.$setValidity("cblMin", !(parseFloat(value) < parseFloat(minValue)));
												}
												if (precision) {
													// controllo di precisione
													var valPrecision = value.indexOf(",");
													var segno = value.indexOf("-") + 1;
													if (valPrecision === -1) {
														// controllo scala non
														// necessario
														ctrl.$setValidity("cblPrecisione",
																(value.length - segno) <= (parseFloat(precision[0]) - parseFloat(precision[1])));
													} else {
														ctrl.$setValidity("cblPrecisione",
																(valPrecision - segno) <= (parseFloat(precision[0]) - parseFloat(precision[1]))
																		&& ((value.length - segno) - valPrecision - 1) <= parseFloat(precision[1])
																		&& valPrecision < (value.length - 1));
													}
	
													// Add zero
													var decimal = parseFloat(precision[1]);
													if (decimal > 0) {
														if (valPrecision === -1) {
															value += ",";
														} else {
															decimal -= value.split(",")[1].length;
														}
														while (decimal > 0) {
															value += "0";
															decimal--;
														}
													}
												}
												// formatta migliaia
												var splitedValue = value.split(',');
												var counter = 0;
												for (var i = splitedValue[0].length - 1; i >= 1; i--) {
													counter++;
													if (counter % 3 == 0) {
														splitedValue[0] = splitedValue[0].slice(0, i) + '.' + splitedValue[0].slice(i);
													}
												}
												value = splitedValue[0] + (splitedValue.length === 1 ? '' : (',' + splitedValue[1]));
												return value;
											});
	
									var manipolaNumerico = function(value) {
										if (!value) {
											return value;
										}
										var validi = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '-' ];
	
										if(isPrezzoInput){
											validi.push('.')
										}
	
										var lung = value.length;
										for (var i = lung - 1; i >= 0; i--) {
											var ch = value.charAt(i);
											if (i !== 0 && ch === '-') {
												// rimuovo il segno negativo se non
												// è all'inizio
												value = value.substring(0, i) + value.substring(i + 1);
												continue;
											}
											var valoreValido = false;
											for ( var j in validi) {
												if (ch === validi[j]) {
													valoreValido = true;
													break;
												}
											}
											if (!valoreValido) {
												value = value.substring(0, i) + value.substring(i + 1);
											}
										}
	
										if(isPrezzoInput){
											value = value.replace('.',',');
										}
	
										var primoDecimale = value.indexOf(',');
										if (primoDecimale >= 0) {
											lung = value.length;
											for (var k = lung - 1; k > primoDecimale; k--) {
												var chd = value.charAt(k);
												if (chd == ",") {
													value = value.substring(0, k) + value.substring(k + 1);
												}
											}
										}
	
										return value;
									}
	
									elem.on("keyup", function(data) {
										var start = this.selectionStart, end = this.selectionEnd;
										var value = this.value;
	
										this.value = manipolaNumerico(value);
										this.setSelectionRange(start, end);
	
									});
	
								}
							}
						} ]);
	}());

/***/ },
/* 12 */
/***/ function(module, exports) {

	(function() {
		"use strict";
		var FinModaleIniziativaController = function ($scope, $modalInstance, labelSrvc) {
			$scope.msg = labelSrvc.getLabel;
	
			$scope.iniziativaBanca = function () {
				$modalInstance.close('B');
			};
		  
			$scope.iniziativaCliente = function () {
				$modalInstance.close('C');
			};
			
			$scope.cancel = function () {
				$modalInstance.dismiss();
			};
		};
		FinModaleIniziativaController.$inject = ['$scope', '$modalInstance', 'FinLabelSrvc'];
		angular.module('cbl.finanza.mf').controller('FinModaleIniziativaCtrl', FinModaleIniziativaController);
	}());

/***/ },
/* 13 */
/***/ function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.finanza.mf.directive:finanzaOperazioni
	 * @restrict E
	 * @scope
	 * @description Menu a tendina per scegliere l'operazione da effettuare sui dossier
	 * @param {String} sceltaDossierStato - Nome dello stato in cui è contenuta la lista dei dossier
	 * @param {Object} ndg - Ndg dell'intestatario
	 */
	(function() {
		"use strict";
		var OperazioniCtrl = function($http, $state, $scope, messaggiFctr,
				labelSrvc, CONSTANTS, $stateParams) {
			this.$http = $http;
			this.$state = $state;
			this.messaggiFctr = messaggiFctr;
			$scope.msg = labelSrvc.getLabel;
			this.$stateParams = $stateParams;
			this.abilitato = false;
			this.vociMenu = [];
	
			var self = this;
	
			this.$http({
				method : 'GET',
				url : CONSTANTS.MOCK_ROOT + CONSTANTS.MOCK_REST.MENU
			}).then(function(response) {
				if (self.messaggiFctr.processaResponse(response)) {
					self.vociMenu = [];
					self.abilitato = false;
					return;
				}
				self.vociMenu = response.data.result;
				self.abilitato = true;
			}, function(reason) {
				self.messaggiFctr.processaResponse(reason);
				self.vociMenu = [];
				self.abilitato = false;
			});
	
			/**
			 * @ngdoc method
			 * @name apriPagina
			 * @methodOf cbl.finanza.mf.directive:finanzaOperazioni
			 * @description Apre la pagina interessata
			 * @param {Object}
			 *            voce - L'oggetto voce contenente l'identificativo della
			 *            sezione in cui si vuole andare
			 */
			this.apriPagina = function(voce) {
				if (voce.abilitato) {
					self.$stateParams.ndg = self.ndg;
					self.$stateParams.finServizio = voce.cod;
					self.$state.go(self.sceltaDossierStato ? self.sceltaDossierStato : "sceltadossier", self.$stateParams);
				} else {
					self.messaggiFctr.addMessage({
						type : 'W',
						message : voce.motivo
					});
				}
			};
		};
	
		OperazioniCtrl.$inject = [ '$http', '$state', '$scope', 'FinMessaggiFctr', 'FinLabelSrvc', 'FIN_CONSTANTS', '$stateParams' ];
	
		var TemplateUrl = function(CONSTANTS) {
			return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + "operazioni/operazioni.html";
		};
		TemplateUrl.$inject = [ 'FIN_CONSTANTS' ];
	
		var OperazioniComponent = {
			bindings : {
				sceltaDossierStato : '@',
				ndg : '<'
			},
			controller : OperazioniCtrl,
			controllerAs : "operazioniCtrl",
			templateUrl : TemplateUrl
		};
	
		angular.module("cbl.finanza.mf").component("finanzaOperazioni",
				OperazioniComponent);
	}());

/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 *@ngdoc directive
	 *@name cbl.finanza.mf.directive:finanzaSceltaDossier
	 *@restrict E
	 *@description Componente contenente la lista dei dossier disponibili su cui effettuare operazioni
	 *@param {String} saldoDossierState - Stato in cui atterrare quando si seleziona un dossier
	 */
	(function() {
	    'use strict';
	    var SceltaDossierCtrl = function(
	        $http,
	        $scope,
	        $state,
	        $stateParams,
	        $window,
	        $q,
	        CONSTANTS,
	        labelSrvc,
	        messaggiFctr,
	        userSrvc,
	        brioSrvc,
	        deskSrvc,
	        modalAlertSrvc
	    ) {
	        this.$http = $http;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.messaggiFctr = messaggiFctr;
	        $scope.msg = labelSrvc.getLabel;
	
	        this.userSrvc = userSrvc;
	        this.brioSrvc = brioSrvc;
	        this.deskSrvc = deskSrvc;
	
	        this.dossierTableData = [];
	        this.anagrafica = {};
	        this.spinner = {
	            listaDossier: true
	        };
	        this.messaggiFctr.chiudiLoaderBrio();
	
	        var self = this;
	
	        /*
	         * -------------------------------------
	         * START METODI PROMISE PER SERVIZI REST
	         * -------------------------------------
	         */
	
	        /**
	         * @ngdoc method
	         * @name promiseDossierTableData
	         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
	         * @description Effettua una chiamata http per ricevere la lista dei dossier
	         * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista dei dossier
	         */
	        this.promiseDossierTableData = function() {
	            self.spinner.listaDossier = true;
	            return self.$http({
	                method: 'GET',
	                url: CONSTANTS.REST_ROOT +
	                    CONSTANTS.REST.DOSSIER +
	                    'listaDossier/' +
	                    self.$stateParams.ndg
	            });
	        };
	
	        this.mifidAbilitato = function() {
	            return userSrvc.abilitazioni.some(function(abilitazione) {
	                return (
	                    abilitazione.codice.toLowerCase() ===
	                    CONSTANTS.ABILITAZIONI.MIFID.toLowerCase()
	                );
	            });
	        };
	        /**
	         * @ngdoc method
	         * @name promiseDati
	         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
	         * @description Effettua una chiamata http per ricevere il dettaglio dell'ndg
	         * @return {Promise} - Ritorna una promise contenente l'anagrafica
	         */
	        this.promiseAnagrafica = function() {
	            return self.$http({
	                method: 'GET',
	                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA + 'Intestatario',
	                params: {
	                    ndg: self.$stateParams.ndg
	                }
	            });
	        };
	
	        /**
	     * @ngdoc method
	     * @name promiseGetAlerts
	     * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
	     * @description Effettua una chiamata http per verificare se i questionari sono ok
	     * @return {Promise} - Ritorna una promise contenente
	     */
	    this.promiseGetAlerts = function () {
	        return self.$http({
	          method: 'GET',
	           url:CONSTANTS.CABEL_CUSTOMER
	            +'customer/'+'getAlertBloccoOperativo/',
	            params :{
	              ndg:self.$stateParams.ndg,
	              listaTipiAlertDaEscludere : 'SCADENZA_MIFID'  
	            }
	  
	        });
	      };
	
	        /*
	         * -----------------------------------
	         * END METODI PROMISE PER SERVIZI REST
	         * -----------------------------------
	         */
	
	        /*
	         * ------------------------
	         * START INIT LABEL TABELLE
	         * ------------------------
	         */
	
	        /**
	         * @ngdoc method
	         * @name initTableLabel
	         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
	         * @description Crea le labels dei campi e ne definisce la struttura
	         */
	        this.initTableLabel = function() {
	            self.tableLabel = [{
	                    name: $scope.msg('lista.scelta.dossier.codice.dossier'),
	                    field: 'codiceRapporto',
	                    width: '*',
	                    enableFiltering: false
	                },
	                {
	                    name: $scope.msg('lista.scelta.dossier.categoria'),
	                    field: 'categoriaDossier',
	                    width: '*',
	                    enableFiltering: false
	                },
	                {
	                    name: $scope.msg('lista.scelta.dossier.tipologia.prodotto'),
	                    field: 'sottoCategoriaDossier',
	                    width: '*',
	                    enableFiltering: false
	                },
	                {
	                    name: $scope.msg('lista.scelta.dossier.ndg'),
	                    field: 'ndgIntestatario',
	                    width: '*',
	                    enableFiltering: false
	                },
	                {
	                    name: $scope.msg('lista.scelta.dossier.intestazione'),
	                    field: 'intestazione',
	                    width: '*',
	                    enableFiltering: false
	                },
	                {
	                    name: $scope.msg('lista.scelta.dossier.apertura'),
	                    field: 'dataApertura',
	                    cellFilter: 'date: "dd/MM/yyyy"',
	                    width: '*',
	                    enableFiltering: false
	                },
	                {
	                    name: $scope.msg('lista.scelta.dossier.blocco'),
	                    field: 'dataBlocco',
	                    cellFilter: 'date: "dd/MM/yyyy"',
	                    width: '*',
	                    enableFiltering: false
	                },
	                {
	                    name: $scope.msg('lista.scelta.dossier.estinzione'),
	                    field: 'dataChiusura',
	                    cellFilter: 'date: "dd/MM/yyyy"',
	                    width: '*',
	                    enableFiltering: false
	                }
	            ];
	            if (self.mifidAbilitato()) {
	                self.tableLabel.push({
	                    name: $scope.msg('lista.scelta.dossier.mifid.valida'),
	                    field: 'mifid',
	                    width: 145,
	                    enableFiltering: false,
	                    cellClass: 'text-center',
	                    cellTemplate: '<i class="fa fa-2x" ' +
	                        " ng-class=\"{'fa-check finIGreen': !row.entity.mifid, " +
	                        "'fa-exclamation-triangle finIOrange': row.entity.mifid === 'SCADUTO' || row.entity.mifid === 'PPROSSIMO_A_SCADERE', " +
	                        "'fa-hourglass-half': row.entity.mifid === 'W'}\" " +
	                        ' data-toggle="tooltip" title="{{row.entity.alert}}" ' +
	                        '></i>'
	                });
	            }
	            self.tableLabel.push({
	                name: $scope.msg('lista.scelta.dossier.abilitato.consulenza'),
	                field: 'abilitatoConsulenza',
	                width: 145,
	                enableFiltering: false,
	                cellClass: 'text-center',
	                cellTemplate: '<i class="fa fa-2x" ng-class="{\'fa-check finIGreen\': row.entity.abilitatoConsulenza === true, \'fa-close finIRed\': row.entity.abilitatoConsulenza === false}"></i>'
	            });
	            self.tableLabel.push({
	                name: $scope.msg('lista.scelta.dossier.abilitato.collocamento'),
	                field: 'abilitatoCollocamento',
	                width: 160,
	                enableFiltering: false,
	                cellClass: 'text-center',
	                cellTemplate: '<i class="fa fa-2x" ng-class="{\'fa-check finIGreen\': row.entity.abilitatoCollocamento === true, \'fa-close finIRed\': row.entity.abilitatoCollocamento === false}"></i>'
	            });
	            if (self.$stateParams.finServizio === '1') {
	                self.tableLabel.push({
	                    name: $scope.msg(
	                        'lista.scelta.dossier.abilitazione.servizi.investimento'
	                    ),
	                    field: 'abilitaConsulenza',
	                    width: 150,
	                    enableFiltering: false,
	                    cellClass: 'center',
	                    cellTemplate: '<button class="btn btn-primary btn-sm" type="button" ng-if=" !row.entity.mifid && !grid.appScope.userSrvc.nascondiAbilitaConsulenza && !row.entity.abilitatoConsulenza && !row.entity.dataChiusura && row.entity.tipologiaProdotto !== \'GESTIONE\'" ng-click="grid.appScope.abilitaConsulenza({row: row.entity})">{{grid.appScope.msg(\'lista.scelta.dossier.abilita.consulenza\')}}</button>'
	                });
	            }
	        };
	
	        /*
	         * ----------------------
	         * END INIT LABEL TABELLE
	         * ----------------------
	         */
	
	        /*
	         * -----------------------
	         * START METODI CONTROLLER
	         * -----------------------
	         */
	
	        /**
	         * @ngdoc method
	         * @name checkAbilitazioni
	         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
	         * @param {Array} dossierList - Array di oggetti contenente i dati della tabella
	         * @returns {Array} dossierList - Array di oggetti con aggiunte per ogni oggetto le varie abilitazioni se presenti
	         * @description - Inserisce nuove properties a livello di root di ciascun oggetto nell'array per identificare le varie abilitazioni nella tabella
	         */
	        this.checkAbilitazioni = function(dossierList) {
	            dossierList.forEach(function(dossier) {
	                //    			Setto di default le variabili a false
	                dossier.abilitatoConsulenza = false;
	                dossier.abilitatoCollocamento = false;
	                if (!!dossier.datiMifid && !!dossier.datiMifid.attivitaConsob) {
	                    dossier.datiMifid.attivitaConsob.forEach(function(item) {
	                        //    				Setto le properties per le varie abilitazioni presenti
	                        switch (item.codice.trim()) {
	                            case 'E':
	                                dossier.abilitatoConsulenza = true;
	                                break;
	                            case 'B':
	                            case 'F':
	                                dossier.abilitatoCollocamento = true;
	                                break;
	                        }
	                    });
	                }
	                if (self.mifidAbilitato()) {
	                    dossier.mifid = 'W';
	                    self.promiseMifid(dossier).then(function(res) {
	                        dossier.mifid = null;
	                        dossier.alert = 'Sono permesse solo operazioni di vendita\n';
	                        if (res.data.result) {
	                            for (var i in res.data.result) {
	                                var statoMifid = res.data.result[i];
	                                dossier.mifid = statoMifid.statoScadenza;
	                                var nominativo = statoMifid.nominativo
	                                    .replaceAll('*.*', '')
	                                    .trim();
	                                dossier.alert +=
	                                    'Questionario ' +
	                                    statoMifid.tipoQuestionario +
	                                    ' in stato ' +
	                                    statoMifid.statoScadenza +
	                                    ' per NDG ' +
	                                    statoMifid.ndg +
	                                    ' ' +
	                                    nominativo +
	                                    '\n';
	                            }
	                        }
	                        if (!dossier.mifid) {
	                            dossier.alert = null;
	                        }
	                    });
	                }
	            });
	            return dossierList;
	        };
	
	        this.promiseMifid = function(dossier) {
	            return $http({
	                method: 'GET',
	                url: CONSTANTS.REST_ROOT +
	                    CONSTANTS.REST.STRUMENTO +
	                    dossier.codiceRapporto +
	                    '/' +
	                    self.$stateParams.ndg +
	                    '/recuperaAlertScadenzaMifid'
	            });
	        };
	
	        /**
	         * @ngdoc method
	         * @name apriPagina
	         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
	         * @description Apre la pagina interessata
	         * @param {Object} row - Oggetto contenente i dati del dossier selezionato
	         */
	        this.apriPagina = function(row) {
	            //    		Effettuo i controlli sul tipo di servizio, l'abilitazione, che non sia chiuso e non sia bloccato
	            if (
	                self.$stateParams.finServizio === '1' &&
	                row.abilitatoConsulenza &&
	                !row.dataChiusura &&
	                !row.dataBlocco
	            ) {
	                self.$stateParams.finCodiceRapporto = row.codiceRapporto;
	                self.$state.go(self.saldoDossierState, self.$stateParams);
	            } else if (
	                self.$stateParams.finServizio === '2' &&
	                row.abilitatoCollocamento &&
	                !row.dataChiusura &&
	                !row.dataBlocco
	            ) {
	                self.$stateParams.finCodiceRapporto = row.codiceRapporto;
	                self.$state.go(self.saldoDossierState, self.$stateParams);
	            }
	        };
	
	        /**
	         * @ngdoc method
	         * @name abilitaConsulenza
	         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
	         * @description Entra nella pagina di attivazione di un dossier
	         * @param {Object} row
	         */
	        this.abilitaConsulenza = function(row) {
	            self.$stateParams.finCodiceRapporto = row.codiceRapporto;
	            self.$state.go(self.abilitaConsulenzaState, self.$stateParams);
	        };
	
	        /**
	         * @ngdoc method
	         * @name indietro
	         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
	         * @description Ritorna alla scheda cliente
	         */
	        this.indietro = function() {
	            if (self.deskSrvc.isDesk) {
	                self.deskSrvc.popEntry();
	            }
	            switch (self.brioSrvc.brioVersion) {
	                case 'brio2':
	                case 'brio3':
	                    self.$stateParams.idAnagrafica = self.anagrafica.idAnagrafica;
	                    self.$state.go('schedaCliente', self.$stateParams);
	                    break;
	                case 'brio-xc':
	                    if (window.location.pathname.indexOf('SCRIVANIAUTENTE') !== -1) {
	                        self.$state.go('home.schedacliente', self.$stateParams);
	                    } else {
	                        var parametri = [
	                            //	    				{
	                            //	    					chiave: 'idAnagrafica',
	                            //	    					valore: self.anagrafica.idAnagrafica
	                            //	    				}
	                            {
	                                chiave: 'ndg',
	                                valore: self.$stateParams.ndg
	                            }
	                        ];
	                        self.brioSrvc.goTo(
	                            'scrivaniautente',
	                            'home.schedacliente',
	                            parametri
	                        );
	                    }
	                    break;
	            }
	        };
	
	        /**
	         * @ngdoc method
	         * @name initPage
	         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
	         * @description Fa partire le chiamate rest per visualizzare i dettagli della pagina
	         */
	        this.initPage = function() {
	            $q.all({
	                    dati: self.promiseDossierTableData(),
	                    anagrafica: self.promiseAnagrafica(),
	                    label: labelSrvc.labelsPronte,
	                    user: userSrvc.abilitazioniPronte
	                })
	                .then(
	                    function(response) {
	                        if (
	                            self.messaggiFctr.processaResponse(response.dati) ||
	                            self.messaggiFctr.processaResponse(response.anagrafica)
	                        ) {
	                            self.dossierTableData = [];
	                            return;
	                        }
	                        self.initTableLabel();
	                        self.dossierTableData = self.checkAbilitazioni(
	                            response.dati.data.result
	                        );
	                        self.anagrafica = response.anagrafica.data.result[0];
	                    },
	                    function(reason) {
	                        self.messaggiFctr.processaResponse(reason.dati);
	                        self.dossierTableData = [];
	                        self.anagrafica = {};
	                    }
	                )
	                .finally(function() {
	                    self.spinner.listaDossier = false;
	                });
	        };
	        /*
	         * ---------------------
	         * END METODI CONTROLLER
	         * ---------------------
	         */
	
	        /*
	         * ----------------------------
	         * START METODI INIT CONTROLLER
	         * ----------------------------
	         */
	
	        this.init = function() {
	            // Se sono in ScrivaniaUtente (Brio Flexcube) chiamo il freddyService per
	            // aggiungere la rotta di consulenza base ai breadcrumb
	
	            if (self.deskSrvc.isDesk) {
	                labelSrvc.labelsPronte.then(function() {
	                    self.deskSrvc.aggiungiEntry(
	                        labelSrvc.getLabel('scelta.dossier.titolo')
	                    );
	                });
	            }
	            this.promiseGetAlerts().then(
	                function (response) {
	                  if (self.messaggiFctr.processaCabelAlertResponse(response)) {
	                    self.spinner.listaDossier = false;
	                    // modalAlertSrvc.notify({ message: 'Test', level: 'WARNING' });
	                    return;
	                  }
	                  if (!response.data.bloccoOperativitaEffettivo) {
	                    self.initPage();
	                  } else {
	                    self.spinner.listaDossier = false;
	                  }
	                },
	                function (reason) {
	                  self.messaggiFctr.processaResponse(reason);
	                  self.spinner.listaDossier = false;
	                }
	            );
	        };
	
	
	        this.init();
	
	        /*
	         * --------------------------
	         * END METODI INIT CONTROLLER
	         * --------------------------
	         */
	    };
	
	    SceltaDossierCtrl.$inject = [
	        '$http',
	        '$scope',
	        '$state',
	        '$stateParams',
	        '$window',
	        '$q',
	        'FIN_CONSTANTS',
	        'FinLabelSrvc',
	        'FinMessaggiFctr',
	        'FinUserSrvc',
	        'FinBrioSrvc',
	        'FinDeskSrvc',
	        'modalAlertSrvc'
	    ];
	
	    var TemplateUrl = function(CONSTANTS) {
	        return (
	            CONSTANTS.BASE_ROOT +
	            CONSTANTS.COMPONENTS_PATH +
	            'sceltaDossier/sceltaDossier.html'
	        );
	    };
	    TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	    var SceltaDossierComponent = {
	        bindings: {
	            saldoDossierState: '@',
	            abilitaConsulenzaState: '@'
	        },
	        controller: SceltaDossierCtrl,
	        controllerAs: 'sceltaDossierCtrl',
	        templateUrl: TemplateUrl
	    };
	
	    angular
	        .module('cbl.finanza.mf')
	        .component('finanzaSceltaDossier', SceltaDossierComponent);
	})();

/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.finanza.mf.directive:finanzaAbilitaConsulenza
	 * @restrict E
	 * @scope
	 * @description Componente utilizzato per dirottare l'utente all'abilitazione del dossier per la consulenza
	 */
	(function () {
	  'use strict';
	  var AbilitaConsulenzaCtrl = function (
	    $http,
	    $scope,
	    $window,
	    $q,
	    $stateParams,
	    $state,
	    $location,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    uiGridConstants,
	    messaggiSrvc,
	    brioSrvc,
	    userSrvc,
	    deskSrvc,
	    ssocoreServices
	  ) {
	    var self = this;
	    this.$http = $http;
	    this.$window = $window;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$location = $location;
	    this.messaggiFctr = messaggiFctr;
	    this.messaggiSrvc = messaggiSrvc;
	    this.brioSrvc = brioSrvc;
	    this.userSrvc = userSrvc;
	    this.ssocoreServices = ssocoreServices;
	    this.deskSrvc = deskSrvc;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.dossier = {};
	    this.portafoglioTableLabel = [];
	    this.portafoglioTableData = [];
	    this.posizione = {};
	    this.spinner = {
	      listaPortafoglio: false
	    };
	    this.domain = {
	      listaTipologiaStrumento: []
	    };
	    this.messaggiFctr.chiudiLoaderBrio();
	
	    /*
	     * -------------------------------------
	     * START METODI PROMISE PER SERVIZI REST
	     * -------------------------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaPortafoglio
	     * @methodOf cbl.finanza.mf.directive:finanzaAbilitaConsulenza
	     * @description Effettua una chiamata http per ricevere la lista del portafoglio associate ad un dossier
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista del portafoglio
	     */
	    this.promiseDatiTabellaPortafoglio = function () {
	      self.spinner.listaPortafoglio = true;
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          self.$stateParams.finCodiceRapporto +
	          '/saldi'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDominioStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaAbilitaConsulenza
	     * @description Effettua una chiamata http per ricevere la lista delle tipologie strumento
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la select del filtro stato per la lista del saldo portafoglio
	     */
	    this.promiseDominioFiltriStrumento = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'categoriaStrumenti'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDettaglioDossier
	     * @methodOf cbl.finanza.mf.directive:finanzaAbilitaConsulenza
	     * @description Effettua una chiamata al dettaglio dossier
	     * @return {Promise} - Ritorna una promise contenente il dettaglio del dossier
	     */
	    this.promiseDettaglioDossier = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.DOSSIER +
	          self.$stateParams.finCodiceRapporto
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseCustomerData
	     * @methodOf cbl.finanza.mf.directive:finanzaAbilitaConsulenza
	     * @description Effettua la chiamata per ricevere il customerdata
	     * @return {Promise} - Ritorna una promise contenente il customerdata
	     */
	    this.promiseCustomerData = function () {
	      return self.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
	        params: {
	          rapporto: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /*
	     * -----------------------------------
	     * END METODI PROMISE PER SERVIZI REST
	     * -----------------------------------
	     */
	
	    /*
	     * ------------------------
	     * START INIT LABEL TABELLE
	     * ------------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name initLabelTabellaPortafoglio
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Crea le label e la struttura della tabella del portafoglio
	     */
	    this.initLabelTabellaPortafoglio = function () {
	      self.portafoglioTableLabel = [
	        {
	          name: $scope.msg('lista.portafoglio.isin'),
	          field: 'strumento.isin',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.intestatario'),
	          field: 'intestatario',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.tipologia'),
	          field: 'strumento.categoriaStrumento.descrizione',
	          width: '*',
	          filter: {
	            type: uiGridConstants.filter.SELECT,
	            selectOptions: self.domain.listaTipologiaStrumento
	          }
	        },
	        {
	          name: $scope.msg('lista.portafoglio.descrizione'),
	          field: 'strumento.descrizione',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.divisa'),
	          field: 'strumento.divisa',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.quantita.disponibile'),
	          field: 'quantita',
	          cellFilter: 'number : 0',
	          cellClass: 'right',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.quantita'),
	          field: 'quantita',
	          cellFilter: 'number : 0',
	          cellClass: 'right',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.ctv.euro'),
	          field: 'valoreMercatoControvalore',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.rateo.netto.euro'),
	          field: 'ctvRateoNettoEuro',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.rateo.lordo.euro'),
	          field: 'ctvRateoLordoEuro',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.prezzo.mercato'),
	          field: 'prezzoMercato',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.prezzo.medio'),
	          field: 'prezzoCarico',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.plus.min'),
	          field: 'percPlusMinus',
	          cellClass: 'right',
	          width: '*',
	          enableFiltering: false
	        }
	      ];
	    };
	
	    /*
	     * ----------------------
	     * END INIT LABEL TABELLE
	     * ----------------------
	     */
	
	    /*
	     * -----------------------
	     * START METODI CONTROLLER
	     * -----------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name prosegui
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Prosegue nella rotta BRIO per attivare i servizi di consulenza sul dossier corrente
	     */
	    this.prosegui = function () {
	      switch (self.brioSrvc.brioVersion) {
	        case 'brio2':
	        case 'brio3':
	          self.$stateParams.ndg = self.dossier.ndgIntestatario;
	          self.$stateParams.numeroRapporto = self.dossier.codiceRapporto;
	          self.$stateParams.isSottoprocesso = 0;
	          self.$state.go('questionarioMifidConsulenza', self.$stateParams);
	          break;
	        case 'brio-xc':
	          var parametri = [
	            {
	              chiave: 'ndg',
	              valore: self.dossier.ndgIntestatario
	            },
	            {
	              chiave: 'numeroRapporto',
	              valore: self.dossier.codiceRapporto
	            },
	            {
	              chiave: 'isSottoprocesso',
	              valore: 0
	            },
	            {
	              chiave: 'Stato',
	              valore: 'questionarioMifidConsulenza'
	            }
	          ];
	          self.brioSrvc.goTo(
	            self.userSrvc.canaleOperativo,
	            'questionarioMifidConsulenza',
	            parametri
	          );
	          break;
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name indietro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Ritorna allo step precedente o ritorna alla rotta della sceltaDossier
	     */
	    this.back = function () {
	      if (self.deskSrvc.isDesk) {
	        self.deskSrvc.popEntry();
	      }
	      self.$state.go(self.sceltaDossierState, self.$stateParams);
	    };
	
	    /*
	     * ---------------------
	     * END METODI CONTROLLER
	     * ---------------------
	     */
	
	    /*
	     * ----------------------------
	     * START METODI INIT CONTROLLER
	     * ----------------------------
	     */
	
	    // Chiamo il getDossier per inserire le info nel customerdata
	    self.promiseCustomerData().then(
	      function (response) {
	        if (self.messaggiFctr.processaResponse(response)) {
	          self.posizione = {};
	          return;
	        }
	        self.posizione = response.data;
	      },
	      function (reason) {
	        self.messaggiFctr.processaResponse(reason);
	      }
	    );
	
	    $q.all({
	      portafoglio: self.promiseDatiTabellaPortafoglio(),
	      filtriStrumento: self.promiseDominioFiltriStrumento(),
	      dossier: self.promiseDettaglioDossier()
	    })
	      .then(
	        function (response) {
	          if (
	            self.messaggiFctr.processaResponse(response.portafoglio) ||
	            self.messaggiFctr.processaResponse(response.filtriStrumento) ||
	            self.messaggiFctr.processaResponse(response.dossier)
	          ) {
	            self.portafoglioTableData = [];
	            self.domain.listaTipologiaStrumento = [];
	            self.dossier = {};
	            return;
	          }
	          response.filtriStrumento.data.result.forEach(function (item) {
	            self.domain.listaTipologiaStrumento.push({
	              label: item.descrizione,
	              value: item.codice
	            });
	          });
	          self.initLabelTabellaPortafoglio();
	          self.portafoglioTableData = response.portafoglio.data.result;
	          self.dossier = response.dossier.data.result;
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason.filtriStrumento);
	          self.messaggiFctr.processaResponse(reason.portafoglio);
	          self.messaggiFctr.processaResponse(reason.dossier);
	          self.portafoglioTableData = [];
	          self.domain.listaTipologiaStrumento = [];
	          self.dossier = {};
	        }
	      )
	      .finally(function () {
	        self.spinner.listaPortafoglio = false;
	      });
	
	    /*
	     * --------------------------
	     * END METODI INIT CONTROLLER
	     * --------------------------
	     */
	
	    if (self.deskSrvc.isDesk) {
	      labelSrvc.labelsPronte.then(function () {
	        self.deskSrvc.aggiungiEntry(
	          labelSrvc.getLabel('lista.scelta.dossier.abilita.consulenza')
	        );
	      });
	    }
	  };
	
	  AbilitaConsulenzaCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$window',
	    '$q',
	    '$stateParams',
	    '$state',
	    '$location',
	    'FIN_CONSTANTS',
	    'FinLabelSrvc',
	    'FinMessaggiFctr',
	    'uiGridConstants',
	    'CblMessageSrvc',
	    'FinBrioSrvc',
	    'FinUserSrvc',
	    'FinDeskSrvc',
	    'ssocoreServices'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'abilitaConsulenza/abilitaConsulenza.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var AbilitaConsulenzaComponent = {
	    bindings: {
	      sceltaDossierState: '@'
	    },
	    controller: AbilitaConsulenzaCtrl,
	    controllerAs: 'abilitaConsulenzaCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finanzaAbilitaConsulenza', AbilitaConsulenzaComponent);
	})();


/***/ },
/* 16 */
/***/ function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.finanza.mf.directive:finanzaSaldoDossier
	 * @restrict E
	 * @scope
	 * @description Componente rappresentante il dettaglio del saldo dossier
	 * @param {String} sceltaDossierState - Nome dello stato per la scelta del dossier
	 * @param {String} visualizzaRaccomandazioneState - Nome dello stato per andare nella sezione di visualizzazione di una raccomandazione
	 * @param {String} modificaRaccomandazioneState - Nome dello stato per andare nella sezione di modifica di una raccomandazione
	 * @param {String} nuovaRaccomandazioneState - Nome dello stato per andare nella sezione di creazione di una raccomandazione
	 * @param {String} rifiutaRaccomandazioneState - Nome dello stato in cui navigare dopo aver rifiutato una raccomandazione
	 * @param {String} accettaRaccomandazioneState - Nome dello stato in cui navigare dopo aver accettato una raccomandazione
	 * @param {String} sceltaDossierState - Nome dello stato in cui è contenuta la lista dei dossiers
	 */
	(function () {
	  'use strict';
	  var SaldoDossierCtrl = function (
	    $http,
	    $scope,
	    $window,
	    $q,
	    $stateParams,
	    $state,
	    $location,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    uiGridConstants,
	    messaggiSrvc,
	    userSrvc,
	    $uibModal,
	    brioSrvc,
	    deskSrvc
	  ) {
	    var self = this;
	    this.$uibModal = $uibModal;
	    this.$http = $http;
	    this.$window = $window;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$location = $location;
	    this.messaggiFctr = messaggiFctr;
	    this.messaggiSrvc = messaggiSrvc;
	    this.userSrvc = userSrvc;
	    this.brioSrvc = brioSrvc;
	    this.deskSrvc = deskSrvc;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.portafoglioTableLabel = [];
	    this.portafoglioTableData = [];
	    this.raccomandazioniTableLabel = [];
	    this.raccomandazioniTableData = [];
	    this.richiesteTableLabel = [];
	    this.richiesteTableData = [];
	    this.listaRegoleStrumento = [];
	    this.raccomandazioniTotalItems = 0;
	    this.richiesteTotalItems = 0;
	    this.pageNumber = 1;
	    this.itemsPerPage = 10;
	    this.statoPratiche = undefined;
	    this.posizione = {};
	    this.inserimentoOrdiniVisibile = false;
	    this.domain = {
	      listaTipologiaStrumento: [],
	      listaStatoRaccomandazione: []
	    };
	    this.spinner = {
	      listaPortafoglio: false,
	      listaRaccomandazioni: false,
	      listaRichieste: false
	    };
	    this.messaggiFctr.chiudiLoaderBrio();
	
	    /*
	     * -------------------------------------
	     * START METODI PROMISE PER SERVIZI REST
	     * -------------------------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name promiseCustomerData
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua la chiamata per ricevere il customerdata
	     * @return {Promise} - Ritorna una promise contenente il customerdata
	     */
	    this.promiseCustomerData = function () {
	      return self.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
	        params: {
	          rapporto: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDominioStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per ricevere la lista delle tipologie strumento
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la select del filtro stato per la lista del saldo portafoglio
	     */
	    this.promiseDominioFiltriStrumento = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'categoriaStrumenti'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDominioFiltri
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per ricevere la lista degli stati possibili di una raccomandazione
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la select del filtro stato per la lista delle raccomandazioni
	     */
	    this.promiseDominioFiltriRaccomandazione = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          'statiRaccomandazione'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaRaccomandazioni
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per ricevere la lista delle raccomandazioni associate ad un dossier
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista delle raccomandazioni
	     */
	    this.promiseDatiTabellaRaccomandazioni = function () {
	      self.spinner.listaRaccomandazioni = true;
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.DOSSIER +
	          self.$stateParams.finCodiceRapporto +
	          '/raccomandazioni',
	        params: {
	          limit: self.itemsPerPage,
	          numeroPagina: self.pageNumber,
	          statoPratiche: self.statoPratiche
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaPortafoglio
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per ricevere la lista del portafoglio associate ad un dossier
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista del portafoglio
	     */
	    this.promiseDatiTabellaPortafoglio = function () {
	      self.spinner.listaPortafoglio = true;
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          self.$stateParams.finCodiceRapporto +
	          '/saldi'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaRichieste
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per ricevere la lista delle richieste associate ad un dossier
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista delle richieste
	     */
	    this.promiseDatiTabellaRichieste = function () {
	      self.spinner.listaRichieste = true;
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          self.$stateParams.finCodiceRapporto +
	          '/richieste',
	        params: {
	          limit: self.itemsPerPage,
	          numeroPagina: self.pageNumber,
	          statoPratiche: self.statoPratiche
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaRichieste
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per eliminare una raccomandazione
	     * @param {Number} idRaccomandazione - Id della raccomandazione da eliminare
	     * @return {Promise} - Ritorna una promise contenente il risultato dell'elimina raccomandazione
	     */
	    this.promiseEliminaRaccomandazione = function (idRaccomandazione) {
	      return self.$http({
	        method: 'DELETE',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          idRaccomandazione
	      });
	    };
	
	    /**
	     * @ngod method
	     * @name promiseRegoleStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per chiedere le regole delle operazioni
	     * effettuabili dall'utente sul proprio saldoPortafoglio
	     * @return {Promise} - Ritorna una lista di regole
	     */
	    this.promiseRegoleStrumento = function () {
	      return this.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'regoleStrumento'
	      });
	    };
	
	    /*
	     * -----------------------------------
	     * END METODI PROMISE PER SERVIZI REST
	     * -----------------------------------
	     */
	
	    /*
	     * ------------------------
	     * START INIT LABEL TABELLE
	     * ------------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name initLabelTabellaRichieste
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesteOrdine
	     * @description Crea le label e la struttura della tabella delle richieste ordine
	     */
	    this.initLabelTabellaRichieste = function () {
	      self.richiesteTableLabel = [
	        {
	          name: $scope.msg('lista.richieste.id.pratica'),
	          field: 'idPratica',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.richieste.id.raccomandazione'),
	          field: 'idRaccomandazione',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.richieste.codice.dossier'),
	          field: 'codiceDossierTitoli',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.richieste.stato'),
	          field: 'stato',
	          width: '*',
	          filter: {
	            type: uiGridConstants.filter.SELECT,
	            selectOptions: self.domain.listaStatoRaccomandazione
	          }
	        },
	        {
	          name: $scope.msg('lista.richieste.inserimento'),
	          field: 'inserimento',
	          cellFilter: 'date: "dd/MM/yyyy"',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.richieste.azione'),
	          field: 'azione',
	          width: 100,
	          enableFiltering: false,
	          cellTemplate:
	            "<i class='fa fa-pencil fa-2x finIMargin finIPointer' ng-if=\"row.entity.stato === 'INCORSO' || row.entity.stato === 'CONSOLIDATA' || row.entity.stato === 'DAREVISIONARE' || (row.entity.stato === 'PRESENTATA' && grid.appScope.userSrvc.valutaPratica)\" aria-hidden='true' uib-tooltip=\"{{grid.appScope.msg('tooltip.modifica')}}\" tooltip-placement=\"left\" ng-click=\"grid.appScope.modificaRichiesta({richiesta: row.entity})\"></i>" +
	            '<i class=\'fa fa-search fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaRichiesta({richiesta: row.entity})"></i>'
	        }
	      ];
	    };
	
	    /**
	     * @ngdoc method
	     * @name initLabelTabellaPortafoglio
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Crea le label e la struttura della tabella del portafoglio
	     */
	    this.initLabelTabellaPortafoglio = function () {
	      self.portafoglioTableLabel = [
	        {
	          name: $scope.msg('lista.portafoglio.isin'),
	          field: 'strumento.isin',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.intestatario'),
	          field: 'intestatario',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.tipologia'),
	          field: 'strumento.categoriaStrumento.descrizione',
	          width: '*',
	          filter: {
	            type: uiGridConstants.filter.SELECT,
	            selectOptions: self.domain.listaTipologiaStrumento
	          }
	        },
	        {
	          name: $scope.msg('lista.portafoglio.descrizione'),
	          field: 'strumento.descrizione',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.divisa'),
	          field: 'strumento.divisa',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.quantita.disponibile'),
	          field: 'quantitaDisponibile',
	          cellFilter: self.userSrvc.doppiaPrecisioneQuantita
	            ? 'number : 6'
	            : 'number : 3',
	          cellClass: 'right',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.quantita'),
	          field: 'quantita',
	          cellFilter: self.userSrvc.doppiaPrecisioneQuantita
	            ? 'number : 6'
	            : 'number : 3',
	          cellClass: 'right',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.ctv.euro'),
	          field: 'valoreMercatoControvalore',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.rateo.netto.euro'),
	          field: 'ctvRateoNettoEuro',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.rateo.lordo.euro'),
	          field: 'ctvRateoLordoEuro',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.prezzo.mercato'),
	          field: 'prezzoMercato',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.prezzo.medio'),
	          field: 'prezzoCarico',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.plus.min'),
	          field: 'percPlusMinus',
	          cellClass: 'right',
	          width: '*',
	          enableFiltering: false
	        }
	      ];
	      if (
	        self.$stateParams.finServizio === '2' &&
	        self.userSrvc.inserimentoOrdiniVisibile
	      ) {
	        var cellTemplate =
	          '<div style="line-height: 40px; ">' +
	          '<i class=\'fa fa-plus fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="row.entity.mostraBottoni && !grid.appScope.userSrvc.mostraSoloVenditaOrdini" uib-tooltip="{{grid.appScope.msg(\'tooltip.acquista\')}}" tooltip-placement="left" ng-click="grid.appScope.acquista({itemPortafoglio: row.entity})"></i>' +
	          '<i class=\'fa fa-minus fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="row.entity.mostraBottoni" uib-tooltip="{{grid.appScope.msg(\'tooltip.vendi\')}}" tooltip-placement="left" ng-click="grid.appScope.vendita({itemPortafoglio: row.entity})"></i>' +
	          '<i class=\'fa fa-exchange fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="row.entity.mostraBottoni && row.entity.strumento.categoriaStrumento.descrizione === \'Fondo\' && !grid.appScope.userSrvc.mostraSoloVenditaOrdini" uib-tooltip="{{grid.appScope.msg(\'tooltip.switch\')}}" tooltip-placement="left" ng-click="grid.appScope.cambio({itemPortafoglio: row.entity})"></i>';
	        if (
	          userSrvc.abilitato(CONSTANTS.ABILITAZIONI.MODIFICA_PIANO) ||
	          userSrvc.isBpa
	        ) {
	          //operativitaPiani
	          cellTemplate +=
	            '<i class="fa fa-product-hunt fa-2x finIMargin finIPointer" aria-hidden="true" ' +
	            ' ng-if="row.entity.mostraBottoni ' +
	            ' && row.entity.operativitaPiani' +
	            " && row.entity.strumento.categoriaStrumento.descrizione === 'Fondo' \"" +
	            ' && !grid.appScope.userSrvc.mostraSoloVenditaOrdini" ' +
	            'uib-tooltip="{{grid.appScope.msg(\'tooltip.piano\')}}" ' +
	            'tooltip-placement="left" ng-click="grid.appScope.cambioPiano({itemPortafoglio: row.entity})"></i>';
	        }
	        cellTemplate += '</div>';
	
	        self.portafoglioTableLabel.push({
	          field: 'azioni',
	          name: $scope.msg('lista.portafoglio.acquista.vendita'),
	          width: 150,
	          enableFiltering: false,
	          cellTemplate: cellTemplate
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name initLabelTabellaRaccomandazioni
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Crea le label e la struttura della tabella delle raccomandazioni
	     */
	    this.initLabelTabellaRaccomandazioni = function () {
	      self.raccomandazioniTableLabel = [
	        {
	          name: $scope.msg('saldo.dossier.numero.raccomandazione'),
	          field: 'idPratica',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('saldo.dossier.stato'),
	          field: 'stato',
	          width: '*',
	          filter: {
	            type: uiGridConstants.filter.SELECT,
	            selectOptions: self.domain.listaStatoRaccomandazione
	          }
	        },
	        {
	          name: $scope.msg('saldo.dossier.data.inserimento'),
	          width: '*',
	          field: 'inserimento',
	          cellFilter: 'date: "dd/MM/yyyy"',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('saldo.dossier.data.scadenza'),
	          width: '*',
	          field: 'dataScadenzaRaccomandazione',
	          cellFilter: 'date: "dd/MM/yyyy"',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('saldo.dossier.ctv.teorico'),
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          field: 'controvaloreTeorico',
	          enableFiltering: false
	        },
	        {
	          field: 'azioni',
	          name: $scope.msg('saldo.dossier.azioni'),
	          width: 120,
	          enableFiltering: false,
	          cellTemplate:
	            '<i class=\'fa fa-search fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>' +
	            '<i class=\'fa fa-pencil fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" tooltip-placement="left" ng-if="grid.appScope.finTableCtrl.showButtonRaccomandazioni(row.entity.stato, \'modifica\')" ng-click="grid.appScope.modificaRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>' +
	            '<i class=\'fa fa-trash fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.elimina\')}}" tooltip-placement="left" ng-if="grid.appScope.finTableCtrl.showButtonRaccomandazioni(row.entity.stato, \'elimina\')" ng-click="grid.appScope.eliminaRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>' +
	            '<i class=\'fa fa-pencil fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" tooltip-placement="left" ng-if="grid.appScope.finTableCtrl.showButtonRaccomandazioni(row.entity.stato, \'valutazione\')" ng-click="grid.appScope.valutazioneRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>'
	        }
	      ];
	    };
	
	    /*
	     * ----------------------
	     * END INIT LABEL TABELLE
	     * ----------------------
	     */
	
	    /*
	     * -----------------------
	     * START METODI CONTROLLER
	     * -----------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name apriModaleNuovaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Apre e gestisce il risultato della modale iniziativa
	     */
	    this.apriModaleNuovaRaccomandazione = function () {
	      //			Se la banca ha già l'iniziativa settata e il profilo è un promotore non faccio vedere la modale
	      if (self.userSrvc.iniziativaRaccomandazione) {
	        self.$stateParams.finIniziativa =
	          self.userSrvc.iniziativaRaccomandazione;
	        self.nuovaRaccomandazione();
	      } else {
	        self.$uibModal
	          .open({
	            animation: true,
	            templateUrl:
	              CONSTANTS.BASE_ROOT +
	              'widgets/finModali/iniziativa/finModaleIniziativa.html',
	            controller: 'FinModaleIniziativaCtrl',
	            controllerAs: 'modalCtrl',
	            size: 'modal-lg'
	          })
	          .result.then(function (response) {
	            self.$stateParams.finIniziativa = response;
	            self.nuovaRaccomandazione();
	          });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name nuovaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di creazione di un nuovo ordine in modalita acquista
	     */
	    this.nuovaRichiesta = function () {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.a');
	      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name acquista
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Entra nello stato nuova richiesta con modalita acquista
	     */
	    this.acquista = function (itemPortafoglio) {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.a');
	      self.$stateParams.finCodiceStrumento = itemPortafoglio.strumento.codice.trim();
	      self.$stateParams.finIntestatarioStrumento =
	        itemPortafoglio.ndgIntestatario;
	      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name vendita
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Entra nello stato nuova richiesta con modalita vendita
	     */
	    this.vendita = function (itemPortafoglio) {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.d');
	      self.$stateParams.finCodiceStrumento = itemPortafoglio.strumento.codice.trim();
	      self.$stateParams.finIntestatarioStrumento =
	        itemPortafoglio.ndgIntestatario;
	      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name cambio
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Entra nello stato nuova proposta con modalita cambio
	     */
	    this.cambio = function (itemPortafoglio) {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.s');
	      self.$stateParams.finCodiceStrumento = itemPortafoglio.strumento.codice.trim();
	      self.$stateParams.finIntestatarioStrumento =
	        itemPortafoglio.ndgIntestatario;
	      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name cambioPiano
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Entra nello stato nuova proposta con modalita cambio
	     */
	    this.cambioPiano = function (itemPortafoglio) {
	      self.$stateParams.acqven = CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO;
	      self.$stateParams.finCodiceStrumento = itemPortafoglio.strumento.codice.trim();
	      self.$stateParams.finIntestatarioStrumento =
	        itemPortafoglio.ndgIntestatario;
	      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name modificaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di modifica di una richiesta
	     * @param {Object} richiesta - Richiesta da modificare
	     */
	    this.modificaRichiesta = function (richiesta) {
	      self.$stateParams.finIdRaccomandazione = richiesta.idRaccomandazione;
	      self.$stateParams.finIdRichiesta = richiesta.idPratica;
	      self.$state.go(self.modificaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name visualizzaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di visualizzazione di una richiesta
	     * @param {Object} richiesta - Richiesta da visualizzare
	     */
	    this.visualizzaRichiesta = function (richiesta) {
	      self.$stateParams.finIdRaccomandazione = richiesta.idRaccomandazione;
	      self.$stateParams.finIdRichiesta = richiesta.idPratica;
	      self.$state.go(self.visualizzaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name nuovaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di creazione di una raccomandazione
	     */
	    this.nuovaRaccomandazione = function () {
	      self.$state.go(self.nuovaRaccomandazioneState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name modificaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di modifica di una raccomandazione
	     * @param {Number} idRaccomandazione - Id della raccomandazione da modificare
	     */
	    this.modificaRaccomandazione = function (idRaccomandazione) {
	      self.$stateParams.finIdRaccomandazione = idRaccomandazione;
	      self.$state.go(self.modificaRaccomandazioneState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name visualizzaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di modifica di una raccomandazione
	     * @param {Number} idRaccomandazione - Id della raccomandazione da visualizzare
	     */
	    this.visualizzaRaccomandazione = function (idRaccomandazione) {
	      self.$stateParams.finIdRaccomandazione = idRaccomandazione;
	      self.$state.go(self.visualizzaRaccomandazioneState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name visualizzaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Elimina una raccomandazione da un dossier
	     * @param {Number} idRaccomandazione - Id della raccomandazione da eliminare
	     */
	    this.eliminaRaccomandazione = function (idRaccomandazione) {
	      self.promiseEliminaRaccomandazione(idRaccomandazione).then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            return;
	          }
	          self.$state.go(self.$state.current.name, self.$stateParams, {
	            reload: true
	          });
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name valutazioneRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Entra nello stato di valutazione di una raccomandazione
	     * @param {Number} idRaccomandazione - Id della raccomandazione da valutare
	     */
	    this.valutazioneRaccomandazione = function (idRaccomandazione) {
	      self.$stateParams.finIdRaccomandazione = idRaccomandazione;
	      self.$state.go(self.valutazioneRaccomandazioneState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name back
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Ritorna alla rotta della sceltaDossier
	     */
	    this.back = function () {
	      if (self.deskSrvc.isDesk) {
	        self.deskSrvc.popEntry();
	      }
	      if(sessionStorage.getItem('isFromSchedaDossier')){
	        sessionStorage.removeItem('isFromSchedaDossier');
	        self.$state.go('schedaDossier', self.$stateParams);
	      }else{
	        self.$state.go(self.sceltaDossierState, self.$stateParams);
	      }
	      
	    };
	
	    /**
	     * @ngdoc method
	     * @name aggiornaLista
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Chiama la promise e gestisce i dati per la lista raccomandazioni e richieste
	     */
	    this.aggiornaLista = function () {
	      if (self.$stateParams.finServizio === '1') {
	        self
	          .promiseDatiTabellaRaccomandazioni()
	          .then(
	            function (response) {
	              if (self.messaggiFctr.processaResponse(response)) {
	                return;
	              }
	              self.raccomandazioniTotalItems =
	                response.data.result.numeroRecord;
	              self.raccomandazioniTableData =
	                response.data.result.listaRisultati;
	            },
	            function (reason) {
	              self.messaggiFctr.processaResponse(reason);
	            }
	          )
	          .finally(function () {
	            self.spinner.listaRaccomandazioni = false;
	          });
	      } else {
	        self
	          .promiseDatiTabellaRichieste()
	          .then(
	            function (response) {
	              if (self.messaggiFctr.processaResponse(response)) {
	                return;
	              }
	              self.richiesteTotalItems = response.data.result.numeroRecord;
	              self.richiesteTableData = response.data.result.listaRisultati;
	            },
	            function (reason) {
	              self.messaggiFctr.processaResponse(reason);
	            }
	          )
	          .finally(function () {
	            self.spinner.listaRichieste = false;
	          });
	      }
	    };
	
	    /**
	     * @ngodc method
	     * @name cambioPaginaTabella
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Cambia il numero di pagina e il numero di elementi per pagina
	     */
	    this.cambioPaginaTabella = function (pageNumber, itemsPerPage) {
	      self.itemsPerPage = itemsPerPage;
	      self.pageNumber = pageNumber;
	      self.aggiornaLista();
	    };
	
	    /**
	     * @ngdoc method
	     * @name applicaFiltri
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Applica il filtro STATO della tabella raccomandazioni o richieste
	     * @param {Object} columns - Tutta la struttura delle colonne
	     */
	    this.applicaFiltri = function (columns) {
	      self.statoPratiche = columns[2].filters[0].term;
	      self.aggiornaLista();
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkRegoleStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Gestisce l'array del saldoPortafoglio e decide
	     * se mostrare o meno i bottoni di Acquisto, Vendita e Switch
	     */
	    this.checkRegoleStrumento = function () {
	      self.portafoglioTableData.forEach(function (portafoglio) {
	        //				Imposta la proprietà mostraBottoniPortafoglio per ciascun saldo in base alle regole dello strumento
	        portafoglio['mostraBottoni'] = self.listaRegoleStrumento.some(function (
	          regola
	        ) {
	          var ruolo = false;
	          //					Se siamo in brio forkato le logiche cambiano
	          if (self.brioSrvc.brioVersion === 'brio-xc') {
	            //						Se siamo in filiale effettuo un controllo diverso rispetto a promotore
	            if (self.userSrvc.canaleOperativo === 'filialefxc') {
	              ruolo =
	                !regola.ruolo ||
	                regola.ruolo.toLowerCase().trim() === 'filiale';
	            } else {
	              ruolo =
	                !regola.ruolo || regola.ruolo.toLowerCase().trim() === 'brio';
	            }
	          } else {
	            //						Se siamo in brio vecchio controllo su un altro campo
	            ruolo =
	              !regola.ruolo ||
	              regola.ruolo.toLowerCase().trim() ===
	                self.userSrvc.user.app.toLowerCase().trim();
	          }
	          var categoria =
	            (!regola.categoria ||
	              regola.categoria.toLowerCase().trim() ===
	                portafoglio.strumento.categoriaStrumento.codice
	                  .toLowerCase()
	                  .trim()) &&
	            regola.categoria.toLowerCase().trim() !== 'pog';
	          var isin =
	            !regola.isin ||
	            regola.isin.toLowerCase().trim() ===
	              portafoglio.strumento.isin.toLowerCase().trim();
	          var emittente =
	            !regola.emittente ||
	            regola.emittente.toLowerCase().trim() ===
	              portafoglio.strumento.emittente.toLowerCase().trim();
	          return ruolo && categoria && isin && emittente;
	        });
	      });
	    };
	
	    /*
	     * ---------------------
	     * END METODI CONTROLLER
	     * ---------------------
	     */
	
	    /*
	     * ----------------------------
	     * START METODI INIT CONTROLLER
	     * ----------------------------
	     */
	
	    // Chiamo il getDossier per inserire le info nel customerdata
	    self.promiseCustomerData().then(
	      function (response) {
	        if (self.messaggiFctr.processaResponse(response)) {
	          self.posizione = {};
	          return;
	        }
	        self.posizione = response.data;
	      },
	      function (reason) {
	        self.messaggiFctr.processaResponse(reason);
	      }
	    );
	
	    if (self.$stateParams.finServizio === '1') {
	      $q.all({
	        filtriRaccomandazione: self.promiseDominioFiltriRaccomandazione(),
	        filtriStrumento: self.promiseDominioFiltriStrumento(),
	        raccomandazioni: self.promiseDatiTabellaRaccomandazioni(
	          self.pageNumber
	        ),
	        portafoglio: self.promiseDatiTabellaPortafoglio(),
	        label: labelSrvc.labelsPronte
	      })
	        .then(
	          function (response) {
	            if (
	              self.messaggiFctr.processaResponse(
	                response.filtriRaccomandazione
	              ) ||
	              self.messaggiFctr.processaResponse(response.filtriStrumento) ||
	              self.messaggiFctr.processaResponse(response.raccomandazioni) ||
	              self.messaggiFctr.processaResponse(response.portafoglio)
	            ) {
	              self.domain.listaStatoRaccomandazione = [];
	              self.domain.listaTipologiaStrumento = [];
	              self.raccomandazioniTableData = [];
	              self.initLabelTabellaRaccomandazioni();
	              self.portafoglioTableData = [];
	              return;
	            }
	            response.filtriRaccomandazione.data.result.forEach(function (item) {
	              self.domain.listaStatoRaccomandazione.push({
	                label: item,
	                value: item
	              });
	            });
	            response.filtriStrumento.data.result.forEach(function (item) {
	              self.domain.listaTipologiaStrumento.push({
	                label: item.descrizione,
	                value: item.descrizione
	              });
	            });
	            self.initLabelTabellaRaccomandazioni();
	            self.initLabelTabellaPortafoglio();
	            self.raccomandazioniTotalItems =
	              response.raccomandazioni.data.result.numeroRecord;
	            self.raccomandazioniTableData =
	              response.raccomandazioni.data.result.listaRisultati;
	            self.portafoglioTableData = response.portafoglio.data.result;
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason.filtriRaccomandazione);
	            self.messaggiFctr.processaResponse(reason.filtriStrumento);
	            self.messaggiFctr.processaResponse(reason.raccomandazioni);
	            self.messaggiFctr.processaResponse(reason.portafoglio);
	            self.domain.listaStatoRaccomandazione = [];
	            self.domain.listaTipologiaStrumento = [];
	            self.raccomandazioniTableData = [];
	            self.portafoglioTableData = [];
	          }
	        )
	        .finally(function () {
	          self.spinner.listaPortafoglio = false;
	          self.spinner.listaRaccomandazioni = false;
	        });
	    } else {
	      $q.all({
	        richieste: self.promiseDatiTabellaRichieste(),
	        portafoglio: self.promiseDatiTabellaPortafoglio(),
	        filtriRaccomandazione: self.promiseDominioFiltriRaccomandazione(),
	        filtriStrumento: self.promiseDominioFiltriStrumento(),
	        regoleStrumento: self.promiseRegoleStrumento(),
	        label: labelSrvc.labelsPronte
	      })
	        .then(
	          function (response) {
	            if (
	              self.messaggiFctr.processaResponse(
	                response.filtriRaccomandazione
	              ) ||
	              self.messaggiFctr.processaResponse(response.richieste) ||
	              self.messaggiFctr.processaResponse(response.portafoglio) ||
	              self.messaggiFctr.processaResponse(response.filtriStrumento) ||
	              self.messaggiFctr.processaResponse(response.regoleStrumento)
	            ) {
	              self.domain.listaStatoRaccomandazione = [];
	              self.richiesteTableData = [];
	              self.portafoglioTableData = [];
	              self.domain.listaTipologiaStrumento = [];
	              self.listaRegoleStrumento = [];
	              return;
	            }
	            response.filtriRaccomandazione.data.result.forEach(function (item) {
	              self.domain.listaStatoRaccomandazione.push({
	                label: item,
	                value: item
	              });
	            });
	            response.filtriStrumento.data.result.forEach(function (item) {
	              self.domain.listaTipologiaStrumento.push({
	                label: item.descrizione,
	                value: item.codice
	              });
	            });
	            self.richiesteTotalItems =
	              response.richieste.data.result.numeroRecord;
	            self.richiesteTableData =
	              response.richieste.data.result.listaRisultati;
	            self.portafoglioTableData = response.portafoglio.data.result;
	            self.listaRegoleStrumento = response.regoleStrumento.data.result;
	            self.checkRegoleStrumento();
	            self.initLabelTabellaRichieste();
	            self.initLabelTabellaPortafoglio();
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason.filtriRaccomandazione);
	            self.messaggiFctr.processaResponse(reason.richieste);
	            self.messaggiFctr.processaResponse(reason.portafoglio);
	            self.messaggiFctr.processaResponse(reason.filtriStrumento);
	            self.messaggiFctr.processaResponse(reason.regoleStrumento);
	            self.domain.listaStatoRaccomandazione = [];
	            self.domain.listaTipologiaStrumento = [];
	            self.richiesteTableData = [];
	            self.portafoglioTableData = [];
	            self.listaRegoleStrumento = [];
	          }
	        )
	        .finally(function () {
	          self.spinner.listaPortafoglio = false;
	          self.spinner.listaRichieste = false;
	        });
	    }
	
	    if (self.deskSrvc.isDesk) {
	      labelSrvc.labelsPronte.then(function () {
	        self.deskSrvc.aggiungiEntry(
	          labelSrvc.getLabel('saldo.dossier.posizione.cliente')
	        );
	      });
	    }
	    /*
	     * --------------------------
	     * END METODI INIT CONTROLLER
	     * --------------------------
	     */
	  };
	
	  SaldoDossierCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$window',
	    '$q',
	    '$stateParams',
	    '$state',
	    '$location',
	    'FIN_CONSTANTS',
	    'FinLabelSrvc',
	    'FinMessaggiFctr',
	    'uiGridConstants',
	    'CblMessageSrvc',
	    'FinUserSrvc',
	    '$uibModal',
	    'FinBrioSrvc',
	    'FinDeskSrvc'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'saldoDossier/saldoDossier.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var SaldoDossierComponent = {
	    bindings: {
	      sceltaDossierState: '@',
	      visualizzaRaccomandazioneState: '@',
	      modificaRaccomandazioneState: '@',
	      nuovaRaccomandazioneState: '@',
	      valutazioneRaccomandazioneState: '@',
	      modificaRichiestaState: '@',
	      nuovaRichiestaState: '@',
	      visualizzaRichiestaState: '@'
	    },
	    controller: SaldoDossierCtrl,
	    controllerAs: 'saldoDossierCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finanzaSaldoDossier', SaldoDossierComponent);
	})();


/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	 * @restrict E
	 * @description Componente che racchiude al suo interno il wizard per la gestione delle raccomandazioni
	 * @param {String} nuovaPropostaState - Nome dello stato su cui navigare quando si vuole creare una nuova proposta
	 * @param {String} modificaPropostaState - Nome dello stato su cui navigare quando si vuole modificare una proposta
	 * @param {String} gestioneRichiestaState - Nome dello stato per la gestione di una richiesta
	 * @param {String} saldoDossierState - Nome dello stato per il saldo del dossier
	 * @param {String} modalita - Modalità di ingresso nella gestione di una raccomandazione, valori possibili:
	 * 'VISUALIZZA', 'MODIFICA', 'NUOVA' e 'VALUTAZIONE'
	 */
	(function () {
	  'use strict';
	  var GestioneRaccomandazioneCtrl = function (
	    $q,
	    $http,
	    $scope,
	    $state,
	    $stateParams,
	    $location,
	    $uibModal,
	    messaggiFctr,
	    labelSrvc,
	    CONSTANTS,
	    $window,
	    gestioneRaccomandazioneService,
	    uiGridConstants,
	    userSrvc,
	    messaggiSrvc,
	    brioSrvc,
	    deskSrvc
	  ) {
	    this.$http = $http;
	    this.$window = $window;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.CONSTANTS = CONSTANTS;
	    this.messaggiFctr = messaggiFctr;
	    this.messaggiSrvc = messaggiSrvc;
	    this.userSrvc = userSrvc;
	    this.brioSrvc = brioSrvc;
	    $scope.msg = labelSrvc.getLabel;
	    this.deskSrvc = deskSrvc;
	
	    this.idRichiestaOrdineDiretto;
	    this.idRaccomandazioneOrdineDiretto;
	    this.ordineDiviso = [];
	    this.ordineDivisoTableLabel = [];
	    this.posizione = {};
	    this.dettaglioDossier = {};
	    this.currentTabMacro = {};
	    this.raccomandazione = {};
	    this.iniziativa = undefined;
	    this.profiloCliente = {};
	    this.proposteTableData = [];
	    this.proposteTableLabel = [];
	    this.portafoglioTableData = [];
	    this.portafoglioTableLabel = [];
	    this.listaRegoleStrumento = [];
	    this.totaleCtvTeorico = 0;
	    this.dossierAbilitato = undefined;
	    this.homeBankingAbilitato = false;
	    this.anagraficaFea = {};
	    this.esgAbilitato = false;
	    this.tmpLiquiditaAggiuntiva = 0;
	    this.liquiditaAggiuntiva = 0;
	    this.attivaLiquiditaAggiuntiva = false;
	    this.domain = {
	      listaTipologiaStrumento: []
	    };
	    this.spinner = {
	      portafoglio: true,
	      proposte: true,
	      raccomandazione: true,
	      listaDossier: false,
	      adeguatezza: true,
	      ba: true
	    };
	    this.richiestaProcessione = 'S';
	    this.regexTestoNota = new RegExp(!/^[a-zA-Z \u00E0-\u00FC'0-9,.;:]+$/i);
	    this.scontoMassivo = false;
	    this.segnalazioni = {};
	
	    this.bloccoAcquisti = false;
	    this.waitUser = true;
	    this.messaggiFctr.chiudiLoaderBrio();
	    var self = this;
	
	    this.mifidAbilitato = function () {
	      return userSrvc.abilitazioni.some(function (abilitazione) {
	        return (
	          abilitazione.codice.toLowerCase() ===
	          CONSTANTS.ABILITAZIONI.MIFID.toLowerCase()
	        );
	      });
	    };
	
	    userSrvc.abilitazioniPronte.then(function () {
	      self.esgAbilitato = userSrvc.abilitato(
	        CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA
	      );
	      self.attivaLiquiditaAggiuntiva =
	        userSrvc.liquiditaAggiuntivaAttiva &&
	        self.$stateParams.finIdRaccomandazione;
	    });
	
	    labelSrvc.labelsPronte.then(function () {
	      self.TAB_LIST_MACRO = [
	        {
	          index: 0,
	          url:
	            self.CONSTANTS.BASE_ROOT +
	            self.CONSTANTS.COMPONENTS_PATH +
	            'gestioneRaccomandazione/partials/inserimentoProposte.html',
	          title: $scope.msg('step.gestione.raccomandazione')
	        },
	        {
	          index: 1,
	          url:
	            self.CONSTANTS.BASE_ROOT +
	            self.CONSTANTS.COMPONENTS_PATH +
	            'gestioneRaccomandazione/partials/esitoRaccomandazione.html',
	          title: $scope.msg('step.esito.raccomandazione')
	        },
	        {
	          index: 2,
	          url:
	            self.CONSTANTS.BASE_ROOT +
	            self.CONSTANTS.COMPONENTS_PATH +
	            'gestioneRaccomandazione/partials/gestioneDocumenti.html',
	          title: $scope.msg('step.documenti')
	        },
	        {
	          index: 3,
	          url:
	            self.CONSTANTS.BASE_ROOT +
	            self.CONSTANTS.COMPONENTS_PATH +
	            'gestioneRaccomandazione/partials/gestioneOrdine.html',
	          title: $scope.msg('step.gestioneOrdine')
	        }
	      ];
	      //			Se provengo da Brio e non ho il codice Dossier
	      if (!self.$stateParams.finCodiceRapporto) {
	        self.promiseDettaglioRaccomandazione().then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.spinner.portafoglio = false;
	              self.spinner.proposte = false;
	              self.spinner.raccomandazione = false;
	              return;
	            }
	            if (response.data.result && response.data.result.raccomandazione) {
	              self.$stateParams.finCodiceRapporto =
	                response.data.result.raccomandazione.codiceDossierTitoli;
	              self.$state.go(self.$state.current.name, self.$stateParams, {
	                reload: true
	              });
	            } else {
	              self.spinner.portafoglio = false;
	              self.spinner.proposte = false;
	              self.spinner.raccomandazione = false;
	            }
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	            self.spinner.portafoglio = false;
	            self.spinner.proposte = false;
	            self.spinner.raccomandazione = false;
	          }
	        );
	      } else {
	        // Normale funzionamento
	        self.getCustomerDossier();
	        if (self.$stateParams.finIdRaccomandazione) {
	          self.initConIdRaccomandazione();
	        } else {
	          self.spinner.proposte = false;
	          self.initSenzaIdRaccomandazione();
	        }
	      }
	      self.checkAccettaRaccomandazione();
	    });
	
	    if (
	      self.$stateParams.finIdRaccomandazione &&
	      CONSTANTS.REST.SCONTO_MASSIVO
	    ) {
	      gestioneRaccomandazioneService
	        .promiseAbilitaScontoMassivo(self.$stateParams.finIdRaccomandazione)
	        .then(
	          function (res) {
	            if (self.messaggiFctr.processaResponse(res)) {
	              return;
	            }
	            self.scontoMassivo = res.data.result;
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        );
	    }
	    //
	    //		---------------------------- REST PROMISES ----------------------------
	    //
	
	    /**
	     * @ngdoc method
	     * @name promiseCustomerData
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua la chiamata per ricevere il customerdata
	     * @return {Promise} - Ritorna una promise contenente il customerdata
	     */
	    this.promiseCustomerData = function () {
	      return self.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
	        params: {
	          rapporto: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseEliminaProposta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per eliminare una proposta
	     */
	    this.promiseEliminaProposta = function (id) {
	      return self.$http({
	        method: 'DELETE',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PROPOSTA +
	          'cancellaProposta/' +
	          id
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDettaglioRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per ricevere il dettaglio di una raccomandazione
	     */
	    this.promiseDettaglioRaccomandazione = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          self.$stateParams.finIdRaccomandazione
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDominioStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per ricevere la lista delle tipologie strumento
	     */
	    this.promiseDominioFiltriStrumento = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'categoriaStrumenti'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaPortafoglio
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per ricevere la lista del portafoglio associate ad un dossier
	     */
	    this.promiseDatiTabellaPortafoglio = function () {
	      self.spinner.listaPortafoglio = true;
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          self.$stateParams.finCodiceRapporto +
	          '/saldi'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaProposte
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per ricevere la lista delle proposte associate ad un dossier
	     */
	    this.promiseDatiTabellaProposte = function () {
	      self.spinner.proposte = true;
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          self.$stateParams.finIdRaccomandazione +
	          '/proposte'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseListaDossier
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per ricevere la lista dei dossier associati ad un ndg
	     */
	    this.promiseListaDossier = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.DOSSIER +
	          'listaDossier/' +
	          self.$stateParams.ndg
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseConsolidaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per consolidare la raccomandazione
	     */
	    this.promiseConsolidaRaccomandazione = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          self.$stateParams.finIdRaccomandazione +
	          '/consolida'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseProfiloCliente
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description - Ritorna una promise contenente il profilo del cliente
	     */
	    this.promiseProfiloCliente = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          'profiloCliente/' +
	          self.dettaglioDossier.ndgIntestatario,
	        params: {
	          idDossier: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseMultivariata
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description - Ritorna una promise contenente i dati della multivariata della raccomandazione
	     */
	    this.promiseMultivariata = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          'punteggioMultivariata',
	        data: {
	          ndgCliente: self.dettaglioDossier.ndgIntestatario,
	          codiceRapporto: self.$stateParams.finCodiceRapporto,
	          idRaccomandazione: self.$stateParams.finIdRaccomandazione,
	          liquiditaAggiuntiva: self.liquiditaAggiuntiva
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseEsitoRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua la chiamata per portare la pratica in CONSOLIDATA - 2
	     */
	    this.promiseEsitoRaccomandazione = function () {
	      return this.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          self.$stateParams.finIdRaccomandazione +
	          '/esito'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseAccettaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per accettare la raccomandazione
	     */
	    this.promiseAccettaRaccomandazione = function () {
	      return self.$http({
	        method: 'POST',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          self.$stateParams.finIdRaccomandazione +
	          '/accetta/S'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseRifiutaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per rifiutare la raccomandazione
	     */
	    this.promiseRifiutaRaccomandazione = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          'rifiuta/' +
	          self.$stateParams.finIdRaccomandazione
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseRevisionaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per mandare in revisione la raccomandazione
	     */
	    this.promiseRevisionaRaccomandazione = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          'revisione/' +
	          self.$stateParams.finIdRaccomandazione +
	          '/' +
	          self.nota
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseTerminaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per terminare la raccomandazione
	     */
	    this.promiseTerminaRaccomandazione = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          'termina/' +
	          self.$stateParams.finIdRaccomandazione +
	          '/' +
	          self.richiestaProcessione
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDettaglioDossier
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per chiedere il dettaglio del dossier corrente
	     */
	    this.promiseDettaglioDossier = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.DOSSIER +
	          self.$stateParams.finCodiceRapporto
	      });
	    };
	
	    /**
	     * @ngod method
	     * @name promiseRegoleStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata http per chiedere le regole delle operazioni
	     * effettuabili dall'utente sul proprio saldoPortafoglio
	     */
	    this.promiseRegoleStrumento = function () {
	      return this.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'regoleStrumento'
	      });
	    };
	    /**
	     * @ngod method
	     * @name promiseGestioneOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Effettua una chiamata per ottenere la proposta suddivisa per tipo
	     * fondo/tuttiGliAltriTipi
	     */
	    this.promiseGestioneOrdine = function () {
	      return this.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          'gestioneOrdine/' +
	          self.$stateParams.finIdRaccomandazione +
	          '/' +
	          self.$stateParams.finCodiceRapporto
	      });
	    };
	    /**
	     * @ngdoc method
	     * @name promiseAddLiquiditaAggiuntiva
	     * @description aggiunge la liquidita aggiuntiva alla raccomandazione
	     */
	    this.promiseAddLiquiditaAggiuntiva = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          self.$stateParams.finIdRaccomandazione +
	          '/liquiditaAggiuntiva/' +
	          self.liquiditaAggiuntiva
	      });
	    };
	    this.buttonEnabled = function () {
	      self.tmpLiquiditaAggiuntiva < 0;
	    };
	    //
	    //		-------------------------- INIT LABEL TABELLE -------------------------
	    //
	    /**
	     * @ngdoc method
	     * @name initLabelTabellaPortafoglio
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Crea le label e la struttura della tabella del portafoglio
	     */
	    this.initLabelTabellaPortafoglio = function () {
	      self.portafoglioTableLabel = [
	        {
	          name: $scope.msg('lista.portafoglio.isin'),
	          field: 'strumento.isin',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.intestatario'),
	          field: 'intestatario',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.tipologia'),
	          field: 'strumento.categoriaStrumento.descrizione',
	          width: '*',
	          filter: {
	            type: uiGridConstants.filter.SELECT,
	            selectOptions: self.domain.listaTipologiaStrumento
	          }
	        },
	        {
	          name: $scope.msg('lista.portafoglio.descrizione'),
	          field: 'strumento.descrizione',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.divisa'),
	          field: 'strumento.divisa',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.quantita.disponibile'),
	          field: 'quantita',
	          cellFilter: self.userSrvc.doppiaPrecisioneQuantita
	            ? 'number : 6'
	            : 'number : 3',
	          cellClass: 'right',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.quantita'),
	          field: 'quantita',
	          cellFilter: self.userSrvc.doppiaPrecisioneQuantita
	            ? 'number : 6'
	            : 'number : 3',
	          cellClass: 'right',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.ctv.euro'),
	          field: 'valoreMercatoControvalore',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.rateo.netto.euro'),
	          field: 'ctvRateoNettoEuro',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.rateo.lordo.euro'),
	          field: 'ctvRateoLordoEuro',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.prezzo.mercato'),
	          field: 'prezzoMercato',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.prezzo.medio'),
	          field: 'prezzoCarico',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.portafoglio.plus.min'),
	          // field: 'bloccoAcquisti',
	          field: 'percPlusMinus',
	          cellClass: 'right',
	          width: '*',
	          enableFiltering: false
	        }
	      ];
	      if (
	        (self.modalita === self.CONSTANTS.MODALITA.NUOVA ||
	          self.modalita === self.CONSTANTS.MODALITA.MODIFICA) &&
	        self.userSrvc.numeroProposteAcquistabili > self.proposteTableData.length
	      ) {
	        self.portafoglioTableLabel.push({
	          field: 'bloccoAcquisti',
	          name: $scope.msg('lista.portafoglio.acquista.vendita'),
	          width: 120,
	          enableFiltering: false,
	          cellTemplate:
	            '<i class=\'fa fa-plus fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="row.entity.mostraBottoni && !gestioneCtrl.waitUser && !row.entity.bloccoAcquisti" uib-tooltip="{{grid.appScope.msg(\'tooltip.acquista\')}}" tooltip-placement="left" ng-click="grid.appScope.acquista({itemPortafoglio: row.entity})"></i>' +
	            '<i class=\'fa fa-minus fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="row.entity.mostraBottoni" uib-tooltip="{{grid.appScope.msg(\'tooltip.vendi\')}}" tooltip-placement="left" ng-click="grid.appScope.vendita({itemPortafoglio: row.entity})"></i>' +
	            '<i class=\'fa fa-exchange fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="!gestioneCtrl.waitUser && !row.entity.bloccoAcquisti && row.entity.mostraBottoni && row.entity.strumento.categoriaStrumento.descrizione === \'Fondo\'" uib-tooltip="{{grid.appScope.msg(\'tooltip.switch\')}}" tooltip-placement="left" ng-click="grid.appScope.cambio({itemPortafoglio: row.entity})"></i>'
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name initLabelTabellaProposte
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Crea le label e la struttura della tabella delle proposte
	     */
	    this.initLabelTabellaProposte = function () {
	      self.proposteTableLabel = [];
	      if (
	        self.userSrvc.abilitato(CONSTANTS.ABILITAZIONI.VERIFICA_PROPOSTE) ||
	        self.userSrvc.isBpa
	      ) {
	        self.proposteTableLabel.push({
	          name: '',
	          field: 'segno',
	          width: '20',
	          enableFiltering: false,
	          cellTemplate:
	            '<div class="ui-grid-cell-contents">' +
	            '   <i class="fa fa-exclamation" style="color: red; font-size: 20px;" ' +
	            '       ng-if="grid.appScope.segnalazioniProposte[row.entity.idProposta].length > 0"' +
	            '       ng-click="grid.appScope.leggiAlert({idProposta: row.entity.idProposta})" >' +
	            '   </i>' +
	            '</div>'
	        });
	      }
	      self.proposteTableLabel.push({
	        name: $scope.msg('lista.proposte.acq.ven'),
	        field: 'segno',
	        width: '*',
	        enableFiltering: false,
	        cellTemplate:
	          '<div class="ui-grid-cell-contents" ng-if="grid.appScope.msg(\'lista.proposte.a\') === row.entity.segno">{{grid.appScope.msg(\'lista.proposte.acq\')}}</div>' +
	          '<div class="ui-grid-cell-contents" ng-if="grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno">{{grid.appScope.msg(\'lista.proposte.ven\')}}</div>' +
	          '<div class="ui-grid-cell-contents" ng-ig="grid.appScope.msg(\'lista.proposte.s\') === row.entity.segno">{{grid.appScope.msg(\'lista.proposte.swi\')}}</div>'
	      });
	      self.proposteTableLabel.push({
	        name: $scope.msg('lista.proposte.titolo'),
	        field: 'DescrizioneStrumento',
	        width: '*',
	        enableFiltering: false
	      });
	      self.proposteTableLabel.push({
	        name: $scope.msg('lista.proposte.qta'),
	        field: 'quantita',
	        width: '*',
	        enableFiltering: false
	      });
	      self.proposteTableLabel.push({
	        name: $scope.msg('lista.proposte.ctv.teorico'),
	        cellFilter: 'number : 2',
	        cellClass: 'right',
	        field: 'ctvPrevisto',
	        width: '*',
	        enableFiltering: false
	      });
	      self.proposteTableLabel.push({
	        name: $scope.msg('lista.proposte.intestatario'),
	        field: 'Intestazione',
	        width: '*',
	        enableFiltering: false
	      });
	      self.proposteTableLabel.push({
	        name: $scope.msg('lista.proposte.rischio.complessita'),
	        field: 'rischioComplessita',
	        width: '*',
	        enableFiltering: false,
	        cellClass: 'center',
	        cellTemplate:
	          '<i class="fa fa-circle fa-2x finITable" ng-class="{finIGreen : (row.entity.profiloAppropriatezza >= row.entity.rischioComplessita || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno), finIOrange: !(row.entity.profiloAppropriatezza >= row.entity.rischioComplessita || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno)}" aria-hidden="true"></i>'
	      });
	      self.proposteTableLabel.push({
	        name: $scope.msg('lista.proposte.rischio.emittente'),
	        field: 'rischioEmittente',
	        width: '*',
	        enableFiltering: false,
	        cellClass: 'center',
	        cellTemplate:
	          '<i class="fa fa-circle fa-2x finITable" ng-class="{finIGreen : (row.entity.profiloAdeguatezza >= row.entity.rischioEmittente || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno), finIOrange: !(row.entity.profiloAdeguatezza >= row.entity.rischioEmittente || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno)}" aria-hidden="true"></i>'
	      });
	      self.proposteTableLabel.push({
	        name: $scope.msg('lista.proposte.rischio.mercato'),
	        field: 'rischioMercato',
	        width: '*',
	        enableFiltering: false,
	        cellClass: 'center',
	        cellTemplate:
	          '<i class="fa fa-circle fa-2x finITable" ng-class="{finIGreen : (row.entity.profiloAdeguatezza >= row.entity.rischioMercato || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno), finIOrange: !(row.entity.profiloAdeguatezza >= row.entity.rischioMercato || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno)}" aria-hidden="true"></i>'
	      });
	      self.proposteTableLabel.push({
	        name: $scope.msg('lista.proposte.rischio.liquidita'),
	        field: 'rischioLiquidita',
	        width: '*',
	        enableFiltering: false,
	        cellClass: 'center',
	        cellTemplate:
	          '<i class="fa fa-circle fa-2x finITable" ng-class="{finIGreen : (row.entity.rischioLiquidita <= row.entity.orizzonteTemporale || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno), finIOrange: !(row.entity.rischioLiquidita <= row.entity.orizzonteTemporale || grid.appScope.msg(\'lista.proposte.d\') === row.entity.segno)}" aria-hidden="true"></i>'
	      });
	      // TODO ESG
	      if (self.esgAbilitato) {
	        self.proposteTableLabel.push({
	          name: $scope.msg('gestione.proposta.esg'),
	          field: 'rischioESG',
	          width: '*',
	          enableFiltering: false,
	          cellClass: 'center',
	          cellTemplate:
	            '<i class="fa fa-circle fa-2x finITable" ng-class="{' +
	            "finIGreen : row.entity.controlloEsg.esito === 'OK'," +
	            "finIOrange: row.entity.controlloEsg.esito === 'WARNING'," +
	            'finIRed: row.entity.controlloEsg.esito === \'KO\'}" aria-hidden="true"></i>'
	        });
	      }
	      //			Se siamo in modalita visualizza faccio visualizzare soltanto la lente di ingarandimento per visualizzare le proposte
	      if (self.modalita === self.CONSTANTS.MODALITA.VISUALIZZA) {
	        self.proposteTableLabel.push({
	          name: $scope.msg('lista.proposte.azione'),
	          field: 'azione',
	          enableFiltering: false,
	          width: 60,
	          cellTemplate:
	            '<i class="fa fa-search fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaProposta({proposta: row.entity});"></i>'
	        });
	      } else {
	        if (
	          self.raccomandazione.stato ===
	          self.CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO
	        ) {
	          self.proposteTableLabel.push({
	            name: $scope.msg('lista.proposte.azione'),
	            field: 'azione',
	            enableFiltering: false,
	            width: 120,
	            cellTemplate:
	              '<i class="fa fa-pencil fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" tooltip-placement="left" ng-click="grid.appScope.modificaProposta({proposta: row.entity});"></i>' +
	              '<i class="fa fa-trash fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.elimina\')}}" tooltip-placement="left" ng-click="grid.appScope.eliminaProposta({proposta: row.entity})"></i>' +
	              '<i class="fa fa-search fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaProposta({proposta: row.entity});"></i>'
	          });
	        } else {
	          self.proposteTableLabel.push({
	            name: $scope.msg('lista.proposte.azione'),
	            field: 'azione',
	            enableFiltering: false,
	            width: 60,
	            cellTemplate:
	              '<i class="fa fa-search fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaProposta({proposta: row.entity});"></i>'
	          });
	        }
	      }
	    };
	    this.initOrdineDivisoTableLabel = function () {
	      self.ordineDivisoTableLabel = [];
	
	      self.ordineDivisoTableLabel.push({
	        name: 'IdRichiesta',
	        field: 'idRichiesta',
	        width: '*',
	        enableFiltering: false,
	        class: 'center'
	      });
	      self.ordineDivisoTableLabel.push({
	        name: 'Codice dossier',
	        field: 'codiceDossier',
	        width: '*',
	        enableFiltering: false,
	        class: 'center'
	      });
	      self.ordineDivisoTableLabel.push({
	        name: 'Tipologia',
	        field: 'tipologia.descrizione',
	        width: '*',
	        enableFiltering: false,
	        class: 'center'
	      });
	      self.ordineDivisoTableLabel.push({
	        name: 'Id raccomandazione',
	        field: 'idRaccomandazione',
	        width: '*',
	        enableFiltering: false,
	        class: 'center'
	      });
	      self.ordineDivisoTableLabel.push({
	        name: 'Data inserimento',
	        field: 'dataInserimento',
	        cellFilter: 'date: "dd/MM/yyyy"',
	        width: '*',
	        enableFiltering: false,
	        class: 'center'
	      });
	      self.ordineDivisoTableLabel.push({
	        name: 'Stato',
	        field: 'stato',
	        width: '*',
	        enableFiltering: false,
	        class: 'center'
	      });
	      self.ordineDivisoTableLabel.push({
	        name: 'Data Scadenza',
	        field: 'dataScadenza',
	        cellFilter: 'date: "dd/MM/yyyy"',
	        width: '*',
	        enableFiltering: false,
	        class: 'center'
	      });
	      self.ordineDivisoTableLabel.push({
	        name: $scope.msg('lista.proposte.azione'),
	        field: 'azione',
	        enableFiltering: false,
	        width: 120,
	        cellTemplate:
	          '<i class="fa fa-pencil fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" tooltip-placement="left" ng-if="row.entity.stato === \'INCORSO\'"  ng-click="grid.appScope.inserisciOrdine({propostaOrdine:row.entity});"></i>' +
	          '<i class="fa fa-search fa-2x finIMargin finIPointer" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaRichiesta({propostaOrdine:row.entity});"></i>'
	      });
	    };
	    //
	    //		--------------------------- INIT CONTROLLER ---------------------------
	    //
	    /**
	     * @ngdoc method
	     * @name initConIdRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Inizializza il component tenendo conto della presenza di un id raccomandazione
	     */
	    this.initConIdRaccomandazione = function () {
	      $q.all({
	        raccomandazione: self.promiseDettaglioRaccomandazione(),
	        portafoglio: self.promiseDatiTabellaPortafoglio(),
	        proposte: self.promiseDatiTabellaProposte(),
	        filtriStrumento: self.promiseDominioFiltriStrumento(),
	        regoleStrumento: self.promiseRegoleStrumento(),
	        ordineDiviso: self.promiseGestioneOrdine()
	      })
	        .then(
	          function (response) {
	            if (
	              self.messaggiFctr.processaResponse(response.raccomandazione) ||
	              self.messaggiFctr.processaResponse(response.portafoglio) ||
	              self.messaggiFctr.processaResponse(response.proposte) ||
	              self.messaggiFctr.processaResponse(response.filtriStrumento) ||
	              self.messaggiFctr.processaResponse(response.regoleStrumento)
	            ) {
	              self.spinner.raccomandazione = false;
	              self.raccomandazione =
	                gestioneRaccomandazioneService.raccomandazione = {};
	              self.portafoglioTableData = [];
	              self.proposteTableData = [];
	              self.filtriStrumento = [];
	              self.listaRegoleStrumento = [];
	              return;
	            }
	            self.raccomandazione =
	              gestioneRaccomandazioneService.raccomandazione =
	                response.raccomandazione.data.result.raccomandazione;
	            self.liquiditaAggiuntiva =
	              response.raccomandazione.data.result.liquiditaAggiuntiva;
	            self.checkStatoPraticaInValutazione();
	            self.setAnagraficaFea();
	            self.adeguata = response.raccomandazione.data.result.adeguata;
	            self.iniziativa = response.raccomandazione.data.result.iniziativa;
	            self.portafoglioTableData = response.portafoglio.data.result;
	            self.ordineDiviso = response.ordineDiviso.data.result;
	            self.initOrdineDivisoTableLabel();
	            self.listaRegoleStrumento = response.regoleStrumento.data.result;
	            self.checkRegoleStrumento();
	            self.proposteTableData = response.proposte.data.result
	              ? response.proposte.data.result
	              : [];
	            self.initLabelTabellaPortafoglio();
	            self.initLabelTabellaProposte();
	            response.filtriStrumento.data.result.forEach(function (item) {
	              self.domain.listaTipologiaStrumento.push({
	                label: item.descrizione,
	                value: item.codice
	              });
	            });
	            // 				Setto l'inverso della somma dei controvalori delle proposte
	            if (self.proposteTableData && self.proposteTableData.length) {
	              self.proposteTableData.forEach(function (el) {
	                self.totaleCtvTeorico += el.ctvPrevisto;
	              });
	              self.totaleCtvTeorico *= -1;
	            }
	            self.checkRightStep();
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason.raccomandazione);
	            self.messaggiFctr.processaResponse(reason.portafoglio);
	            self.messaggiFctr.processaResponse(reason.proposte);
	            self.messaggiFctr.processaResponse(reason.filtriStrumento);
	            self.messaggiFctr.processaResponse(reason.regoleStrumento);
	            self.spinner.raccomandazione = false;
	            self.raccomandazione =
	              gestioneRaccomandazioneService.raccomandazione = {};
	            self.portafoglioTableData = [];
	            self.proposteTableData = [];
	            self.filtriStrumento = [];
	            self.listaRegoleStrumento = [];
	          }
	        )
	        .finally(function () {
	          self.spinner.portafoglio = false;
	          self.spinner.proposte = false;
	        });
	      if (gestioneRaccomandazioneService.forzaControlli) {
	        gestioneRaccomandazioneService.forzaControlli = false;
	        self.checkProposte();
	      }
	    };
	
	    this.checkProposte = function () {
	      var defer = $q.defer();
	      self.spinner.proposte = true;
	      gestioneRaccomandazioneService
	        .promiseCheckProposte(
	          self.$stateParams.finCodiceRapporto,
	          self.$stateParams.finIdRaccomandazione
	        )
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.spinner.proposte = false;
	              defer.reject(false);
	              return;
	            }
	            self.segnalazioni = {};
	            var segnalazioniPresenti = false;
	            if (response.data.result) {
	              response.data.result.forEach(function (segnalazione) {
	                self.segnalazioni[segnalazione.idProposta] =
	                  segnalazione.segnalazioni;
	                if (segnalazione.segnalazioni) {
	                  segnalazione.segnalazioni.forEach(function (s) {
	                    if (s.livello === 'ERRORE' || s.livello === 'ERROR') {
	                      segnalazioniPresenti = true;
	                    }
	                  });
	                }
	              });
	            }
	            self.spinner.proposte = false;
	            if (segnalazioniPresenti) {
	              self.messaggiFctr.addMessage({
	                type: 'E',
	                message: 'Segnalazioni presenti'
	              });
	              defer.reject(false);
	              return;
	            }
	            defer.resolve(true);
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	            self.spinner.proposte = false;
	            defer.reject(false);
	          }
	        );
	      return defer.promise;
	    };
	
	    this.leggiAlert = function (idProposta) {
	      gestioneRaccomandazioneService.segnalazioniProposta =
	        self.segnalazioni[idProposta];
	      gestioneRaccomandazioneService.propostaSegnalata = idProposta;
	
	      var modalScontoMassivo = $uibModal.open({
	        animation: true,
	        templateUrl:
	          CONSTANTS.BASE_ROOT +
	          CONSTANTS.COMPONENTS_PATH +
	          'modalAlertProposte/modalAlertProposte.html',
	        size: 'lg',
	        controller: 'ModalAlertProposte',
	        controllerAs: 'controller'
	      });
	
	      modalScontoMassivo.result.then(
	        function () {
	          gestioneRaccomandazioneService.segnalazioniProposta = [];
	          gestioneRaccomandazioneService.propostaSegnalata = null;
	        },
	        function () {
	          gestioneRaccomandazioneService.segnalazioniProposta = [];
	          gestioneRaccomandazioneService.propostaSegnalata = null;
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name initSenzaIdRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Inizializza il component nel caso in cui siamo in una nuova raccomandazione
	     */
	    this.initSenzaIdRaccomandazione = function () {
	      $q.all({
	        portafoglio: self.promiseDatiTabellaPortafoglio(),
	        filtriStrumento: self.promiseDominioFiltriStrumento(),
	        regoleStrumento: self.promiseRegoleStrumento()
	      })
	        .then(
	          function (response) {
	            if (
	              self.messaggiFctr.processaResponse(response.portafoglio) ||
	              self.messaggiFctr.processaResponse(response.filtriStrumento) ||
	              self.messaggiFctr.processaResponse(response.regoleStrumento)
	            ) {
	              self.spinner.raccomandazione = false;
	              self.filtriStrumento = [];
	              self.portafoglioTableData = [];
	              self.listaRegoleStrumento = [];
	              return;
	            }
	            response.filtriStrumento.data.result.forEach(function (item) {
	              self.domain.listaTipologiaStrumento.push({
	                label: item.descrizione,
	                value: item.codice
	              });
	            });
	            self.portafoglioTableData = response.portafoglio.data.result;
	            self.listaRegoleStrumento = response.regoleStrumento.data.result;
	            self.checkRegoleStrumento();
	            self.initLabelTabellaPortafoglio();
	            self.checkRightStep();
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason.portafoglio);
	            self.messaggiFctr.processaResponse(reason.filtriStrumento);
	            self.messaggiFctr.processaResponse(reason.regoleStrumento);
	            self.spinner.raccomandazione = false;
	            self.listaRegoleStrumento = [];
	            self.filtriStrumento = [];
	            self.portafoglioTableData = [];
	          }
	        )
	        .finally(function () {
	          self.spinner.portafoglio = false;
	        });
	    };
	
	    //
	    //		---------------------------- HELPER METHOD ----------------------------
	    //
	    /**
	     * @ngdoc method
	     * @name checkAccettaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Controllo se ho l'abilitazione per poter mostrare il radio button Home Banking
	     * ovvero se la funzione ACCETTARACCOMAN è abilitata
	     */
	    this.checkAccettaRaccomandazione = function () {
	      self.userSrvc.abilitazioniPronte.then(function (value) {
	        if (value) {
	          self.homeBankingAbilitato = self.userSrvc.abilitazioni.some(function (
	            abilitazione
	          ) {
	            return (
	              abilitazione.codice.toLowerCase() ===
	              self.CONSTANTS.ABILITAZIONI.ACCETTA_RACCOMANDAZIONE.toLowerCase()
	            );
	          });
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name getCustomerDossier
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Dicide quale servizio per il customer dossier richiamare
	     */
	    this.getCustomerDossier = function () {
	      // Chiamo il getDossier per inserire le info nel customerdata
	      self.promiseCustomerData().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.posizione = {};
	            return;
	          }
	          self.posizione = response.data;
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    this.promiseMifid = function () {
	      return $http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          self.$stateParams.finCodiceRapporto +
	          '/' +
	          self.$stateParams.ndg +
	          '/recuperaAlertScadenzaMifid'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkRegexNota
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Ritorna true se il testo passato rispetta il pattern per le note
	     */
	    this.checkRegexNota = function (testo) {
	      return self.regexTestoNota.test(testo);
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkStatoPraticaInValutazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Se siamo in INCORSO, PRESENTATA o VALUTAZIONE e
	     * la pratica è in uno stato diverso da PRESENTATA
	     * effettuo il redirect allo stato di visualizzazione
	     */
	    this.checkStatoPraticaInValutazione = function () {
	      var statiRaccomandazioneModificabile = [
	        self.CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO,
	        self.CONSTANTS.STATO_RACCOMANDAZIONE.PRESENTATA,
	        self.CONSTANTS.STATO_RACCOMANDAZIONE.CONSOLIDATA,
	        self.CONSTANTS.STATO_RACCOMANDAZIONE.DA_REVISIONARE
	      ];
	      //			Se lo stato della raccomandazione non è compreso tra quelli soprastanti
	      //			e la modalità è valutazione vado in modalità visualizza
	      if (
	        statiRaccomandazioneModificabile.indexOf(self.raccomandazione.stato) ===
	          -1 &&
	        self.modalita === self.CONSTANTS.MODALITA.VALUTAZIONE
	      ) {
	        self.$stateParams.esterno = true;
	        self.$state.go(self.visualizzaRaccomandazioneState, self.$stateParams, {
	          reload: true
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name setAnagraficaFea
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Costruisce l'oggetto anagraficaFea
	     */
	    this.setAnagraficaFea = function () {
	      self.anagraficaFea = {
	        idAnagrafica: self.raccomandazione.intestatario.idAnagrafica,
	        ndg: self.raccomandazione.intestatario.ndg,
	        naturaGiuridica: self.raccomandazione.intestatario.formaCostitutiva
	      };
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkRegoleStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Gestisce l'array del saldoPortafoglio e decide
	     * se mostrare o meno i bottoni di Acquisto, Vendita e Switch
	     */
	    this.checkRegoleStrumento = function () {
	      self.portafoglioTableData.forEach(function (portafoglio) {
	        //				Imposta la proprietà mostraBottoniPortafoglio per ciascun saldo in base alle regole dello strumento
	        portafoglio['mostraBottoni'] = self.listaRegoleStrumento.some(function (
	          regola
	        ) {
	          var ruolo = false;
	          //					Se siamo in brio forkato le logiche cambiano
	          if (self.brioSrvc.brioVersion === 'brio-xc') {
	            //						Se siamo in filiale effettuo un controllo diverso rispetto a promotore
	            if (self.userSrvc.canaleOperativo === 'filialefxc') {
	              ruolo =
	                !regola.ruolo ||
	                regola.ruolo.toLowerCase().trim() === 'filiale';
	            } else {
	              ruolo =
	                !regola.ruolo || regola.ruolo.toLowerCase().trim() === 'brio';
	            }
	          } else {
	            //						Se siamo in brio vecchio controllo su un altro campo
	            ruolo =
	              !regola.ruolo ||
	              regola.ruolo.toLowerCase().trim() ===
	                self.userSrvc.user.app.toLowerCase().trim();
	          }
	          var categoria =
	            (!regola.categoria ||
	              regola.categoria.toLowerCase().trim() ===
	                (portafoglio.strumento.categoriaStrumento.codice
	                  ? portafoglio.strumento.categoriaStrumento.codice
	                      .toLowerCase()
	                      .trim()
	                  : '')) &&
	            regola.categoria.toLowerCase().trim() !== 'pog';
	          var isin =
	            !regola.isin ||
	            regola.isin.toLowerCase().trim() ===
	              portafoglio.strumento.isin.toLowerCase().trim();
	          var emittente =
	            !regola.emittente ||
	            regola.emittente.toLowerCase().trim() ===
	              portafoglio.strumento.emittente.toLowerCase().trim();
	          return ruolo && categoria && isin && emittente;
	        });
	      });
	
	      userSrvc.abilitazioniPronte
	        .then(function () {
	          if (self.mifidAbilitato()) {
	            self
	              .promiseMifid()
	              .then(function (res) {
	                if (res.data.result) {
	                  self.bloccoAcquisti = res.data.result.some(function (blocco) {
	                    return (
	                      blocco.statoScadenza === 'SCADUTO' ||
	                      blocco.statoScadenza === 'PPROSSIMO_A_SCADERE'
	                    );
	                  });
	                  self.portafoglioTableData.forEach(function (entity) {
	                    entity.bloccoAcquisti = self.bloccoAcquisti;
	                  });
	                }
	              })
	              .finally(function () {
	                self.spinner.ba = false;
	              });
	          } else {
	            self.spinner.ba = false;
	          }
	        })
	        .finally(function () {
	          self.waitUser = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkRightStep
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Seleziona il giusto step in cui reindirizzare l'utente
	     */
	    this.checkRightStep = function () {
	      //			Se c'è idRaccomandazione devo gestire lo stato in cui si trova
	      if (self.$stateParams.finIdRaccomandazione) {
	        if (self.modalita === self.CONSTANTS.MODALITA.VISUALIZZA) {
	          //					Chiamo il dossier perché mi serve nel rest del profiloCliente
	          self.promiseDettaglioDossier().then(
	            function (response) {
	              if (self.messaggiFctr.processaResponse(response)) {
	                self.spinner.raccomandazione = false;
	                return;
	              }
	              self.dettaglioDossier = response.data.result;
	              self.getEsitoRaccomandazione();
	            },
	            function (reason) {
	              self.spinner.raccomandazione = false;
	              self.messaggiFctr.processaResponse(reason);
	            }
	          );
	        } else {
	          switch (self.raccomandazione.stato) {
	            case self.CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO:
	              sessionStorage.getItem('isFromGestioneOrdine')
	                ? self.changeTabMacro(self.TAB_LIST_MACRO[3])
	                : self.changeTabMacro(self.TAB_LIST_MACRO[0]);
	              sessionStorage.removeItem('isFromGestioneOrdine');
	              self.spinner.raccomandazione = false;
	              break;
	            case self.CONSTANTS.STATO_RACCOMANDAZIONE.ANNULLATA:
	            case self.CONSTANTS.STATO_RACCOMANDAZIONE.RIFIUTATA:
	            case self.CONSTANTS.STATO_RACCOMANDAZIONE.ACCETTATA:
	              sessionStorage.getItem('isFromGestioneOrdine')
	                ? self.changeTabMacro(self.TAB_LIST_MACRO[3])
	                : self.changeTabMacro(self.TAB_LIST_MACRO[0]);
	              sessionStorage.removeItem('isFromGestioneOrdine');
	              self.spinner.raccomandazione = false;
	              break;
	            case self.CONSTANTS.STATO_RACCOMANDAZIONE.CONSOLIDATA:
	            case self.CONSTANTS.STATO_RACCOMANDAZIONE.DA_REVISIONARE:
	              switch (self.raccomandazione.step) {
	                case 0:
	                  //							Chiamo il dossier perché mi serve nel rest del profiloCliente
	                  self.promiseDettaglioDossier().then(
	                    function (response) {
	                      if (self.messaggiFctr.processaResponse(response)) {
	                        self.spinner.raccomandazione = false;
	                        return;
	                      }
	                      self.dettaglioDossier = response.data.result;
	                      self.getEsitoRaccomandazione();
	                    },
	                    function (reason) {
	                      self.spinner.raccomandazione = false;
	                      self.messaggiFctr.processaResponse(reason);
	                    }
	                  );
	                  break;
	                case 1:
	                case 2:
	                case 3:
	                case 4:
	                case 5:
	                case 6:
	                  self.spinner.raccomandazione = false;
	                  self.changeTabMacro(self.TAB_LIST_MACRO[2]);
	                  break;
	              }
	              break;
	            case self.CONSTANTS.STATO_RACCOMANDAZIONE.PRESENTATA:
	              self.getDettaglioDossier();
	              self.spinner.raccomandazione = false;
	              // 							Se filiale entro allo step 1 altrimenti step 0
	              if (self.userSrvc.user.app === 'filiale') {
	                self.changeTabMacro(self.TAB_LIST_MACRO[1]);
	              } else {
	                self.changeTabMacro(self.TAB_LIST_MACRO[0]);
	              }
	              break;
	          }
	        }
	      } else {
	        //				Non c'è id quindi sono in creazione
	        self.spinner.raccomandazione = false;
	        self.changeTabMacro(self.TAB_LIST_MACRO[0]);
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name getDatiRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Recupera i dati di una raccomandazione e inizializza l'oggetto fea per i documenti
	     */
	    this.getDatiRaccomandazione = function () {
	      self
	        .promiseDettaglioRaccomandazione()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            self.raccomandazione =
	              gestioneRaccomandazioneService.raccomandazione =
	                response.data.result.raccomandazione;
	            self.adeguata = response.data.result.adeguata;
	            self.iniziativa = response.data.result.iniziativa;
	            self.setAnagraficaFea();
	            self.checkRightStep();
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.raccomandazione = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name getEsitoRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Chiama i rest del profiloCliente e multivariata per l'esito della raccomandazione
	     */
	    this.getEsitoRaccomandazione = function () {
	      self.spinner.raccomandazione = true;
	      self.spinner.adeguatezza = true;
	      $q.all({
	        profiloCliente: self.promiseProfiloCliente(),
	        multivariata: self.promiseMultivariata()
	      })
	        .then(
	          function (response) {
	            if (
	              self.messaggiFctr.processaResponse(response.profiloCliente) ||
	              self.messaggiFctr.processaResponse(response.multivariata)
	            ) {
	              self.profiloCliente = {};
	              self.multivariata = {};
	              return;
	            }
	            self.profiloCliente = response.profiloCliente.data.result;
	            self.multivariata = response.multivariata.data.result;
	
	            if (sessionStorage.getItem('isFromGestioneOrdine')) {
	              sessionStorage.removeItem('isFromGestioneOrdine');
	              self.changeTabMacro(self.TAB_LIST_MACRO[3]);
	            } else {
	              self.changeTabMacro(self.TAB_LIST_MACRO[1]);
	            }
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(response);
	            self.profiloCliente = {};
	            self.multivariata = {};
	          }
	        )
	        .finally(function () {
	          self.spinner.raccomandazione = false;
	          self.spinner.adeguatezza = false;
	        });
	    };
	    /**
	     * @ngdoc method
	     * @name setListaDossier
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Riempie la lista dossier
	     */
	    this.setListaDossier = function () {
	      self
	        .promiseListaDossier()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            self.listaDossier = self.rimuoviDossierNonValidi(
	              response.data.result
	            );
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.listaDossier = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name rimuoviDossierNonValidi
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Rimuove dalla lista dei dossier quelli non validi
	     * (estinti o non abilitati né a Consulenza né alla gestione degli ordini)
	     * @param {Array} - Array completo dei dossier
	     * @return {Array} - Array con dossier non validi rimossi
	     */
	    this.rimuoviDossierNonValidi = function (arrayDossier) {
	      return arrayDossier.filter(function (dossier) {
	        // Tengo i dossier con dataChiusura a null e quelli che soddisfano la condizione sottostante
	        return (
	          dossier.dataChiusura === null &&
	          dossier.datiMifid.attivitaConsob.some(function (abilitazione) {
	            // Controllo che ci sia almeno una delle due abilitazioni
	            return (
	              abilitazione.codice.trim() === 'B' ||
	              abilitazione.codice.trim() === 'D'
	            );
	          })
	        );
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name getDettaglioDossier
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Riceve il dettalgio del dossier
	     */
	    this.getDettaglioDossier = function () {
	      self.spinner.listaDossier = true;
	      self.promiseDettaglioDossier().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.spinner.listaDossier = false;
	            return;
	          }
	          self.dettaglioDossier = response.data.result;
	          self.getEsitoRaccomandazione();
	          self.checkAbilitazioniOrdini();
	        },
	        function (reason) {
	          self.spinner.listaDossier = false;
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkAbilitazioniOrdini
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Verifica che il dossier sia abilitato alla raccolta degli ordini
	     */
	    this.checkAbilitazioniOrdini = function () {
	      //			Verifica che l'array attivitaConsob sia abilitato alla raccolta degli ordini
	      self.dossierAbilitato =
	        self.dettaglioDossier.datiMifid.attivitaConsob.some(function (
	          abilitazione
	        ) {
	          return (
	            abilitazione.codice.trim() === 'B' ||
	            abilitazione.codice.trim() === 'D'
	          );
	        });
	      if (self.dossierAbilitato === false) {
	        self.setListaDossier();
	      } else {
	        self.spinner.listaDossier = false;
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name getStyleTabMacro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Riceve la classe appropriata per la colorazione del macro
	     * @param {Number} currentTabIndex - L'indice del tab corrente
	     * @return {String} - Il nome della classe per settare il colore del macro
	     */
	    this.getStyleTabMacro = function (currentTabIndex) {
	      if (currentTabIndex < self.currentTabMacro.index) {
	        return 'progress-pass';
	      }
	      if (currentTabIndex === self.currentTabMacro.index) {
	        return 'progress-current';
	      }
	      return 'progress-next';
	    };
	
	    /**
	     * @ngdoc method
	     * @name getStyleTabMacroReadOnly
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Riceve la classe appropriata per la colorazione del macro (soltanto per la modalita visualizza)
	     * @param {Number} currentTabIndex - L'indice del tab corrente
	     * @return {String} - Il nome della classe per settare il colore del macro
	     */
	    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
	      if (currentTabIndex < this.currentTabMacro.index) {
	        return 'progress-next-read';
	      }
	      if (currentTabIndex === this.currentTabMacro.index) {
	        return 'progress-current-read';
	      }
	      return 'progress-next-read';
	    };
	    this.inserisciOrdine = function (propostaOrdine) {
	      self.$stateParams.finIdRaccomandazione = propostaOrdine.idRaccomandazione;
	      self.$stateParams.finIdRichiesta = propostaOrdine.idRichiesta;
	      if (self.modalita === 'visualizza') {
	        sessionStorage.setItem('isFromGestioneOrdine', true);
	        sessionStorage.setItem('isVisualizza', true);
	      }
	      if (self.modalita === 'modifica') {
	        sessionStorage.setItem('isFromGestioneOrdine', true);
	        sessionStorage.setItem('isModifica', true);
	      }
	      self.$state.go('gestionerichiesta', self.$stateParams);
	    };
	    this.visualizzaRichiesta = function (propostaOrdine) {
	      self.$stateParams.finIdRaccomandazione = propostaOrdine.idRaccomandazione;
	      self.$stateParams.finIdRichiesta = propostaOrdine.idRichiesta;
	      sessionStorage.setItem('isFromGestioneOrdine', true);
	      sessionStorage.setItem('isVisualizza', true);
	      self.$state.go('visualizzarichiesta', self.$stateParams);
	    };
	    //
	    //		--------------------------- BUTTONS METHOD ----------------------------
	    //
	
	    this.apriMassivo = function () {
	      var modalScontoMassivo = $uibModal.open({
	        animation: true,
	        templateUrl:
	          CONSTANTS.BASE_ROOT +
	          CONSTANTS.COMPONENTS_PATH +
	          'modalScontoMassivo/modalScontoMassivo.html',
	        size: 'xl',
	        controller: 'ModalScontoMassivoController',
	        controllerAs: 'controller'
	      });
	
	      modalScontoMassivo.result.then(
	        function (res) {},
	        function (reason) {}
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name changeTabMacro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Setta il tab attuale
	     * @param {Object} tab - L'oggetto tab che deve essere setatto come attuale
	     */
	    this.changeTabMacro = function (tab) {
	      self.currentTabMacro = tab;
	      self.messaggiSrvc.reset();
	    };
	
	    /**
	     * @ngdoc method
	     * @name avanti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Avanza allo step successivo
	     */
	    this.avanti = function () {
	      self.changeTabMacro(self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]);
	    };
	
	    /**
	     * @ngdoc method
	     * @name indietro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Ritorna allo step precedente
	     */
	    this.indietro = function () {
	      if (self.deskSrvc.isDesk) {
	        self.deskSrvc.popEntry();
	      }
	      switch (self.brioSrvc.brioVersion) {
	        case 'brio2':
	        case 'brio3':
	          self.$stateParams.idAnagrafica = self.anagraficaFea.idAnagrafica;
	          self.$state.go('schedaCliente', self.$stateParams);
	          break;
	        case 'brio-xc':
	          var parametri = [
	            {
	              chiave: 'idAnagrafica',
	              valore: self.anagraficaFea.idAnagrafica
	            }
	          ];
	          self.brioSrvc.goTo(
	            'scrivaniautente',
	            'home.schedacliente',
	            parametri
	          );
	          break;
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name esci
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Se è presente il parametro esterno torna su Brio altrimenti torna al saldoDossier
	     */
	    this.esci = function () {
	      if (self.deskSrvc.isDesk) {
	        self.deskSrvc.popEntry();
	      }
	      if (self.$stateParams.esterno === 'true') {
	        switch (self.brioSrvc.brioVersion) {
	          case 'brio2':
	          case 'brio3':
	            self.$stateParams.idAnagrafica = self.anagraficaFea.idAnagrafica;
	            self.$state.go('schedaCliente', self.$stateParams);
	            break;
	          case 'brio-xc':
	            var parametri = [
	              //	    				{
	              //	    					chiave: 'idAnagrafica',
	              //	    					valore: self.anagrafica.idAnagrafica
	              //	    				}
	              {
	                chiave: 'ndg',
	                valore: self.$stateParams.ndg
	              }
	            ];
	            self.brioSrvc.goTo(
	              'scrivaniautente',
	              'home.schedacliente',
	              parametri
	            );
	            break;
	        }
	      } else {
	        // self.$window.history.back();
	        if (
	          sessionStorage.getItem('isFromSchedaDossier') &&
	          sessionStorage.getItem('isFromSchedaDossier') === 'true'
	        ) {
	          sessionStorage.removeItem('isFromSchedaDossier');
	          self.$state.go('schedaDossier', self.$stateParams);
	        } else {
	          self.$state.go(self.saldoDossierState, self.$stateParams);
	        }
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name nuovaProposta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Va nello stato di creazione delle proposte
	     */
	    this.nuovaProposta = function () {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.a');
	      if (!!self.iniziativa) {
	        self.$stateParams.finIniziativa = self.iniziativa;
	      }
	      self.$state.go(self.nuovaPropostaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name modificaProposta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Va nello stato di gestione della proposta
	     * @param {Object} proposta - Oggetto proposta da modificare
	     */
	    this.modificaProposta = function (proposta) {
	      self.$stateParams.acqven = proposta.segno;
	      self.$stateParams.finIdProposta = proposta.idProposta;
	      self.$stateParams.finCodiceStrumento = proposta.strumento.trim();
	      self.$state.go(self.modificaPropostaState, self.$stateParams);
	    };
	
	    /**
	     * @method
	     * @name visualizzaProposta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Entra nello stato di visualizzazione di una proposta
	     * @param {Object} proposta - Oggetto proposta da visualizzare
	     */
	    this.visualizzaProposta = function (proposta) {
	      self.$stateParams.acqven = proposta.segno;
	      self.$stateParams.finIdProposta = proposta.idProposta;
	      self.$stateParams.finCodiceStrumento = proposta.strumento.trim();
	      self.$state.go(self.visualizzaPropostaState, $stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name acquista
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Entra nello stato nuova proposta con modalita acquisto
	     */
	    this.acquista = function (itemPortafoglio) {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.a');
	      self.$stateParams.finCodiceStrumento =
	        itemPortafoglio.strumento.codice.trim();
	      self.$stateParams.finIntestatarioStrumento =
	        itemPortafoglio.ndgIntestatario;
	      self.$state.go(self.nuovaPropostaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name vendita
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Entra nello stato nuova proposta con modalita vendita
	     */
	    this.vendita = function (itemPortafoglio) {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.d');
	      self.$stateParams.finCodiceStrumento =
	        itemPortafoglio.strumento.codice.trim();
	      self.$stateParams.finIntestatarioStrumento =
	        itemPortafoglio.ndgIntestatario;
	      self.$state.go(self.nuovaPropostaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name cambio
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Entra nello stato di una nuova proposta
	     * ma per effettuare uno switch su un altro portafoglio
	     */
	    this.cambio = function (itemPortafoglio) {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.s');
	      self.$stateParams.finCodiceStrumento =
	        itemPortafoglio.strumento.codice.trim();
	      self.$stateParams.finIntestatarioStrumento =
	        itemPortafoglio.ndgIntestatario;
	      self.$state.go(self.nuovaPropostaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name accetta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Accetta la raccomandazione
	     */
	    this.accetta = function () {
	      self.spinner.raccomandazione = true;
	      self
	        .promiseAccettaRaccomandazione()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            if (response.data.result && response.data.result.idPratica) {
	              self.$stateParams.finIdRichiesta = response.data.result.idPratica;
	              self.$stateParams.finServizio = 1;
	              self.$state.go(self.gestioneRichiestaState, self.$stateParams);
	            } else {
	              self.$state.go(self.saldoDossierState, self.$stateParams);
	            }
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.raccomandazione = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name rifiuta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Rifiuta la raccomandazione
	     */
	    this.rifiuta = function () {
	      self.promiseRifiutaRaccomandazione().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            return;
	          }
	          // Inserire la rotta per uscire da consulenza
	          self.$state.go(self.saldoDossierState, self.$stateParams);
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name revisiona
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Manda in revisione la raccomandazione
	     */
	    this.revisiona = function () {
	      self.promiseRevisionaRaccomandazione().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            return;
	          }
	          // Inserire la rotta per uscire da consulenza
	          self.$state.go(self.saldoDossierState, self.$stateParams);
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name elimina
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Elimina la proposta dalla lista e se l'operazione va
	     * a buon fine rieffettua la chiamata per la lista delle proposte
	     * @param {Number} idProposta - L'id della proposta da eliminare
	     */
	    this.eliminaProposta = function (proposta) {
	      self.spinner.listaProposte = true;
	      self.promiseEliminaProposta(proposta.idProposta).then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.spinner.listaProposte = false;
	            return;
	          }
	          if (response.data.result) {
	            self.$state.go(self.$state.current.name, self.$stateParams, {
	              reload: true
	            });
	          } else {
	            self.spinner.listaProposte = false;
	          }
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	          self.spinner.listaProposte = false;
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name consolida
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Consolida la raccomandazione
	     */
	    this.consolida = function () {
	      if (!self.liquiditaAggiuntiva) {
	        self.consolidaRaccomandazione();
	        return;
	      }
	      self.spinner.raccomandazione = true;
	      self.promiseAddLiquiditaAggiuntiva().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.spinner.raccomandazione = false;
	            return;
	          }
	          self.consolidaRaccomandazione();
	        },
	        function () {
	          self.spinner.raccomandazione = false;
	        }
	      );
	    };
	
	    this.consolidaRaccomandazione = function () {
	      self.spinner.raccomandazione = true;
	      var promise =
	        self.userSrvc.abilitato(CONSTANTS.ABILITAZIONI.VERIFICA_PROPOSTE) ||
	        self.userSrvc.isBpa
	          ? self.checkProposte()
	          : $q.when(true);
	
	      promise.then(
	        function (value) {
	          if (value) {
	            self.promiseConsolidaRaccomandazione().then(
	              function (response) {
	                if (self.messaggiFctr.processaResponse(response)) {
	                  self.spinner.raccomandazione = false;
	                  return;
	                }
	                self.getDatiRaccomandazione();
	              },
	              function (reason) {
	                self.messaggiFctr.processaResponse(reason);
	                self.spinner.raccomandazione = false;
	              }
	            );
	          }
	        },
	        function () {
	          self.spinner.raccomandazione = false;
	        }
	      );
	    };
	    /**
	     *
	     * @name addLiquiditaAggiuntiva
	     * @description Aggiunge la liquidita aggiuntiva
	     */
	    this.addLiquiditaAggiuntiva = function () {
	      self.spinner.raccomandazione = true;
	      if (
	        this.tmpLiquiditaAggiuntiva === undefined ||
	        this.tmpLiquiditaAggiuntiva === null
	      ) {
	        console.log('Liquidita minore di zero');
	        self.spinner.raccomandazione = false;
	        this.tmpLiquiditaAggiuntiva = 0;
	        return;
	      }
	      this.liquiditaAggiuntiva = 0;
	      this.liquiditaAggiuntiva += this.tmpLiquiditaAggiuntiva;
	      this.tmpLiquiditaAggiuntiva = 0;
	      this.promiseAddLiquiditaAggiuntiva().then(function (response) {
	        if (self.messaggiFctr.processaResponse(response)) {
	          self.spinner.raccomandazione = false;
	          return;
	        }
	        self.initConIdRaccomandazione();
	        self.spinner.raccomandazione = false;
	      });
	      $('#liquiditaAggiuntivaModal').modal('hide');
	    };
	    /**
	     * @ngdoc method
	     * @name proseguiToDocumenti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Chiama il servizio che cambia di stato la pratica
	     */
	    this.proseguiToDocumenti = function () {
	      self.spinner.raccomandazione = true;
	      self.promiseEsitoRaccomandazione().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.spinner.raccomandazione = false;
	            return;
	          }
	          self.getDatiRaccomandazione();
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	          self.spinner.raccomandazione = false;
	        }
	      );
	    };
	    /**
	     * @ngdoc method
	     * @name termina
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Termina la gestione della raccomandazione
	     */
	    this.termina = function () {
	      if (self.deskSrvc.isDesk) {
	        self.deskSrvc.popEntry();
	      }
	      self.spinner.raccomandazione = true;
	      self
	        .promiseTerminaRaccomandazione()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.spinner.raccomandazione = false;
	              return;
	            }
	            if (response.data.result && self.richiestaProcessione === 'N') {
	              self.$state.go('saldodossier', self.$stateParams);
	              self.spinner.raccomandazione = false;
	            }
	            if (response.data.result === true) {
	              self.promiseGestioneOrdine().then(function (response) {
	                if (self.messaggiFctr.processaResponse(response)) {
	                  self.spinner.raccomandazione = false;
	                  return;
	                }
	                if (response.data.result && response.data.result.length > 1) {
	                  self.ordineDiviso = response.data.result;
	                  self.ordineDiviso.forEach(function (ordine) {
	                    ordine.modalita = self.modalita;
	                  });
	                  self.initOrdineDivisoTableLabel();
	                  self.spinner.raccomandazione = false;
	                  self.avanti();
	                } else if (
	                  response.data.result &&
	                  response.data.result.length === 1
	                ) {
	                  self.$stateParams.finIdRichiesta =
	                    response.data.result[0].idRichiesta;
	                  self.$state.go('gestionerichiesta', self.$stateParams);
	                }
	              });
	            } else {
	              self.$state.go('saldodossier', self.$stateParams);
	            }
	            /* if (response.data.result && response.data.result.idPratica) {
	                                                                self.$stateParams.finIdRichiesta =
	                                                                  response.data.result.idPratica;
	                                                                self.$stateParams.finServizio = 1;
	                                                                self.$state.go(self.gestioneRichiestaState, self.$stateParams);
	                                                              } else {
	                                                                self.$state.go(self.saldoDossierState, self.$stateParams);
	                                                              } */
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.raccomandazione = false;
	        });
	    };
	
	    if (self.deskSrvc.isDesk) {
	      labelSrvc.labelsPronte.then(function () {
	        self.deskSrvc.aggiungiEntry(
	          labelSrvc.getLabel('gestione.raccomandazione')
	        );
	      });
	    }
	  };
	  GestioneRaccomandazioneCtrl.$inject = [
	    '$q',
	    '$http',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$location',
	    '$uibModal',
	    'FinMessaggiFctr',
	    'FinLabelSrvc',
	    'FIN_CONSTANTS',
	    '$window',
	    'gestioneRaccomandazioneService',
	    'uiGridConstants',
	    'FinUserSrvc',
	    'CblMessageSrvc',
	    'FinBrioSrvc',
	    'FinDeskSrvc'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'gestioneRaccomandazione/gestioneRaccomandazione.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var GestioneRaccomandazioneComponent = {
	    bindings: {
	      nuovaPropostaState: '@',
	      modificaPropostaState: '@',
	      visualizzaPropostaState: '@',
	      gestioneRichiestaState: '@',
	      saldoDossierState: '@',
	      visualizzaRaccomandazioneState: '@',
	      modalita: '@'
	    },
	    controller: GestioneRaccomandazioneCtrl,
	    controllerAs: 'gestioneCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component(
	      'finanzaGestioneRaccomandazione',
	      GestioneRaccomandazioneComponent
	    );
	})();


/***/ },
/* 18 */
/***/ function(module, exports) {

	/**
	 *@ngdoc directive
	 *@name cbl.finanza.mf.directive:finanzaGestioneProposta
	 *@restrict E
	 *@scope
	 *@description Componente utilizzato per l'inserimento di una nuova proposta
	 *@param {String} modificaRaccomandazioneState - Nome dello stato per la modifica di una raccomandazione
	 */
	(function () {
	  'use strict';
	  var GestionePropostaCtrl = function (
	    $http,
	    $q,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $location,
	    $filter,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    messaggiSrvc,
	    userSrvc,
	    brioSrvc,
	    deskSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.CONSTANTS = CONSTANTS;
	    this.$window = $window;
	    this.$location = $location;
	    this.messaggiFctr = messaggiFctr;
	    this.messaggiSrvc = messaggiSrvc;
	    this.userSrvc = userSrvc;
	    this.brioSrvc = brioSrvc;
	    $scope.msg = labelSrvc.getLabel;
	    this.deskSrvc = deskSrvc;
	
	    this.proposta = {};
	    this.dossier = {};
	    this.saldoPortafoglio = {};
	    this.dettaglioStrumento = undefined;
	    this.tipoOrdine = undefined;
	    this.listaNoteSwitch = [];
	    this.listaContratti = [];
	    this.contratto = {};
	    this.parametriAggiuntivi = undefined;
	    this.profiloCliente = {};
	    this.profiloAdeguatezza = {};
	    this.marketCliente = {};
	    this.marketStrumento = {};
	    this.risultatoVerifica = {};
	    this.mostraParametriAggiuntivi = true;
	    this.showFinancialTool = false;
	    this.spinner = {
	      dettaglioProposta: false,
	      parametriAggiuntivi: false,
	      visualizzazione: false
	    };
	    this.datepicker = {
	      isOpen: false,
	      dateOptions: {
	        formatDay: 'dd',
	        formatMonth: 'MM',
	        formatYear: 'yyyy',
	        startingDay: 1
	      }
	    };
	    this.regexTestoNota = new RegExp(/^[a-zA-Z \u00E0-\u00FC'0-9,.;:]+$/i);
	    this.messaggiFctr.chiudiLoaderBrio();
	    this.mostraParametriBloccati = false;
	    this.modalitaEsposizioneESG;
	    this.esposizioneRatingESG = false;
	    this.esposizioneScoreESG = false;
	    this.esgVisible = function () {
	      return userSrvc.abilitato(CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA);
	    };
	    this.modalita;
	    this.isFromGestioneProposta = true;
	    this.listaErroriForzabili = null;
	
	    var self = this;
	    /**
	     * Abilitazioni
	     */
	    this.userSrvc.abilitazioniPronte.then(function (value) {
	      if (value) {
	        self.mostraParametriBloccati = self.userSrvc.abilitazioni.some(
	          function (abilitazione) {
	            return (
	              abilitazione.codice.toLowerCase() ===
	              self.CONSTANTS.ABILITAZIONI.VISUALIZZA_PARAMETRI_BLOCCATI.toLowerCase()
	            );
	          }
	        );
	      }
	    });
	
	    /*
	     * -------------------------------------
	     * START METODI PROMISE PER SERVIZI REST
	     * -------------------------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name promiseCustomerData
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Effettua la chiamata per ricevere il customerdata
	     * @return {Promise} - Ritorna una promise contenente il customerdata
	     */
	    this.promiseCustomerData = function () {
	      return self.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
	        params: {
	          rapporto: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDettaglioProposta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente il dettaglio di una proposta
	     */
	    this.promiseDettaglioProposta = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PROPOSTA +
	          self.$stateParams.finIdProposta
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDettaglioStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @param {String} [codiceStrumento] - Parametro opzionale passato esclusivamente quando si viene richiamati dal metodo dettalgioStrumentoFinanziario
	     * @return {Promise} - Ritorna una promise conentente i dati del dettaglio dello strumento
	     */
	    this.promiseDettaglioStrumento = function (codiceStrumentoFinanziario) {
	      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO;
	      url += codiceStrumentoFinanziario
	        ? codiceStrumentoFinanziario
	        : self.$stateParams.finCodiceStrumento;
	      return self.$http({
	        method: 'GET',
	        url: url
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseListaNoteSwitch
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente la lista delle note
	     */
	    this.promiseListaNoteSwitch = function () {
	      var url =
	        CONSTANTS.REST_ROOT +
	        CONSTANTS.REST.STRUMENTO +
	        'recuperaNote/' +
	        self.tipoOrdine.codiceOperazione;
	      return self.$http({
	        method: 'GET',
	        url: url
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseSaldoPortafoglio
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente i dati del saldo portafoglio
	     */
	    this.promiseSaldoPortafoglio = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          self.$stateParams.finCodiceRapporto +
	          '/saldi'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseTipoOrdineFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente la lista dei tipi di ordine per i fondo
	     */
	    this.promiseTipoOrdineFondo = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PARAMETRI +
	          'fondo/' +
	          self.proposta.strumento
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseGetPresentatoreFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente i parametri aggiuntivi dello strumento di tipo fondo
	     */
	    this.promiseGetPresentatoreFondo = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PARAMETRI +
	          'presentatoreFondo/' +
	          self.$stateParams.finCodiceRapporto +
	          '/' +
	          self.proposta.strumento +
	          '/' +
	          self.proposta.segno
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseParametriAggiuntiviFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna i parametri aggiuntivi per i fondo
	     */
	    this.promiseParametriAggiuntiviFondo = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PARAMETRI +
	          'fondo/' +
	          self.$stateParams.finCodiceRapporto,
	        data: {
	          strumento: self.proposta.strumento,
	          codiceOrdine: self.tipoOrdine.codiceOperazione,
	          parametri: self.parametriAggiuntivi,
	          quantita: self.proposta.quantita,
	          ctvPrevisto: self.proposta.ctvPrevisto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseParametriAggiuntiviNonFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna tutti i dati compresi i parametri aggiuntivi per i non fondi
	     */
	    this.promiseParametriAggiuntiviNonFondo = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PARAMETRI +
	          'nonFondo/' +
	          self.$stateParams.finCodiceRapporto +
	          '/' +
	          self.proposta.strumento +
	          '/' +
	          self.proposta.segno
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseProfiloCliente
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente il profilo del cliente
	     */
	    this.promiseProfiloCliente = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          'profiloCliente/' +
	          self.dossier.ndgIntestatario,
	        params: {
	          idDossier: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseMarketCliente
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente le informazioni market del cliente
	     */
	    this.promiseMarketCliente = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          'marketCliente/' +
	          self.dossier.ndgIntestatario,
	        params: {
	          idDossier: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseProfiloAdeguatezza
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente la verifica dell'adeguatezza
	     */
	    // TODO: rimettere nuovo metodo
	    this.promiseProfiloAdeguatezza = function () {
	      var propostaVerifica = {
	        idProposta: self.$stateParams.finIdProposta,
	        idRaccomandazione: self.$stateParams.finIdRaccomandazione,
	        strumento: self.dettaglioStrumento.codice.trim(), //self.getCodiceStrumento(),
	        quantita: self.proposta.quantita,
	        ctvPrevisto: self.proposta.ctvPrevisto,
	        intestatario: self.proposta.intestatario,
	        nota: self.proposta.nota,
	        prezzo: self.proposta.prezzo,
	        presentatore: self.proposta.presentatore,
	        segno: self.proposta.segno,
	        mercato: self.proposta.mercato,
	        divisaISO: self.proposta.divisaISO,
	        profiloAdeguatezza: self.profiloCliente.profiloAdeguatezza,
	        profiloAppropriatezza: self.profiloCliente.profiloAppropriatezza,
	        contratto: self.contratto.contratto,
	        prgContratto: self.contratto.id,
	        rischioComplessita: self.profiloAdeguatezza.rischioComplessita,
	        rischioEmittente: self.profiloAdeguatezza.rischioEmittente,
	        rischioLiquidita: self.profiloAdeguatezza.rischioLiquidita,
	        rischioMercato: self.profiloAdeguatezza.rischioMercato,
	        codiceOrdine: self.proposta.codiceOrdine,
	        parametri: self.parametriAggiuntivi
	      };
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          'profiloAdeguatezza/' +
	          self.getCodiceStrumento(),
	        params: {
	          codiceRapporto: self.$stateParams.finCodiceRapporto
	        },
	        data: propostaVerifica
	      });
	      // return self.$http({
	      //   method: 'GET',
	      //   url:
	      //       CONSTANTS.REST_ROOT +
	      //       CONSTANTS.REST.STRUMENTO +
	      //       'profiloAdeguatezza/' +
	      //       self.getCodiceStrumento()
	      // });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseMarketStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente le informazioni market dello strumento
	     */
	    this.promiseMarketStrumento = function () {
	      return self.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'marketStrumento',
	        params: {
	          codiceStrumento: self.proposta.strumento
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseInserisciRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente i dati della nuova raccomandazione
	     */
	    this.promiseInserisciRaccomandazione = function () {
	      return self.$http({
	        method: 'POST',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          'raccomandazione/' +
	          self.$stateParams.finIniziativa,
	        data: {
	          codiceDossierTitoli: self.$stateParams.finCodiceRapporto,
	          intestatario: {
	            //						intestazione: 'FRANCESCO ABBRUZZESE',
	            //						formaCostitutiva: 'PRV',
	            //						ndg: '354823'
	            intestazione: self.posizione.intestazione,
	            formaCostitutiva: self.posizione.naturaGiuridicaIntestatario,
	            ndg: self.posizione.ndgIntestatario
	          },
	          inserimento: new Date().getTime(),
	          ultimaModifica: new Date().getTime(),
	          hidden: false
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseContratti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @return {Promise} - Ritorna una promise contenente la lista dei contratti
	     */
	    this.promiseContratti = function () {
	      return self.$http({
	        method: 'PUT',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'contratti',
	        data: {
	          dossier: self.$stateParams.finCodiceRapporto,
	          prodotto: self.proposta.strumento.trim(),
	          ndgSottoscrittore: self.proposta.intestatario
	            ? self.proposta.intestatario
	            : 0
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseVerificaNonFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Costruisce l'oggetto proposta per i non fondi
	     * @return {Promise} - Ritorna una promise contenente il risultato della verifica
	     */
	    this.promiseVerificaNonFondo = function () {
	      var proposta = {
	        idProposta: self.$stateParams.finIdProposta,
	        idRaccomandazione: self.$stateParams.finIdRaccomandazione,
	        strumento: self.proposta.strumento.trim(),
	        quantita: self.proposta.quantita,
	        ctvPrevisto: self.proposta.ctvPrevisto,
	        intestatario: self.proposta.intestatario,
	        nota: self.proposta.nota,
	        prezzo: self.proposta.prezzo,
	        presentatore: self.proposta.presentatore,
	        segno: self.proposta.segno,
	        dataScadenza:
	          new Date(self.proposta.dataScadenza).getTime() + 1000 * 60 * 60 * 4,
	        mercato: self.proposta.mercato,
	        divisaISO: self.proposta.divisaISO,
	        codiceOrdine: self.proposta.codiceOrdine
	      };
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PROPOSTA +
	          'verificaNonFondo/' +
	          self.$stateParams.finCodiceRapporto,
	        data: proposta
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseVerificaFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Costruisce l'oggetto proposta per i fondi
	     * @return {Promise} - Ritorna una promise contenente il risultato della chiamata
	     */
	    this.promiseVerificaFondo = function () {
	      // Fix Daniele 21/10: durante il caricamento in visualizzazione i dati del contratto potrebbero
	      // non essere ancora arrivati
	      // Se il caso è questo, utilizzo i dati presenti sulla pratica
	      var numContratto = self.contratto.contratto;
	      var prgContratto = self.contratto.id;
	
	      if (self.$state.current.name.indexOf('visualizza') > -1) {
	        if (!self.contratto.contratto && self.proposta.contratto) {
	          numContratto = self.proposta.contratto.trim();
	        }
	
	        if (!self.contratto.contratto) {
	          prgContratto = self.proposta.prgContratto;
	        }
	      }
	
	      var proposta = {
	        strumento: self.dettaglioStrumento.codice.trim(),
	        intestatario: self.proposta.intestatario,
	        presentatore: self.proposta.presentatore,
	        codiceOrdine: self.proposta.codiceOrdine,
	        quantita: self.proposta.quantita,
	        ctvPrevisto: self.proposta.ctvPrevisto,
	        contratto: numContratto,
	        prgContratto: prgContratto,
	        nota: self.proposta.nota,
	        parametri: self.parametriAggiuntivi
	      };
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PROPOSTA +
	          'verificaFondo/' +
	          self.$stateParams.finCodiceRapporto,
	        data: proposta
	      });
	    };
	
	    this.isFON_POG = function () {
	      return (
	        self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'FON' ||
	        self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'POG'
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseInserisciProposta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Crea l'endpoint in base a fondi o non fondi
	     * @return {Promise} - Ritorna una promise contenente la risposta dell'inserimento proposta
	     */
	    this.promiseInserisciProposta = function (propostaToSave) {
	      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.PROPOSTA;
	      if (!self.isFON_POG()) {
	        url = url + 'propostaNonFondo/';
	      } else {
	        url = url + 'propostaFondo/';
	      }
	      url = url + self.$stateParams.finCodiceRapporto;
	      return self.$http({
	        method: 'POST',
	        url: url,
	        data: propostaToSave
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseModificaProposta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Crea l'endpoint in base a fondi o non fondi
	     * @return {Promise} - Ritorna una promise contenente la risposta della modifica proposta
	     */
	    this.promiseModificaProposta = function (propostaToUpdate) {
	      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.PROPOSTA;
	      if (!self.isFON_POG()) {
	        url = url + 'modificaPropostaNonFondo/';
	      } else {
	        url = url + 'modificaPropostaFondo/';
	      }
	      url = url + self.$stateParams.finCodiceRapporto;
	      return self.$http({
	        method: 'PUT',
	        url: url,
	        data: propostaToUpdate
	      });
	    };
	
	    /*
	     * -----------------------------------
	     * END METODI PROMISE PER SERVIZI REST
	     * -----------------------------------
	     */
	
	    /*
	     * -----------------------
	     * START METODI CONTROLLER
	     * -----------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name checkRegexNota
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Ritorna true se il testo della nota rispetta il pattern
	     */
	    this.checkRegexNota = function (testo) {
	      return self.regexTestoNota.test(testo);
	    };
	
	    /**
	     * @ngdoc method
	     * @name recuperaDettaglioProposta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Recupera il dettaglio di una proposta
	     */
	    this.recuperaDettaglioProposta = function () {
	      self.promiseDettaglioProposta().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.proposta = {};
	            self.spinner.dettaglioProposta = false;
	            return;
	          }
	          self.proposta = response.data.result;
	          //    			Se ci sono i parametri allora siamo in un fondo
	          if (self.proposta.parametri) {
	            self.parametriAggiuntivi = self.proposta.parametri;
	            self.parametriAggiuntivi.forEach(function (parametro) {
	              parametro.codice = parametro.codice.trim();
	              parametro.descrizione = parametro.descrizione.trim();
	              parametro.valore = parametro.valore.trim();
	              if (parametro.scelte) {
	                parametro.scelte.forEach(function (scelta) {
	                  scelta.descrizione = scelta.descrizione.trim();
	                  scelta.valore = scelta.valore.trim();
	                });
	              }
	            });
	          }
	          delete self.proposta.parametri;
	          self.dettaglioStrumentoFinanziario();
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	          self.spinner.dettaglioProposta = false;
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name recuperaSaldoPortafoglio
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Recupera il saldo portafoglio
	     * @return {Array} - Lista dei saldi portafoglio
	     */
	    this.recuperaSaldoPortafoglio = function () {
	      self.promiseSaldoPortafoglio().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.saldoPortafoglio = {};
	            self.spinner.dettaglioProposta = false;
	            return;
	          }
	          if (response.data && response.data.result) {
	            //    				Creo un nuovo array che contiene soltanto gli
	            //    				strumenti che coincidono con quello selezionato dal saldo
	            var saldi = response.data.result.filter(function (saldo) {
	              return (
	                saldo.strumento.codice.trim() ===
	                self.$stateParams.finCodiceStrumento
	              );
	            });
	            //    				Se la length è maggiore di 1 allora cerco quello con ndg ricevuto tramite params
	            if (saldi.length > 1) {
	              //    					Non posso usare il find() perché non supportato da IE
	              saldi.forEach(function (saldo) {
	                if (
	                  saldo.ndgIntestatario &&
	                  saldo.ndgIntestatario.toString() ===
	                    self.$stateParams.finIntestatarioStrumento
	                ) {
	                  self.saldoPortafoglio = saldo;
	
	                  // 			Si può presentare anche il caso che ci siano più saldi per un certo strumento, dipende se l'ndg è cointestato o mono.
	                  //			Se il saldo dello strumento si riferisce ad un ndg cointestato l'ndgIntestatario arriverà nullo (e quindi verrà passato
	                  //			nullo anche negli stateParams). Quindi se $stateParams.finIntestatarioStrumento è nullo seleziono il saldo con ndgIntestatario nullo.
	                } else if (
	                  !saldo.ndgIntestatario &&
	                  !self.$stateParams.finIntestatarioStrumento
	                ) {
	                  self.saldoPortafoglio = saldo;
	                }
	              });
	            } else {
	              //    					Prendo l'unico saldo rimasto
	              self.saldoPortafoglio = saldi[0];
	            }
	            //    				Chiamo il recupero del dettaglio strumento
	            self.dettaglioStrumentoFinanziario();
	          } else {
	            self.spinner.saldoPortafoglio = false;
	          }
	        },
	        function (reason) {
	          self.spinner.saldoPortafoglio = false;
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name recuperaStrumentoFinanziario
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Funzione richiamata al click su una riga dello strumento finanziario.
	     * Tale funzione viene richiamata soltanto durante la creazione di una nuova proposta
	     * @param {Object} - Strumento finanziario ricercato tramite il widget
	     */
	    this.ricercaStrumentoFinanziario = function (callbackStrumentoFinanziario) {
	      self.spinner.dettaglioProposta = true;
	      //    		Ricreo una nuova proposta quando cerco un nuovo strumento
	      self.proposta = {
	        segno: $scope.msg('gestione.proposta.a')
	      };
	      self.parametriAggiuntivi = undefined;
	      self.tipoOrdine = undefined;
	      self.dettaglioStrumentoFinanziario(
	        callbackStrumentoFinanziario.codice.trim()
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name dettaglioStrumentoFinanziario
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Gestisce la promise del dettaglio strumento finanziario
	     */
	    this.dettaglioStrumentoFinanziario = function (codiceStrumentoFinanziario) {
	      self.promiseDettaglioStrumento(codiceStrumentoFinanziario).then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.dettaglioStrumento = {};
	            self.spinner.dettaglioProposta = false;
	            return;
	          }
	          self.dettaglioStrumento = response.data.result;
	          self.recuperaDatiStrumentoFinanziario();
	          //        		Se siamo in visualizza chiamo anche i rest per la pagina delal verifica adeguatezza
	          if (self.$state.current.name.indexOf('visualizza') > -1) {
	            self.spinner.visualizzazione = true;
	            self.verifica(true);
	          }
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	          self.spinner.dettaglioProposta = false;
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name recuperDatiStrumentoFinanziario
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Imposta i valori predefiniti per la proposta in base a creazione/creazione(da strumento)/modifica
	     */
	    this.recuperaDatiStrumentoFinanziario = function () {
	      //    		Se sono in modifica effettuo soltanto i trim dei dati (stringhe) ricevuti
	      if (self.$stateParams.finIdProposta) {
	        self.proposta.strumento = self.proposta.strumento.trim();
	      } else {
	        if (!self.dettaglioStrumento.codice) {
	          self.messaggiFctr.addMessage({
	            type: 'E',
	            message:
	              'Errore, il dettaglio strumento non ha codice, impossibile proseguire con la creazione della proposta'
	          });
	          self.spinner.dettaglioProposta = false;
	          self.spinner.parametriAggiuntivi = false;
	          self.spinner.visualizzazione = false;
	          return;
	        }
	
	        // Sono in creazione quindi recupero altri valori dal dettaglioStrumento
	        self.proposta.strumento = self.dettaglioStrumento.codice.trim();
	
	        var divisore = self.calcolaDivisoreQuantita(
	          self.dettaglioStrumento.qtaMinimaTrattabile
	        );
	
	        var qta = null;
	        if (
	          self.isFON_POG() &&
	          self.dettaglioStrumento.divisa.trim() !== 'EURO'
	        ) {
	          qta =
	            self.dettaglioStrumento.qtaMinimaTrattabile *
	            self.dettaglioStrumento.cambioStorico.prezzo;
	        } else {
	          qta = self.dettaglioStrumento.qtaMinimaTrattabile;
	        }
	
	        self.proposta.quantita = Math.round(qta * divisore) / divisore || 1;
	
	        self.proposta.ctvPrevisto =
	          Math.round(
	            self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo *
	              self.proposta.quantita *
	              100
	          ) / 100;
	        //            	Se provengo da un saldo portafoglio setto l'intestatario del saldo
	        if (self.$stateParams.finCodiceStrumento) {
	          self.proposta.intestatario = self.saldoPortafoglio.ndgIntestatario;
	        } else {
	          //        			Se siamo in un non-fondo e
	          //        			lo strumento è nominativo e
	          //        			l'intestatario del dossier e solo 1
	          //        			allora setto come intestatario della proposta l'unico intestatario del dossier
	          if (
	            !self.isFON_POG() &&
	            self.dettaglioStrumento.nominativo &&
	            self.dossier.intestatari.length === 1
	          ) {
	            self.proposta.intestatario = self.dossier.intestatari[0].ndg;
	          }
	        }
	      }
	      if (self.isFON_POG()) {
	        self.getDatiAggiuntiviFondo();
	      } else {
	        self.getParametriAggiuntiviNonFondo();
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name mappingParametri
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Esegue il mapping dell'array parametri per utilizzarlo con le select
	     */
	    this.mappingParametriNonFondo = function () {
	      self.parametriAggiuntivi.forEach(function (parametro) {
	        //    			Effettuo un trim dei valori all'interno di ciascuna scelta
	        parametro.scelte.forEach(function (scelta) {
	          scelta.valore = scelta.valore.trim();
	          //    				Imposto il valore del presentatore a un number
	          if (parametro.descrizione === 'PRESENTATORE') {
	            scelta.valore = Number(scelta.valore) || '';
	          }
	        });
	        switch (parametro.descrizione.trim()) {
	          case 'MERCATO':
	            self.parametroMercato = parametro;
	            break;
	          case 'TIPO ORDINE':
	            self.parametroTipoOrdine = parametro;
	            break;
	          case 'DIVISA REGOLAMENTO':
	            self.parametroDivisaRegolamento = parametro;
	            break;
	          case 'PRESENTATORE':
	            self.parametroPresentatore = parametro;
	            break;
	        }
	      });
	      self.spinner.dettaglioProposta = false;
	    };
	
	    /**
	     * @ngdoc method
	     * @name getParametriAggiuntiviFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @param {boolean} oldTipoOrdine - Vecchio valore del tipoOrdine
	     * @param {number} index - Index nell'array parametriAggiuntivi del parametro aggiuntivo modificato
	     * @param {event} keyCode - Codice del tasto premuto
	     * @description Riceve ed elabora i parametri aggiuntivi per i fondi
	     */
	    this.getParametriAggiuntiviFondo = function (
	      oldTipoOrdine,
	      newTipoOrdine,
	      index,
	      event
	    ) {
	      if (index >= 0) {
	        //    			In caso di evento sull'input di testo
	        if (event && event.keyCode !== 13) {
	          return;
	        }
	        var gruppo = self.parametriAggiuntivi[index].gruppo;
	        var parametriAggiuntiviTmp = self.parametriAggiuntivi.filter(function (
	          parametro
	        ) {
	          return parametro.gruppo <= gruppo;
	        });
	        self.parametriAggiuntivi = parametriAggiuntiviTmp;
	      }
	      //    		Se il tipoOrdine è cambiato e quindi c'è un nuovo valore
	      if (newTipoOrdine !== oldTipoOrdine) {
	        self.parametriAggiuntivi = [];
	        //    			Se la select del contratto non si deve far vedere allora annullo il codice contratto scelto
	        if (!self.tipoOrdine.codiceContrattoObbligatorio) {
	          self.contratto = {};
	        }
	        //    			Se siamo in switch chiamo il rest delle note
	        if (self.$stateParams.acqven === $scope.msg('gestione.proposta.s')) {
	          self.getListaNoteSwitch();
	        }
	      }
	      //    		Esco perché la funzione viene richiamata quando la select viene popolata e non ho il tipoOrdine
	      if (!self.tipoOrdine) {
	        return;
	      }
	      self.spinner.parametriAggiuntivi = true;
	      //    		Imposto il codiceOrdine prelevato dall'oggetto tipoOrdine
	      self.proposta.codiceOrdine = self.tipoOrdine.codiceOperazione;
	      //    		Se il contratto è obbligatorio e non sto operando con i parametri aggiuntivi allora gestisco il contratto
	      if (self.tipoOrdine.codiceContrattoObbligatorio && isNaN(index)) {
	        self.getContratti();
	      }
	      self
	        .promiseParametriAggiuntiviFondo()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.parametriAggiuntivi = [];
	              return;
	            }
	            response.data.result.richiesta.parametri.forEach(function (
	              parametro
	            ) {
	              parametro.codice = parametro.codice.trim();
	              parametro.descrizione = parametro.descrizione.trim();
	              if (parametro.valore) {
	                parametro.valore = parametro.valore.trim();
	              }
	              if (parametro.scelte) {
	                parametro.scelte.forEach(function (scelta) {
	                  scelta.descrizione = scelta.descrizione.trim();
	                  scelta.valore = scelta.valore.trim();
	                });
	              }
	            });
	            self.parametriAggiuntivi = response.data.result.richiesta.parametri;
	          },
	          function (reason) {
	            self.parametriAggiuntivi = [];
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.parametriAggiuntivi = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name getgetListaNoteSwitch
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Metodo che recupera la lista delle note per gli switch
	     */
	    this.getListaNoteSwitch = function () {
	      self.promiseListaNoteSwitch().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.listaNoteSwitch = [];
	            return;
	          }
	          self.listaNoteSwitch = response.data.result;
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	          self.listaNoteSwitch = [];
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name getContratti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Metodo che recupera la lista dei contratti per le proposte di tipo fondo
	     */
	    this.getContratti = function () {
	      self.promiseContratti().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.listaContratti = [];
	            return;
	          }
	          //    			Effettuo il trim dei valori su cui dovrò operare
	          response.data.result.forEach(function (item) {
	            item.contratto = item.contratto.trim();
	          });
	          self.listaContratti = response.data.result;
	          //    			Se è presente un idProposta devo trovare l'oggetto di listaContratti che ha come id il prgContratto e come stringa il contratto
	          if (self.$stateParams.finIdProposta) {
	            //    				Non uso il find() perché non supportato da IE
	            self.listaContratti.forEach(function (contratto) {
	              if (
	                contratto.contratto === self.proposta.contratto.trim() &&
	                contratto.id === self.proposta.prgContratto
	              ) {
	                self.contratto = contratto;
	              }
	            });
	          }
	          self.calcolaOptionsContratti();
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	          self.spinner.parametriAggiuntivi = false;
	          self.listaContratti = [];
	          self.calcolaOptionsContratti();
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name getDatiAggiuntiviFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Gestisce le due chiamate al tipoOrdine per la select e ai parametri aggiuntivi del fondo
	     */
	    this.getDatiAggiuntiviFondo = function () {
	      $q.all({
	        tipoOrdine: self.promiseTipoOrdineFondo(),
	        presentatore: self.promiseGetPresentatoreFondo()
	      }).then(
	        function (response) {
	          if (
	            self.messaggiFctr.processaResponse(response.tipoOrdine) ||
	            self.messaggiFctr.processaResponse(response.presentatore)
	          ) {
	            self.arrayTipoOrdine = [];
	            self.spinner.parametriAggiuntivi = false;
	            return;
	          }
	          self.getTipoOrdine(response.tipoOrdine);
	          self.getPresentatoreFondi(response.presentatore);
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason.tipoOrdine);
	          self.messaggiFctr.processaResponse(reason.presentatore);
	          self.arrayTipoOrdine = [];
	          self.spinner.parametriAggiuntivi = false;
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name getPresentatoreFondi
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Gestisce i dati per il presentatore nei fondi
	     */
	    this.getPresentatoreFondi = function (response) {
	      if (!self.$stateParams.finIdProposta) {
	        self.proposta.presentatore = response.data.result.presentatore;
	      }
	      response.data.result.parametri.forEach(function (parametro) {
	        //    			Effettuo un trim dei valori all'interno di ciascuna scelta
	        parametro.scelte.forEach(function (scelta) {
	          scelta.valore = scelta.valore.trim();
	          //    				Imposto il valore del presentatore a un number
	          if (parametro.descrizione === 'PRESENTATORE') {
	            scelta.valore = Number(scelta.valore) || '';
	          }
	        });
	        switch (parametro.descrizione.trim()) {
	          case 'PRESENTATORE':
	            self.parametroPresentatore = parametro;
	            break;
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name getCodiceStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Setta il giusto codiceStrumento in base a se siamo in uno switch o meno
	     * @return string - Ritorna la stringa del codiceStrumento
	     */
	    this.getCodiceStrumento = function () {
	      var codiceStrumento = '';
	      //    		Se siamo in uno switch
	      if (self.$stateParams.acqven === $scope.msg('gestione.proposta.s')) {
	        self.parametriAggiuntivi.forEach(function (parametro) {
	          //    				Se trovo il campo dove viene inserito il fondo su cui switchare
	          if (parametro.codice.trim() === 'FNSWIPROD') {
	            //    					Prendo il valore dello switch scelto nella select
	            codiceStrumento = parametro.valore.trim();
	          }
	        });
	      } else {
	        codiceStrumento = self.proposta.strumento;
	      }
	      return codiceStrumento;
	    };
	
	    /**
	     * @ngdoc method
	     * @name getTipoOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Gestisce i dati per popolare la select tipo ordine
	     */
	    this.getTipoOrdine = function (response) {
	      if (self.proposta.segno === $scope.msg('gestione.proposta.d')) {
	        self.arrayTipoOrdine = response.data.result.filter(function (item) {
	          return (
	            item.segnoOperazione.trim() === $scope.msg('gestione.proposta.d')
	          );
	        });
	      } else if (self.proposta.segno === $scope.msg('gestione.proposta.a')) {
	        self.arrayTipoOrdine = response.data.result.filter(function (item) {
	          return (
	            item.segnoOperazione.trim() === $scope.msg('gestione.proposta.a')
	          );
	        });
	      } else if (self.proposta.segno === $scope.msg('gestione.proposta.s')) {
	        self.arrayTipoOrdine = response.data.result.filter(function (item) {
	          return (
	            item.segnoOperazione.trim() === $scope.msg('gestione.proposta.s')
	          );
	        });
	      }
	      //    		Effettuo il trim dei valori su cui dovrò operare
	      self.arrayTipoOrdine.forEach(function (item) {
	        item.codiceOperazione = item.codiceOperazione.trim();
	        item.descrizione = item.descrizione.trim();
	      });
	      //    		Se è presente un idProposta devo trovare l'oggetto di arrayTipoOrdine che ha come stringa il codiceOperazione
	      if (self.$stateParams.finIdProposta) {
	        self.arrayTipoOrdine.forEach(function (tipoOrdine) {
	          if (tipoOrdine.codiceOperazione === self.proposta.codiceOrdine) {
	            self.tipoOrdine = tipoOrdine;
	          }
	        });
	        //				Chiamo la lista delle note per gl iswitch solo se ho i ltipoOrdine
	        if (self.$stateParams.acqven === $scope.msg('gestione.proposta.s')) {
	          self.getListaNoteSwitch();
	        }
	      }
	      self.showFinancialTool = false;
	      self.spinner.dettaglioProposta = false;
	      //    		Azzero l'oggetto contratto
	      self.contratto = {};
	      //    		Chiamo i parametri aggiuntivi per il fondo
	      self.getParametriAggiuntiviFondo();
	    };
	
	    /**
	     * @ngdoc method
	     * @name getParametriAggiuntiviNonFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Riceve ed elabora i parametri aggiuntivi per i NON fondi
	     */
	    this.getParametriAggiuntiviNonFondo = function () {
	      self.spinner.parametriAggiuntivi = true;
	      self
	        .promiseParametriAggiuntiviNonFondo()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.parametriAggiuntivi = [];
	              return;
	            }
	            if (!self.$stateParams.finIdProposta) {
	              self.proposta.dataScadenza = response.data.result.dataScadenza;
	              self.proposta.divisaISO = response.data.result.divisaISO
	                ? response.data.result.divisaISO.trim()
	                : null;
	              self.proposta.codiceOrdine = response.data.result.codiceOrdine
	                ? response.data.result.codiceOrdine.trim()
	                : null;
	              self.proposta.mercato = response.data.result.mercato
	                ? response.data.result.mercato.trim()
	                : null;
	              self.proposta.prezzo = response.data.result.prezzo;
	              self.proposta.presentatore = response.data.result.presentatore;
	            }
	            self.parametriAggiuntivi = response.data.result.parametri;
	            self.mappingParametriNonFondo();
	          },
	          function (reason) {
	            self.parametriAggiuntivi = [];
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.parametriAggiuntivi = false;
	          self.showFinancialTool = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkVenditaMassima
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Controllo che non supero la quantita disponibile in fase di vendita
	     * @param {Number} quantita - Nuova valore della quantita da settare
	     * @return {Number} - Il nuovo valore controllato
	     */
	    this.checkVenditaMassima = function (quantita) {
	      return quantita <= self.saldoPortafoglio.quantita
	        ? quantita
	        : self.saldoPortafoglio.quantita;
	    };
	
	    /**
	     * @mgdoc method
	     * @name checkRimanenzaQuantita
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Controllo che non rimanga una quantita compresa tra 0 e qtaMinimaTrattabile.
	     * Se così fosse ritorno un valore che lascia nel portafoglio una quantita pari a qtaMinimaTrattabile
	     * @param {Number} quantita - Nuovo valore della quantita da settare
	     * @return {Number} - Il nuovo valore controllato
	     */
	    this.checkRimamenzaQuantita = function (quantita) {
	      var qtaDisp = self.saldoPortafoglio.quantita;
	      var qtaMin = self.dettaglioStrumento.qtaMinimaTrattabile;
	      return qtaDisp - quantita >= 0 &&
	        (qtaDisp - quantita >= qtaMin || qtaDisp - quantita === 0)
	        ? quantita
	        : qtaDisp - qtaMin;
	    };
	
	    /**
	     * @ngdoc method
	     * @name incrementaQuantita
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Incrementa la quantita di 1 unita tramite il pulsante +
	     */
	    //    	this.incrementaQuantita = function() {
	    ////    		Se il taglioSuccessivo è 0 allora incremento di 1
	    //    		var newValue = (Number(self.proposta.quantita) || 0) + (Math.round(self.dettaglioStrumento.taglioSuccessivo) || 1);
	    ////    		Se sono in vendita effettuo ulteriori controlli
	    //    		if (self.$stateParams.acqven === $scope.msg('gestione.proposta.d')) {
	    //    			newValue = self.checkVenditaMassima(newValue);
	    //    			newValue = self.checkRimamenzaQuantita(newValue);
	    //    		}
	    //    		self.proposta.quantita = Math.round(newValue * 1000) / 1000;
	    //    		self.proposta.ctvPrevisto = Math.round(self.proposta.quantita * self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo * 100) / 100;
	    //    	};
	
	    /**
	     * @ngdoc method
	     * @name decrementaQuantita
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Decrementa la quantita di 1 unita tramite il pulsante -
	     */
	    //    	this.decrementaQuantita = function() {
	    ////    		Se il taglioSuccessivo è 0 allora incremento di 1
	    //    		var newValue = (Number(self.proposta.quantita) || 0) - (Math.round(self.dettaglioStrumento.taglioSuccessivo) || 1);
	    ////    		Se vado sotto la qtaMinimaTrattabile non salvo il valore (di conseguenza non andrò mai in negativo)
	    //    		if (newValue < self.dettaglioStrumento.qtaMinimaTrattabile) {
	    //    			return;
	    //    		}
	    //    		self.proposta.quantita = Math.round(newValue * 1000) / 1000;
	    //    		self.proposta.ctvPrevisto = Math.round(self.proposta.quantita * self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo * 100) / 100;
	    //    	};
	
	    /**
	     * @ngdoc method
	     * @name checkQuantitaInserita
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Controlla la quantita e la aggiusta se necessario quando si inserisce il valore a mano
	     */
	    this.checkQuantitaInserita = function () {
	      if (!self.isFON_POG()) {
	        //        		Controllo se c'è contenuto
	        if (!self.proposta.quantita) {
	          self.proposta.quantita = self.dettaglioStrumento.qtaMinimaTrattabile;
	        }
	        //        		Controllo se viene inserito un valore non numerico
	        if (isNaN(self.proposta.quantita)) {
	          self.proposta.quantita = self.dettaglioStrumento.qtaMinimaTrattabile;
	        }
	        //        		Rendo la quantita inserita un multiplo del taglio
	        //        		self.proposta.quantita = self.proposta.quantita - Math.round(self.proposta.quantita % (self.dettaglioStrumento.taglioSuccessivo || 1));
	        //        		Se viene inserito un valore minore della qtaMinimaTrattabile viene impostato quest'ultimo valore
	        if (
	          self.proposta.quantita < self.dettaglioStrumento.qtaMinimaTrattabile
	        ) {
	          self.proposta.quantita = self.dettaglioStrumento.qtaMinimaTrattabile;
	        }
	        //        		Si siamo in vendita effettuo ulteriori controlli
	        if (self.$stateParams.acqven === $scope.msg('gestione.proposta.d')) {
	          self.proposta.quantita = self.checkVenditaMassima(
	            self.proposta.quantita
	          );
	          self.proposta.quantita = self.checkRimamenzaQuantita(
	            self.proposta.quantita
	          );
	        }
	
	        var divisore = self.calcolaDivisoreQuantita(
	          self.dettaglioStrumento.qtaMinimaTrattabile
	        );
	
	        self.proposta.quantita =
	          Math.round(self.proposta.quantita * divisore) / divisore;
	      }
	
	      // Se si sta trattando un fondo, controllo se la valuta dello strumento è diversa da EURO e in caso faccio la conversione dalla valuta in euro
	      var prezzo;
	      if (
	        self.isFON_POG() &&
	        self.dettaglioStrumento.divisa.trim() !== 'EURO'
	      ) {
	        prezzo =
	          self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo /
	          self.dettaglioStrumento.cambioStorico.prezzo;
	      } else {
	        prezzo = self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo;
	      }
	
	      //    		Setto il controvalore e imposto 2 decimali
	      self.proposta.ctvPrevisto =
	        Math.round(self.proposta.quantita * prezzo * 100) / 100;
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkControvaloreInserito
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Effettua controlli sul controvalore inserito a mano
	     */
	    this.checkControvaloreInserito = function () {
	      // Se si sta trattando un fondo, controllo se la valuta dello strumento è diversa da EURO e in caso faccio la conversione dalla valuta in euro
	      var prezzo;
	      if (
	        self.isFON_POG() &&
	        self.dettaglioStrumento.divisa.trim() !== 'EURO'
	      ) {
	        prezzo =
	          self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo /
	          self.dettaglioStrumento.cambioStorico.prezzo;
	      } else {
	        prezzo = self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo;
	      }
	
	      //    		Se non è stato inserito niente o 0 calcolo il ctvPrevisto in base alla quantità;
	      if (!self.proposta.ctvPrevisto) {
	        self.proposta.ctvPrevisto = self.proposta.quantita * prezzo;
	      }
	      //    		Se non è stato inserito un numero lo rimpiazzo calcolandolo in base alla quantita
	      if (isNaN(self.proposta.ctvPrevisto)) {
	        self.proposta.ctvPrevisto = self.proposta.quantita * prezzo;
	      }
	      //    		Imposto a 2 decimali il ctv
	      self.proposta.ctvPrevisto =
	        Math.round(self.proposta.ctvPrevisto * 100) / 100;
	
	      var divisore = self.calcolaDivisoreQuantita(
	        self.dettaglioStrumento.qtaMinimaTrattabile
	      );
	
	      self.proposta.quantita =
	        Math.round((self.proposta.ctvPrevisto / prezzo) * divisore) / divisore;
	      //    		Aggiusto la quantita in base al controvalore inserito
	      //    		self.checkQuantitaInserita();
	      // if( self.isFON_POG() && self.dettaglioStrumento.divisa.trim() !== 'EURO'){
	      // 	self.proposta.quantita =  Math.round((self.proposta.quantita * self.dettaglioStrumento.cambioStorico.prezzo)
	      // }
	
	      if (
	        self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'FON' ||
	        self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'POG'
	      ) {
	        self.getParametriAggiuntiviFondo();
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name incrementaPrezzoLimite
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Incrementa di un'unità' il valore del prezzo limite
	     */
	    this.incrementaPrezzoLimite = function () {
	      if (self.proposta.prezzo >= 0) {
	        self.proposta.prezzo += 0.01;
	        self.proposta.prezzo = Math.round(self.proposta.prezzo * 10000) / 10000;
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name decrementaPrezzoLimite
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Decrementa di un'unità' il valore del prezzo limite
	     */
	    this.decrementaPrezzoLimite = function () {
	      if (self.proposta.prezzo > 0) {
	        self.proposta.prezzo -= 0.01;
	        self.proposta.prezzo = Math.round(self.proposta.prezzo * 10000) / 10000;
	      }
	    };
	
	    this.calcolaDivisoreQuantita = function (quantitaMinima) {
	      if (!quantitaMinima) {
	        return 1;
	      }
	
	      var quantitaStr = quantitaMinima.toString();
	      var decimali = quantitaStr.split('.');
	      var nDecimali = decimali[1] ? decimali[1].length : 0;
	      var divisore = Math.pow(10, nDecimali);
	
	      return divisore;
	    };
	
	    /**
	     * @ngdoc method
	     * @name calcolaOptionsContratti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Crea le options per la select relativa ai contratti. A causa di un errore nel calcolo delle quantità disponibili e della formattazione
	     * è necessario aggiungere la proprietà labelOption in modo da poter effettuare il calcolo precisamente anche a seconda della precisone
	     * desiderata.
	     */
	    this.calcolaOptionsContratti = function () {
	      self.listaContratti.forEach(function (contratto) {
	        // Trovo la precisione massima per la quale effettuare la sottrazione senza errori
	        var contr = contratto.saldoContratto.toString().split('.');
	        var precisioneSaldoContr = contr[1] ? contr[1].length : 1;
	        var impegn = contratto.saldoImpegnato.toString().split('.');
	        var precisioneSaldoImp = impegn[1] ? impegn[1].length : 1;
	        var precisioneMax =
	          Math.max(precisioneSaldoContr, precisioneSaldoImp) + 1;
	        var divisore = Math.pow(10, precisioneMax);
	
	        contratto.labelOption =
	          contratto.contratto +
	          '  - QTA DISP: ' +
	          (
	            Math.round(
	              (contratto.saldoContratto - contratto.saldoImpegnato) * divisore
	            ) / divisore
	          )
	            .toString()
	            .replace('.', ',');
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name changeTabMacro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Setta il tab attuale
	     * @param {Object} tab - L'oggetto tab che deve essere setatto come attuale
	     */
	    this.changeTabMacro = function (tab) {
	      if (tab) {
	        self.currentTabMacro = tab;
	        self.messaggiSrvc.reset();
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name getStyleTabMacro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Riceve la classe appropriata per la colorazione del macro
	     * @param {Number} currentTabIndex - L'indice del tab corrente
	     * @return {String} - Il nome della classe per settare il colore del macro
	     */
	    this.getStyleTabMacro = function (currentTabIndex) {
	      if (currentTabIndex < self.currentTabMacro.index) {
	        return 'progress-pass';
	      }
	      if (currentTabIndex === self.currentTabMacro.index) {
	        return 'progress-current';
	      }
	      return 'progress-next';
	    };
	
	    /**
	     * @ngdoc method
	     * @name getStyleTabMacroReadOnly
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Riceve la classe appropriata per la colorazione del macro (soltanto per la modalita visualizza)
	     * @param {Number} currentTabIndex - L'indice del tab corrente
	     * @return {String} - Il nome della classe per settare il colore del macro
	     */
	    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
	      if (currentTabIndex < this.currentTabMacro.index) {
	        return 'progress-next-read';
	      }
	
	      if (currentTabIndex === this.currentTabMacro.index) {
	        return 'progress-current-read';
	      }
	
	      return 'progress-next-read';
	    };
	
	    /**
	     * Per la issue CONSULENZA2017-686 in caso di nuova proposta o nuovo ordine e stata modificata la
	     * gestione degli errori, in caso di infMessage e warMessage non vengono più mostrati nel toastr in alto nella pagina ma in una modale
	     * Se si  clicca conferma il processo continua altrimenti si rimane nella pagina di inserimento parametri
	     * @param {*} defer
	     * @description Apre la modale che mostra gli errori forzabili, premendo conferma si prosegue con il processo di verifica,
	     * altrimenti si rimane sulla pagina
	     */
	    this.gestisciErroriForzabili = function (defer) {
	      self.spinner.dettaglioProposta = false;
	      $('#erroriForzabiliModal').modal('show');
	
	      document.getElementById('confirm-button').onclick = function () {
	        $('#erroriForzabiliModal').modal('hide');
	        self.spinner.dettaglioProposta = true;
	        defer.resolve();
	      };
	
	      document.getElementById('cancel-button').onclick = function () {
	        $('#erroriForzabiliModal').modal('hide');
	        self.spinner.dettaglioProposta = true;
	        defer.reject();
	      };
	    };
	
	    /**
	     * Per la issue CONSULENZA2017-686 è stato modificato,solo qui, il metodo processaResponse
	     * in modo che non consideri gli infmessage e i warmessage
	     * @ngdoc method
	     * @name promiseParametriAggiuntivi
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Funzione che decide quale verifica richiamare in base a fondo/non-fondo
	     * @return {Promise} - Ritorna una promise senza messaggio
	     */
	    this.verificaParametriAggiuntivi = function () {
	      //			Reset eventuali messaggi di Brio
	      self.messaggiSrvc.reset();
	      var defer = $q.defer();
	      if (self.isFON_POG()) {
	        self.promiseVerificaFondo().then(
	          function (response) {
	            if (self.$state.current.name.indexOf('visualizza') > -1) {
	              if (messaggiFctr.processaResponseErroriForzabili(response)) {
	                defer.reject();
	              } else {
	                //Mi salvo il risultato per usare l'esito ESG nella verifica adeguatezza
	                self.risultatoVerifica = response.data.result;
	                defer.resolve();
	              }
	            } else {
	              if (messaggiFctr.processaResponseErroriForzabili(response)) {
	                defer.reject();
	              } else {
	                //Mi salvo il risultato per usare l'esito ESG nella verifica adeguatezza
	                self.risultatoVerifica = response.data.result;
	                self.listaErroriForzabili = self.recuperaErroriForzabili(
	                  response.data.messageList
	                );
	                if (self.listaErroriForzabili.length > 0) {
	                  self.gestisciErroriForzabili(defer);
	                } else {
	                  defer.resolve();
	                }
	              }
	            }
	          },
	          function (reason) {
	            messaggiFctr.processaResponse(reason);
	            defer.reject();
	          }
	        );
	      } else {
	        self.promiseVerificaNonFondo().then(
	          function (response) {
	            if (self.$state.current.name.indexOf('visualizza') > -1) {
	              if (messaggiFctr.processaResponseErroriForzabili(response)) {
	                defer.reject();
	              } else {
	                //Mi salvo il risultato per usare l'esito ESG nella verifica adeguatezza
	                self.risultatoVerifica = response.data.result;
	                defer.resolve();
	              }
	            } else {
	              if (messaggiFctr.processaResponseErroriForzabili(response)) {
	                defer.reject();
	              } else {
	                //Mi salvo il risultato per usare l'esito ESG nella verifica adeguatezza
	                self.risultatoVerifica = response.data.result;
	                self.listaErroriForzabili = self.recuperaErroriForzabili(
	                  response.data.messageList
	                );
	                if (self.listaErroriForzabili.length > 0) {
	                  self.gestisciErroriForzabili(defer);
	                } else {
	                  defer.resolve();
	                }
	              }
	            }
	          },
	          function (reason) {
	            messaggiFctr.processaResponse(reason);
	            defer.reject();
	          }
	        );
	      }
	      return defer.promise;
	    };
	
	    /**
	     * @ngdoc method
	     * @name verifica
	     * @methodOf cbl.finanza.mf.directive:fiannzaGestioneProposta
	     * @description Effettua la verifica della proposta e procede allo step successivo
	     */
	    this.verifica = function (skipCambioPagina) {
	      self.spinner.dettaglioProposta = true;
	      self.verificaParametriAggiuntivi().then(
	        function () {
	          $q.all({
	            profiloCliente: self.promiseProfiloCliente(),
	            profiloAdeguatezza: self.promiseProfiloAdeguatezza(),
	            marketCliente: self.promiseMarketCliente(),
	            marketStrumento: self.promiseMarketStrumento()
	          })
	            .then(
	              function (response) {
	                if (
	                  self.messaggiFctr.processaResponse(response.profiloCliente) ||
	                  self.messaggiFctr.processaResponse(
	                    response.profiloAdeguatezza
	                  ) ||
	                  self.messaggiFctr.processaResponse(response.marketCliente) ||
	                  self.messaggiFctr.processaResponse(response.marketStrumento)
	                ) {
	                  self.profiloCliente = {};
	                  self.profiloAdeguatezza = {};
	                  self.marketCliente = {};
	                  self.marketStrumento = {};
	                  return;
	                }
	                self.profiloCliente = response.profiloCliente.data.result;
	                self.profiloAdeguatezza =
	                  response.profiloAdeguatezza.data.result;
	                console.log(self.profiloAdeguatezza);
	                self.marketCliente = response.marketCliente.data.result;
	                self.marketStrumento = response.marketStrumento.data.result;
	                self.recuperaModalitaEsposizioneESG();
	                if (!skipCambioPagina) {
	                  self.changeTabMacro(
	                    self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]
	                  );
	                }
	              },
	              function (reason) {
	                self.messaggiFctr.processaResponse(reason.profiloCliente);
	                self.messaggiFctr.processaResponse(reason.profiloAdeguatezza);
	                self.messaggiFctr.processaResponse(reason.marketCliente);
	                self.messaggiFctr.processaResponse(reason.marketStrumento);
	                self.profiloCliente = {};
	                self.profiloAdeguatezza = {};
	                self.marketCliente = {};
	                self.marketStrumento = {};
	              }
	            )
	            .finally(function () {
	              self.spinner.dettaglioProposta = false;
	              self.spinner.visualizzazione = false;
	            });
	        },
	        function () {
	          self.spinner.dettaglioProposta = false;
	          self.spinner.visualizzazione = false;
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkIdRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Verifica la presenza o meno di un idRaccomandazione nello stateParams
	     * Se non è presente effettua prima un inserimento di una raccomandazione
	     */
	    this.checkIdRaccomandazione = function () {
	      self.spinner.dettaglioProposta = true;
	      if (self.$stateParams.finIdRaccomandazione) {
	        self.inserisciProposta(self.$stateParams.finIdRaccomandazione);
	      } else {
	        self.promiseInserisciRaccomandazione().then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.spinner.dettaglioProposta = false;
	              return;
	            }
	            self.$stateParams.finIdRaccomandazione =
	              response.data.result.idPratica;
	            self.inserisciProposta(response.data.result.idPratica);
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	            self.spinner.dettaglioProposta = false;
	          }
	        );
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name inserisciProposta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Effettua l'inserimento di un proposta
	     * @param {Number} idRaccomandazione - Id della richiesta
	     */
	    this.inserisciProposta = function (idRaccomandazione) {
	      var propostaToSave = {
	        idProposta: self.$stateParams.finIdProposta,
	        idRaccomandazione: self.$stateParams.finIdRaccomandazione,
	        strumento: self.proposta.strumento.trim(),
	        quantita: self.proposta.quantita,
	        ctvPrevisto: self.proposta.ctvPrevisto,
	        nota: self.proposta.nota,
	        prezzo: self.proposta.prezzo,
	        segno: self.proposta.segno,
	        mercato: self.proposta.mercato,
	        divisaISO: self.proposta.divisaISO,
	        profiloAdeguatezza: self.profiloCliente.profiloAdeguatezza,
	        profiloAppropriatezza: self.profiloCliente.profiloAppropriatezza,
	        rischioComplessita: self.profiloAdeguatezza.rischioComplessita,
	        rischioEmittente: self.profiloAdeguatezza.rischioEmittente,
	        rischioLiquidita: self.profiloAdeguatezza.rischioLiquidita,
	        rischioMercato: self.profiloAdeguatezza.rischioMercato,
	        contratto: self.contratto.contratto,
	        prgContratto: self.contratto.id,
	        codiceOrdine: self.proposta.codiceOrdine,
	        presentatore: self.proposta.presentatore,
	        intestatario: self.proposta.intestatario
	      };
	      if (userSrvc.abilitato(CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA)) {
	        propostaToSave.controlloEsg = {
	          esito:
	            self.risultatoVerifica.controlloEsg.esito !== null
	              ? self.risultatoVerifica.controlloEsg.esito
	              : null
	        };
	      }
	      if (!self.isFON_POG()) {
	        propostaToSave.dataScadenza =
	          new Date(self.proposta.dataScadenza).getTime() + 1000 * 60 * 60 * 4;
	        delete propostaToSave.ctvPrevisto;
	      } else {
	        propostaToSave.parametri = self.parametriAggiuntivi;
	      }
	      self
	        .promiseInserisciProposta(propostaToSave)
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            self.$state.go(
	              self.modificaRaccomandazioneState,
	              self.$stateParams
	            );
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.dettaglioProposta = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name modificaProposta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Effettua la modifica di una proposta
	     */
	    this.modificaProposta = function () {
	      var propostaToUpdate = {
	        idProposta: self.$stateParams.finIdProposta,
	        idRaccomandazione: self.$stateParams.finIdRaccomandazione,
	        strumento: self.$stateParams.finCodiceStrumento.trim(),
	        quantita: self.proposta.quantita,
	        ctvPrevisto: self.proposta.ctvPrevisto,
	        intestatario: self.proposta.intestatario,
	        nota: self.proposta.nota,
	        prezzo: self.proposta.prezzo,
	        presentatore: self.proposta.presentatore,
	        segno: self.proposta.segno,
	        mercato: self.proposta.mercato,
	        divisaISO: self.proposta.divisaISO,
	        profiloAdeguatezza: self.profiloCliente.profiloAdeguatezza,
	        profiloAppropriatezza: self.profiloCliente.profiloAppropriatezza,
	        contratto: self.contratto.contratto,
	        prgContratto: self.contratto.id,
	        rischioComplessita: self.profiloAdeguatezza.rischioComplessita,
	        rischioEmittente: self.profiloAdeguatezza.rischioEmittente,
	        rischioLiquidita: self.profiloAdeguatezza.rischioLiquidita,
	        rischioMercato: self.profiloAdeguatezza.rischioMercato,
	        codiceOrdine: self.proposta.codiceOrdine
	      };
	      if (userSrvc.abilitato(CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA)) {
	        propostaToUpdate.controlloEsg = {
	          esito:
	            self.risultatoVerifica.controlloEsg.esito !== null
	              ? self.risultatoVerifica.controlloEsg.esito
	              : null
	        };
	      }
	      if (!self.isFON_POG()) {
	        propostaToUpdate.dataScadenza =
	          new Date(self.proposta.dataScadenza).getTime() + 1000 * 60 * 60 * 4;
	        delete propostaToUpdate.ctvPrevisto;
	      } else {
	        propostaToUpdate.parametri = self.parametriAggiuntivi;
	      }
	      self.spinner.dettaglioProposta = true;
	      self
	        .promiseModificaProposta(propostaToUpdate)
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            self.$state.go(
	              self.modificaRaccomandazioneState,
	              self.$stateParams
	            );
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.dettaglioProposta = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name indietro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Ritorna allo step precedente o ritorna alla rotta precedente (altra rotta se viene passato il parametro "prevState" al componente)
	     */
	    this.indietro = function () {
	      if (self.deskSrvc.isDesk) {
	        self.deskSrvc.popEntry();
	      }
	      //			Se c'è si va alla modifica della raccomandazione altrimenti si va allo stato di nuova raccomandazione
	      if (self.currentTabMacro.index === 1) {
	        self.changeTabMacro(
	          self.TAB_LIST_MACRO[self.currentTabMacro.index - 1]
	        );
	      } else {
	        self.$window.history.back();
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name avanti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Funzione utilizzata in modalità visualizza per passare allo step successivo
	     */
	    this.avanti = function () {
	      self.profiloCliente.profiloAdeguatezza = self.proposta.profiloAdeguatezza;
	      self.profiloCliente.profiloAppropriatezza =
	        self.proposta.profiloAppropriatezza;
	      self.profiloAdeguatezza.rischioComplessita =
	        self.proposta.rischioComplessita;
	      self.profiloAdeguatezza.rischioEmittente = self.proposta.rischioEmittente;
	      self.profiloAdeguatezza.rischioLiquidita = self.proposta.rischioLiquidita;
	      self.profiloAdeguatezza.rischioMercato = self.proposta.rischioMercato;
	      self.changeTabMacro(self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]);
	    };
	
	    /**
	     *
	     * @param {*} messageList
	     * @description recupera la lista degli errori forzabili dalla messageList
	     */
	    this.recuperaErroriForzabili = function (messageList) {
	      var tempListaErroriForzabili = [];
	      var tempListaErroriWar = null;
	      var tempListaErroriInf = null;
	
	      if (!!messageList && messageList.infMessages.length > 0) {
	        tempListaErroriInf = messageList.infMessages.map(function (error) {
	          return error;
	        });
	      }
	      if (!!messageList && messageList.warMessages.length > 0) {
	        tempListaErroriWar = messageList.warMessages.map(function (error) {
	          return error;
	        });
	      }
	      if (!!tempListaErroriWar) {
	        tempListaErroriWar.forEach(function (err) {
	          tempListaErroriForzabili.push(err);
	        });
	      }
	      if (!!tempListaErroriInf) {
	        tempListaErroriInf.forEach(function (err) {
	          tempListaErroriForzabili.push(err);
	        });
	      }
	      return tempListaErroriForzabili;
	    };
	    /*
	     * ---------------------
	     * END METODI CONTROLLER
	     * ---------------------
	     */
	
	    /*
	     * ----------------------------
	     * START METODI INIT CONTROLLER
	     * ----------------------------
	     */
	    this.recuperaModalitaEsposizioneESG = function () {
	      // modalitaEsposizioneESG
	      self.modalitaEsposizioneESG =
	        self.userSrvc.configurazioni[
	          CONSTANTS.ABILITAZIONI.MODALITA_ESPOSIZIONE_ESG_STRUMENTO
	        ];
	      switch (self.modalitaEsposizioneESG) {
	        case 'RATING':
	          self.esposizioneRatingESG = true;
	          self.esposizioneScoreESG = false;
	          break;
	        case 'SCORE':
	          self.esposizioneRatingESG = false;
	          self.esposizioneScoreESG = true;
	          break;
	        case 'ALL':
	          self.esposizioneRatingESG = true;
	          self.esposizioneScoreESG = true;
	          break;
	      }
	    };
	    this.checkCasiDaGestire = function () {
	      /*
	       * Casi da gestire quando entro in gestioneProposta
	       * 1 - Nuova proposta
	       *   Se non ho idPratica e codiceStrumento apro ricercaStrumento: ricercaStrumento -> dettaglioStrumento -> parametriAggiuntivi
	       * 2 - Nuova proposta dal saldo portafoglio
	       *   Se ho soltanto codiceStrumento chiamo saldoPortafoglio -> dettaglioStrumento -> parametriAggiuntivi
	       * 3 - Modifica proposta
	       *   Se ho sia codiceStrumento che idPratica: dettaglioProposta -> dettaglioStrumento -> parametriAggiuntivi
	       */
	      if (
	        self.$stateParams.finCodiceStrumento &&
	        self.$stateParams.finIdProposta
	      ) {
	        // Modifica di una proposta
	        self.spinner.dettaglioProposta = true;
	        self.recuperaDettaglioProposta();
	      } else if (
	        self.$stateParams.finCodiceStrumento &&
	        !self.$stateParams.finIdProposta
	      ) {
	        // Nuova proposta da saldo
	        self.spinner.dettaglioProposta = true;
	        //	    		Setto il segno se vengo dal saldo portafoglio
	        self.proposta.segno = self.$stateParams.acqven;
	        self.recuperaSaldoPortafoglio();
	      } else {
	        // Nuova proposta da zero
	        self.showFinancialTool = true;
	      }
	    };
	
	    labelSrvc.labelsPronte.then(function () {
	      self.TAB_LIST_MACRO = [
	        {
	          index: 0,
	          url:
	            self.CONSTANTS.BASE_ROOT +
	            self.CONSTANTS.COMPONENTS_PATH +
	            'gestioneProposta/partials/inserimentoParametri.html',
	          title: $scope.msg('step.preparazione.proposta')
	        },
	        {
	          index: 1,
	          url:
	            self.CONSTANTS.BASE_ROOT +
	            self.CONSTANTS.COMPONENTS_PATH +
	            'gestioneProposta/partials/verificaAdeguatezza.html',
	          title: $scope.msg('step.verifica.adeguatezza')
	        }
	      ];
	      self.currentTabMacro = self.TAB_LIST_MACRO[0];
	    });
	
	    /**
	     * @ngdoc method
	     * @name getDossier
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Chiama il rest per avere il dettalgio del dossier
	     */
	    this.$http({
	      method: 'GET',
	      url:
	        CONSTANTS.REST_ROOT +
	        CONSTANTS.REST.DOSSIER +
	        self.$stateParams.finCodiceRapporto
	    }).then(
	      function (response) {
	        if (self.messaggiFctr.processaResponse(response)) {
	          return;
	        }
	        self.dossier = response.data.result;
	        self.checkCasiDaGestire();
	      },
	      function (reason) {
	        self.messaggiFctr.processaResponse(reason);
	      }
	    );
	
	    // Chiamo il getDossier per inserire le info nel customerdata
	    self.promiseCustomerData().then(
	      function (response) {
	        if (self.messaggiFctr.processaResponse(response)) {
	          self.posizione = {};
	          return;
	        }
	        self.posizione = response.data;
	      },
	      function (reason) {
	        self.messaggiFctr.processaResponse(reason);
	      }
	    );
	
	    /*
	     * --------------------------
	     * END METODI INIT CONTROLLER
	     * --------------------------
	     */
	
	    if (self.deskSrvc.isDesk) {
	      labelSrvc.labelsPronte.then(function () {
	        self.deskSrvc.aggiungiEntry(labelSrvc.getLabel('gestione.proposta'));
	      });
	    }
	  };
	
	  GestionePropostaCtrl.$inject = [
	    '$http',
	    '$q',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$location',
	    '$filter',
	    'FIN_CONSTANTS',
	    'FinLabelSrvc',
	    'FinMessaggiFctr',
	    'CblMessageSrvc',
	    'FinUserSrvc',
	    'FinBrioSrvc',
	    'FinDeskSrvc'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'gestioneProposta/gestioneProposta.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var GestionePropostaComponent = {
	    bindings: {
	      modificaRaccomandazioneState: '@'
	    },
	    controller: GestionePropostaCtrl,
	    controllerAs: 'gestioneCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finanzaGestioneProposta', GestionePropostaComponent);
	})();


/***/ },
/* 19 */
/***/ function(module, exports) {

	/**
	 *@ngdoc directive
	 *@name cbl.finanza.mf.directive:finanzaGestioneRichiesta
	 *@restrict E
	 *@scope
	 *@description Componente utilizzato per inserire le richieste d'ordine e per visualizzare il riepilogo dei documenti
	 *@param {String} gestioneOrdineState - Nome dello stato per gestire un ordine
	 *@param {String} saldoDossierState - Nome dello stato del saldo dossier
	 */
	(function () {
	  'use strict';
	  var GestioneRichiestaCtrl = function (
	    $q,
	    $scope,
	    $http,
	    $state,
	    $stateParams,
	    $window,
	    $location,
	    $uibModal,
	    CONSTANTS,
	    messaggiFctr,
	    labelSrvc,
	    messaggiSrvc,
	    userSrvc,
	    brioSrvc,
	    deskSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.messaggiFctr = messaggiFctr;
	    this.messaggiSrvc = messaggiSrvc;
	    this.userSrvc = userSrvc;
	    this.brioSrvc = brioSrvc;
	    this.deskSrvc = deskSrvc;
	    $scope.msg = labelSrvc.getLabel;
	    this.CONSTANTS = CONSTANTS;
	    this.$uibModal = $uibModal;
	    this.spinner = {
	      listaOrdini: false,
	      avanzamento: false
	    };
	    this.ordiniTableData = [];
	    this.richiesta = {};
	    this.messaggiFctr.chiudiLoaderBrio();
	    this.anagraficaFea = {};
	    this.isBloccoCutOff = false;
	    var self = this;
	
	    //
	    //		---------------------------- REST PROMISES ----------------------------
	    //
	
	    /**
	     * @ngdoc method
	     * @name promiseCustomerData
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Effettua la chiamata per ricevere il customerdata
	     * @return {Promise} - Ritorna una promise contenente il customerdata
	     */
	    this.promiseCustomerData = function () {
	      return self.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
	        params: {
	          rapporto: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaRichieste
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Effettua una chiamata http per ricevere la lista delle richieste associate ad una raccomandazione
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista delle richieste
	     */
	    this.promiseDatiTabellaOrdini = function () {
	      self.spinner.listaOrdini = true;
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          self.$stateParams.finIdRichiesta +
	          '/ordini'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDettaglioRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Effettua una chiamata http per ricevere il dettaglio di una richiesta
	     * @return {Promise} - Ritorna una promise contenente i dati del dettaglio di una richiesta
	     */
	    this.promiseDettaglioRichiesta = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RICHIESTA +
	          'richiesta/' +
	          self.$stateParams.finIdRichiesta
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseConsolidaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Effettua una chiamata http per consolidare una richiesta
	     * @return {Promise} - Ritorna una promise contenente il risultato del consolida richiesta
	     */
	    this.promiseConsolidaRichiesta = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RICHIESTA +
	          self.$stateParams.finIdRichiesta +
	          '/consolida'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseAccettaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Effettua una chiamata http per accettare una richiesta
	     * @return {Promise} - Ritorna una promise contenente il risultato dell'accetta richiesta
	     */
	    this.promiseAccettaRichiesta = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RICHIESTA +
	          self.$stateParams.finIdRichiesta +
	          '/accetta'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseRevisionaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Effettua una chiamata http per revisionare una richiesta
	     * @return {Promise} - Ritorna una promise contenente il risultato della revisione richiesta
	     */
	    this.promiseRevisionaRichiesta = function (nota) {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RICHIESTA +
	          'revisione/' +
	          self.$stateParams.finIdRichiesta,
	        data: { nota: nota }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseRifiutaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Effettua una chiamata http per rifiutare una richiesta
	     * @return {Promise} - Ritorna una promise contenente il risultato del rifiuta richiesta
	     */
	    this.promiseRifiutaRichiesta = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RICHIESTA +
	          'rifiuta/' +
	          self.$stateParams.finIdRichiesta
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseAccettaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Effettua una chiamata http per accettare una richiesta
	     * @return {Promise} - Ritorna una promise contenente il risultato dell'accetta richiesta
	     */
	    this.promiseTerminaRichiesta = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RICHIESTA +
	          'termina/' +
	          self.$stateParams.finIdRichiesta
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseIniziaRevisioneRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Effettua una chiamata http per iniziare la revisione di una richiesta
	     * @return {Promise} - Ritorna una promise contenente il risultato dell'avvio della revisione richiesta
	     */
	    this.promiseIniziaRevisioneRichiesta = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RICHIESTA +
	          'iniziaRevisione/' +
	          self.$stateParams.finIdRichiesta
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDati
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Effettua una chiamata http per ricevere il dettaglio dell'ndg
	     * @return {Promise} - Ritorna una promise contenente l'anagrafica
	     */
	    this.promiseAnagrafica = function () {
	      return self.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA + 'Intestatario',
	        params: {
	          ndg: self.$stateParams.ndg
	        }
	      });
	    };
	    this.promiseBloccoCutOff = function(finIdRichiesta) {
	      return $http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CUT_OFF+ '/'+ 
	        finIdRichiesta,
	        params: {}
	      });
	  };
	    //
	    //		-------------------------- INIT LABEL TABELLE -------------------------
	    //
	
	    /**
	     * @ngdoc method
	     * @name initLabelTabellaOrdini
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Crea le label e la struttura della tabella degli ordini
	     */
	    this.initLabelTabellaOrdini = function () {
	      self.ordiniTableLabel = [
	        {
	          name: $scope.msg('lista.ordini.descrizione'),
	          field: 'DescrizioneStrumento',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.ordini.intestatario'),
	          field: 'Intestazione',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.proposte.acq.ven'),
	          field: 'tipo.segno',
	          width: '*',
	          enableFiltering: false,
	          cellTemplate:
	            '<div class="ui-grid-cell-contents" ng-if="grid.appScope.msg(\'lista.ordini.a\') === row.entity.segno">{{grid.appScope.msg(\'lista.ordini.acq\')}}</div>' +
	            '<div class="ui-grid-cell-contents" ng-if="grid.appScope.msg(\'lista.ordini.d\') === row.entity.segno">{{grid.appScope.msg(\'lista.ordini.ven\')}}</div>' +
	            '<div class="ui-grid-cell-contents" ng-if="grid.appScope.msg(\'lista.ordini.s\') === row.entity.segno">{{grid.appScope.msg(\'lista.ordini.swi\')}}</div>' +
	            '<div class="ui-grid-cell-contents" ng-if="\'P\' === row.entity.segno">{{grid.appScope.msg(\'lista.ordini.piano\')}}</div>'
	        },
	        {
	          name: $scope.msg('lista.ordini.qta'),
	          field: 'quantita',
	          width: '12%',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.ordini.ctv.teorico'),
	          field: 'ctvPrevisto',
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.ordini.tipo.ordine'),
	          field: 'codiceOrdine',
	          width: '12%',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.ordini.check'),
	          field: 'check',
	          width: '*',
	          enableFiltering: false,
	          cellClass: 'center',
	          cellTemplate:
	            '<i class="fa fa-circle fa-2x finIMargin" ng-class="{finIGreen : row.entity.profiloAppropriatezza >= row.entity.rischioComplessita, finIOrange: row.entity.profiloAppropriatezza < row.entity.rischioComplessita}" aria-hidden="true"></i>'
	        },
	        {
	          name: 'Stato', /**Da riempire con  label */
	          field: 'descrizioneStatoOrdine',
	          width: '*',
	          enableFiltering: false,
	          cellClass: 'center',
	        },{
	          name:'Numero ordine',/**Da riempire con  label */
	          field: 'numeroOrdine',
	          width: '*',
	          enableFiltering: false,
	          cellClass: 'center',
	        },
	      ];
	      if (
	        self.$stateParams.finIdRaccomandazione ||
	        self.$state.current.name.indexOf('visualizza') > -1
	      ) {
	        self.ordiniTableLabel.push({
	          name: $scope.msg('lista.ordini.azione'),
	          field: 'azione',
	          width: 60,
	          enableFiltering: false,
	          cellTemplate:
	            '<i class="fa fa-search finIPointer finIMargin fa-2x" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaOrdine({ordine: row.entity})"></i>'
	        });
	      } else {
	        self.ordiniTableLabel.push({
	          name: $scope.msg('lista.ordini.azione'),
	          field: 'azione',
	          width: 60,
	          enableFiltering: false,
	          cellTemplate:
	            '<i class="fa fa-pencil finIPointer finIMargin fa-2x" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" tooltip-placement="left" ng-click="grid.appScope.gestioneOrdine({ordine: row.entity})"></i>'
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name initData
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Esegue il caricamento dei dati per la pagina
	     */
	    this.initData = function () {
	      $q.all({
	        label: labelSrvc.labelsPronte,
	        ordini: self.promiseDatiTabellaOrdini(),
	        richiesta: self.promiseDettaglioRichiesta()
	      })
	        .then(
	          function (response) {
	            if (
	              self.messaggiFctr.processaResponse(response.ordini) ||
	              self.messaggiFctr.processaResponse(response.richiesta)
	            ) {
	              self.ordiniTableData = [];
	              return;
	            }
	            self.richiesta = response.richiesta.data.result;
	            self.getCustomerDossier();
	            self.checkStatoPraticaInValutazione();
	            self.initLabelTabellaOrdini();
	            self.ordiniTableData = response.ordini.data.result;
	            self.setAnagraficaFea();
	
	            if (
	              self.richiesta &&
	              self.richiesta.stato ===
	                CONSTANTS.STATO_RACCOMANDAZIONE.DA_REVISIONARE
	            ) {
	              self.avviaRevisionePratica();
	              return;
	            }
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason.ordini);
	            self.messaggiFctr.processaResponse(reason.richiesta);
	            self.messaggiFctr.processaResponse(reason.customerDossier);
	            self.ordiniTableData = [];
	          }
	        )
	        .finally(function () {
	          self.initTabListMacro();
	          self.spinner.listaOrdini = false;
	        });
	    };
	    this.initBloccoCutOff = function(finIdRichiesta)
	    {
	      self.promiseBloccoCutOff(finIdRichiesta)
	      .then(function(response){
	        if(self.modalita &&
	          self.modalita.stato !== CONSTANTS.MODALITA.VISUALIZZA ){
	              //BLOCCO CUT-OFF IL PULSANTE ACCETTA VIENE DISABILITATO NEL CASO IN CUI RITORNI UNA LISTA DI ERRORI
	              //O SE RESULT === FALSE
	              if(self.messaggiFctr.processaResponse(response) || response.data.result === false ){
	              self.isBloccoCutOff = true;
	              self.spinner.avanzamento = false;
	              }
	        }
	      });
	    }
	    //
	    //		--------------------------- INIT CONTROLLER ---------------------------
	    //
	
	    //		Se non ho il codiceRapporto perché vengo da Brio lo prendo, lo metto nello $stateParams e faccio un refresh
	    if (!self.$stateParams.finCodiceRapporto) {
	      self.promiseDettaglioRichiesta().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            return;
	          }
	          if (response.data.result) {
	            self.$stateParams.finCodiceRapporto =
	              response.data.result.codiceDossierTitoli;
	            self.$state.go(self.$state.current.name, self.$stateParams, {
	              reload: true
	            });
	          }
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    } else {
	      // Normale funzionamento
	      self.initData();
	      //self.initBloccoCutOff(self.$stateParams.finIdRichiesta);
	    }
	    //
	    //		---------------------------- HELPER METHOD ----------------------------
	    //
	    /**
	     * @ngdoc method
	     * @name getCustomerDossier
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Dicide quale servizio per il customer dossier richiamare
	     */
	    this.getCustomerDossier = function () {
	      // Chiamo il getDossier per inserire le info nel customerdata
	      self.promiseCustomerData().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.posizione = {};
	            return;
	          }
	          self.posizione = response.data;
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkStatoPraticaInValutazione
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     *@description Se siamo in INCORSO, PRESENTATA o VALUTAZIONE e
	     * la pratica è in uno stato diverso da PRESENTATA
	     * effettuo il redirect allo stato di visualizzazione
	     */
	    this.checkStatoPraticaInValutazione = function () {
	      var statiRichiestaModificabile = [
	        CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO,
	        CONSTANTS.STATO_RACCOMANDAZIONE.PRESENTATA,
	        CONSTANTS.STATO_RACCOMANDAZIONE.CONSOLIDATA,
	        CONSTANTS.STATO_RACCOMANDAZIONE.DA_REVISIONARE
	      ];
	      //			Se lo stato della raccomandazione non è compreso tra quelli soprastanti
	      //			e la modalità è valutazione vado in modalità visualizza
	      if (
	        statiRichiestaModificabile.indexOf(self.richiesta.stato) === -1 &&
	        self.modalita === CONSTANTS.MODALITA.MODIFICA &&
	        self.$stateParams.esterno
	      ) {
	        self.$state.go(self.visualizzaRichiestaState, self.$stateParams, {
	          reload: true
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name avviaRevisionePratica
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Se la pratica è in stato DA REVISIONARE, lancio la chiamata
	     * per portarla in revisione e ricarico
	     */
	    this.avviaRevisionePratica = function () {
	      $q.all({
	        revisione: self.promiseIniziaRevisioneRichiesta()
	      }).then(function (response) {
	        if (self.messaggiFctr.processaResponse(response.revisione)) {
	          return;
	        }
	
	        // Recupero nuovamente la richiesta aggiornata
	        self.initData();
	        //self.initBloccoCutOff(self.$stateParams.finIdRichiesta);
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name getDettaglioRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Recupera la richiesta dal backend
	     */
	    this.getDettaglioRichiesta = function () {
	      self
	        .promiseDettaglioRichiesta()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.spinner.avanzamento = false;
	              return;
	            }
	            self.richiesta = response.data.result;
	            self.changeTabMacro(
	              self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]
	            );
	            self.initBloccoCutOff(self.$stateParams.finIdRichiesta);
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.avanzamento = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name initTabListMacro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Inizializza il giusto step in base allo stato della richiesta
	     */
	    this.initTabListMacro = function () {
	      self.TAB_LIST_MACRO = [
	        {
	          index: 0,
	          url:
	            CONSTANTS.BASE_ROOT +
	            CONSTANTS.COMPONENTS_PATH +
	            'gestioneRichiesta/partials/inserimentoOrdini.html',
	          title: $scope.msg('step.inserimento.richieste.ordine')
	        },
	        {
	          index: 1,
	          url:
	            CONSTANTS.BASE_ROOT +
	            CONSTANTS.COMPONENTS_PATH +
	            'gestioneRichiesta/partials/documentiRiepilogo.html',
	          title: $scope.msg('step.documenti.riepilogo')
	        }
	      ];
	      if (
	        self.richiesta.stato === CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO ||
	        self.modalita === CONSTANTS.MODALITA.VISUALIZZA
	      ) {
	        self.currentTabMacro = self.TAB_LIST_MACRO[0];
	      } else {
	        self.currentTabMacro = self.TAB_LIST_MACRO[1];
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name setAnagraficaFea
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Crea l'oggetto anagraficaFea per passarlo al widget della FEA
	     */
	    this.setAnagraficaFea = function () {
	      self.anagraficaFea = {
	        idAnagrafica: self.richiesta.intestatario.idAnagrafica,
	        ndg: self.richiesta.intestatario.ndg,
	        naturaGiuridica: self.richiesta.intestatario.formaCostitutiva
	      };
	    };
	
	    /**
	     * @ngdoc method
	     * @name ritornoBackOffice
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Dopo aver ricevuto il dettaglio dell'ndg ritorna al backoffice
	     */
	    this.ritornoBackOffice = function () {
	      self.promiseAnagrafica().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            return;
	          }
	          if (
	            response.data &&
	            response.data.result &&
	            response.data.result.length
	          ) {
	            switch (self.brioSrvc.brioVersion) {
	              case 'brio2':
	              case 'brio3':
	                self.$stateParams.idAnagrafica =
	                  response.data.result[0].idAnagrafica;
	                self.$state.go('schedaCliente', self.$stateParams);
	                break;
	              case 'brio-xc':
	                var parametri = [
	                  //		    				{
	                  //		    					chiave: 'idAnagrafica',
	                  //		    					valore: response.data.result[0].idAnagrafica
	                  //		    				}
	                  {
	                    chiave: 'ndg',
	                    valore: self.$stateParams.ndg
	                  }
	                ];
	                self.brioSrvc.goTo(
	                  'scrivaniautente',
	                  'home.schedacliente',
	                  parametri
	                );
	                break;
	            }
	          }
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name changeTabMacro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Setta il tab attuale
	     * @param {Object} tab - L'oggetto tab che deve essere setatto come attuale
	     */
	    this.changeTabMacro = function (tab) {
	      self.currentTabMacro = tab;
	      self.messaggiSrvc.reset();
	    };
	
	    /**
	     * @ngdoc method
	     * @name getStyleTabMacro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Riceve la classe appropriata per la colorazione del macro
	     * @param {Number} currentTabIndex - L'indice del tab corrente
	     * @return {String} - Il nome delal classe per settare il colore del macro
	     */
	    this.getStyleTabMacro = function (currentTabIndex) {
	      if (currentTabIndex < self.currentTabMacro.index) {
	        return 'progress-pass';
	      }
	      if (currentTabIndex === self.currentTabMacro.index) {
	        return 'progress-current';
	      }
	      return 'progress-next';
	    };
	
	    /**
	     * @ngdoc method
	     * @name getStyleTabMacroReadOnly
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Riceve la classe appropriata per la colorazione del macro (soltanto per la modalita visualizza)
	     * @param {Number} currentTabIndex - L'indice del tab corrente
	     * @return {String} - Il nome della classe per settare il colore del macro
	     */
	    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
	      if (currentTabIndex < this.currentTabMacro.index) {
	        return 'progress-next-read';
	      }
	
	      if (currentTabIndex === this.currentTabMacro.index) {
	        return 'progress-current-read';
	      }
	
	      return 'progress-next-read';
	    };
	
	    //
	    //		--------------------------- BUTTONS METHOD ----------------------------
	    //
	
	    /**
	     * @ngdoc method
	     * @name modificaOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Va nello stato di modifica dell'ordine
	     * @param {Object} ordine - L'ordine da gestire
	     */
	    this.gestioneOrdine = function (ordine) {
	      self.$stateParams.finIdOrdine = ordine.idOrdine;
	      self.$stateParams.finCodiceStrumento = ordine.strumento;
	      self.$state.go(self.gestioneOrdineState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name visualizzaOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Va nello stato di visualizzazione dell'ordine
	     * @param {Object} ordine - L'ordine da visualizzare
	     */
	    this.visualizzaOrdine = function (ordine) {
	      self.$stateParams.finIdOrdine = ordine.idOrdine;
	      self.$stateParams.finCodiceStrumento = ordine.strumento;
	      self.$state.go(self.visualizzaOrdineState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name consolidaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Consolida lo stato della richiesta e va allo step successivo
	     */
	    this.consolidaRichiesta = function () {
	      self.spinner.avanzamento = true;
	      self.promiseConsolidaRichiesta().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.spinner.avanzamento = false;
	            return;
	          }
	          if (response.data.result) {
	            self.getDettaglioRichiesta();
	            /* self.promiseBloccoCutOff(self.$stateParams.finIdRichiesta)
	            .then(function(response){
	              //BLOCCO CUT-OFF IL PULSANTE ACCETTA VIENE DISABILITATO NEL CASO IN CUI RITORNI UNA LISTA DI ERRORI
	              //O SE RESULT === FALSE
	              if(self.messaggiFctr.processaResponse(response) || response.data.result === false ){
	                self.isBloccoCutOff = true;
	                self.spinner.avanzamento = false;
	              }
	        }) */
	          }
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	          self.spinner.avanzamento = false;
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name accetta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description: Accetta la richiesta e torna allo stato del dettaglio del saldo
	     */
	    this.accetta = function () {
	      self.spinner.avanzamento = true;
	      self
	        .promiseAccettaRichiesta()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            if (response.data.result) {
	                self.ritornoBackOffice();
	            }
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.avanzamento = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name revisiona
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description: Manda la richiesta in stato di revisione e torna allo stato del dettaglio del saldo
	     */
	    this.revisiona = function () {
	      var modalController = function ($scope, $modalInstance) {
	        $scope.revisionaRichiesta = function () {
	          self.spinner.avanzamento = true;
	          var nota = $scope.notaRevisione;
	          self
	            .promiseRevisionaRichiesta(nota)
	            .then(
	              function (response) {
	                if (self.messaggiFctr.processaResponse(response)) {
	                  return;
	                }
	                if (response.data.result) {
	                  $modalInstance.close();
	                  self.ritornoBackOffice();
	                }
	              },
	              function (reason) {
	                self.messaggiFctr.processaResponse(reason);
	              }
	            )
	            .finally(function () {
	              self.spinner.avanzamento = false;
	            });
	        };
	      };
	
	      modalController.$inject = ['$scope', '$modalInstance'];
	
	      var modalInstance = this.$uibModal.open({
	        animation: true,
	        template:
	          '<div style="padding: 10px 20px; text-align: center;"><p><b>Inserisci una nota per la revisione</b></p><textarea class="form-control" rows="6" style="width:100%; margin-bottom:15px;" ng-model="notaRevisione"></textarea><button type="button" class="btn btn-primary" ng-click="revisionaRichiesta()">Conferma</button></div>',
	        size: 'sm',
	        controller: modalController
	      });
	
	      modalInstance.result.then(function (confirmResult) {
	        if (confirmResult !== true) {
	          return;
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name rifiuta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description: Rifiuta la richiesta e torna allo stato del dettaglio del saldo
	     */
	    this.rifiuta = function () {
	      self.spinner.avanzamento = true;
	      self
	        .promiseRifiutaRichiesta()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            if (response.data.result) {
	              self.ritornoBackOffice();
	            }
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.avanzamento = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name termina
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Termina la gestione della richiesta
	     */
	    this.termina = function () {
	      self.spinner.avanzamento = true;
	      self.promiseBloccoCutOff(self.$stateParams.finIdRichiesta)
	      .then(function(response) {
	        //BLOCCO CUT-OFF IL PULSANTE ACCETTA VIENE DISABILITATO NEL CASO IN CUI RITORNI UNA LISTA DI ERRORI
	        //O SE RESULT === FALSE il secondo controllo è preventivo mi aspetto non capiti mai
	        if (self.messaggiFctr.processaResponse(response) || response.data.result === false ) {
	          self.spinner.avanzamento = false;
	          self.isBloccoCutOff = true;
	          return;
	        }
	        self
	        .promiseTerminaRichiesta()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            if (response.data.result) {
	              if(sessionStorage.getItem('isFromGestioneOrdine')){
	                self.$state.go('modificaraccomandazione', self.$stateParams);
	              }
	              else{
	                self.$state.go(self.saldoDossierState, self.$stateParams);
	              }
	            }
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.avanzamento = false;
	        });
	      })
	      .finally(function(){
	        self.spinner.raccomandazione = false;
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name avanti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Procede allo step1 quando siamo in modalita visualizza
	     */
	    this.avanti = function () {
	      self.changeTabMacro(self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]);
	    };
	
	    /**
	     * @ngdoc method
	     * @name indietro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
	     * @description Ritorna allo step precedente se siamo in modalita visualizza e allo step1 altrimenti ritorna alla sezione precedente (saldo dossier)
	     */
	    this.indietro = function () {
	      if (self.deskSrvc.isDesk) {
	        self.deskSrvc.popEntry();
	      }
	      if (
	        self.modalita === CONSTANTS.MODALITA.VISUALIZZA &&
	        self.currentTabMacro.index === 1
	      ) {
	        self.changeTabMacro(self.TAB_LIST_MACRO[0]);
	      } else {
	            if (self.$stateParams.esterno) {
	              self.ritornoBackOffice();
	        }   else if(sessionStorage.getItem('isFromGestioneOrdine') && sessionStorage.getItem('isModifica')){
	              /* sessionStorage.removeItem('isFromGestioneOrdine'); */
	              sessionStorage.removeItem('isModifica');
	              self.$state.go('modificaraccomandazione', self.$stateParams);
	        }else if(sessionStorage.getItem('isFromGestioneOrdine') && sessionStorage.getItem('isVisualizza')){
	              /* sessionStorage.removeItem('isFromGestioneOrdine'); */
	              sessionStorage.removeItem('isVisualizza');
	              self.$state.go('visualizzaraccomandazione', self.$stateParams);
	        }   
	        else {
	              self.$state.go(self.saldoDossierState, self.$stateParams);
	        }
	      }
	    };
	
	    if (self.deskSrvc.isDesk) {
	      labelSrvc.labelsPronte.then(function () {
	        self.deskSrvc.aggiungiEntry(labelSrvc.getLabel('gestione.richiesta'));
	      });
	    }
	  };
	  GestioneRichiestaCtrl.$inject = [
	    '$q',
	    '$scope',
	    '$http',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$location',
	    '$uibModal',
	    'FIN_CONSTANTS',
	    'FinMessaggiFctr',
	    'FinLabelSrvc',
	    'CblMessageSrvc',
	    'FinUserSrvc',
	    'FinBrioSrvc',
	    'FinDeskSrvc'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'gestioneRichiesta/gestioneRichiesta.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var GestioneRichiestaComponent = {
	    bindings: {
	      gestioneOrdineState: '@',
	      saldoDossierState: '@',
	      visualizzaOrdineState: '@',
	      visualizzaRichiestaState: '@',
	      modalita: '@'
	    },
	    controller: GestioneRichiestaCtrl,
	    controllerAs: 'gestioneCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finanzaGestioneRichiesta', GestioneRichiestaComponent);
	})();


/***/ },
/* 20 */
/***/ function(module, exports) {

	/**
	 *@ngdoc directive
	 *@name cbl.finanza.mf.directive:finanzaGestioneOrdine
	 *@restrict E
	 *@scope
	 *@description Componente utilizzato per l'inserimento dei parametri riferiti ad un ordine
	 *@param {String} gestioneRichiestaState - Nome dello stato di gestione della richiesta
	 */
	(function () {
	  'use strict';
	  var GestioneOrdineCtrl = function (
	    $http,
	    $q,
	    $scope,
	    $state,
	    $stateParams,
	    $window,
	    $location,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    messaggiSrvc,
	    userSrvc,
	    brioSrvc,
	    deskSrvc
	  ) {
	    this.$http = $http;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.CONSTANTS = CONSTANTS;
	    this.$window = $window;
	    this.$location = $location;
	    this.messaggiFctr = messaggiFctr;
	    this.messaggiSrvc = messaggiSrvc;
	    this.userSrvc = userSrvc;
	    this.brioSrvc = brioSrvc;
	    $scope.msg = labelSrvc.getLabel;
	    this.deskSrvc = deskSrvc;
	
	    this.ordine = {};
	    this.dossier = {};
	    this.saldoPortafoglio = {};
	    this.dettaglioStrumento = undefined;
	    this.tipoOrdine = undefined;
	    this.listaContratti = [];
	    this.contratto = {};
	    this.parametriAggiuntivi = undefined;
	    this.profiloCliente = {};
	    this.profiloAdeguatezza = {};
	    this.mostraParametriAggiuntivi = true;
	    this.showFinancialTool = false;
	    this.spinner = {
	      dettaglioOrdine: false,
	      parametriAggiuntivi: false
	    };
	    this.datepicker = {
	      isOpen: false,
	      dateOptions: {
	        formatDay: 'dd',
	        formatMonth: 'MM',
	        formatYear: 'yyyy',
	        startingDay: 1
	      }
	    };
	    this.regexTestoNota = new RegExp(/^[a-zA-Z \u00E0-\u00FC'0-9,.;:]+$/i);
	    this.messaggiFctr.chiudiLoaderBrio();
	    this.mostraParametriBloccati = false;
	    this.isFromGestioneProposta = false;
	    
	    this.listaErroriForzabili=null;
	
	    var self = this;
	
	    /**
	     * Abilitazioni
	     */
	    this.userSrvc.abilitazioniPronte.then(function (value) {
	      if (value) {
	        self.mostraParametriBloccati = self.userSrvc.abilitazioni.some(
	          function (abilitazione) {
	            return (
	              abilitazione.codice.toLowerCase() ===
	              self.CONSTANTS.ABILITAZIONI.VISUALIZZA_PARAMETRI_BLOCCATI.toLowerCase()
	            );
	          }
	        );
	      }
	    });
	
	    /*
	     * -------------------------------------
	     * START METODI PROMISE PER SERVIZI REST
	     * -------------------------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name promiseCustomerData
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua la chiamata per ricevere il customerdata
	     * @return {Promise} - Ritorna una promise contenente il customerdata
	     */
	    this.promiseCustomerData = function () {
	      return self.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
	        params: {
	          rapporto: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDettaglioOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua una chiamata http per ricevere il dettaglio di un ordine
	     * @return {Promise} - Ritorna una promise contenente il dettaglio di un ordine
	     */
	    this.promiseDettaglioOrdine = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RICHIESTA +
	          self.$stateParams.finIdOrdine
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDettaglioStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua la chiamata GET per ricevere il dettaglio dello strumento
	     * @param {String} [codiceStrumento] - Parametro opzionale passato esclusivamente quando si viene richiamati dalla funzione financialToolResult
	     * @return {Promise} - Ritorna una promise conentente i dati del dettaglio dello strumento
	     */
	    this.promiseDettaglioStrumento = function (codiceStrumento) {
	      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO;
	      url += codiceStrumento
	        ? codiceStrumento
	        : self.$stateParams.finCodiceStrumento;
	      return self.$http({
	        method: 'GET',
	        url: url
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseSaldoPortafoglio
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua la chiamata POST per ricevere il saldo portafoglio
	     * @return {Promise} - Ritorna una promise contenente i dati del saldo portafoglio
	     */
	    this.promiseSaldoPortafoglio = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          self.$stateParams.finCodiceRapporto +
	          '/saldi'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseTipoOrdineFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Ritorna la lista dei tipo ordine per i fondi
	     * @return {Promise} - Ritorna una promise contenente la lista dei tipi di ordine per i fondo
	     */
	    this.promiseTipoOrdineFondo = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PARAMETRI +
	          'fondo/' +
	          self.ordine.strumento
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseGetPresentatoreFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Ritorna i parametri aggiuntivi per il tipo fondo
	     * @return {Promise} - Ritorna una promise contenente i parametri aggiuntivi dello strumento di tipo fondo
	     */
	    this.promiseGetPresentatoreFondo = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PARAMETRI +
	          'presentatoreFondo/' +
	          self.$stateParams.finCodiceRapporto +
	          '/' +
	          self.ordine.strumento +
	          '/' +
	          self.ordine.segno
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseParametriAggiuntiviFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Ritorna i parametri aggiuntivi per i fondo
	     */
	    this.promiseParametriAggiuntiviFondo = function () {
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PARAMETRI +
	          'fondo/' +
	          self.$stateParams.finCodiceRapporto,
	        data: {
	          strumento: self.ordine.strumento,
	          codiceOrdine: self.tipoOrdine.codiceOperazione,
	          contratto: self.contratto ? self.contratto.contratto : undefined,
	          parametri: self.parametriAggiuntivi,
	          quantita: self.ordine.quantita,
	          ctvPrevisto: self.ordine.ctvPrevisto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseParametriAggiuntiviNonFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Ritorna tutti i dati compresi i parametri aggiuntivi per i non fondi
	     */
	    this.promiseParametriAggiuntiviNonFondo = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.PARAMETRI +
	          'nonFondo/' +
	          self.$stateParams.finCodiceRapporto +
	          '/' +
	          self.ordine.strumento +
	          '/' +
	          self.ordine.segno
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseProfiloCliente
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua la chiamata rest per il profilo cliente
	     * @return {Promise} - Ritorna una promise contenente il profilo del cliente
	     */
	    this.promiseProfiloCliente = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          'profiloCliente/' +
	          self.dossier.ndgIntestatario,
	        params: {
	          idDossier: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseProfiloAdeguatezza
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua la chiamata rest per la verifica dell'adeguatezza
	     * @return {Promise} - Ritorna una promise contenente la verifica dell'adeguatezza
	     */
	    this.promiseProfiloAdeguatezza = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.STRUMENTO +
	          'profiloAdeguatezza/' +
	          self.getCodiceStrumento()
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseInserisciRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Inserisce una nuova richiesta
	     * @return {Promise} - Ritorna una promise contenente i dati della nuova richiesta
	     */
	    this.promiseInserisciRichiesta = function () {
	      return self.$http({
	        method: 'POST',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.RICHIESTA + 'richiesta',
	        data: {
	          codiceDossierTitoli: self.$stateParams.finCodiceRapporto,
	          intestatario: {
	            //						intestazione: 'FRANCESCO ABBRUZZESE',
	            //						formaCostitutiva: 'PRV',
	            //						ndg: '354823'
	            intestazione: self.posizione.intestazione,
	            formaCostitutiva: self.posizione.naturaGiuridicaIntestatario,
	            ndg: self.posizione.ndgIntestatario
	          },
	          idRaccomandazione: self.$stateParams.finIdRaccomandazione || null
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseContratti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Chiama la lista dei contratti
	     * @return {Promise} - Ritorna una promise contenente la lista dei contratti
	     */
	    this.promiseContratti = function () {
	      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'contratti';
	      if (self.ordine.segno === self.CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO) {
	        url = CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'piani';
	      }
	      return self.$http({
	        method: 'PUT',
	        url: url,
	        data: {
	          dossier: self.$stateParams.finCodiceRapporto,
	          prodotto: self.ordine.strumento.trim(),
	          ndgSottoscrittore: self.ordine.intestatario
	            ? self.ordine.intestatario
	            : 0
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseVerificaNonFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua la chiamata rest per la verifica dei parametri aggiuntivi per non fondo
	     * @return {Promise} - Ritorna una promise contenente il risultato della chiamata
	     */
	    this.promiseVerificaNonFondo = function () {
	      var ordine = {
	        idOrdine: self.$stateParams.finIdOrdine,
	        idRichiesta: self.$stateParams.finIdRichiesta,
	        idProposta: self.ordine.idProposta,
	        strumento: self.ordine.strumento.trim(),
	        quantita: self.ordine.quantita,
	        ctvPrevisto: self.ordine.ctvPrevisto,
	        intestatario: self.ordine.intestatario,
	        nota: self.ordine.nota,
	        prezzo: self.ordine.prezzo,
	        presentatore: self.ordine.presentatore,
	        segno: self.ordine.segno,
	        dataScadenza:
	          new Date(self.ordine.dataScadenza).getTime() + 1000 * 60 * 60 * 4,
	        mercato: self.ordine.mercato,
	        divisaISO: self.ordine.divisaISO,
	        codiceOrdine: self.ordine.codiceOrdine
	      };
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RICHIESTA +
	          'verificaNonFondo/' +
	          self.$stateParams.finCodiceRapporto,
	        data: ordine
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseVerificaFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua la chiamata rest per la verifica dei parametri aggiuntivi per fondo
	     * @return {Promise} - Ritorna una promise contenente il risultato della chiamata
	     */
	    this.promiseVerificaFondo = function () {
	      var ordine = {
	        strumento: self.ordine.strumento.trim(),
	        intestatario: self.ordine.intestatario,
	        presentatore: self.ordine.presentatore,
	        codiceOrdine: self.ordine.codiceOrdine,
	        quantita: self.ordine.quantita,
	        ctvPrevisto: self.ordine.ctvPrevisto,
	        contratto: self.contratto.contratto,
	        prgContratto: self.contratto.id,
	        nota: self.ordine.nota,
	        parametri: self.parametriAggiuntivi
	      };
	      return self.$http({
	        method: 'PUT',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RICHIESTA +
	          'verificaFondo/' +
	          self.$stateParams.finCodiceRapporto,
	        data: ordine
	      });
	    };
	
	    this.isFON_POG = function () {
	      return (
	        !!self.dettaglioStrumento &&
	        !!self.dettaglioStrumento.categoriaStrumento &&
	        (self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'FON' ||
	          self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'POG')
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseInserisciOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Inserisce un nuovo ordine
	     * @return {Promise} - Ritorna una promise contenente il risultato della chiamata
	     */
	    this.promiseInserisciOrdine = function (ordineToSave) {
	      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.RICHIESTA;
	      if (!self.isFON_POG()) {
	        url = url + 'ordineNonFondo/';
	      } else {
	        url = url + 'ordineFondo/';
	      }
	      url = url + self.$stateParams.finCodiceRapporto;
	      return self.$http({
	        method: 'POST',
	        url: url,
	        data: ordineToSave
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseModificaOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Modifica un ordine
	     * @return {Promise} - Ritorna una promise contenente il risultato della chiamata
	     */
	    this.promiseModificaOrdine = function (ordineToUpdate) {
	      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.RICHIESTA;
	      if (!self.isFON_POG()) {
	        url = url + 'modificaOrdineNonFondo/';
	      } else {
	        url = url + 'modificaOrdineFondo/';
	      }
	      url = url + self.$stateParams.finCodiceRapporto;
	      return self.$http({
	        method: 'PUT',
	        url: url,
	        data: ordineToUpdate
	      });
	    };
	
	    /*
	     * -----------------------------------
	     * END METODI PROMISE PER SERVIZI REST
	     * -----------------------------------
	     */
	
	    /*
	     * -----------------------
	     * START METODI CONTROLLER
	     * -----------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name recuperaDettaglioOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Ritorna true se il testo della nota rispetta il pattern
	     */
	    this.checkRegexNota = function (testo) {
	      return self.regexTestoNota.test(testo);
	    };
	
	    /**
	     * @ngdoc methos
	     * @name recuperaDettaglioOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Recupera il dettaglio di un ordine
	     */
	    this.recuperaDettaglioOrdine = function () {
	      self.promiseDettaglioOrdine().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.ordine = {};
	            self.spinner.dettaglioOrdine = false;
	            return;
	          }
	          self.ordine = response.data.result;
	          //				Se ci sono i parametri allora siamo in un fondo
	          if (self.ordine.parametri) {
	            self.parametriAggiuntivi = self.ordine.parametri;
	            self.parametriAggiuntivi.forEach(function (parametro) {
	              parametro.codice = parametro.codice.trim();
	              parametro.descrizione = parametro.descrizione.trim();
	              if (parametro.scelte) {
	                parametro.scelte.forEach(function (scelta) {
	                  scelta.descrizione = scelta.descrizione.trim();
	                  scelta.valore = scelta.valore.trim();
	                });
	              }
	            });
	          }
	          delete self.ordine.parametri;
	          self.recuperaProfiloCliente();
	          self.recuperaProfiloAdeguatezza();
	          self.dettaglioStrumentoFinanziario();
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	          self.spinner.dettaglioOrdine = false;
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name recuperaSaldoPortafoglio
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Recupera il saldo portafoglio
	     * @return {Array} - Lista dei saldi portafoglio
	     */
	    this.recuperaSaldoPortafoglio = function () {
	      self.promiseSaldoPortafoglio().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.saldoPortafoglio = {};
	            self.spinner.dettaglioOrdine = false;
	            return;
	          }
	          if (response.data && response.data.result) {
	            //					Creo un nuovo array che contiene soltanto gli strumenti
	            //    				con lo stesso codice selezionato dal saldo portafoglio
	            var saldi = response.data.result.filter(function (saldo) {
	              return (
	                saldo.strumento.codice.trim() ===
	                self.$stateParams.finCodiceStrumento
	              );
	            });
	            //					Se la length è maggiore di 1 allora cerco il saldo con ndg ricevuto tramite params
	            if (saldi.length > 1) {
	              saldi.forEach(function (saldo) {
	                if (
	                  saldo.ndgIntestatario &&
	                  saldo.ndgIntestatario.toString() ===
	                    self.$stateParams.finIntestatarioStrumento
	                ) {
	                  self.saldoPortafoglio = saldo;
	                  // 			Si può presentare anche il caso che ci siano più saldi per un certo strumento, dipende se l'ndg è cointestato o mono.
	                  //			Se il saldo dello strumento si riferisce ad un ndg cointestato l'ndgIntestatario arriverà nullo (e quindi verrà passato
	                  //			nullo anche negli stateParams). Quindi se $stateParams.finIntestatarioStrumento è nullo seleziono il saldo con ndgIntestatario nullo.
	                } else if (
	                  !saldo.ndgIntestatario &&
	                  !self.$stateParams.finIntestatarioStrumento
	                ) {
	                  self.saldoPortafoglio = saldo;
	                }
	              });
	            } else {
	              //						Prendo l'unico saldo rimasto
	              self.saldoPortafoglio = saldi[0];
	            }
	            //					Chiamo il recupero del dettaglio strumento
	          } else {
	            self.spinner.saldoPortafoglio = false;
	          }
	          self.dettaglioStrumentoFinanziario();
	        },
	        function (reason) {
	          self.spinner.saldoPortafoglio = false;
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name recuperaStrumentoFinanziario
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Funzione richiamata al click su una riga dello strumento finanziario.
	     * Tale funzione viene richiamata soltanto durante la creazione di un nuovo ordine
	     * @param {Object} - Strumento finanziario ricercato tramite il widget
	     */
	    this.ricercaStrumentoFinanziario = function (callbackStrumentoFinanziario) {
	      self.spinner.dettaglioOrdine = true;
	      //    		Ricreo un nuovo ordine quando cerco un nuovo strumento
	      self.ordine = {
	        segno: $scope.msg('gestione.proposta.a')
	      };
	      self.parametriAggiuntivi = undefined;
	      self.tipoOrdine = undefined;
	      self.dettaglioStrumentoFinanziario(
	        callbackStrumentoFinanziario.codice.trim()
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name dettaglioStrumentoFinanziario
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Gestisce la promise del dettaglio strumento finanziario
	     */
	    this.dettaglioStrumentoFinanziario = function (codiceStrumentoFinanziario) {
	      self.promiseDettaglioStrumento(codiceStrumentoFinanziario).then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.dettaglioStrumento = {};
	            self.spinner.dettaglioOrdine = false;
	            return;
	          }
	          self.dettaglioStrumento = response.data.result;
	          self.recuperaDatiStrumentoFinanziario();
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	          self.spinner.dettaglioOrdine = false;
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name recuperDatiStrumentoFinanziario
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Imposta i valori predefiniti per l'ordine in base a creazione/modifica
	     */
	    this.recuperaDatiStrumentoFinanziario = function () {
	      //    		Se sono in modifica effettuo soltanto i trim dei dati (stringhe) ricevuti
	      if (self.$stateParams.finIdOrdine) {
	        self.ordine.strumento = self.ordine.strumento.trim();
	      } else {
	        // Sono in creazione quindi recupero altri valori dal dettaglioStrumento
	        self.ordine.strumento = self.dettaglioStrumento.codice.trim();
	
	        var divisore = self.calcolaDivisoreQuantita(
	          self.dettaglioStrumento.qtaMinimaTrattabile
	        );
	
	        var qta = null;
	        if (
	          self.isFON_POG() &&
	          self.dettaglioStrumento.divisa.trim() !== 'EURO'
	        ) {
	          qta =
	            self.dettaglioStrumento.qtaMinimaTrattabile *
	            self.dettaglioStrumento.cambioStorico.prezzo;
	        } else {
	          qta = self.dettaglioStrumento.qtaMinimaTrattabile;
	        }
	
	        self.ordine.quantita = Math.round(qta * divisore) / divisore || 1;
	
	        self.ordine.ctvPrevisto =
	          Math.round(
	            self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo *
	              self.ordine.quantita *
	              100
	          ) / 100;
	        //            	Se provengo da un saldo portafoglio setto l'intestatario del saldo
	        if (self.$stateParams.finCodiceStrumento) {
	          self.ordine.intestatario = self.saldoPortafoglio.ndgIntestatario;
	        } else {
	          //        			Se siamo in un non-fondo e
	          //        			lo strumento è nominativo e
	          //        			l'intestatario del dossier e solo 1
	          //        			allora setto come intestatario dell'ordine l'unico intestatario del dossier
	          if (
	            !self.isPO &&
	            self.dettaglioStrumento.nominativo &&
	            self.dossier.intestatari.length === 1
	          ) {
	            self.ordine.intestatario = self.dossier.intestatari[0].ndg;
	          }
	        }
	      }
	      if (self.isFON_POG()) {
	        self.getDatiAggiuntiviFondo();
	      } else {
	        self.getParametriAggiuntiviNonFondo();
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name  recuperaProfiloCliente
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Recupera il profilo cliente
	     */
	    this.recuperaProfiloCliente = function(){
	      this.promiseProfiloCliente()
	      .then(function(response){
	        if (self.messaggiFctr.processaResponse(response)) {
	          self.profiloCliente = {};
	          self.spinner.dettaglioOrdine = false;
	          return;
	        }
	        self.profiloCliente = response.data.result;
	      })
	    }
	    /**
	     * @ngdoc method
	     * @name  recuperaProfiloAdeguattezza
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Recupera il profilo adeguatezza
	     */
	    this.recuperaProfiloAdeguatezza = function(){
	      this.promiseProfiloAdeguatezza()
	      .then(function(response){
	        if (self.messaggiFctr.processaResponse(response)) {
	          self.profiloAdeguatezza = {};
	          self.spinner.dettaglioOrdine = false;
	          return;
	        }
	        self.profiloAdeguatezza = response.data.result;
	      })
	    }
	    /**
	     * @ngdoc method
	     * @name mappingParametri
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Esegue il mapping dell'array parametri per utilizzarlo con le select
	     */
	    this.mappingParametriNonFondo = function () {
	      self.parametriAggiuntivi.forEach(function (parametro) {
	        //    			Effettuo un trim dei valori all'interno di ciascuna scelta
	        parametro.scelte.forEach(function (scelta) {
	          scelta.valore = scelta.valore.trim();
	          //    				Imposto il valore del presentatore a un number
	          if (parametro.descrizione === 'PRESENTATORE') {
	            scelta.valore = Number(scelta.valore) || '';
	          }
	        });
	        switch (parametro.descrizione.trim()) {
	          case 'MERCATO':
	            self.parametroMercato = parametro;
	            break;
	          case 'TIPO ORDINE':
	            self.parametroTipoOrdine = parametro;
	            break;
	          case 'DIVISA REGOLAMENTO':
	            self.parametroDivisaRegolamento = parametro;
	            break;
	          case 'PRESENTATORE':
	            self.parametroPresentatore = parametro;
	            break;
	        }
	      });
	      self.spinner.dettaglioOrdine = false;
	    };
	
	    this.getParametriAggiuntiviFondoAsync = function (
	      newTipoOrdine,
	      oldTipoOrdine,
	      index,
	      event
	    ) {
	      setTimeout(function () {
	        self.getParametriAggiuntiviFondo(
	          newTipoOrdine,
	          oldTipoOrdine,
	          index,
	          event
	        );
	      }, 100);
	    };
	
	    /**
	     * @ngdoc method
	     * @name getParametriAggiuntiviFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Riceve ed elabora i parametri aggiuntivi per i fondi
	     * @param {boolean} oldTipoOrdine - Vecchio valore del tipoOrdine
	     * @param {number} index - Index nell'array parametriAggiuntivi del parametro aggiuntivo modificato
	     * @param {event} keyCode - Codice del tasto premuto
	     */
	    this.getParametriAggiuntiviFondo = function (
	      newTipoOrdine,
	      oldTipoOrdine,
	      index,
	      event
	    ) {
	      if (index >= 0) {
	        //    			In caso di evento sull'input di testo
	        if (event && event.keyCode !== 13) {
	          return;
	        }
	        var gruppo = self.parametriAggiuntivi[index].gruppo;
	        var parametriAggiuntiviTmp = self.parametriAggiuntivi.filter(function (
	          parametro
	        ) {
	          return parametro.gruppo <= gruppo;
	        });
	        self.parametriAggiuntivi = parametriAggiuntiviTmp;
	      }
	      //    		Se il tipoOrdine è cambiato e quindi c'è un nuovo valore
	      if (newTipoOrdine !== oldTipoOrdine) {
	        self.parametriAggiuntivi = [];
	        //    			Se la select del contratto non si deve far vedere allora annullo il codice contratto scelto
	        if (!self.tipoOrdine.codiceContrattoObbligatorio) {
	          self.contratto = {};
	        }
	      }
	      //    		Esco perché la funzione viene richiamata quando la select viene popolata e non ho il tipoOrdine
	      if (!self.tipoOrdine) {
	        return;
	      }
	      self.spinner.parametriAggiuntivi = true;
	      //    		Imposto il codiceOrdine prelevato dall'oggetto tipoOrdine
	      self.ordine.codiceOrdine = self.tipoOrdine.codiceOperazione;
	      //    		Se il contratto è obbligatorio e non sto operando con i parametri aggiuntivi allora gestisco il contratto
	      if (
	        (self.tipoOrdine.codiceContrattoObbligatorio ||
	          self.ordine.segno === CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO) &&
	        isNaN(index)
	      ) {
	        self.getContratti();
	      }
	      self
	        .promiseParametriAggiuntiviFondo()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.parametriAggiuntivi = [];
	              return;
	            }
	            response.data.result.richiesta.parametri.forEach(function (
	              parametro
	            ) {
	              parametro.codice = parametro.codice.trim();
	              parametro.descrizione = parametro.descrizione.trim();
	              if (parametro.valore) {
	                parametro.valore = parametro.valore.trim();
	              }
	              if (parametro.scelte) {
	                parametro.scelte.forEach(function (scelta) {
	                  scelta.descrizione = scelta.descrizione.trim();
	                  scelta.valore = scelta.valore.trim();
	                });
	              }
	            });
	            self.parametriAggiuntivi = response.data.result.richiesta.parametri;
	          },
	          function (reason) {
	            self.parametriAggiuntivi = [];
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.parametriAggiuntivi = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name getContratti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Metodo che recupera la lista dei contratti per le proposte di tipo fondo
	     */
	    this.getContratti = function () {
	      self.promiseContratti().then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.listaContratti = [];
	            return;
	          }
	          //    			Effettuo il trim dei valori su cui dovrò operare
	          response.data.result.forEach(function (item) {
	            item.contratto = item.contratto.trim();
	          });
	          self.listaContratti = response.data.result;
	          if (self.$stateParams.finIdOrdine) {
	            self.listaContratti.forEach(function (contratto) {
	              if (
	                contratto.contratto === self.ordine.contratto.trim() &&
	                contratto.id === self.ordine.prgContratto
	              ) {
	                self.contratto = contratto;
	              }
	            });
	          }
	          self.calcolaOptionsContratti();
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	          self.spinner.parametriAggiuntivi = false;
	          self.listaContratti = [];
	          self.calcolaOptionsContratti();
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name getDatiAggiuntiviFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Gestisce le due chiamate al tipoOrdine e alla select del presentatore
	     */
	    this.getDatiAggiuntiviFondo = function () {
	      $q.all({
	        tipoOrdine: self.promiseTipoOrdineFondo(),
	        presentatore: self.promiseGetPresentatoreFondo()
	      }).then(
	        function (response) {
	          if (
	            self.messaggiFctr.processaResponse(response.tipoOrdine) ||
	            self.messaggiFctr.processaResponse(response.presentatore)
	          ) {
	            self.arrayTipoOrdine = [];
	            self.spinner.parametriAggiuntivi = false;
	            return;
	          }
	          self.getTipoOrdine(response.tipoOrdine);
	          self.getPresentatoreFondi(response.presentatore);
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason.tipoOrdine);
	          self.messaggiFctr.processaResponse(reason.presentatore);
	          self.arrayTipoOrdine = [];
	          self.spinner.parametriAggiuntivi = false;
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name getPresentatoreFondi
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Gestisce i dati per il presentatore nei fondi
	     */
	    this.getPresentatoreFondi = function (response) {
	      if (!self.$stateParams.finIdProposta) {
	        self.ordine.presentatore = response.data.result.presentatore;
	      }
	      response.data.result.parametri.forEach(function (parametro) {
	        //    			Effettuo un trim dei valori all'interno di ciascuna scelta
	        parametro.scelte.forEach(function (scelta) {
	          scelta.valore = scelta.valore.trim();
	          //    				Imposto il valore del presentatore a un number
	          if (parametro.descrizione === 'PRESENTATORE') {
	            scelta.valore = Number(scelta.valore) || '';
	          }
	        });
	        switch (parametro.descrizione.trim()) {
	          case 'PRESENTATORE':
	            self.parametroPresentatore = parametro;
	            break;
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name getCodiceStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneProposta
	     * @description Setta il giusto codiceStrumento in base a se siamo in uno switch o meno
	     * @return string - Ritorna la stringa del codiceStrumento
	     */
	    this.getCodiceStrumento = function () {
	      var codiceStrumento = '';
	      //    		Se siamo in uno switch
	      if (self.$stateParams.acqven === $scope.msg('gestione.proposta.s')) {
	        self.parametriAggiuntivi.forEach(function (parametro) {
	          //    				Se trovo il campo dove viene inserito il fondo su cui switchare
	          if (parametro.codice.trim() === 'FNSWIPROD') {
	            //    					Prendo il valore dello switch scelto nella select
	            codiceStrumento = parametro.valore.trim();
	          }
	        });
	      } else {
	        codiceStrumento = self.ordine.strumento;
	      }
	      return codiceStrumento;
	    };
	
	    /**
	     * @ngdoc method
	     * @name getTipoOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Gestisce i dati per popolare la select tipo ordine
	     */
	    this.getTipoOrdine = function (response) {
	      if (self.messaggiFctr.processaResponse(response)) {
	        self.arrayTipoOrdine = [];
	        return;
	      }
	      if (self.ordine.segno === $scope.msg('gestione.ordine.d')) {
	        self.arrayTipoOrdine = response.data.result.filter(function (item) {
	          return (
	            item.segnoOperazione.trim() === $scope.msg('gestione.ordine.d')
	          );
	        });
	      } else if (self.ordine.segno === $scope.msg('gestione.ordine.a')) {
	        self.arrayTipoOrdine = response.data.result.filter(function (item) {
	          return (
	            item.segnoOperazione.trim() === $scope.msg('gestione.ordine.a')
	          );
	        });
	      } else if (self.ordine.segno === $scope.msg('gestione.ordine.s')) {
	        self.arrayTipoOrdine = response.data.result.filter(function (item) {
	          return (
	            item.segnoOperazione.trim() === $scope.msg('gestione.ordine.s')
	          );
	        });
	      } else if (
	        self.ordine.segno === self.CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO
	      ) {
	        self.arrayTipoOrdine = response.data.result.filter(function (item) {
	          return (
	            item.segnoOperazione.trim() ===
	            self.CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO
	          );
	        });
	      }
	      //    			Effettuo il trim dei valori su cui dovrò operare
	      self.arrayTipoOrdine.forEach(function (item) {
	        item.codiceOperazione = item.codiceOperazione.trim();
	        item.descrizione = item.descrizione.trim();
	      });
	      //    			Se è presente un idOrdine devo trovare l'oggetto di arrayTipoOrdine che ha come stringa il codiceOperazione
	      if (self.$stateParams.finIdOrdine) {
	        self.arrayTipoOrdine.forEach(function (tipoOrdine) {
	          if (tipoOrdine.codiceOperazione === self.ordine.codiceOrdine) {
	            self.tipoOrdine = tipoOrdine;
	          }
	        });
	      }
	      self.showFinancialTool = false;
	      self.spinner.dettaglioOrdine = false;
	      //    		Azzero l'oggetto contratto
	      self.contratto = {};
	      //    		Chiamo i parametri aggiuntivi per il fondo
	      self.getParametriAggiuntiviFondo();
	    };
	
	    /**
	     * @ngdoc method
	     * @name getParametriAggiuntiviNonFondo
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Riceve ed elabora i parametri aggiuntivi per i NON fondi
	     */
	    this.getParametriAggiuntiviNonFondo = function () {
	      self.spinner.parametriAggiuntivi = true;
	      self
	        .promiseParametriAggiuntiviNonFondo()
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.parametriAggiuntivi = [];
	              return;
	            }
	            if (!self.$stateParams.finIdOrdine) {
	              self.ordine.dataScadenza = response.data.result.dataScadenza;
	              self.ordine.divisaISO = response.data.result.divisaISO
	                ? response.data.result.divisaISO.trim()
	                : null;
	              self.ordine.codiceOrdine = response.data.result.codiceOrdine
	                ? response.data.result.codiceOrdine.trim()
	                : null;
	              self.ordine.mercato = response.data.result.mercato
	                ? response.data.result.mercato.trim()
	                : null;
	              self.ordine.prezzo = response.data.result.prezzo;
	              self.ordine.presentatore = response.data.result.presentatore;
	              //            		Cambio il presentatore in alcuni casi
	              if (self.dossier.intestatari.length > 1 && !self.isFON_POG()) {
	                self.ordine.presentatore = self.dossier.intestatari[0].ndg;
	              }
	            }
	            self.parametriAggiuntivi = response.data.result.parametri;
	            self.mappingParametriNonFondo();
	          },
	          function (reason) {
	            self.parametriAggiuntivi = [];
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.parametriAggiuntivi = false;
	          self.showFinancialTool = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkVenditaMassima
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Controllo che non supero la quantita disponibile in fase di vendita
	     * @param {Number} quantita - Nuova valore della quantita da settare
	     * @return {Number} - Il nuovo valore controllato
	     */
	    this.checkVenditaMassima = function (quantita) {
	      return quantita <= self.saldoPortafoglio.quantita
	        ? quantita
	        : self.saldoPortafoglio.quantita;
	    };
	
	    this.calcolaDivisoreQuantita = function (quantitaMinima) {
	      if (!quantitaMinima) {
	        return 1;
	      }
	      var quantitaStr = quantitaMinima.toString();
	      var decimali = quantitaStr.split('.');
	      var nDecimali = decimali[1] ? decimali[1].length : 0;
	      var divisore = Math.pow(10, nDecimali);
	
	      return divisore;
	    };
	
	    /**
	     * @mgdoc method
	     * @name checkRimanenzaQuantita
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Controllo che non rimanga una quantita compresa tra 0 e qtaMinimaTrattabile.
	     * Se così fosse ritorno un valore che lascia nel portafoglio una quantita pari a qtaMinimaTrattabile
	     * @param {Number} quantita - Nuovo valore della quantita da settare
	     * @return {Number} - Il nuovo valore controllato
	     */
	    this.checkRimamenzaQuantita = function (quantita) {
	      var qtaDisp = self.saldoPortafoglio.quantita;
	      var qtaMin = self.dettaglioStrumento.qtaMinimaTrattabile;
	      return qtaDisp - quantita >= 0 &&
	        (qtaDisp - quantita >= qtaMin || qtaDisp - quantita === 0)
	        ? quantita
	        : qtaDisp - qtaMin;
	    };
	
	    /**
	     * @ngdoc method
	     * @name incrementaQuantita
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Incrementa la quantita di 1 unita tramite il pulsante +
	     */
	    //    	this.incrementaQuantita = function() {
	    ////    		Se il taglioSuccessivo è 0 allora incremento di 1
	    //    		var newValue = (Number(self.ordine.quantita) || 0) + (Math.round(self.dettaglioStrumento.taglioSuccessivo) || 1);
	    ////    		Se sono in vendita effettuo ulteriori controlli
	    //    		if (self.$stateParams.acqven === $scope.msg('gestione.proposta.d')) {
	    //    			newValue = self.checkVenditaMassima(newValue);
	    //    			newValue = self.checkRimamenzaQuantita(newValue);
	    //    		}
	    //    		self.ordine.quantita = Math.round(newValue * 1000) / 1000;
	    //    		self.ordine.ctvPrevisto = Math.round(self.ordine.quantita * self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo * 100) / 100;
	    //    	};
	
	    /**
	     * @ngdoc method
	     * @name decrementaQuantita
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Decrementa la quantita di 1 unita tramite il pulsante -
	     */
	    //    	this.decrementaQuantita = function() {
	    ////    		Se il taglio successivo è 0 allora incremento di 1
	    //    		var newValue = (Number(self.ordine.quantita) || 0) - (Math.round(self.dettaglioStrumento.taglioSuccessivo) || 1);
	    ////    		Se vado sotto la qtaMinimaTrattabile non salvo il valore (di conseguenza non andrò mai in negativo)
	    //    		if (newValue < self.dettaglioStrumento.qtaMinimaTrattabile) {
	    //    			return;
	    //    		}
	    //    		self.ordine.quantita = Math.round(newValue * 1000) / 1000;
	    //    		self.ordine.ctvPrevisto = Math.round(self.ordine.quantita * self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo * 100) / 100;
	    //    	};
	
	    this.apriMfWeb = function (evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	
	      self.spinner.parametriAggiuntivi = true;
	      // FIXME: aggiungere servizio calcolo link
	      $q.when('https://www.milanofinanza.it/')
	        .then(function (url) {
	          window.open(url, '_mfWebFrame');
	        })
	        .finally(function () {
	          self.spinner.parametriAggiuntivi = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkQuantitaInserita
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Controlla la quantita e la aggiusta se necessario quando si inserisce il valore a mano
	     */
	    this.checkQuantitaInserita = function () {
	      if (!self.isFON_POG()) {
	        //    		Controllo se c'è contenuto
	        if (!self.ordine.quantita) {
	          self.ordine.quantita = self.dettaglioStrumento.qtaMinimaTrattabile;
	        }
	        //    		Controllo se viene inserito un valore non numerico
	        if (isNaN(self.ordine.quantita)) {
	          self.ordine.quantita = self.dettaglioStrumento.qtaMinimaTrattabile;
	        }
	        //    		Rendo la quantita inserita un multiplo del taglio
	        //    		self.ordine.quantita = self.ordine.quantita - Math.round(self.ordine.quantita % (self.dettaglioStrumento.taglioSuccessivo || 1));
	        //    		Se viene inserito un valore minore della qtaMinimaTrattabile viene impostato quest'ultimo valore
	        if (
	          self.ordine.quantita < self.dettaglioStrumento.qtaMinimaTrattabile
	        ) {
	          self.ordine.quantita = self.dettaglioStrumento.qtaMinimaTrattabile;
	        }
	        //    		Se siamo in vendita effettuo ulteriori controlli
	        if (self.$stateParams.acqven === $scope.msg('gestione.proposta.d')) {
	          self.ordine.quantita = self.checkVenditaMassima(self.ordine.quantita);
	          self.ordine.quantita = self.checkRimanenzaQuantita(
	            self.ordine.quantita
	          );
	        }
	
	        var divisore = self.calcolaDivisoreQuantita(
	          self.dettaglioStrumento.qtaMinimaTrattabile
	        );
	
	        self.ordine.quantita =
	          Math.round(self.ordine.quantita * divisore) / divisore || 1;
	      }
	
	      // Se si sta trattando un fondo, controllo se la valuta dello strumento è diversa da EURO e in caso faccio la conversione dalla valuta in euro
	      var prezzo;
	      if (
	        self.isFON_POG() &&
	        self.dettaglioStrumento.divisa.trim() !== 'EURO'
	      ) {
	        prezzo =
	          self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo /
	          self.dettaglioStrumento.cambioStorico.prezzo;
	      } else {
	        prezzo = self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo;
	      }
	
	      //    		Aggiorno il controvalore e imposto a 2 decimali
	      self.ordine.ctvPrevisto =
	        Math.round(self.ordine.quantita * prezzo * 100) / 100;
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkControvaloreInserito
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua controlli sul controvalore inserito a mano
	     */
	    this.checkControvaloreInserito = function () {
	      // Se si sta trattando un fondo, controllo se la valuta dello strumento è diversa da EURO e in caso faccio la conversione dalla valuta in euro
	      var prezzo;
	      if (
	        self.isFON_POG() &&
	        self.dettaglioStrumento.divisa.trim() !== 'EURO'
	      ) {
	        prezzo =
	          self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo /
	          self.dettaglioStrumento.cambioStorico.prezzo;
	      } else {
	        prezzo = self.dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo;
	      }
	
	      //    		Se non è stato inserito niente o 0 calcolo il ctvPrevisto in base alla quantità;
	      if (!self.ordine.ctvPrevisto) {
	        self.ordine.ctvPrevisto = self.ordine.quantita * prezzo;
	      }
	      //    		Se non è stato inserito un numero lo rimpiazzo calcolandolo in base alla quantita
	      if (isNaN(self.ordine.ctvPrevisto)) {
	        self.ordine.ctvPrevisto = self.ordine.quantita * prezzo;
	      }
	      //    		Imposto a 2 decimali il ctv
	      self.ordine.ctvPrevisto = Math.round(self.ordine.ctvPrevisto * 100) / 100;
	
	      var divisore = self.calcolaDivisoreQuantita(
	        self.dettaglioStrumento.qtaMinimaTrattabile
	      );
	
	      self.ordine.quantita =
	        Math.round((self.ordine.ctvPrevisto / prezzo) * divisore) / divisore;
	
	      //    		Aggiusto la quantita in base al controvalore inserito
	      //    		self.checkQuantitaInserita();
	      if (
	        self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'FON' ||
	        self.dettaglioStrumento.categoriaStrumento.codice.trim() === 'POG'
	      ) {
	        self.getParametriAggiuntiviFondo();
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name incrementaPrezzoLimite
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Incrementa di un'unità' il valore del prezzo limite
	     */
	    this.incrementaPrezzoLimite = function () {
	      if (self.ordine.prezzo >= 0) {
	        self.ordine.prezzo += 0.01;
	        self.ordine.prezzo = Math.round(self.ordine.prezzo * 10000) / 10000;
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name decrementaPrezzoLimite
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Decrementa di un'unità' il valore del prezzo limite
	     */
	    this.decrementaPrezzoLimite = function () {
	      if (self.ordine.prezzo >= 0) {
	        self.ordine.prezzo -= 0.01;
	        self.ordine.prezzo = Math.round(self.ordine.prezzo * 10000) / 10000;
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name calcolaOptionsContratti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Crea le options per la select relativa ai contratti. A causa di un errore nel calcolo delle quantità disponibili e della formattazione
	     * è necessario aggiungere la proprietà labelOption in modo da poter effettuare il calcolo precisamente anche a seconda della precisone
	     * desiderata.
	     */
	    this.calcolaOptionsContratti = function () {
	      self.contrattiOptions = [];
	      if (self.ordine.segno === self.CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO) {
	        self.listaContratti.forEach(function (contratto) {
	          contratto.labelOption =
	            contratto.contratto +
	            ' - Stato ' +
	            contratto.statoPiano +
	            ' ' +
	            contratto.tipoPiano;
	        });
	      } else {
	        self.listaContratti.forEach(function (contratto) {
	          // Trovo la precisione massima per la quale effettuare la sottrazione senza errori
	          var contr = contratto.saldoContratto.toString().split('.');
	          var precisioneSaldoContr = contr[1] ? contr[1].length : 1;
	          var impegn = contratto.saldoImpegnato.toString().split('.');
	          var precisioneSaldoImp = impegn[1] ? impegn[1].length : 1;
	          var precisioneMax =
	            Math.max(precisioneSaldoContr, precisioneSaldoImp) + 1;
	          var divisore = Math.pow(10, precisioneMax);
	
	          contratto.labelOption =
	            contratto.contratto +
	            '  - QTA DISP: ' +
	            (
	              Math.round(
	                (contratto.saldoContratto - contratto.saldoImpegnato) * divisore
	              ) / divisore
	            )
	              .toString()
	              .replace('.', ',');
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name changeTabMacro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Setta il tab attuale
	     * @param {Object} tab - L'oggetto tab che deve essere setatto come attuale
	     */
	    this.changeTabMacro = function (tab) {
	      self.currentTabMacro = tab;
	    };
	
	    /**
	     * @ngdoc method
	     * @name getStyleTabMacro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Riceve la classe appropriata per la colorazione del macro
	     * @param {Number} currentTabIndex - L'indice del tab corrente
	     * @return {String} - Il nome della classe per settare il colore del macro
	     */
	    this.getStyleTabMacro = function (currentTabIndex) {
	      if (currentTabIndex < self.currentTabMacro.index) {
	        return 'progress-pass';
	      }
	      if (currentTabIndex === self.currentTabMacro.index) {
	        return 'progress-current';
	      }
	      return 'progress-next';
	    };
	
	    /**
	     * @ngdoc method
	     * @name getStyleTabMacroReadOnly
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Riceve la classe appropriata per la colorazione del macro (soltanto per la modalita visualizza)
	     * @param {Number} currentTabIndex - L'indice del tab corrente
	     * @return {String} - Il nome della classe per settare il colore del macro
	     */
	    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
	      if (currentTabIndex < this.currentTabMacro.index) {
	        return 'progress-next-read';
	      }
	
	      if (currentTabIndex === this.currentTabMacro.index) {
	        return 'progress-current-read';
	      }
	
	      return 'progress-next-read';
	    };
	
	     /**
	     * Per la issue CONSULENZA2017-686 in caso di nuova proposta o nuovo ordine e stata modificata la
	     * gestione degli errori, in caso di infMessage e warMessage non vengono più mostrati nel toastr in alto nella pagina ma in una modale
	     * Se si  clicca conferma il processo continua altrimenti si rimane nella pagina di inserimento parametri
	     * @param {*} defer 
	     * @description Apre la modale che mostra gli errori forzabili, premendo conferma si prosegue con il processo di verifica,
	     * altrimenti si rimane sulla pagina
	     */
	     this.gestisciErroriForzabili = function(defer)
	    {
	      self.spinner.dettaglioOrdine = false;
	      $('#erroriForzabiliModal').modal('show');
	
	      document.getElementById('confirm-button')
	      .onclick= function(){
	          $('#erroriForzabiliModal').modal('hide');
	          self.spinner.dettaglioOrdine = true;
	          defer.resolve();
	      };
	
	      document.getElementById('cancel-button')
	      .onclick = function(){
	          $('#erroriForzabiliModal').modal('hide');
	          self.spinner.dettaglioOrdine = true;
	          defer.reject();
	      }
	    }
	    /**
	     * 
	     * @param {*} messageList 
	     * @description recupera la lista degli errori forzabili dalla messageList
	    */
	     this.recuperaErroriForzabili = function(messageList)
	    {
	      var tempListaErroriForzabili = [];
	      var tempListaErroriWar = null;
	      var tempListaErroriInf = null;
	            if(!!messageList && messageList.infMessages.length > 0){
	              tempListaErroriInf = messageList.infMessages.map(function(error){
	                    return error;
	                });
	            }
	            if(!!messageList && messageList.warMessages.length > 0){
	                tempListaErroriWar = messageList.warMessages.map(function(error){
	                    return error;
	                });
	            };
	            if(!!tempListaErroriWar){
	              tempListaErroriWar.forEach(function(err){
	                tempListaErroriForzabili.push(err);
	              });
	            }
	            if(!!tempListaErroriInf){
	              tempListaErroriInf.forEach(function(err){
	                tempListaErroriForzabili.push(err);
	              });
	            }
	
	            return tempListaErroriForzabili;
	    }
	
	    /**
	     * @ngdoc method
	     * @name promiseParametriAggiuntivi
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Funzione che decide quale verifica richiamare in base a fondo/non-fondo
	     * @return {Promise} - Ritorna una promise con valori true o false
	     */
	    this.verificaParametriAggiuntivi = function () {
	      //			Reset eventuali messaggi di Brio
	      self.messaggiSrvc.reset();
	      var defer = $q.defer();
	      if (self.isFON_POG()) {
	        self.promiseVerificaFondo().then(
	          function (response) {
	            if(self.$state.current.name.indexOf('visualizzaordine') > -1){
	              if (messaggiFctr.processaResponseErroriForzabili(response)) {
	                defer.reject();
	              } else {
	                defer.resolve();
	              }
	            }else{
	              if (messaggiFctr.processaResponseErroriForzabili(response)) {
	                defer.reject();
	              } else {
	                self.listaErroriForzabili = self.recuperaErroriForzabili(response.data.messageList);
	                if(self.listaErroriForzabili.length > 0){
	                  self.gestisciErroriForzabili(defer);
	                }else{
	                  defer.resolve();
	                }
	              }
	            }
	          },
	          function (reason) {
	            messaggiFctr.processaResponse(reason);
	            defer.reject();
	          }
	        );
	      } else {
	        self.promiseVerificaNonFondo().then(
	          function (response) {
	            if(self.$state.current.name.indexOf('visualizzaordine') > -1){
	              if (messaggiFctr.processaResponseErroriForzabili(response)) {
	                defer.reject();
	              } else {
	                defer.resolve();
	              }
	            }else{
	              if (messaggiFctr.processaResponseErroriForzabili(response)) {
	                defer.reject();
	              } else {
	                self.listaErroriForzabili = self.recuperaErroriForzabili(response.data.messageList);
	                if(self.listaErroriForzabili.length > 0){
	                  self.gestisciErroriForzabili(defer);
	                }else{
	                  defer.resolve();
	                }
	              }
	            }
	          },
	          function (reason) {
	            messaggiFctr.processaResponse(reason);
	            defer.reject();
	          }
	        );
	      }
	      return defer.promise;
	    };
	
	    this.proseguiOrdine = function () {
	      $q.all({
	        profiloCliente: self.promiseProfiloCliente(),
	        profiloAdeguatezza: self.promiseProfiloAdeguatezza()
	      })
	        .then(
	          function (response) {
	            if (
	              self.messaggiFctr.processaResponse(response.profiloCliente) ||
	              self.messaggiFctr.processaResponse(response.profiloAdeguatezza)
	            ) {
	              self.profiloCliente = {};
	              self.profiloAdeguatezza = {};
	              return;
	            }
	            self.profiloCliente = response.profiloCliente.data.result;
	            self.profiloAdeguatezza = response.profiloAdeguatezza.data.result;
	            self.changeTabMacro(
	              self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]
	            );
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason.profiloCliente);
	            self.messaggiFctr.processaResponse(reason.profiloAdeguatezza);
	            self.profiloCliente = {};
	            self.profiloAdeguatezza = {};
	          }
	        )
	        .finally(function () {
	          self.spinner.dettaglioOrdine = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name verifica
	     * @methodOf cbl.finanza.mf.directive:fiannzaGestioneOrdine
	     * @description Effettua la verifica dell'ordine e procede allo step successivo
	     */
	    this.verifica = function () {
	      self.spinner.dettaglioOrdine = true;
	      self.verificaParametriAggiuntivi().then(self.proseguiOrdine, function () {
	        self.spinner.dettaglioOrdine = false;
	      });
	    };
	
	    this.registra = function () {
	      self.spinner.dettaglioOrdine = true;
	      self.proseguiOrdine();
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkIdRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Verifica la presenza o meno di un idRichiesta nello stateParams.
	     * Se non è presente effettua prima un inserimento di una richiesta
	     */
	    this.checkIdRichiesta = function () {
	      self.spinner.dettaglioOrdine = true;
	      if (self.$stateParams.finIdRichiesta) {
	        self.inserisciOrdine(self.$stateParams.finIdRichiesta);
	      } else {
	        self.promiseInserisciRichiesta().then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.spinner.dettaglioOrdine = false;
	              return;
	            }
	            self.$stateParams.finIdRichiesta = response.data.result.idRichiesta;
	            self.inserisciOrdine(response.data.result.idPratica);
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	            self.spinner.dettaglioOrdine = false;
	          }
	        );
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name inserisciOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua l'inserimento di un ordine
	     * @param {Number} idRaccomandazione - Id della richiesta
	     */
	    this.inserisciOrdine = function (idRichiesta) {
	      var ordineToSave = {
	        idProposta: self.$stateParams.finIdProposta,
	        idRichiesta: idRichiesta,
	        strumento: self.ordine.strumento,
	        quantita: self.ordine.quantita,
	        ctvPrevisto: self.ordine.ctvPrevisto,
	        nota: self.ordine.nota,
	        prezzo: self.ordine.prezzo,
	        segno: self.ordine.segno,
	        mercato: self.ordine.mercato,
	        divisaISO: self.ordine.divisaISO,
	        profiloAdeguatezza: self.profiloCliente.profiloAdeguatezza,
	        profiloAppropriatezza: self.profiloCliente.profiloAppropriatezza,
	        rischioComplessita: self.profiloAdeguatezza.rischioComplessita,
	        rischioEmittente: self.profiloAdeguatezza.rischioEmittente,
	        rischioLiquidita: self.profiloAdeguatezza.rischioLiquidita,
	        rischioMercato: self.profiloAdeguatezza.rischioMercato,
	        contratto: self.contratto.contratto,
	        prgContratto: self.contratto.id,
	        codiceOrdine: self.ordine.codiceOrdine,
	        presentatore: self.ordine.presentatore,
	        intestatario: self.ordine.intestatario
	      };
	      if (!self.isFON_POG()) {
	        ordineToSave.dataScadenza =
	          new Date(self.ordine.dataScadenza).getTime() + 1000 * 60 * 60 * 4;
	        delete ordineToSave.ctvPrevisto;
	      } else {
	        ordineToSave.parametri = self.parametriAggiuntivi;
	      }
	      self
	        .promiseInserisciOrdine(ordineToSave)
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            self.$stateParams.finIdRichiesta = idRichiesta;
	            self.$state.go(self.gestioneRichiestaState, self.$stateParams);
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.dettaglioOrdine = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name modificaOrdine
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Effettua la modifica di un ordine
	     */
	    this.modificaOrdine = function () {
	      var ordineToUpdate = {
	        idProposta: self.$stateParams.finIdProposta,
	        idOrdine: self.ordine.idOrdine,
	        idRichiesta: self.ordine.idRichiesta,
	        strumento: self.ordine.strumento,
	        quantita: self.ordine.quantita,
	        ctvPrevisto: self.ordine.ctvPrevisto,
	        intestatario: self.ordine.intestatario,
	        nota: self.ordine.nota,
	        prezzo: self.ordine.prezzo,
	        presentatore: self.ordine.presentatore,
	        segno: self.ordine.segno,
	        dataScadenza:
	          new Date(self.ordine.dataScadenza).getTime() + 1000 * 60 * 60 * 4,
	        mercato: self.ordine.mercato,
	        divisaISO: self.ordine.divisaISO,
	        profiloAdeguatezza: self.profiloCliente.profiloAdeguatezza,
	        profiloAppropriatezza: self.profiloCliente.profiloAppropriatezza,
	        contratto: self.contratto.contratto,
	        prgContratto: self.contratto.id,
	        rischioComplessita: self.profiloAdeguatezza.rischioComplessita,
	        rischioEmittente: self.profiloAdeguatezza.rischioEmittente,
	        rischioLiquidita: self.profiloAdeguatezza.rischioLiquidita,
	        rischioMercato: self.profiloAdeguatezza.rischioMercato,
	        codiceOrdine: self.ordine.codiceOrdine
	      };
	      if (self.isFON_POG()) {
	        ordineToUpdate.parametri = self.parametriAggiuntivi;
	      } else {
	        delete ordineToUpdate.ctvPrevisto;
	      }
	      self.promiseModificaOrdine(ordineToUpdate).then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            return;
	          }
	          self.$state.go(self.gestioneRichiestaState, self.$stateParams);
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    /**
	     * @ngdoc method
	     * @name avanti
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Procede allo step successivo, possibile soltanto in modalita lettura
	     */
	    this.avanti = function () {
	      self.profiloCliente.profiloAdeguatezza = self.ordine.profiloAdeguatezza;
	      self.profiloCliente.profiloAppropriatezza =
	        self.ordine.profiloAppropriatezza;
	      self.profiloAdeguatezza.rischioComplessita =
	        self.ordine.rischioComplessita;
	      self.profiloAdeguatezza.rischioEmittente = self.ordine.rischioEmittente;
	      self.profiloAdeguatezza.rischioLiquidita = self.ordine.rischioLiquidita;
	      self.profiloAdeguatezza.rischioMercato = self.ordine.rischioMercato;
	      self.changeTabMacro(self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]);
	    };
	
	    /**
	     * @ngdoc method
	     * @name indietro
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneOrdine
	     * @description Ritorna allo step precedente se sono allo step1 altrimenti allo stato precedente in base ai casi nello switch
	     */
	    this.indietro = function () {
	      if (self.deskSrvc.isDesk) {
	        self.deskSrvc.popEntry();
	      }
	      if (self.currentTabMacro.index > 0) {
	        self.changeTabMacro(
	          self.TAB_LIST_MACRO[self.currentTabMacro.index - 1]
	        );
	      } else {
	        switch (self.$state.current.name) {
	          case 'nuovoordine':
	          case 'home.nuovoordine':
	            self.$state.go(self.saldoDossierState, self.$stateParams);
	            break;
	          case 'modificaordine':
	          case 'home.modificaordine':
	            self.$state.go(self.gestioneRichiestaState, self.$stateParams);
	            break;
	          case 'visualizzaordine':
	          case 'home.visualizzaordine':
	            //					Devo utilizzare l'history.back() perché non so se provengo da gestioneRichiesta o visualizzaRichiesta
	            self.$window.history.back();
	            break;
	        }
	      }
	    };
	
	    /*
	     * ---------------------
	     * END METODI CONTROLLER
	     * ---------------------
	     */
	
	    /*
	     * ----------------------------
	     * START METODI INIT CONTROLLER
	     * ----------------------------
	     */
	
	    this.checkCasiDaGestire = function () {
	      /*
	       * Casi da gestire quando entro in gestioneOrdine
	       * 1 - Nuovo ordine
	       *   Se non ho idOrdine apro ricercaStrumento: ricercaStrumento -> dettaglioStrumento -> parametriAggiuntivi
	       * 2 - Nuovo ordine dal saldo portafoglio
	       *   Se ho soltanto codiceStrumento chiamo saldoPortafoglio -> dettaglioStrumento -> parametriAggiuntivi
	       * 3 - Modifica ordine
	       *   Se ho idOrdine e codiceStrumento: dettaglioOrdine -> dettaglioStrumento -> parametriAggiuntivi
	       */
	      if (
	        self.$stateParams.finCodiceStrumento &&
	        self.$stateParams.finIdOrdine
	      ) {
	        // Modifica di un ordine
	        self.spinner.dettaglioOrdine = true;
	        self.recuperaDettaglioOrdine();
	      } else if (
	        self.$stateParams.finCodiceStrumento &&
	        !self.$stateParams.finIdOrdine
	      ) {
	        // Nuovo ordine da saldo
	        self.spinner.dettaglioOrdine = true;
	        //	    		Setto il segno se vengo dal saldo portafoglio
	        self.ordine.segno = self.$stateParams.acqven;
	        self.recuperaSaldoPortafoglio();
	      } else {
	        // Nuovo ordine
	        self.showFinancialTool = true;
	      }
	    };
	
	    labelSrvc.labelsPronte.then(function () {
	      self.TAB_LIST_MACRO = [
	        {
	          index: 0,
	          url:
	            self.CONSTANTS.BASE_ROOT +
	            self.CONSTANTS.COMPONENTS_PATH +
	            'gestioneOrdine/partials/inserimentoParametri.html',
	          title: $scope.msg('step.preparazione.ordine')
	        },
	        {
	          index: 1,
	          url:
	            self.CONSTANTS.BASE_ROOT +
	            self.CONSTANTS.COMPONENTS_PATH +
	            'gestioneOrdine/partials/verificaAdeguatezza.html',
	          title: $scope.msg('step.verifica.appropriatezza')
	        }
	      ];
	      self.currentTabMacro = self.TAB_LIST_MACRO[0];
	    });
	
	    this.$http({
	      method: 'GET',
	      url:
	        CONSTANTS.REST_ROOT +
	        CONSTANTS.REST.DOSSIER +
	        self.$stateParams.finCodiceRapporto
	    }).then(
	      function (response) {
	        if (self.messaggiFctr.processaResponse(response)) {
	          return;
	        }
	        self.dossier = response.data.result;
	        self.checkCasiDaGestire();
	      },
	      function (reason) {
	        self.messaggiFctr.processaResponse(reason);
	      }
	    );
	
	    // Chiamo il getDossier per inserire le info nel customerdata
	    self.promiseCustomerData().then(
	      function (response) {
	        if (self.messaggiFctr.processaResponse(response)) {
	          self.posizione = {};
	          return;
	        }
	        self.posizione = response.data;
	      },
	      function (reason) {
	        self.messaggiFctr.processaResponse(reason);
	      }
	    );
	
	    /*
	     * --------------------------
	     * END METODI INIT CONTROLLER
	     * --------------------------
	     */
	
	    if (self.deskSrvc.isDesk) {
	      labelSrvc.labelsPronte.then(function () {
	        self.deskSrvc.aggiungiEntry(labelSrvc.getLabel('gestione.ordine'));
	      });
	    }
	  };
	
	  GestioneOrdineCtrl.$inject = [
	    '$http',
	    '$q',
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$window',
	    '$location',
	    'FIN_CONSTANTS',
	    'FinLabelSrvc',
	    'FinMessaggiFctr',
	    'CblMessageSrvc',
	    'FinUserSrvc',
	    'FinBrioSrvc',
	    'FinDeskSrvc'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'gestioneOrdine/gestioneOrdine.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var GestioneOrdineComponent = {
	    bindings: {
	      gestioneRichiestaState: '@',
	      visualizzaRichiestaState: '@',
	      saldoDossierState: '@'
	    },
	    controller: GestioneOrdineCtrl,
	    controllerAs: 'gestioneCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finanzaGestioneOrdine', GestioneOrdineComponent);
	})();


/***/ },
/* 21 */
/***/ function(module, exports) {

	(function(window, undefined) {
		'use strict';
		var DeskSrvc = function() {
			this.isDesk = false;
		};
	
		DeskSrvc.$inject = [];
	
		angular.module('cbl.finanza.mf').service('FinDeskSrvc', DeskSrvc);
	}(window));

/***/ },
/* 22 */
/***/ function(module, exports) {

	/**
	 * 
	 */
	(function() {
		angular.module("cbl.finanza.mf").service("FinLabelSrvc", [ function() {
			this.labels = [];
			var self = this;
			this.develop = true;
			this.loading = true;
			this.labelsPronte;
	
			this.getLabel = function(label) {
				var res = self.labels[label];
				if (res === undefined || res === "") {
					res = "UNDEFINED LABEL";
					if (self.develop) {
						res += " [" + label + "]";
					}
				}
				return res;
			};
		} ]);
	}());


/***/ },
/* 23 */
/***/ function(module, exports) {

	/**
	 * 
	 */
	(function() {
		angular.module("cbl.finanza.mf").service("FinMappingSrvc", [ function() {
			this.values = [];
			var self = this;
	
			this.getValue = function(key) {
				var res = self.values[key];
				if (res === undefined || res === "") {
					res = "UNDEFINED VALUE";
				}
				return res;
			};
			
		} ]);
	}());


/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 *
	 */
	(function () {
	  'use strict';
	  angular.module('cbl.finanza.mf').factory('FinMessaggiFctr', [
	    'CblMessageSrvc',
	    'FinLabelSrvc',
	    'FinLoggerSrvc',
	    '$timeout',
	    function (messaggiSrvc, labelSrvc, loggerSrvc, $timeout) {
	      
	      var processaResponse = function (response) {
	        if (!response) {
	          var message = {
	            message: 'Undefined Error - Missing response'
	          };
	          messaggiSrvc.pushErrorMessage(message.message);
	          return true;
	        }
	        var hasError = false;
	        if (response.data && response.data.messageList) {
	          if (response.data.messageList.errMessages.length) {
	            for (var i in response.data.messageList.errMessages) {
	              messaggiSrvc.pushErrorMessage(
	                response.data.messageList.errMessages[i].message
	              );
	            }
	            hasError = response.data.messageList.errMessages.length > 0;
	          }
	          if (response.data.messageList.fatMessages.length) {
	            for (var j in response.data.messageList.fatMessages) {
	              messaggiSrvc.pushErrorMessage(
	                response.data.messageList.fatMessages[j].message
	              );
	            }
	            hasError = response.data.messageList.fatMessages.length > 0;
	          }
	          if (response.data.messageList.warMessages.length) {
	            for (var k in response.data.messageList.warMessages) {
	              messaggiSrvc.pushWarningMessage(
	                response.data.messageList.warMessages[k].message
	              );
	            }
	          }
	          if (response.data.messageList.infMessages.length) {
	            for (var z in response.data.messageList.infMessages) {
	              messaggiSrvc.pushInfoMessage(
	                response.data.messageList.infMessages[z].message
	              );
	            }
	          }
	        }
	        if (response.status > 399) {
	          hasError = true;
	          if (angular.isString(response.data)) {
	            // Errori DotNet
	            try {
	              var messages = JSON.parse(response.data).Messages;
	              for (var x in messages) {
	                messaggiSrvc.pushErrorMessage(messages[x].Message);
	              }
	            } catch (e) {
	              messaggiSrvc.pushErrorMessage(
	                "Si è verificato un errore, contattare l'assistenza"
	              );
	            }
	          } else {
	            var messageHttp = {
	              message: 'Error ' + response.status + ' ' + response.statusText
	            };
	            messaggiSrvc.pushErrorMessage(messageHttp.message);
	          }
	        }
	        return hasError;
	      };
	      
	      /**
	       * 
	       * @param {*} response 
	       * @returns boolean
	       * @description Processa la response come processaResponse() ma nel caso dei warning non li fa mostrare nel pop-up
	       */
	      var processaResponseErroriForzabili = function(response){
	        if (!response) {
	          var message = {
	            message: 'Undefined Error - Missing response'
	          };
	          messaggiSrvc.pushErrorMessage(message.message);
	          return true;
	        }
	        var hasError = false;
	        if (response.data && response.data.messageList) {
	          if (response.data.messageList.errMessages.length) {
	            for (var i in response.data.messageList.errMessages) {
	              messaggiSrvc.pushErrorMessage(
	                response.data.messageList.errMessages[i].message
	              );
	            }
	            hasError = response.data.messageList.errMessages.length > 0;
	          }
	          if (response.data.messageList.fatMessages.length) {
	            for (var j in response.data.messageList.fatMessages) {
	              messaggiSrvc.pushErrorMessage(
	                response.data.messageList.fatMessages[j].message
	              );
	            }
	            hasError = response.data.messageList.fatMessages.length > 0;
	          }
	          if (response.data.messageList.infMessages.length) {
	            for (var z in response.data.messageList.infMessages) {
	              messaggiSrvc.pushInfoMessage(
	                response.data.messageList.infMessages[z].message
	              );
	            }
	          }
	        }
	        if (response.status > 399) {
	          hasError = true;
	          if (angular.isString(response.data)) {
	            // Errori DotNet
	            try {
	              var messages = JSON.parse(response.data).Messages;
	              for (var x in messages) {
	                messaggiSrvc.pushErrorMessage(messages[x].Message);
	              }
	            } catch (e) {
	              messaggiSrvc.pushErrorMessage(
	                "Si è verificato un errore, contattare l'assistenza"
	              );
	            }
	          } else {
	            var messageHttp = {
	              message: 'Error ' + response.status + ' ' + response.statusText
	            };
	            messaggiSrvc.pushErrorMessage(messageHttp.message);
	          }
	        }
	        return hasError;
	      };
	
	      var processaCabelAlertResponse = function(response){
	        if (!response) {
	          var message = {
	            message: 'Undefined Error - Missing response'
	          };
	          messaggiSrvc.pushErrorMessage(message.message);
	          return true;
	        }
	        var hasError = response.data.bloccoOperativitaEffettivo;
	        if(response.data && response.data.listaAlert && hasError){
	          //PROCESSO WARNING MESSAGE
	          response.data.listaAlert.forEach(function(alert) {
	            if(alert.livelloGravitaSpecified && alert.livelloGravita === 'Warning' ){
	              messaggiSrvc.pushWarningMessage(alert.testo);
	            }
	          });
	          //PROCESSO ERRROR MESSAGES
	          response.data.listaAlert.forEach(function(alert) {
	            if(alert.livelloGravitaSpecified && alert.livelloGravita === 'Error' ){
	              messaggiSrvc.pushErrorMessage(alert.testo);
	
	            }
	          });
	        }else if(response.data && response.data.listaAlert && !hasError){
	          response.data.listaAlert.forEach(function(alert) {
	            if(alert.livelloGravitaSpecified && alert.livelloGravita === 'Warning' ){
	              messaggiSrvc.pushWarningMessage(alert.testo);
	            }
	          });
	          //PROCESSO ERRROR MESSAGES
	          response.data.listaAlert.forEach(function(alert) {
	            if(alert.livelloGravitaSpecified && alert.livelloGravita === 'Error' ){
	              messaggiSrvc.pushWarningMessage(alert.testo);
	
	            }
	          });
	        }
	        if(response.status > 399){
	          hasError = true;
	          var messageHttp = {
	            message: 'Error ' + response.status + ' ' + response.statusText
	          };
	          messaggiSrvc.pushErrorMessage(messageHttp.message);
	        }
	        
	        return hasError;
	      };
	      var addMessage = function (message) {
	        if (message.type === 'E' || message.type === 'F') {
	          messaggiSrvc.pushErrorMessage(message.message);
	          // console.error(message.message);
	        } else if (message.type === 'W') {
	          messaggiSrvc.pushWarningMessage(message.message);
	          // console.warning(message.message);
	        } else {
	          messaggiSrvc.pushInfoMessage(message.message);
	        }
	      };
	
	      var resetMessages = function () {
	        messaggiSrvc.reset();
	      };
	
	      var processaForm = function (form) {
	        if (form.$valid) {
	          return true;
	        }
	        this.validaForm(form);
	        var message = null;
	        for (var label in form.$error.required) {
	          message = {
	            type: 'E',
	            message:
	              form.$error.required[label].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.obbligatorio')
	          };
	          this.addMessage(message);
	        }
	        for (var labelMax in form.$error.max) {
	          message = {
	            type: 'E',
	            message:
	              form.$error.max[labelMax].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.valore.massimo')
	          };
	          this.addMessage(message);
	        }
	        for (var labelNmb in form.$error.number) {
	          message = {
	            type: 'E',
	            message:
	              form.$error.number[labelNmb].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.numerico')
	          };
	          this.addMessage(message);
	        }
	        for (var labelMin in form.$error.min) {
	          message = {
	            type: 'E',
	            message:
	              form.$error.number[labelMin].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.valore.minimo')
	          };
	          this.addMessage(message);
	        }
	        return false;
	      };
	
	      var validaForm = function (form) {
	        this.resetMessages();
	        var valid = true;
	        var message = null;
	        var label = null;
	        for (label in form.$error.pattern) {
	          valid = false;
	          message = {
	            type: 'E',
	            message:
	              form.$error.pattern[label].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.formato')
	          };
	          this.addMessage(message);
	        }
	        for (label in form.$error.cblMax) {
	          valid = false;
	          message = {
	            type: 'E',
	            message:
	              form.$error.cblMax[label].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.massimo')
	          };
	          this.addMessage(message);
	        }
	        for (label in form.$error.cblMin) {
	          valid = false;
	          message = {
	            type: 'E',
	            message:
	              form.$error.cblMin[label].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.minimo')
	          };
	          this.addMessage(message);
	        }
	        for (label in form.$error.cblPrecisione) {
	          valid = false;
	          message = {
	            type: 'E',
	            message:
	              form.$error.cblPrecisione[label].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.precisione')
	          };
	          this.addMessage(message);
	        }
	        for (label in form.$error.maxlength) {
	          valid = false;
	          message = {
	            type: 'E',
	            message:
	              form.$error.maxlength[label].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.maxlength')
	          };
	          this.addMessage(message);
	        }
	        for (label in form.$error.minlength) {
	          valid = false;
	          message = {
	            type: 'E',
	            message:
	              form.$error.minlength[label].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.minlength')
	          };
	          this.addMessage(message);
	        }
	        for (label in form.$error.maxDate) {
	          valid = false;
	          message = {
	            type: 'E',
	            message:
	              form.$error.maxDate[label].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.maxdate')
	          };
	          this.addMessage(message);
	        }
	        for (label in form.$error.minDate) {
	          valid = false;
	          message = {
	            type: 'E',
	            message:
	              form.$error.minDate[label].$name +
	              ': ' +
	              labelSrvc.getLabel('validazione.mindate')
	          };
	          this.addMessage(message);
	        }
	        return valid;
	      };
	
	      var chiudiLoaderBrio = function () {
	        $timeout(function () {
	          try {
	            CblBrioLoader.hideLoader();
	          } catch (e) {}
	        }, 100);
	      };
	
	      var scroll = function (id) {
	        var headerMarg = parseInt(
	          angular.element('.navbar-fixed-top').css('margin-top')
	        );
	        if (isNaN(headerMarg)) {
	          headerMarg = 0;
	        }
	        var diffScroll =
	          angular.element('.navbar-fixed-top').height() +
	          headerMarg +
	          angular.element('#prodConvBox').height();
	        var scrollPoint = angular.element(id).offset().top - diffScroll;
	        angular.element('body,html').animate(
	          {
	            scrollTop: scrollPoint
	          },
	          500
	        );
	      };
	
	      return {
	        processaResponse: processaResponse,
	        processaCabelAlertResponse: processaCabelAlertResponse,
	        processaResponseErroriForzabili:processaResponseErroriForzabili,
	        addMessage: addMessage,
	        resetMessages: resetMessages,
	        processaForm: processaForm,
	        validaForm: validaForm,
	        scroll: scroll,
	        chiudiLoaderBrio: chiudiLoaderBrio
	      };
	    }
	  ]);
	})();


/***/ },
/* 25 */
/***/ function(module, exports) {

	/**
	 * 
	 */
	(function() {
		angular.module("cbl.finanza.mf").service("FinPaginatoreSrvc", [ function() {
	
			this.itemsPerPage = 10;
			this.pageNumber = 1;
			this.maxSize = 5;
	
			self = this;
	
			this.init = function() {
				self.itemsPerPage = 10;
				self.pageNumber = 1;
				self.maxSize = 5;
				self.listaFiltrata = null;
			}
	
		} ]);
	}());

/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * 
	 */
	(function() {
		"use strict";
		angular.module("cbl.finanza.mf").service("FinDomainSrvc", [ '$http', '$q', 'FinMessaggiFctr', 'FIN_CONSTANTS', function($http, $q, messaggiFctr, CONSTANTS) {
			this.domains = {};
	
			this.getDomain = function(domain, skipBlank) {
				if (this.domains === undefined) {
					this.domains = {};
				}
				if (this.domains[domain] === undefined || this.domains[domain].length === 0) {
					// chiamata Rest al servizio di recupero dominio in caso non sia
					// gia' memorizzato
					var self = this;
					$http({
						method : "GET",
						url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
						params : {
							table : domain.toUpperCase()
						}
					}).then(function(response) {
						if (messaggiFctr.processaResponse(response)) {
							return;
						}
						self.domains[domain] = [];
						if (!skipBlank) {
							self.domains[domain].push({
								cod : "",
								dsc : "Seleziona..."
							});
						}
						for ( var i in response.data.result) {
							self.domains[domain].push(response.data.result[i]);
						}
	
					}, function(reason) {
						messaggiFctr.processaResponse(reason);
					});
				}
				return this.domains[domain];
			};
	
			this.promiseDomain = function(domain) {
				var deferred = $q.defer();
	
				if (this.domains[domain] === undefined) {
					var self = this;
					$http({
						method : "GET",
						url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
						params : {
							table : domain.toUpperCase()
						}
					}).then(function(response) {
						if (messaggiFctr.processaResponse(response)) {
							return;
						}
						self.domains[domain] = [];
	
						for ( var j in response.data.result) {
							self.domains[domain].push(response.data.result[j]);
						}
	
						deferred.resolve(self.domains[domain]);
					}, function(reason) {
						deferred.reject(reason);
						messaggiFctr.processaResponse(reason);
					});
				} else {
					deferred.resolve(this.domains[domain]);
				}
	
				return deferred.promise;
			};
	
			this.promiseCascading = function(domain, cascading, skipBlank) {
				var deferred = $q.defer();
	
				var self = this;
				var cascadingDomain = [];
				$http({
					method : "GET",
					url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
					cache : true,
					params : {
						table : domain.toUpperCase(),
						params : cascading
					}
				}).then(function(response) {
					if (messaggiFctr.processaResponse(response)) {
						deferred.reject(response);
						return;
					}
					if (!skipBlank) {
						cascadingDomain.push({
							cod : "",
							dsc : "Seleziona..."
						});
					}
					for ( var i in response.data.result) {
						cascadingDomain.push(response.data.result[i]);
					}
					deferred.resolve(cascadingDomain);
				}, function(reason) {
					messaggiFctr.processaResponse(reason);
					deferred.reject(reason);
				});
	
				return deferred.promise;
			};
	
			this.promiseEccezioni = function(domain, cascading, skipBlank) {
				var deferred = $q.defer();
	
				var self = this;
				var cascadingDomain = [];
				$http({
					method : "GET",
					url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
					cache : true,
					params : {
						table : domain.toUpperCase(),
						params : cascading
					}
				}).then(function(response) {
					if (messaggiFctr.processaResponse(response)) {
						deferred.reject(response);
						return;
					}
					if (!skipBlank) {
						cascadingDomain.push({
							cod : "",
							dsc : "Seleziona..."
						});
					}
					for ( var i in response.data.result) {
						cascadingDomain.push(response.data.result[i]);
					}
					deferred.resolve({
						cod : cascading,
						ecz : cascadingDomain
					});
				}, function(reason) {
					messaggiFctr.processaResponse(reason);
					deferred.reject(reason);
				});
	
				return deferred.promise;
			};
	
			this.getLabel = function(domain, key) {
				if (!this.domains) {
					return "";
				}
				var array = this.domains[domain];
				if (!array) {
					return "";
				}
				for ( var i in array) {
					if (array[i].cod === key) {
						return array[i].dsc;
					}
				}
				return "";
			};
	
		} ]);
	}());

/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 *
	 */
	(function(window, undefined) {
	    'use strict';
	    var UserSrvc = function() {
	        this.user;
	        this.abilitazioni = [];
	        this.configurazioni = {};
	        this.abilitazioniPronte;
	        this.labelsPronte;
	        this.numeroProposteAcquistabili = 10000;
	        this.promotoreAccettaRaccomandazione = '0';
	        this.nascondiAbilitaConsulenza = false;
	        this.selezioneIntestCoiFondo = 'N';
	        this.inserimentoOrdiniVisibile = false;
	        this.doppiaPrecisioneQuantita = false;
	        this.iniziativaRaccomandazione = '';
	        this.canaleOperativo = '';
	        this.infoUploadDocumenti = '';
	        this.mostraSoloVenditaOrdini = false;
	        this.valutaPratica = false;
	        this.modalitaEsposizioneESG = null;
	        this.liquiditaAggiuntivaAttiva = null;
	        // FIXME: rimuovere
	        this.isBpa = false;
	
	        var self = this;
	        this.abilitato = function(funz) {
	            if (!Array.isArray(self.abilitazioni) || !funz || !funz.trim) {
	                return false;
	            }
	            funz = funz.trim();
	            for (var i = 0; i < self.abilitazioni.length; i++) {
	                var elem = self.abilitazioni[i];
	                if (elem.codice === funz) {
	                    return true;
	                }
	            }
	            return false;
	        };
	    };
	
	    UserSrvc.$inject = [];
	
	    angular.module('cbl.finanza.mf').service('FinUserSrvc', UserSrvc);
	})(window);


/***/ },
/* 28 */
/***/ function(module, exports) {

	/**
	 * 
	 */
	(function() {
		"use strict";
		angular.module("cbl.finanza.mf").service("FinLoggerSrvc", [ "$http", "FIN_CONSTANTS", function($http, CONSTANTS) {
			/**
			 * Constants
			 */
			this.SEVERE = "SEVERE";
			this.WARNING = "WARNING";
			this.INFO = "INFO";
			this.CONFIG = "CONFIG";
			this.FINE = "FINE";
			this.FINER = "FINER";
			this.FINEST = "FINEST";
			var LEVELS = [ this.FINEST, this.FINER, this.FINE, this.CONFIG, this.INFO, this.WARNING, this.SEVERE ];
	
			/**
			 * Default value
			 */
			this.loggerLevelString = this.FINEST;
	
			this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);
	
			this.setupLogger = function(baseLevel) {
				if (LEVELS.indexOf(baseLevel) !== -1) {
					this.loggerLevelString = baseLevel;
				}
				this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);
			};
	
			this.levelEnabled = function(level) {
				return this.loggerLevel <= LEVELS.indexOf(level);
			}
	
			this.formattaMessaggio = function(logPayload) {
				var message = "";
				if (typeof logPayload !== 'string') {
					if (Object.prototype.toString.call(logPayload) === '[object Array]') {
						for ( var idx in logPayload) {
							if (typeof logPayload[idx] === 'string') {
								message += ' ' + logPayload[idx];
							} else {
								message += ' ' + JSON.stringify(logPayload[idx]);
							}
						}
					} else {
						message += JSON.stringify(logPayload);
					}
					return message;
				} else {
					return logPayload;
				}
			};
	
			this.log = function(controller, type, message) {
				message = this.formattaMessaggio(message);
	
				var level = LEVELS.indexOf(type);
	
				if (level < this.loggerLevel) {
					return;
				}
	
				$http({
					method : "POST",
					url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG,
					data : {
						level : type,
						msg : message,
						ctrl : controller
					}
				});
			};
		} ]);
	}());

/***/ },
/* 29 */
/***/ function(module, exports) {

	(function(window, undefined) {
		"use strict";
		var BrioSrvc = function(ssocoreServices, userSrvc) {
			this.userSrvc = userSrvc;
			this.ssocoreServices = ssocoreServices;
			this.brioVersion = 'brio2';
			
			var self = this;
	
			this.goTo = function(app, stato, parametri) {
				ssocoreServices.accediDaEntryPoint({
					app: app,
					nome: stato,
					parametri: parametri
				});
			};
		};
	
		BrioSrvc.$inject = [ 'ssocoreServices', 'FinUserSrvc'];
	
		angular.module("cbl.finanza.mf").service("FinBrioSrvc", BrioSrvc);
	}(window));

/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 *
	 */
	(function (window, document, undefined) {
	  'use strict';
	  var Run = function (
	    $http,
	    $q,
	    $stateParams,
	    userSrvc,
	    messaggiFctr,
	    labelSrvc,
	    loggerSrvc,
	    CONSTANTS,
	    ssocoreServices,
	    brioSrvc
	  ) {
	    var userSrvcDefer = $q.defer();
	    var labelSrvcDefer = $q.defer();
	    userSrvc.abilitazioniPronte = userSrvcDefer.promise;
	    labelSrvc.labelsPronte = labelSrvcDefer.promise;
	
	    var startService = function () {
	      ssocoreServices.caricaContesto(
	        function (response) {
	          //			Se l'inserimento degli ordini è abilitato
	          if (
	            ssocoreServices.caricaFunzionalita(
	              response,
	              'InserimentoOrdiniVisibile'
	            )
	          ) {
	            userSrvc.inserimentoOrdiniVisibile = true;
	          }
	          //			Setting delle variabili in base ai Parametri di Installazione
	          if (
	            ssocoreServices.caricaFunzionalita(
	              response,
	              'ConsulenzaFinanzaVisibile'
	            )
	          ) {
	            startAbilitazioniPromise();
	            startLabelsPromise();
	            startLoggerPromise();
	
	            if (response.app.codice === 'scrivaniautente') {
	              brioSrvc.brioVersion = 'brio-xc';
	            }
	
	            response.parametriInstallazione.forEach(function (parametro) {
	              //					Parametro SSO per il numero massimo di proposte acquistabili
	              if (
	                parametro.codice.toUpperCase() === 'CONSULENZANUMEROPROPOSTE'
	              ) {
	                userSrvc.numeroProposteAcquistabili = Number(parametro.valore);
	              }
	              //					Parametro SSO per mostrare/nascondere pulsante abilita consulenza
	              if (
	                parametro.codice.toUpperCase() === 'NASCONDIABILITACONSULENZA'
	              ) {
	                userSrvc.nascondiAbilitaConsulenza =
	                  parametro.valore === 'true' ? true : false;
	              }
	              //					Parametro SSO per permettere al promotore di accettare le raccomandazioni
	              if (
	                parametro.codice.toUpperCase() ===
	                'PROMOTOREACCETTARACCOMANDAZIONE'
	              ) {
	                userSrvc.promotoreAccettaRaccomandazione = parametro.valore;
	              }
	              //					Parametro SSO per forzare la scelta delle intestazioni in una proposta di tipo fondo
	              if (
	                parametro.codice.toUpperCase() === 'SELEZIONEINTESTCOIFONDO'
	              ) {
	                userSrvc.selezioneIntestCoiFondo = parametro.valore;
	              }
	              //					Parametro SSO per presettare l'iniziativa senza far apparire la modale
	              if (
	                parametro.codice.toUpperCase() === 'INIZIATIVARACCOMANDAZIONE'
	              ) {
	                userSrvc.iniziativaRaccomandazione = parametro.valore;
	              }
	              //					Parametro SSO per sapere se far apparire l'informativa nello step upload della raccomandazione
	              if (parametro.codice.toUpperCase() === 'INFOUPLOADDOCUMENTI') {
	                userSrvc.infoUploadDocumenti = parametro.valore.toLowerCase();
	              }
	              //					Parametro SSO per limitare alla sola vendita l'inserimento degli ordini
	              if (
	                parametro.codice.toUpperCase() === 'MOSTRASOLOVENDITAORDINI'
	              ) {
	                userSrvc.mostraSoloVenditaOrdini =
	                  parametro.valore === 'true' ? true : false;
	              }
	            });
	
	            if (userSrvc.isBpa && !userSrvc.iniziativaRaccomandazione) {
	              userSrvc.iniziativaRaccomandazione = 'B';
	            }
	          }
	          //			Se sono in brio flexcube controllo il canale operativo
	          if (brioSrvc.brioVersion === 'brio-xc') {
	            //				Se c'è un parametro con valore FILIALE allora setto filialefxc
	            if (
	              response.parametri.some(function (parametro) {
	                return parametro.valore === 'FILIALE';
	              })
	            ) {
	              userSrvc.canaleOperativo = 'filialefxc';
	            } else {
	              //					Altrimenti lo setto come briofxc
	              userSrvc.canaleOperativo = 'briofxc';
	            }
	          }
	        },
	        function (reason) {}
	      );
	    };
	
	    var parametriDaAbilitazione = [
	      CONSTANTS.ABILITAZIONI.VISUALIZZA_PARAMETRI_BLOCCATI,
	      CONSTANTS.ABILITAZIONI.FILTRA_RACCOMANDAZIONI,
	      CONSTANTS.ABILITAZIONI.COPIA_RACCOMANDAZIONE,
	      CONSTANTS.ABILITAZIONI.TABELLA_RACCOMNDAZIONI_ESTESA,
	      CONSTANTS.ABILITAZIONI.VERIFICA_PROPOSTE,
	      CONSTANTS.ABILITAZIONI.CASHFLOW,
	      CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA,
	      CONSTANTS.ABILITAZIONI.ATTIVA_LIQUIDITA_AGGIUNTIVA,
	      CONSTANTS.ABILITAZIONI.RICONTRATTUALIZZAZIONE
	    ];
	
	    /**
	     * Carica le abilitazioni dell'utente loggato
	     */
	    var startAbilitazioniPromise = function () {
	      $http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.USER,
	        params: { ndg: $stateParams.ndg }
	      }).then(
	        function (response) {
	          if (messaggiFctr.processaResponse(response)) {
	            userSrvcDefer.reject(response);
	            return;
	          }
	          userSrvc.user = response.data.result.profile;
	          userSrvc.abilitazioni = response.data.result.abilitazioni;
	          if (!!response.data.result.parametri) {
	            response.data.result.parametri.forEach(function (parametro) {
	              if (
	                (parametriDaAbilitazione.indexOf(parametro.codice) > -1 &&
	                  parametro.valore === 'Y') ||
	                (parametro.codice === CONSTANTS.ABILITAZIONI.MIFID &&
	                  (parametro.valore === 'S' || parametro.valore === 'T'))
	              ) {
	                userSrvc.abilitazioni.push({
	                  codice: parametro.codice,
	                  descrizione: parametro.codice
	                });
	              }
	            });
	          }
	          if (!!response.data.result.parametriInstallazione) {
	            response.data.result.parametriInstallazione.forEach(function (
	              parametro
	            ) {
	              if (
	                (parametriDaAbilitazione.indexOf(parametro.codice) > -1 &&
	                  (parametro.valore === 'Y' || parametro.valore === 'true')) ||
	                (parametro.codice === CONSTANTS.ABILITAZIONI.MIFID &&
	                  (parametro.valore === 'S' || parametro.valore === 'T'))
	              ) {
	                userSrvc.abilitazioni.push({
	                  codice: parametro.codice,
	                  descrizione: parametro.codice
	                });
	              } else {
	                userSrvc.configurazioni[parametro.codice] = parametro.valore;
	              }
	            });
	            userSrvc.modalitaEsposizioneESG =
	              userSrvc.configurazioni[
	                CONSTANTS.ABILITAZIONI.MODALITA_ESPOSIZIONE_ESG_STRUMENTO
	              ];
	          }
	
	          userSrvc.doppiaPrecisioneQuantita =
	            response.data.result.profile.banca === '03138';
	
	          userSrvc.valutaPratica = response.data.result.abilitazioni.some(
	            function (abilitazione) {
	              return (
	                abilitazione.codice.toLowerCase() ===
	                CONSTANTS.ABILITAZIONI.VALUTA_PRATICA.toLowerCase()
	              );
	            }
	          );
	          userSrvc.liquiditaAggiuntivaAttiva =
	            response.data.result.abilitazioni.some(function (abilitazione) {
	              return (
	                abilitazione.codice.toLowerCase() ===
	                CONSTANTS.ABILITAZIONI.ATTIVA_LIQUIDITA_AGGIUNTIVA.toLowerCase()
	              );
	            });
	          userSrvcDefer.resolve(true);
	        },
	        function (reason) {
	          messaggiFctr.processaResponse(reason);
	          userSrvcDefer.reject(reason);
	        }
	      );
	    };
	
	    /**
	     * Carica le labels dell'applicazione
	     */
	    var startLabelsPromise = function () {
	      $http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LABEL
	      }).then(
	        function (response) {
	          if (messaggiFctr.processaResponse(response)) {
	            labelSrvcDefer.reject(response);
	            return;
	          }
	          labelSrvc.labels = response.data.result;
	          labelSrvcDefer.resolve(true);
	        },
	        function (reason) {
	          messaggiFctr.processaResponse(reason);
	          labelSrvcDefer.reject(reason);
	        }
	      );
	    };
	
	    /**
	     * Imposta il livello di logger per i messaggi da loggare
	     */
	    var startLoggerPromise = function () {
	      $http({
	        method: 'GET',
	        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG
	      }).then(
	        function (response) {
	          if (messaggiFctr.processaResponse(response)) {
	            return;
	          }
	          loggerSrvc.setupLogger(response.data.result);
	          labelSrvc.develop = loggerSrvc.levelEnabled(loggerSrvc.FINE);
	        },
	        function (reason) {
	          messaggiFctr.processaResponse(reason);
	        }
	      );
	    };
	
	    this.runned = false;
	
	    this.avvio = function () {
	      if (this.runned) {
	        return $q.when(true);
	      }
	      var defer = $q.defer();
	      startService();
	      self.runned = true;
	      $q.all({
	        userSrvcDefer: userSrvcDefer,
	        labelSrvcDefer: labelSrvcDefer
	      }).then(
	        function (response) {
	          defer.resolve(response);
	        },
	        function (reason) {
	          this.runned = false;
	          defer.reject(reason);
	        }
	      );
	      return defer.promise;
	    };
	
	    this.runnedLabel = false;
	    var self = this;
	
	    this.avvioLabel = function () {
	      if (this.runnedLabel || this.runned) {
	        return $q.when(true);
	      }
	      var defer = $q.defer();
	      self.runnedLabel = true;
	      ssocoreServices.caricaContesto(function (response) {
	        if (
	          ssocoreServices.caricaFunzionalita(
	            response,
	            'ConsulenzaFinanzaVisibile'
	          )
	        ) {
	          startService();
	          this.runned = true;
	        } else {
	          startAbilitazioniPromise();
	          $http({
	            method: 'GET',
	            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LABEL
	          }).then(
	            function (response) {
	              if (messaggiFctr.processaResponse(response)) {
	                defer.reject(response);
	                return;
	              }
	              labelSrvc.labels = response.data.result;
	              defer.resolve(true);
	            },
	            function (reason) {
	              messaggiFctr.processaResponse(reason);
	              defer.reject(reason);
	            }
	          );
	        }
	      });
	
	      return defer.promise;
	    };
	  };
	
	  Run.$inject = [
	    '$http',
	    '$q',
	    '$stateParams',
	    'FinUserSrvc',
	    'FinMessaggiFctr',
	    'FinLabelSrvc',
	    'FinLoggerSrvc',
	    'FIN_CONSTANTS',
	    'ssocoreServices',
	    'FinBrioSrvc'
	  ];
	  angular.module('cbl.finanza.mf').service('FinanzaRunService', Run);
	})(window, document);


/***/ },
/* 31 */
/***/ function(module, exports) {

	(function () {
	  'use strict';
	  angular.module('cbl.finanza.mf.directives').directive('finDossierHeader', [
	    'CommonUtilitiesSrvc',
	    'CblMessageSrvc',
	    'FIN_CONSTANTS',
	    '$http',
	    '$stateParams',
	    'FinMessaggiFctr',
	    'FinUploadSrvc',
	    'FinLabelSrvc',
	    function (
	      commonUtilities,
	      messaggiSrvc,
	      CONSTANTS,
	      $http,
	      $stateParams,
	      messaggiFctr,
	      FinUploadSrvc,
	      labelSrvc
	    ) {
	      var directiveImpl = function ($scope) {
	        var self = this;
	
	        $scope.loading = false;
	
	        $scope.commonUtilities = commonUtilities;
	        $scope.messaggiSrvc = messaggiSrvc;
	        $scope.msg = labelSrvc.getLabel;
	
	        $scope.spinner = $scope.commonUtilities.getSpinnerStyle($scope);
	        $scope.finSpinner = {
	          reportData: false,
	          report: false
	        };
	        $scope.stateParams = $stateParams;
	        $scope.configurazioneEffe = {};
	        $scope.listaCampi = {};
	        $scope.reportEffeSelectedConfiguration;
	        $scope.FinUploadSrvc = FinUploadSrvc;
	
	        console.log($scope.finDataContratto);
	
	        if (!$scope.dossierDivisa) {
	          $scope.dossierDivisa = 'EUR';
	        }
	
	        if (!$scope.dossierCambio) {
	          console.log('Cambio non impostato, setto default (1)');
	          $scope.dossierCambio = 1;
	        }
	
	        if (!$scope.dossierDecimali) {
	          $scope.dossierDecimali = 2;
	        }
	
	        $scope.getCustomer = function () {
	          return {
	            ndg: $scope.customerNdg,
	            idAnagrafica: $scope.customerIdAnagrafica,
	            naturaGiuridica: $scope.customerLegalNature
	          };
	        };
	        $scope.promiseReportEffeConf = function (codicePortafoglio) {
	          return $http({
	            method: 'GET',
	            url:
	              CONSTANTS.REST_ROOT +
	              CONSTANTS.REST.REPORT +
	              '/' +
	              codicePortafoglio
	          });
	        };
	        //Ritorna la configurazione per scaricare il report effe
	        $scope.getReportEffeConf = function () {
	          $scope.finSpinner.reportData = true;
	          $scope
	            .promiseReportEffeConf($stateParams.finCodiceRapporto)
	            .then(function (response) {
	              if (messaggiFctr.processaResponse(response)) {
	                $scope.finSpinner.reportData = false;
	                return;
	              }
	              $scope.configurazioneEffe = response.data.result;
	              $scope.assignEffeConfiguration(0);
	            })
	            .finally(function () {
	              $scope.finSpinner.reportData = false;
	            });
	        };
	        $scope.assignEffeConfiguration = function (index) {
	          $scope.listaCampi =
	            this.configurazioneEffe.elencoConfigurazioni[index].elencoCampi;
	          this.listaCampi.forEach(function (campo) {
	            if (campo.valore === 'true') {
	              campo.valore = true;
	            } else if (campo.valore === 'false') {
	              campo.valore = false;
	            }
	          });
	          $scope.reportEffeSelectedConfiguration = index;
	        };
	        $scope.promisePostReportEffeConf = function () {
	          return $http({
	            method: 'POST',
	            url:
	              CONSTANTS.REST_ROOT +
	              CONSTANTS.REST.REPORT +
	              '/' +
	              $stateParams.finCodiceRapporto,
	            data: this.configurazioneEffe.elencoConfigurazioni[
	              $scope.reportEffeSelectedConfiguration
	            ]
	          });
	        };
	        $scope.postEffeConfiguration = function () {
	          $scope.finSpinner.report = true;
	          this.listaCampi.forEach(function (campo) {
	            if (campo.campo.tipo === 'DATE') {
	              campo.valore = campo.valore.toISOString().substring(0, 10);
	            }
	          });
	          $('#reportModal').modal('hide');
	          $scope.promisePostReportEffeConf().then(function (response) {
	            if (messaggiFctr.processaResponse(response)) {
	              $scope.finSpinner.report = false;
	              return;
	            } else {
	              $scope.finSpinner.report = false;
	              var pdfString = response.data.result;
	              $scope.FinUploadSrvc.download(pdfString, 'report-effe.pdf');
	            }
	          });
	        };
	      };
	      directiveImpl.$inject = ['$scope'];
	      return {
	        restrict: 'E',
	        scope: {
	          customerHeader: '=?customerHeader',
	          customerNdg: '=?customerNdg',
	          customerLegalNature: '=?customerLegalNature',
	          customerFiscalCode: '=?customerFiscalCode',
	          customerIdAnagrafica: '=?customerIdAnagrafica',
	          customerPunteggioAdeguatezza: '=?customerPunteggioAdeguatezza',
	          customerPunteggioAppropriatezza: '=?customerPunteggioAppropriatezza',
	          customerContoCorrente: '=?customerContoCorrente',
	          customerTipologiaCliente: '=?customerTipologiaCliente',
	          customerPaese: '=?customerPaese',
	          customerProvincia: '=?customerProvincia',
	          customerComune: '=?customerComune',
	          customerCap: '=?customerCap',
	          customerIndirizzo: '=?customerIndirizzo',
	          customerAttivitaConsob: '=?customerAttivitaConsob',
	          customerPromotore: '=?customerPromotore',
	          dossierAbilitatoConsulenza: '=?dossierAbilitatoConsulenza',
	          dossierAbilitatoCollocamento: '=?dossierAbilitatoCollocamento',
	          dossierNumber: '=?dossierNumber',
	          dossierProductDescription: '=?dossierProductDescription',
	          dossierStartDate: '=?dossierStartDate',
	          dossierLockDate: '=?dossierLockDate',
	          dossierEndDate: '=?dossierEndDate',
	          dossierContovaloreTitoli: '=?dossierContovaloreTitoli',
	          dossierBalanceAvailableCcEuro: '=?dossierBalanceAvailableCcEuro',
	          dossierBalanceAvailableCdEuro: '=?dossierBalanceAvailableCdEuro',
	          dossierBalanceCountingCcEuro: '=?dossierBalanceCountingCcEuro',
	          dossierBalanceCountingCdEuro: '=?dossierBalanceCountingCdEuro',
	          dossierBalanceTotEuro: '=?dossierBalanceTotEuro',
	          doNotShowExportButton: '=?doNotShowExportButton',
	          dossierDivisa: '=?',
	          dossierCambio: '=?',
	          dossierDecimali: '=?',
	          isDossierBtnEnabled: '=?isDossierBtnEnabled',
	          customerDettagliEsg: '=?customerDettagliEsg',
	          customerPunteggioEsg: '=?customerPunteggioEsg',
	          finDataContratto: '=?finDataContratto',
	          esgVisibile: '=?esgVisibile'
	        },
	        templateUrl:
	          CONSTANTS.BASE_ROOT +
	          'widgets/finDossierHeader/finDossierHeader.html',
	        replace: true,
	        controller: directiveImpl
	      };
	    }
	  ]);
	})();


/***/ },
/* 32 */
/***/ function(module, exports) {

	(function() {
	    'use strict';
	    angular
	        .module('cbl.finanza.mf.directives')
	        .directive('finDossierComposition', [
	            '$filter',
	            'FinDossierCompositionSrvc',
	            'uiGridConstants',
	            'uiGridGroupingConstants',
	            'CommonUtilitiesSrvc',
	            'FinDeskSrvc',
	            'FIN_CONSTANTS',
	            function(
	                $filter,
	                finDossierCompositionSrvc,
	                uiGridConstants,
	                uiGridGroupingConstants,
	                commonUtilities,
	                deskSrvc,
	                CONSTANTS
	            ) {
	                var directiveImpl = function($scope) {
	                    $scope.service = finDossierCompositionSrvc;
	                    $scope.commonUtilities = commonUtilities;
	
	                    if (!$scope.dossierDivisa) {
	                        $scope.dossierDivisa = 'EUR';
	                    }
	
	                    if (!$scope.dossierCambio) {
	                        $scope.dossierCambio = 1;
	                    }
	
	                    if (!$scope.dossierDecimali) {
	                        $scope.dossierDecimali = 2;
	                    }
	
	                    $scope.spinner = $scope.commonUtilities.getSpinnerStyle($scope);
	
	                    if ($scope.numeroRapporto && $scope.numeroRapporto.length < 6) {
	                        var leftPadding = 6 - $scope.numeroRapporto.length;
	                        for (var index = 0; index < leftPadding; index++) {
	                            $scope.numeroRapporto = '0' + $scope.numeroRapporto;
	                        }
	                    }
	
	                    $scope.formCompositionReset = function() {
	                        $scope.service.inputCompositionForm = {
	                            startDate: null,
	                            isRaggruppaDerivati: false
	                        };
	                        $scope.service.datasource = null;
	                    };
	
	                    $scope.service.views.defaultView = {
	                        title: 'Composizione',
	                        url: CONSTANTS.BASE_ROOT +
	                            'widgets/finDossierComposition/states/finDossierComposition.states.table.html',
	                        visible: true,
	                        searchEnabled: true,
	                        type: 'TABLE'
	                    };
	                    $scope.service.groups.defaultGroup = {
	                        title: 'Nessuno (per Isin)',
	                        field: 'CodiceIsin',
	                        grouping: false,
	                        row: 2,
	                        graph: false
	                    };
	
	                    $scope.setToday = function() {
	                        if ($scope.service.inputCompositionForm.isRaggruppaDerivati) {
	                            $scope.service.inputCompositionForm.startDate = new Date();
	                        }
	                    };
	
	                    $scope.detectGroupingCellContent = function(row, col) {
	                        var flag = !col.grouping ||
	                            col.grouping.groupPriority === undefined ||
	                            col.grouping.groupPriority === null ||
	                            (row.groupHeader && col.grouping.groupPriority === row.treeLevel);
	                        return flag;
	                    };
	
	                    // Costruzione della tabella ui-grid
	                    var gridColumns = [
	                        { name: 'Isin', field: 'CodiceIsin' },
	                        { name: 'Tipologia', field: 'Tipologia' },
	                        { name: 'Descrizione', field: 'Descrizione', width: '15%' },
	                        {
	                            name: 'Intestatario',
	                            field: 'Intestatario',
	                            visible: true,
	                            width: '10%'
	                        },
	                        { name: 'Divisa', field: 'DivisaQuotazione', width: '5%' },
	                        {
	                            name: "Qta' disp.",
	                            field: 'quantitaDisponibile',
	                            cellFilter: 'number: 6',
	                            cellClass: 'right'
	                        },
	                        {
	                            name: "Qta'",
	                            field: 'quantita',
	                            cellFilter: 'number: 6',
	                            cellClass: 'right'
	                        },
	                        {
	                            name: 'Ctv (' + $scope.dossierDivisa + ')',
	                            field: 'Controvalore',
	                            cellClass: 'right',
	                            cellFilter: 'number: 2',
	                            cellTemplate: '<div ng-if="grid.appScope.detectGroupingCellContent(row, col)" class="ui-grid-cell-contents" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}}</div>',
	                            customTreeAggregationFinalizerFn: function(aggregation) {
	                                aggregation.rendered = aggregation.value;
	                            }
	                        },
	                        {
	                            name: 'Rateo (' + $scope.dossierDivisa + ')',
	                            field: 'RateoMercato',
	                            cellFilter: 'number: 2',
	                            cellClass: 'right',
	                            cellTemplate: '<div ng-if="grid.appScope.detectGroupingCellContent(row, col)" class="ui-grid-cell-contents" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}}</div>',
	                            customTreeAggregationFinalizerFn: function(aggregation) {
	                                aggregation.rendered = aggregation.value;
	                            }
	                        },
	                        {
	                            name: 'Prz Merc.',
	                            field: 'PrezzoMercato',
	                            cellFilter: 'number: 5',
	                            cellClass: 'right'
	                        },
	                        {
	                            name: 'Prz Med.',
	                            field: 'PrezzoMedioCarico',
	                            cellFilter: 'number: 5',
	                            cellClass: 'right'
	                        },
	                        {
	                            name: 'Plus/Minus (%)',
	                            field: 'PercPlusMinValenza',
	                            cellFilter: 'number: 3',
	                            cellClass: 'right'
	                        },
	                        {
	                            name: 'Plus/Minus (Eur)',
	                            field: 'ImportoPlusMinValenza',
	                            cellFilter: 'number: 2',
	                            visible: false
	                        },
	                        {
	                            name: 'Cambio di mercato',
	                            field: 'CambioMercato',
	                            cellFilter: 'number: 2',
	                            visible: false
	                        },
	                        {
	                            name: 'Data prezzo di mercato',
	                            field: 'DataPrezzoMercato',
	                            cellFilter: 'date:"dd/MM/yyyy"',
	                            visible: false
	                        },
	                        {
	                            name: 'Cambio medio di carico',
	                            field: 'CambioCarico',
	                            cellFilter: 'number: 5',
	                            visible: false
	                        },
	                        {
	                            name: 'ClasseRischioComplessita',
	                            field: 'ClasseRischioComplessita',
	                            visible: false
	                        },
	                        {
	                            name: 'ClasseRischioEmittente',
	                            field: 'ClasseRischioEmittente',
	                            visible: false
	                        },
	                        {
	                            name: 'ClasseRischioMercato',
	                            field: 'ClasseRischioMercato',
	                            visible: false
	                        }
	                    ];
	                    var defaultGrouping = { groupPriority: 0 };
	                    var defaultSort = { priority: 0, direction: 'asc' };
	
	                    // Customizzazione dei raggruppamenti: in caso di valore NULL nella colonna il raggruppamento restituisce NON SPECIFICATO
	                    var setGroupValues = function(columns, rows) {
	                        columns.forEach(function(column) {
	                            if (column.grouping && column.grouping.groupPriority > -1) {
	                                column.customTreeAggregationFinalizerFn = function(
	                                    aggregation
	                                ) {
	                                    if (typeof aggregation.groupVal !== 'undefined') {
	                                        var label = aggregation.groupVal;
	                                        if (label === 'Null') label = 'NON SPECIFICATO';
	                                        aggregation.rendered =
	                                            label + ' (' + aggregation.value + ')';
	                                    } else {
	                                        aggregation.rendered = null;
	                                    }
	                                };
	                            }
	                        });
	                        return columns;
	                    };
	
	                    var filter = $filter;
	
	                    $scope.service.gridComposizioneProdottoOptions = {
	                        enableSorting: true,
	                        enableColumnMenus: false,
	                        enableFiltering: true,
	                        enableCellEditing: false,
	                        enableCellEditOnFocus: false,
	
	                        enableGridMenu: true,
	                        gridMenuShowHideColumns: false,
	                        exporterCsvFilename: 'ComposizioneDossier.csv',
	                        exporterCsvColumnSeparator: ';',
	                        exporterFieldCallback: function(grid, row, col, value) {
	                            if (col.cellFilter) {
	                                var filterSplit = col.cellFilter.split(':');
	                                var typeFilter = filterSplit[0].trim();
	                                var argFilter =
	                                    filterSplit.length < 2 ?
	                                    '' :
	                                    filterSplit[1].trim().replace(new RegExp(/"/g), '');
	                                var result = $filter(typeFilter)(value, argFilter);
	                                return result;
	                            }
	                            return value;
	                        },
	                        exporterHeaderFilterUseName: true,
	                        exporterHeaderFilter: function(name) {
	                            return name.toUpperCase();
	                        },
	                        exporterMenuPdf: false,
	
	                        enableColumnResizing: true,
	
	                        showGridFooter: true,
	                        enablePagination: true,
	                        paginationPageSizes: [10, 25, 50, 100],
	                        paginationPageSize: 10,
	                        paginationCurrentPage: 1,
	
	                        enableRowSelection: true,
	                        multiSelect: false,
	                        enableRowHeaderSelection: false,
	
	                        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
	                        //enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
	
	                        onRegisterApi: function(gridApi) {
	                            $scope.service.gridApi = gridApi;
	
	                            // Attivo la customizzazione del rendered dei raggruppamenti
	                            $scope.service.gridApi.grid.registerColumnsProcessor(
	                                setGroupValues,
	                                410
	                            );
	
	                            $scope.service.gridApi.grouping.on.groupingChanged(
	                                $scope,
	                                function(column) {
	                                    if (column.grouping.groupPriority === undefined) {
	                                        column.unsort();
	                                    }
	                                }
	                            );
	
	                            $scope.service.gridApi.selection.on.rowSelectionChanged(
	                                $scope,
	                                function(row) {
	                                    $scope.showDetails(row.entity);
	                                }
	                            );
	                        },
	
	                        columnDefs: gridColumns,
	                        data: $scope.service.datasource
	                    };
	                    commonUtilities.calculateHeightUIGridComponent(
	                        $scope.service.gridComposizioneProdottoOptions
	                    );
	
	                    // Legge dal servizio tutti gli elementi da visualizzare
	                    $scope.getCompositionItems = function() {
	                        this.service.searchInProgress = true;
	
	                        var startDate = Date.parse(
	                            $scope.service.inputCompositionForm.startDate
	                        );
	                        var includiDerivati =
	                            $scope.service.inputCompositionForm.isRaggruppaDerivati;
	
	                        var serviceUrl = CONSTANTS.REST_ROOT + CONSTANTS.REST.COMPOSIZIONE;
	                        var serviceParams = {
	                            rapporto: $scope.numeroRapporto,
	                            dataSaldo: new Date(startDate),
	                            includiDerivati: $scope.derivatiVisible ?
	                                includiDerivati :
	                                $scope.derivatiDefault
	                        };
	                        var successCallback = function(data) {
	                            $scope.datasource = $scope.service.remapComposition(
	                                data.data.composizione
	                            );
	                            $scope.controvaloreComposizione = data.data.controvalore;
	
	                            if (data.data !== null) {
	                                // Inizializzo le sorgenti
	                                $scope.service.datasource = $scope.service.remapComposition(
	                                    data.data.composizione
	                                );
	                                if ($scope.service.datasource) {
	                                    $scope.service.datasource.forEach(function(data) {
	                                        data.Controvalore =
	                                            data.Controvalore * $scope.dossierCambio;
	                                        data.RateoMercato =
	                                            data.RateoMercato * $scope.dossierCambio;
	                                    });
	                                    $scope.service.controvaloreComposizione =
	                                        data.data.controvalore;
	                                    $scope.service.gridComposizioneProdottoOptions.data =
	                                        $scope.service.datasource;
	                                    commonUtilities.calculateHeightUIGridComponent(
	                                        $scope.service.gridComposizioneProdottoOptions
	                                    );
	
	                                    $scope.getSourceChart();
	                                    $scope.service.searchInProgress = false;
	                                }
	                            }
	                        };
	                        var errorCallback = function() {
	                            $scope.datasource = null;
	                            $scope.service.searchInProgress = false;
	                        };
	                        $scope.service.callComposition(
	                            serviceUrl,
	                            serviceParams,
	                            successCallback,
	                            errorCallback
	                        );
	                    };
	
	                    // Determina se ci sono elementi
	                    $scope.hasItems = function() {
	                        if (
	                            $scope.service.datasource === null ||
	                            $scope.service.datasource === undefined
	                        ) {
	                            return false;
	                        }
	                        var count = $scope.service.datasource.length;
	                        if (count === null || count === undefined) {
	                            return false;
	                        }
	                        var flag = count > 0;
	                        return flag;
	                    };
	
	                    // #region Funzioni per la gestione delle viste
	
	                    $scope.isActiveView = function(viewUrl) {
	                        return viewUrl == $scope.service.views.defaultView.url;
	                    };
	
	                    $scope.changeView = function(view) {
	                        $scope.service.views.defaultView = view;
	                    };
	
	                    $scope.showDetails = function(item) {
	                        $scope.service.views.defaultView = $scope.service.views.listView[2];
	                        $scope.service.currentItem = item;
	                    };
	
	                    $scope.backToTable = function() {
	                        $scope.service.views.defaultView = $scope.service.views.listView[0];
	                        $scope.service.currentItem = null;
	                    };
	
	                    // #endregion
	
	                    // #region Funzioni per la gestione dei gruppi
	
	                    $scope.isActiveGroup = function(groupField) {
	                        return groupField == $scope.service.groups.defaultGroup.field;
	                    };
	
	                    // Cambia il raggruppamento delle righe
	                    $scope.changeGroup = function(group) {
	                        $scope.backToTable();
	                        $scope.service.groups.defaultGroup = group;
	
	                        if ($scope.hasItems()) {
	                            $scope.groupBy(group);
	                        }
	                    };
	
	                    // Effettua il raggruppamento delle righe
	                    $scope.groupBy = function(group) {
	                        $scope.service.gridApi.grouping.clearGrouping();
	                        if (group.grouping) {
	                            $scope.service.gridApi.grouping.groupColumn(group.grouping);
	                            $scope.service.gridApi.grouping.aggregateColumn(
	                                'Ctv (' + $scope.dossierDivisa + ')',
	                                uiGridGroupingConstants.aggregation.SUM
	                            );
	                            $scope.service.gridApi.grouping.aggregateColumn(
	                                'Rateo (' + $scope.dossierDivisa + ')',
	                                uiGridGroupingConstants.aggregation.SUM
	                            );
	
	                            gridColumns.forEach(function(element, index, array) {
	                                if (element.name === group.grouping) {
	                                    element.grouping = defaultGrouping;
	                                    element.sort = defaultSort;
	                                } else {
	                                    delete element.grouping;
	                                    delete element.sort;
	                                }
	                            });
	
	                            $scope.service.gridComposizioneProdottoOptions.columnDefs =
	                                gridColumns;
	                            //$scope.service.gridApi.core.queueGridRefresh();
	                            $scope.service.gridApi.core.refresh();
	                        }
	
	                        $scope.getSourceChart();
	                    };
	
	                    // #endregion
	
	                    // Costruzione del datasource del grafico
	                    $scope.getSourceChart = function() {
	                        var group = $scope.service.groups.defaultGroup;
	                        $scope.service.datasourceChart = [];
	                        if (!group.graph) {
	                            return;
	                        }
	
	                        // Raggruppo in base al campo selezionato e genero il datasource per il grafico
	                        // - Passo 1: estraggo le chiavi
	                        var flags = {};
	                        var keys = {};
	                        var length = $scope.service.datasource.length;
	                        var currentField = group.field;
	                        for (var index = 0; index < length; index++) {
	                            var fieldName = $scope.service.datasource[index][currentField];
	                            var fieldValue = $scope.service.datasource[index].Controvalore;
	
	                            if (flags[fieldName]) {
	                                keys[fieldName] =
	                                    keys[fieldName] + new Number(fieldValue).valueOf();
	                            } else {
	                                flags[fieldName] = true;
	                                keys[fieldName] = new Number(fieldValue).valueOf();
	                            }
	                        }
	                        //console.log(JSON.stringify(keys));
	
	                        // - Passo 2: inizializzo il datasource del grafico
	                        for (var key in keys) {
	                            var segment = {
	                                name: key === 'null' ? 'NON SPECIFICATO' : key,
	                                y: keys[key]
	                            };
	                            $scope.service.datasourceChart.push(segment);
	                        }
	                        //console.log(JSON.stringify($scope.service.datasourceChart));
	                    };
	
	                    $scope.exportTableToCSV = function() {
	                        var dataCSV = [];
	                        // Elimino i campi di angular (quelli che iniziano per $)
	                        for (var index in $scope.service.datasource) {
	                            var element = $scope.service.datasource[index];
	                            var current = {};
	                            for (var item in element) {
	                                if (item.indexOf('$') !== 0) {
	                                    current[item] = element[item];
	                                }
	                            }
	                            dataCSV.push(current);
	                        }
	                        commonUtilities.downloadCSV(dataCSV, 'export-composizione.csv');
	                    };
	
	                    $scope.init = (function() {
	                        if (
	                            (!$scope.hasItems() &&
	                                $scope.service.inputCompositionForm.startDate === null) ||
	                            $scope.service.numeroRapporto !== $scope.numeroRapporto
	                        ) {
	                            $scope.service.inputCompositionForm.startDate = new Date();
	                            $scope.service.views.defaultView =
	                                $scope.service.views.listView[0];
	                            $scope.service.groups.defaultGroup =
	                                $scope.service.groups.listGroup[
	                                    $scope.service.groups.listGroup.length - 1
	                                ];
	                            $scope.service.currentItem = null;
	                            $scope.getCompositionItems();
	                            $scope.service.numeroRapporto = $scope.numeroRapporto;
	                        }
	                    })();
	                };
	                directiveImpl.$inject = ['$scope'];
	
	                return {
	                    restrict: 'E',
	                    scope: {
	                        numeroRapporto: '=?numeroRapporto',
	                        derivatiVisible: '=?derivatiVisible',
	                        derivatiDefault: '=?derivatiDefault',
	                        dossierCambio: '=?',
	                        dossierDivisa: '=?',
	                        dossierDecimali: '=?'
	                    },
	                    templateUrl: CONSTANTS.BASE_ROOT +
	                        'widgets/finDossierComposition/finDossierComposition.html',
	                    replace: false,
	                    controller: directiveImpl
	                };
	            }
	        ]);
	})();

/***/ },
/* 33 */
/***/ function(module, exports) {

	(function() {
	    'use strict';
	    angular
	        .module('cbl.finanza.mf.directives')
	        .service('FinDossierCompositionSrvc', [
	            '$http',
	            'FIN_CONSTANTS',
	            function($http, CONSTANTS) {
	                this.inputCompositionForm = {
	                    startDate: null,
	                    isRaggruppaDerivati: false
	                };
	
	                this.datasource = null;
	                this.controvaloreComposizione = null;
	                this.gridComposizioneProdottoOptions = null;
	                this.gridApi = null;
	
	                // Gestione delle viste
	                this.views = {
	                    defaultView: {
	                        title: 'Composizione',
	                        url: CONSTANTS.BASE_ROOT +
	                            'widgets/finDossierComposition/states/finDossierComposition.states.table.html',
	                        visible: true,
	                        searchEnabled: true,
	                        type: 'TABLE'
	                    },
	                    listView: [{
	                            title: 'Composizione',
	                            url: CONSTANTS.BASE_ROOT +
	                                'widgets/finDossierComposition/states/finDossierComposition.states.table.html',
	                            visible: true,
	                            searchEnabled: true,
	                            type: 'TABLE'
	                        },
	                        {
	                            title: 'Grafico',
	                            url: CONSTANTS.BASE_ROOT +
	                                'widgets/finDossierComposition/states/finDossierComposition.states.graph.html',
	                            visible: true,
	                            searchEnabled: true,
	                            type: 'GRAPH'
	                        },
	                        {
	                            title: 'Dettaglio titolo',
	                            url: CONSTANTS.BASE_ROOT +
	                                'widgets/finDossierComposition/states/finDossierComposition.states.details.html',
	                            visible: false,
	                            searchEnabled: false,
	                            type: 'DETAIL'
	                        }
	                    ]
	                };
	
	                // Gestione dei raggruppamenti
	                this.groups = {
	                    defaultGroup: {
	                        title: 'Nessuno (per Isin)',
	                        field: 'CodiceIsin',
	                        grouping: false,
	                        row: 1,
	                        graph: false
	                    },
	                    listGroup: [{
	                            title: 'Tipologia',
	                            field: 'Tipologia',
	                            grouping: 'Tipologia',
	                            row: 1,
	                            graph: true
	                        },
	                        {
	                            title: 'Divisa',
	                            field: 'DivisaQuotazione',
	                            grouping: 'Divisa',
	                            row: 1,
	                            graph: true
	                        },
	                        {
	                            title: 'Nessuno (per Isin)',
	                            field: 'CodiceIsin',
	                            grouping: false,
	                            row: 1,
	                            graph: false
	                        }
	                    ]
	                };
	
	                this.currentItem = null;
	                // Determina se sto facendo una ricerca (e quindi mostro il loader) o se non ho
	                // trovato risultati (e mostro il messaggio di nessun elemento trovato)
	                this.searchInProgress = false;
	
	                this.callComposition = function(url, body, success, error) {
	                    $http.post(url, body).then(success, error);
	                };
	
	                this.remapComposition = function(composizione) {
	                    if (!composizione) {
	                        return null;
	                    }
	                    var result = [];
	                    composizione.forEach(function(comp) {
	                        result.push({
	                            CambioCarico: comp.cambioCarico,
	                            CambioMercato: comp.cambioMercato,
	                            ClasseRischioComplessita: comp.classeRischioComplessita,
	                            ClasseRischioEmittente: comp.classeRischioEmittente,
	                            ClasseRischioMercato: comp.classeRischioMercato,
	                            CodiceIsin: comp.codiceIsin,
	                            CodiceTitolo: comp.codiceTitolo,
	                            CodiceRischioComplessita: comp.codiceRischioComplessita,
	                            CodiceRischioEmittente: comp.codiceRischioEmittente,
	                            CodiceRischioMercato: comp.codiceRischioMercato,
	                            Controvalore: comp.controvalore,
	                            DataPrezzoMercato: comp.dataPrezzoMercato,
	                            Descrizione: comp.descrizione,
	                            DivisaQuotazione: comp.divisaQuotazione,
	                            ImportoPlusMinValenza: comp.importoPlusMinValenza,
	                            Intestatario: comp.intestatario,
	                            PercPlusMinValenza: comp.percPlusMinValenza,
	                            PrezzoMedioCarico: comp.prezzoMedioCarico,
	                            PrezzoMercato: comp.prezzoMercato,
	                            Quantita: comp.quantita,
	                            QuantitaDisponibile: comp.quantitaDisponibile,
	                            RateoMercato: comp.rateoMercato,
	                            Tipologia: comp.tipologia,
	                            quantita: comp.quantita,
	                            quantitaDisponibile: comp.quantitaDisponibile
	                        });
	                    });
	                    return result;
	                };
	            }
	        ]);
	})();

/***/ },
/* 34 */
/***/ function(module, exports) {

	(function () {
	  'use strict';
	  angular.module('cbl.finanza.mf.directives').directive('finDossierMovements', [
	    '$filter',
	    'FinDossierMovementsSrvc',
	    'uiGridConstants',
	    'uiGridGroupingConstants',
	    'CommonUtilitiesSrvc',
	    'FIN_CONSTANTS',
	    function (
	      $filter,
	      cblDossierMovementsSrvc,
	      uiGridConstants,
	      uiGridGroupingConstants,
	      commonUtilities,
	      CONSTANTS
	    ) {
	      var directiveImpl = function ($scope) {
	        $scope.service = cblDossierMovementsSrvc;
	        $scope.commonUtilities = commonUtilities;
	        $scope.spinner = $scope.commonUtilities.getSpinnerStyle($scope);
	
	        $scope.formMovementsReset = function () {
	          $scope.service.inputFormMovimenti = {
	            startDate: null,
	            endDate: null,
	            isin: null,
	            descrizione: null
	          };
	          $scope.service.datasource = null;
	        };
	
	        $scope.service.views.defaultView = {
	          title: 'Movimenti',
	          url:
	            CONSTANTS.BASE_ROOT +
	            'widgets/finDossierMovements/states/finDossierMovements.states.table.html',
	          visible: true,
	          searchEnabled: true,
	          type: 'TABLE'
	        };
	        //$scope.detectGroupingCellContent = function (row, col) {
	        //    var flag = !col.grouping || col.grouping.groupPriority === undefined || col.grouping.groupPriority === null || (row.groupHeader && col.grouping.groupPriority === row.treeLevel);
	        //    return flag;
	        //};
	        $scope.startDateRequired = false;
	        $scope.endDateRequired = false;
	        // Costruzione della tabella ui-grid
	        var gridColumns = [
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: 'Numero rapporto',
	            field: 'codiceDossier',
	            width: '5%'
	          },
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: 'Data Contabile',
	            field: 'dataContabile',
	            width: '6%',
	            cellFilter: 'date:"dd/MM/yyyy"'
	          },
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: 'Isin',
	            field: 'isin'
	          },
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: 'Causale',
	            field: 'causale'
	          },
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: 'Descrizione',
	            field: 'descrizioneTitolo'
	          },
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: 'Segno',
	            field: 'segnoOperazione'
	          },
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: "Quantita' Nominale",
	            field: 'quantitaNominale',
	            cellClass: 'right',
	            cellFilter: 'number: 6'
	          },
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: 'Prezzo (EUR)',
	            field: 'prezzoLordo',
	            cellClass: 'right',
	            cellFilter: 'number: 5'
	          },
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: 'Importo (EUR)',
	            field: 'totaleLiquiditaControparte',
	            cellFilter: 'number: 2',
	            cellClass: function (
	              grid,
	              row,
	              col,
	              rowRenderIndex,
	              colRenderIndex
	            ) {
	              if (grid.getCellValue(row, col) < 0) return 'red right';
	              return 'right';
	            }
	          },
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: 'Divisa',
	            field: 'divisaTitolo'
	          },
	          {
	            cellTooltip: true,
	            headerTooltip: true,
	            name: 'Cambio',
	            field: 'cambio',
	            cellClass: 'right',
	            cellFilter: 'number: 5'
	          }
	        ];
	        var defaultGrouping = { groupPriority: 0 };
	        var defaultSort = { priority: 0, direction: 'asc' };
	
	        var filter = $filter;
	
	        $scope.service.gridMovimentiProdottoOptions = {
	          enableSorting: true,
	          enableColumnMenus: false,
	          enableFiltering: true,
	          enableCellEditing: false,
	          enableCellEditOnFocus: false,
	
	          enableGridMenu: true,
	          gridMenuShowHideColumns: false,
	          exporterCsvFilename: 'MovimentiDossier.csv',
	          exporterCsvColumnSeparator: ';',
	          exporterFieldCallback: function (grid, row, col, value) {
	            if (col.cellFilter) {
	              var filterSplit = col.cellFilter.split(':');
	              var typeFilter = filterSplit[0].trim();
	              var argFilter =
	                filterSplit.length < 2
	                  ? ''
	                  : filterSplit[1].trim().replace(new RegExp(/"/g), '');
	              var result = $filter(typeFilter)(value, argFilter);
	              return result;
	            }
	            return value;
	          },
	          exporterHeaderFilterUseName: true,
	          exporterHeaderFilter: function (name) {
	            return name.toUpperCase();
	          },
	          exporterMenuPdf: false,
	
	          enableColumnResizing: true,
	
	          showGridFooter: true,
	          enablePagination: true,
	          paginationPageSizes: [10, 25, 50, 100],
	          paginationPageSize: 10,
	          paginationCurrentPage: 1,
	
	          enableRowSelection: true,
	          multiSelect: false,
	          enableRowHeaderSelection: false,
	
	          enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
	
	          onRegisterApi: function (gridApi) {
	            $scope.service.gridApi = gridApi;
	
	            $scope.service.gridApi.selection.on.rowSelectionChanged(
	              $scope,
	              function (row) {
	                $scope.showDetails(row.entity);
	              }
	            );
	          },
	
	          columnDefs: gridColumns,
	          data: $scope.service.datasource
	        };
	        commonUtilities.calculateHeightUIGridComponent(
	          $scope.service.gridMovimentiProdottoOptions
	        );
	
	        ($scope.getDossierMovements = function () {
	          this.service.searchInProgress = true;
	          this.service.datasource = new Array();
	          this.service.gridMovimentiProdottoOptions.data = new Array();
	
	          var serviceUrl =
	            CONSTANTS.REST_ROOT +
	            CONSTANTS.REST.MOVEMENTS +
	            '/' +
	            $scope.numeroRapporto;
	          var serviceParams = {
	            dataDa: this.service.inputFormMovimenti.startDate,
	            dataA: this.service.inputFormMovimenti.endDate,
	            isin: this.service.inputFormMovimenti.isin,
	            descrizioneTitolo: this.service.inputFormMovimenti.descrizione
	          };
	          if (serviceParams.dataA !== null && serviceParams.dataDa !== null) {
	            serviceParams.dataDa = serviceParams.dataDa
	              .toISOString()
	              .substring(0, 10);
	            serviceParams.dataA = serviceParams.dataA
	              .toISOString()
	              .substring(0, 10);
	          }
	          //VERIFICA SE I CAMPI CALENDARIO SONO VALORIZZATI
	          $scope.startDateRequired = isNaN(
	            Date.parse(this.service.inputFormMovimenti.startDate)
	          );
	          $scope.endDateRequired = isNaN(
	            Date.parse(this.service.inputFormMovimenti.endDate)
	          );
	          //SE I CAMPI CALENDARIO NON SONO VALORIZZATI LA CHIAMATA NON PARTE
	          if ($scope.startDateRequired || $scope.endDateRequired) {
	            $scope.service.searchInProgress = false;
	            return;
	          }
	          var parentThis = this;
	          var successCallback = function (self, data) {
	            if (data !== null) {
	              $scope.service.datasource = data.result;
	
	              $scope.service.gridMovimentiProdottoOptions.data =
	                $scope.service.datasource;
	              commonUtilities.calculateHeightUIGridComponent(
	                $scope.service.gridMovimentiProdottoOptions
	              );
	              $scope.movementsNotFound = $scope.service.datasource.length === 0;
	
	              $scope.service.searchInProgress = false;
	            }
	            $scope.internalLoading = false;
	          };
	          var errorCallback = function (self, error) {
	            $scope.internalLoading = false;
	            $scope.service.searchInProgress = false;
	          };
	          var showLoaderService = false;
	          this.internalLoading = true;
	          this.commonUtilities.executeHttpGetService(
	            serviceUrl,
	            serviceParams,
	            parentThis,
	            showLoaderService,
	            successCallback,
	            errorCallback
	          );
	        }),
	          // Determina se ci sono elementi
	          ($scope.hasItems = function () {
	            if (
	              $scope.service.datasource === null ||
	              $scope.service.datasource === undefined
	            ) {
	              return false;
	            }
	            var count = $scope.service.datasource.length;
	            if (count === null || count === undefined) {
	              return false;
	            }
	            var flag = count > 0;
	            return flag;
	          });
	
	        // #region Funzioni per la gestione delle viste
	
	        $scope.isActiveView = function (viewUrl) {
	          return viewUrl == $scope.service.views.defaultView.url;
	        };
	
	        $scope.changeView = function (view) {
	          $scope.service.views.defaultView = view;
	        };
	
	        $scope.showDetails = function (item) {
	          $scope.service.views.defaultView = $scope.service.views.listView[1];
	          $scope.service.currentItem = item;
	        };
	
	        $scope.backToTable = function () {
	          $scope.service.views.defaultView = $scope.service.views.listView[0];
	          $scope.service.currentItem = null;
	        };
	
	        // #endregion
	
	        $scope.exportTableToCSV = function () {
	          var dataCSV = [];
	          // Elimino i campi di angular (quelli che iniziano per $)
	          for (var index in $scope.service.datasource) {
	            var element = $scope.service.datasource[index];
	            var current = {};
	            for (var item in element) {
	              if (item.indexOf('$') !== 0) {
	                current[item] = element[item];
	              }
	            }
	            dataCSV.push(current);
	          }
	          commonUtilities.downloadCSV(dataCSV, 'export-movimenti.csv');
	        };
	
	        $scope.init = (function () {
	          if (
	            (!$scope.hasItems() &&
	              $scope.service.inputFormMovimenti.startDate === null) ||
	            $scope.service.numeroRapporto !== $scope.numeroRapporto
	          ) {
	            $scope.service.views.defaultView = $scope.service.views.listView[0];
	            $scope.service.currentItem = null;
	            $scope.service.numeroRapporto = $scope.numeroRapporto;
	          }
	        })();
	      };
	      directiveImpl.$inject = ['$scope'];
	
	      return {
	        restrict: 'E',
	        scope: {
	          numeroRapporto: '=?numeroRapporto'
	        },
	        templateUrl:
	          CONSTANTS.BASE_ROOT +
	          'widgets/finDossierMovements/finDossierMovements.html',
	        replace: false,
	        controller: directiveImpl
	      };
	    }
	  ]);
	})();


/***/ },
/* 35 */
/***/ function(module, exports) {

	(function () {
	  'use strict';
	  angular
	    .module('cbl.finanza.mf.directives')
	    .service('FinDossierMovementsSrvc', [
	      'FIN_CONSTANTS',
	      function (CONSTANTS) {
	        var numeroRapporto = null;
	        var datasource = null;
	        var gridMovimentiProdottoOptions = null;
	        var gridApi = null;
	
	        var inputFormMovimenti = {
	          startDate: null,
	          endDate: null,
	          isin: null,
	          descrizione: null
	        };
	
	        // Gestione delle viste
	        var views = {
	          defaultView: {
	            title: 'Movimenti',
	            url:
	              CONSTANTS.BASE_ROOT +
	              'widgets/finDossierMovements/states/finDossierMovements.states.table.html',
	            visible: true,
	            searchEnabled: true,
	            type: 'TABLE'
	          },
	          listView: [
	            {
	              title: 'Movimenti',
	              url:
	                CONSTANTS.BASE_ROOT +
	                'widgets/finDossierMovements/states/finDossierMovements.states.table.html',
	              visible: true,
	              searchEnabled: true,
	              type: 'TABLE'
	            },
	            {
	              title: 'Dettaglio movimento',
	              url:
	                CONSTANTS.BASE_ROOT +
	                'widgets/finDossierMovements/states/finDossierMovements.states.details.html',
	              visible: false,
	              searchEnabled: false,
	              type: 'DETAIL'
	            }
	          ]
	        };
	
	        var currentItem = null;
	        // Determina se sto facendo una ricerca (e quindi mostro il loader) o se non ho
	        // trovato risultati (e mostro il messaggio di nessun elemento trovato)
	        var searchInProgress = false;
	
	        return {
	          numeroRapporto: numeroRapporto,
	          datasource: datasource,
	
	          gridMovimentiProdottoOptions: gridMovimentiProdottoOptions,
	          gridApi: gridApi,
	
	          views: views,
	          currentItem: currentItem,
	          searchInProgress: searchInProgress,
	
	          inputFormMovimenti: inputFormMovimenti
	        };
	      }
	    ]);
	})();


/***/ },
/* 36 */
/***/ function(module, exports) {

	(function () {
	  'use strict';
	  angular.module('cbl.finanza.mf.directives').directive('finDossierChartPane', [
	    'FinDossierChartPaneSrvc',
	    'CommonUtilitiesSrvc',
	    'FIN_CONSTANTS',
	    function (finDossierChartPaneSrvc, commonUtilities, CONSTANTS) {
	      var directiveImpl = function ($scope) {
	        $scope.service = finDossierChartPaneSrvc;
	        $scope.commonUtilities = commonUtilities;
	
	        $scope.startDateRequired = false;
	        $scope.startDate = null;
	        $scope.endDateRequired = false;
	        $scope.endDate = null;
	
	        $scope.getGraficoSaldoDossier = function () {
	          $scope.startDateRequired = isNaN(Date.parse($scope.startDate));
	          $scope.endDateRequired = isNaN(Date.parse($scope.endDate));
	
	          if ($scope.startDateRequired || $scope.endDateRequired) {
	            return;
	          }
	          
	          $scope.service.chartDatasource = new Array();
	          var serviceUrl = CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.CHART +
	          '/' +
	          $scope.rapporto;
	          var serviceParams = {
	            dataDa: new Date($scope.startDate).toISOString().substring(0,10),
	            dataA: new Date($scope.endDate).toISOString().substring(0,10)
	          };
	          var parentThis = $scope;
	          var successCallback = function (self, data) {
	            data.result.forEach(function (element, index, array) {
	              var datasource = [];
	              var date = new Date(element.data);
	              var y = element.saldo;
	
	              var chartPoint = [];
	              chartPoint.push(
	                Date.UTC(
	                  date.getFullYear(),
	                  date.getMonth(),
	                  date.getDate(),
	                  date.getHours(),
	                  date.getMinutes(),
	                  date.getSeconds()
	                )
	              );
	              chartPoint.push(y);
	              self.service.chartDatasource.push(chartPoint);
	            });
	          };
	          var showLoaderService = 'Caricamento in corso...';
	          $scope.commonUtilities.executeHttpGetService(
	            serviceUrl,
	            serviceParams,
	            parentThis,
	            showLoaderService,
	            successCallback,
	            null
	          );
	        };
	
	        $scope.resetGraficoSaldoDossier = function () {
	          $scope.startDate = null;
	          $scope.endDate = null;
	          $scope.service.chartDatasource = new Array();
	        };
	      };
	      directiveImpl.$inject = ['$scope'];
	
	      return {
	        restrict: 'E',
	        require: 'ngModel',
	        scope: {
	          rapporto: '=?ngModel'
	        },
	        templateUrl:
	          CONSTANTS.BASE_ROOT +
	          'widgets/finDossierChartPane/finDossierChartPane.html',
	        replace: false,
	        controller: directiveImpl
	      };
	    }
	  ]);
	})();


/***/ },
/* 37 */
/***/ function(module, exports) {

	(function () {
	  'use strict';
	  angular
	    .module('cbl.finanza.mf.directives')
	    .service('FinDossierChartPaneSrvc', function () {
	      var chartDatasource = null;
	
	      return {
	        chartDatasource: chartDatasource
	      };
	    });
	})();


/***/ },
/* 38 */
/***/ function(module, exports) {

	(function () {
	  'use strict';
	  var FinInfoTooltipController = function ($scope, labelSrvc) {
	    $scope.msg = labelSrvc.getLabel;
	  };
	  FinInfoTooltipController.$inject = ['$scope', 'FinLabelSrvc'];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT + 'widgets/finModali/info-tooltip/finInfoTooltip.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var FinInfoTooltipComponent = {
	    bindings: {
	      dettaglioStrumento: '=?'
	    },
	    controller: FinInfoTooltipController,
	    controllerAs: 'tooltipCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finInfoTooltip', FinInfoTooltipComponent);
	})();


/***/ },
/* 39 */
/***/ function(module, exports) {

	/**
	 *
	 */
	(function () {
	  'use strict';
	  angular
	    .module('cbl.finanza.mf.directives')
	    .directive('cblCalendar', [
	      '$parse',
	      'FIN_CONSTANTS',
	      function ($parse, CONSTANTS) {
	        return {
	          restrict: 'E',
	          require: 'ngModel',
	          scope: {
	            value: '=ngModel',
	            placeholder: '=',
	            ngRequired: '=',
	            ngDisabled: '=',
	            minDate: '=',
	            maxDate: '=',
	            ngClass: '=',
	            cblChange: '=',
	            name: '='
	          },
	          templateUrl:
	            CONSTANTS.BASE_ROOT + 'widgets/cblCalendar/cblCalendar.html',
	          controller: [
	            '$scope',
	            function ($scope) {
	              $scope.minDate = $scope.minDate ? $scope.minDate : null;
	              $scope.maxDate = $scope.maxDate ? $scope.maxDate : null;
	
	              if ($scope.value && $scope.value.length === 10) {
	                $scope.value = new Date($scope.value + 'T02:00:00');
	              } else {
	                try {
	                  if ($scope.value) {
	                    $scope.value = new Date($scope.value);
	                  }
	                } catch (e) {
	                  // $scope.value = null;
	                  console.log('Date not valid for that value: ' + $scope.value);
	                }
	              }
	
	              $scope.apri = function ($event) {
	                $scope.opened = true;
	              };
	
	              $scope.opened = false;
	
	              $scope.dateOptions = {
	                formatYear: 'yy',
	                startingDay: 1,
	                formatMonth: 'MM'
	              };
	              $scope.formats = [
	                'dd-MM-yyyy',
	                'yyyy/MM/dd',
	                'dd.MM.yyyy',
	                'shortDate'
	              ];
	              $scope.format = $scope.formats[0];
	            }
	          ],
	          link: link
	        };
	
	        function link(scope, element, attr, ctrls) {
	          ctrls.$formatters.unshift(function (value) {
	            // format check
	            if (value && scope.value && !(scope.value instanceof Date)) {
	              var dateArray = value.split('-');
	              if (dateArray[0].length === 4) {
	                value = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
	              }
	              dateArray = value.split('-');
	              scope.value = new Date(
	                dateArray[2],
	                dateArray[1] - 1,
	                dateArray[0].substr(0, 2)
	              );
	            }
	            return value;
	          });
	        }
	      }
	    ])
	    .directive('cblCalendarValidator', [
	      function () {
	        return {
	          restrict: 'A',
	          require: 'ngModel',
	          link: link
	        };
	
	        function link(scope, element, attr, ctrls) {
	          element.on('keyup', function (evt) {
	            if (evt.which === 8 || evt.keyCode === 8) {
	              if (this.value.length === 5 || this.value.length === 2) {
	                this.value = this.value.substr(0, this.value.length - 1);
	              }
	              return;
	            }
	            this.value = this.value.replace(/[^0-9\-]/g, '');
	            var v = this.value;
	            if (v.match(/^\d{2}$/) !== null) {
	              this.value = v + '-';
	            } else if (v.match(/^\d{2}\-\d{2}$/) !== null) {
	              this.value = v + '-';
	            }
	            this.value = this.value.replace(/\-\-/g, '-');
	            if (this.value.length > 10) {
	              this.value = this.value.substr(0, 10);
	            }
	          });
	
	          // For DOM -> model validation
	          ctrls.$parsers.unshift(function (value) {
	            var minDate = scope.minDate;
	            // minDate Validation
	            ctrls.$setValidity('minDate', true);
	            if (!minDate || !value) {
	              return value;
	            }
	
	            var dateArray = value.split('-');
	            if (dateArray.length < 2) {
	              ctrls.$setValidity('minDate', false);
	              return value;
	            }
	            var dateTime = new Date(
	              dateArray[2],
	              dateArray[1] - 1,
	              dateArray[0],
	              12
	            );
	            if (dateTime.getTime() < minDate.getTime()) {
	              ctrls.$setValidity('minDate', false);
	            }
	            return value;
	          });
	
	          // For DOM -> model validation
	          ctrls.$parsers.unshift(function (value) {
	            var maxDate = scope.maxDate;
	            // maxDate Validation
	            ctrls.$setValidity('maxDate', true);
	            if (!maxDate || !value) {
	              return value;
	            }
	
	            var dateArray = value.split('-');
	            if (dateArray.length < 2) {
	              ctrls.$setValidity('maxDate', false);
	              return value;
	            }
	            var dateTime = new Date(
	              dateArray[2],
	              dateArray[1] - 1,
	              dateArray[0]
	            );
	            if (dateTime.getTime() > maxDate.getTime()) {
	              ctrls.$setValidity('maxDate', false);
	            }
	            return value;
	          });
	
	          ctrls.$parsers.unshift(function (value) {
	            if (scope.cblChange) {
	              scope.cblChange(value);
	            }
	            return value;
	          });
	
	          ctrls.$formatters.unshift(function (value) {
	            // format check
	            if (value) {
	              var dateArray = value.split('-');
	              if (dateArray[0].length === 4) {
	                value = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
	              }
	            }
	            if (scope.cblChange) {
	              scope.cblChange(value);
	            }
	
	            return value;
	          });
	
	          // For model -> DOM validation
	          ctrls.$formatters.unshift(function (value) {
	            var minDate = scope.minDate;
	            // minDate Validation
	            ctrls.$setValidity('minDate', true);
	            if (!minDate || !value) {
	              return value;
	            }
	
	            var dateArray = value.split('-');
	            if (dateArray.length < 2) {
	              ctrls.$setValidity('minDate', false);
	              return value;
	            }
	            var dateTime = new Date(
	              dateArray[2],
	              dateArray[1] - 1,
	              dateArray[0],
	              12
	            );
	            if (dateTime.getTime() < minDate.getTime()) {
	              ctrls.$setValidity('minDate', false);
	            }
	            return value;
	          });
	
	          // For model -> DOM validation
	          ctrls.$formatters.unshift(function (value) {
	            var maxDate = scope.maxDate;
	            // maxDate Validation
	            ctrls.$setValidity('maxDate', true);
	            if (!maxDate || !value) {
	              return value;
	            }
	
	            var dateArray = value.split('-');
	            if (dateArray.length < 2) {
	              ctrls.$setValidity('maxDate', false);
	              return value;
	            }
	            var dateTime = new Date(
	              dateArray[2],
	              dateArray[1] - 1,
	              dateArray[0]
	            );
	            if (dateTime.getTime() > maxDate.getTime()) {
	              ctrls.$setValidity('maxDate', false);
	            }
	            return value;
	          });
	        }
	      }
	    ]);
	})();


/***/ },
/* 40 */
/***/ function(module, exports) {

	(function () {
	  'use strict';
	  var CblSchedaProdottoDossierCtrl = function (
	    $scope,
	    $state,
	    $stateParams,
	    $filter,
	    schedaDossierSrvc,
	    uiGridConstants,
	    $sce,
	    commonUtilities,
	    CONSTANTS,
	    messaggiFctr,
	    deskSrvc,
	    labelSrvc,
	    userSrvc
	  ) {
	    if ($scope === undefined) {
	      return;
	    }
	
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$filter = $filter;
	    this.schedaDossierSrvc = schedaDossierSrvc;
	    this.$sce = $sce;
	    this.commonUtilities = commonUtilities;
	    this.messaggiFctr = messaggiFctr;
	    this.posizione = {};
	    this.totaliConti = {};
	    this.finSpinner = {
	      customerData: false
	    };
	    this.dataContratto = null;
	    this.deskSrvc = deskSrvc;
	    this.userSrvc = userSrvc;
	    this.CONSTANTS = CONSTANTS;
	    $scope.msg = labelSrvc.getLabel;
	    $scope.urlIcons = './common/assets/img/schedaCliente';
	    // Lettura dei parametri di input
	    this.numeroRapporto = this.$stateParams.finCodiceRapporto;
	    if (this.numeroRapporto && this.numeroRapporto.length < 6) {
	      var leftPadding = 6 - this.numeroRapporto.length;
	      for (var index = 0; index < leftPadding; index++) {
	        this.numeroRapporto = '0' + this.numeroRapporto;
	      }
	    }
	
	    this.dossierDivisa = $stateParams.finDivisa;
	    this.dossierCambio = $stateParams.finCambio;
	    this.dossierDecimali = $stateParams.finDecimali;
	    this.isDossierEffeBtnEnabled = userSrvc.abilitato(
	      'EffeReportisticaVisibile'
	    );
	    this.isPunteggioESGEnabled = /*userSrvc.abilitato('EsgConsulenzaAttiva')*/ true;
	    this.customerPunteggioEsg = 0;
	    this.customerDettagliEsg = {};
	    this.customerpunteggioSinteticoESG = null;
	
	    var self = this;
	
	    this.esgVisibile = function () {
	      return userSrvc.abilitato(CONSTANTS.ABILITAZIONI.ESG_CONSULENZA_ATTIVA);
	    };
	
	    if (self.deskSrvc.isDesk) {
	      labelSrvc.labelsPronte.then(function () {
	        self.deskSrvc.aggiungiEntry(
	          labelSrvc.getLabel('dettaglio.dossier.titolo')
	        );
	      });
	    }
	
	    if (self.isDossierEffeBtnEnabled) {
	      self.schedaDossierSrvc
	        .promisereportEffe($stateParams.finCodiceRapporto)
	        .then(function (response) {
	          self.isDossierEffeBtnEnabled = response.data.result !== null;
	        });
	    }
	
	    // Inizializzazione del DTO - rapporto
	    if (this.numeroRapporto !== null && this.numeroRapporto !== '') {
	      //this.getSchedaDossierDTO(this.numeroRapporto);
	      self.finSpinner.customerData = true;
	      self.schedaDossierSrvc
	        .promiseCustomerData(self.$stateParams.finCodiceRapporto)
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.posizione = {};
	              return;
	            }
	            self.posizione = response.data;
	            if (!!response.data.esgCliente) {
	              self.customerDettagliEsg =
	                response.data.esgCliente.tipoCalcoloEsg === 'D'
	                  ? response.data.esgCliente.dettagliEsg
	                  : null;
	              self.customerpunteggioSinteticoESG =
	                response.data.esgCliente.sinteticoEsg.punteggioSintetico;
	            }
	            self.schedaDossierSrvc
	              .promiseTotaliConti(self.$stateParams.finCodiceRapporto)
	              .then(function (response) {
	                if (self.messaggiFctr.processaResponse(response)) {
	                  self.totaliConti = {};
	                  return;
	                }
	                self.totaliConti = response.data.result;
	                self.schedaDossierSrvc.schedaDossierDTO = response.data.result;
	
	                self.schedaDossierSrvc.datasourceItalia =
	                  response.data.result.contiInEuro;
	                self.gridOptionsControvalore.data =
	                  self.schedaDossierSrvc.datasourceItalia;
	                self.gridOptionsControvalore.height =
	                  self.commonUtilities.calculateHeightUIGridComponent(
	                    self.gridOptionsControvalore
	                  );
	
	                self.schedaDossierSrvc.datasourceEstero =
	                  response.data.result.contiInEuro.contiEsteri;
	                self.gridOptionsControvaloreEstero.data =
	                  self.schedaDossierSrvc.datasourceEstero;
	                self.gridOptionsControvaloreEstero.height =
	                  self.commonUtilities.calculateHeightUIGridComponent(
	                    self.gridOptionsControvaloreEstero
	                  );
	
	                self.schedaDossierSrvc.datasourceDerivatiEuro =
	                  response.data.result.contiInEuro.contiInDerivatiEuro;
	                self.gridOptionsControvaloreDerivatiEuro.data =
	                  self.schedaDossierSrvc.datasourceDerivatiEuro;
	                self.gridOptionsControvaloreDerivatiEuro.height =
	                  self.commonUtilities.calculateHeightUIGridComponent(
	                    self.gridOptionsControvaloreDerivatiEuro
	                  );
	
	                self.schedaDossierSrvc.datasourceDerivatiEstero =
	                  response.data.result.contiInEuro.contiInDerivatiEstero;
	                self.gridOptionsControvaloreDerivatiEstero.data =
	                  self.schedaDossierSrvc.datasourceDerivatiEstero;
	                self.gridOptionsControvaloreDerivatiEstero.height =
	                  self.commonUtilities.calculateHeightUIGridComponent(
	                    self.gridOptionsControvaloreDerivatiEstero
	                  );
	              });
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.finSpinner.customerData = false;
	        });
	    }
	    // Costanti
	    this.TAB_LIST = [
	      {
	        title: 'Composizione',
	        url:
	          CONSTANTS.BASE_ROOT +
	          CONSTANTS.COMPONENTS_PATH +
	          'schedaDossier/states/finProductViewDossier.states.composizione.html',
	        reasonVisible: true,
	        template: false
	      },
	      {
	        title: 'Movimenti',
	        url:
	          CONSTANTS.BASE_ROOT +
	          CONSTANTS.COMPONENTS_PATH +
	          'schedaDossier/states/finProductViewDossier.states.movimenti.html',
	        reasonVisible: true,
	        template: false
	      },
	      {
	        title: 'Controvalore',
	        url:
	          CONSTANTS.BASE_ROOT +
	          CONSTANTS.COMPONENTS_PATH +
	          'schedaDossier/states/finProductViewDossier.states.controvalore.html',
	        reasonVisible: true,
	        template: false
	      },
	      {
	        title: 'Pratiche consulenza attiva',
	        url: false,
	        reasonVisible: false,
	        template: true
	      },
	      {
	        title: 'Grafico saldo periodo',
	        url:
	          CONSTANTS.BASE_ROOT +
	          CONSTANTS.COMPONENTS_PATH +
	          'schedaDossier/states/finProductViewDossier.states.graficoSaldo.html',
	        reasonVisible: false,
	        template: false
	      }
	    ];
	
	    // Tab corrente
	    this.currentTab = sessionStorage.getItem(
	      'fin_schedaDossier_' +
	        this.schedaDossierSrvc.schedaDossierDTO.NdgIntestatario
	    )
	      ? JSON.parse(
	          sessionStorage.getItem(
	            'fin_schedaDossier_' +
	              this.schedaDossierSrvc.schedaDossierDTO.NdgIntestatario
	          )
	        )
	      : this.TAB_LIST[0];
	
	    // Reset della ricerca
	    //this.formReset();
	    this.formMovimentiReset();
	    this.searchField = null;
	
	    // Variabil di errore
	    this.errorStarDate = false;
	    this.errorEndDate = false;
	    this.movementsNotFound = false;
	
	    //variabile per grafico
	    this.highchartsDS = null;
	
	    this.getDatacontratto = function () {
	      self.schedaDossierSrvc
	        .promiseDataRicontrattualizzazione(self.numeroRapporto)
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.posizione = {};
	              return;
	            }
	            self.dataContratto = response.data.result;
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        );
	    };
	
	    this.userSrvc.abilitazioniPronte.then(function () {
	      if (
	        self.userSrvc.abilitato(CONSTANTS.ABILITAZIONI.RICONTRATTUALIZZAZIONE)
	      ) {
	        self.dataContratto = '-';
	        self.getDatacontratto();
	      }
	    });
	
	    // #region Costruzione della tabella ui-grid
	
	    var onlyValueAggregation = function (aggregation) {
	      aggregation.rendered = aggregation.value;
	    };
	
	    this.apriConsulenzaBase = function (event, tipo) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      sessionStorage.setItem('isFromSchedaDossier', true);
	
	      $state.go(self.deskSrvc.isDesk ? 'home.sceltadossier' : 'saldodossier', {
	        finServizio: tipo,
	        ndg: $stateParams.ndg,
	        finCodiceRapporto: $stateParams.finCodiceRapporto
	      });
	    };
	
	    this.apriCashflow = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      $state.go(self.deskSrvc.isDesk ? 'home.cashflow' : 'cashflow', {
	        finCodiceRapporto: $stateParams.finCodiceRapporto,
	        ndg: $stateParams.ndg,
	        finDivisa: $stateParams.finDivisa,
	        finCambio: $stateParams.finCambio,
	        finDecimali: $stateParams.finDecimali
	      });
	    };
	    this.apriEstrattoConto = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      $state.go(self.deskSrvc.isDesk ? 'home.estrattoConto' : 'estrattoConto', {
	        finCodiceRapporto: $stateParams.finCodiceRapporto,
	        ndg: $stateParams.ndg,
	        finDivisa: $stateParams.finDivisa,
	        finCambio: $stateParams.finCambio,
	        finDecimali: $stateParams.finDecimali
	      });
	    };
	
	    this.apriRicontrattualizzazione = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      $state.go(
	        self.deskSrvc.isDesk
	          ? 'home.ricontrattualizzazione'
	          : 'ricontrattualizzazione',
	        {
	          finCodiceRapporto: $stateParams.finCodiceRapporto,
	          rapporto: $stateParams.finCodiceRapporto,
	          ndg: $stateParams.ndg,
	          idPratica: '',
	          tipo: 'DOS'
	        }
	      );
	    };
	    // #endregion
	
	    // #region Griglie del controvalore
	
	    var gridColumnsControvalore = [
	      {
	        cellTooltip: true,
	        headerTooltip: true,
	        displayName: 'TipologiaConto',
	        field: 'tipologiaConto'
	      },
	      {
	        cellTooltip: true,
	        headerTooltip: true,
	        displayName: 'Rapporto',
	        field: 'rapporto',
	        cellTemplate:
	          '<div class="ui-grid-cell-contents"><a href="javascript:;" ng-click="grid.appScope.redirectRapporto(row.entity[col.field])">{{row.entity[col.field]}}</a></div>'
	      },
	      {
	        cellTooltip: true,
	        headerTooltip: true,
	        displayName: 'Saldo contabile',
	        field: 'saldoContabile',
	        cellTemplate:
	          '<div class="ui-grid-cell-contents right" ng-class="{ red:row.entity[col.field] < 0 }">{{row.entity[col.field] | number: 2}} &euro;</div>'
	      },
	      {
	        cellTooltip: true,
	        headerTooltip: true,
	        displayName: 'Saldo disponibile',
	        field: 'saldoDisponibile',
	        cellTemplate:
	          '<div class="ui-grid-cell-contents right" ng-class="{ red:row.entity[col.field] < 0 }">{{row.entity[col.field] | number: 2}} &euro;</div>'
	      },
	      {
	        cellTooltip: true,
	        headerTooltip: true,
	        displayName: 'Fido',
	        field: 'fido',
	        cellTemplate:
	          '<div class="ui-grid-cell-contents right" ng-class="{ red:row.entity[col.field] < 0 }">{{row.entity[col.field] | number: 2}} &euro;</div>'
	      },
	      {
	        cellTooltip: true,
	        headerTooltip: true,
	        displayName: 'Non Contabilizzato',
	        field: 'saldoNonContabilizzato',
	        cellTemplate:
	          '<div class="ui-grid-cell-contents right" ng-class="{ red:row.entity[col.field] < 0 }">{{row.entity[col.field] | number: 2}} &euro;</div>'
	      }
	    ];
	
	    this.gridOptionsControvalore = {
	      enableSorting: true,
	      enableColumnMenus: false,
	      enableFiltering: false,
	
	      enableGridMenu: false,
	      gridMenuShowHideColumns: false,
	      enableGrouping: false,
	
	      enableCellEditing: false,
	      enableCellEditOnFocus: false,
	      treeRowHeaderAlwaysVisible: false,
	
	      enablePagination: false,
	      enablePaginationControls: false,
	      paginationPageSize: 10,
	
	      enableRowSelection: false,
	      multiSelect: false,
	      enableRowHeaderSelection: false,
	
	      showGridFooter: false,
	
	      rowHeight: 30,
	
	      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
	      enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
	      columnDefs: gridColumnsControvalore,
	
	      onRegisterApi: function (gridApi) {
	        //self.gridApi = gridApi;
	      },
	      data: []
	    };
	    this.gridOptionsControvalore.height =
	      commonUtilities.calculateHeightUIGridComponent(
	        this.gridOptionsControvalore
	      );
	
	    this.gridOptionsControvaloreEstero = jQuery.extend(
	      {},
	      this.gridOptionsControvalore
	    );
	    this.gridOptionsControvaloreDerivatiEuro = jQuery.extend(
	      {},
	      this.gridOptionsControvalore
	    );
	    this.gridOptionsControvaloreDerivatiEstero = jQuery.extend(
	      {},
	      this.gridOptionsControvalore
	    );
	
	    // #endregion
	
	    this.$scope.redirectRapporto = function (numeroRapporto) {
	      self.commonUtilities.openContoCorrente(
	        self.$stateParams.ndg,
	        numeroRapporto,
	        'schedaContoCorrenteDossier'
	      );
	    };
	
	    this.$scope.controvaloreHelp = $sce.trustAsHtml(
	      "Per ulteriori dettagli consultare la sezione 'Controvalore'"
	    );
	
	    this.spinner = this.commonUtilities.getUrlSpinner($scope);
	    this.internalLoading = false;
	  };
	
	  CblSchedaProdottoDossierCtrl.prototype = {
	    formMovimentiReset: function () {
	      this.schedaDossierSrvc.inputFormMovimenti = {
	        startDate: null,
	        endDate: null,
	        isin: null,
	        descrizione: null
	      };
	      this.schedaDossierSrvc.movimenti = null;
	      this.searchField = null;
	      this.errorStarDate = false;
	      this.errorEndDate = false;
	      this.movementsNotFound = false;
	    },
	
	    // Cerca movimenti
	    getCurrentAccountMovements: function () {
	      var startDate = Date.parse(
	        this.schedaDossierSrvc.inputFormMovimenti.startDate
	      );
	      var endDate = Date.parse(
	        this.schedaDossierSrvc.inputFormMovimenti.endDate
	      );
	      var enabled =
	        !isNaN(startDate) &&
	        startDate !== null &&
	        !isNaN(endDate) &&
	        endDate !== null;
	
	      if (isNaN(startDate) || startDate === null) {
	        this.errorStarDate = true;
	      }
	      if (isNaN(endDate) || endDate === null) {
	        this.errorEndDate = true;
	      }
	      if (enabled && startDate > endDate) {
	        this.errorStarDate = false;
	        this.errorEndDate = true;
	        return;
	      }
	
	      if (enabled) {
	        this.errorStarDate = false;
	        this.errorEndDate = false;
	
	        var self = this;
	        var input = {
	          Rapporto: this.numeroRapporto,
	          DataInizio: new Date(startDate),
	          DataFine: new Date(endDate),
	          CodiceIsin: this.schedaDossierSrvc.inputFormMovimenti.isin
	            ? this.schedaDossierSrvc.inputFormMovimenti.isin
	            : null,
	          Descrizione: this.schedaDossierSrvc.inputFormMovimenti.descrizione
	            ? this.schedaDossierSrvc.inputFormMovimenti.descrizione
	            : null
	        };
	        this.getDossierMovements(input);
	      }
	    },
	
	    // Determina se ci sono movimenti
	    hasMovements: function () {
	      if (
	        this.schedaDossierSrvc.movimenti === null ||
	        this.schedaDossierSrvc.movimenti === undefined
	      ) {
	        return false;
	      }
	      var count = this.schedaDossierSrvc.movimenti.length;
	      if (count === null || count === undefined) {
	        return false;
	      }
	      var flag = count > 0;
	      return flag;
	    },
	
	    // Recupero controvalore
	    //getDossierValue: function () {
	    //    //this.getDossierValueService(this.numeroRapporto);
	    //},
	
	    //Recupero valori per grafico saldo
	    getDossierBalances: function () {
	      CblBrioLoader.showLoader();
	      var startDate = Date.parse(
	        this.schedaDossierSrvc.inputFormGraficoSaldo.startDate
	      );
	      var endDate = Date.parse(
	        this.schedaDossierSrvc.inputFormGraficoSaldo.endDate
	      );
	      var enabled =
	        !isNaN(startDate) &&
	        startDate !== null &&
	        !isNaN(endDate) &&
	        endDate !== null;
	
	      if (isNaN(startDate) || startDate === null) {
	        this.errorStarDate = true;
	      }
	      if (isNaN(endDate) || endDate === null) {
	        this.errorEndDate = true;
	      }
	      if (enabled && startDate > endDate) {
	        this.errorStarDate = false;
	        this.errorEndDate = true;
	        CblBrioLoader.hideLoader();
	        return;
	      }
	
	      if (enabled) {
	        this.errorStarDate = false;
	        this.errorEndDate = false;
	
	        var self = this;
	        var input = {
	          Rapporto: this.numeroRapporto,
	          DataInizio: new Date(startDate),
	          DataFine: new Date(endDate)
	        };
	        this.getDossierBalancesService(input);
	      }
	    },
	
	    getCustomer: function () {
	      return {
	        ndg: this.schedaDossierSrvc.schedaDossierDTO.NdgIntestatario,
	        idAnagrafica:
	          this.schedaDossierSrvc.schedaDossierDTO.IdAnagraficaIntestatario,
	        naturaGiuridica:
	          this.schedaDossierSrvc.schedaDossierDTO.NaturaGiuridicaIntestatario
	      };
	    },
	    // #region Funzioni per la gestione dei tab
	    changeTab: function (tab) {
	      sessionStorage.setItem(
	        'fin_schedaDossier_' +
	          this.schedaDossierSrvc.schedaDossierDTO.NdgIntestatario,
	        JSON.stringify(tab)
	      );
	      this.currentTab = tab;
	    },
	
	    isActiveTab: function (tabUrl) {
	      return tabUrl == this.currentTab.url;
	    },
	
	    changeTab2: function (tab) {
	      this.currentTab_2 = tab;
	    },
	
	    isActiveTab2: function (tabUrl) {
	      return tabUrl == this.currentTab_2.url;
	    },
	    // #endregion
	
	    getSeries: function () {
	      this.schedaDossierSrvc.chart.series = ['Movimenti'];
	    },
	
	    getSource: function () {
	      CblBrioLoader.showLoader();
	      this.schedaDossierSrvc.chart.labels = [];
	      this.schedaDossierSrvc.chart.dataset = [];
	      var currentDataset = [];
	      this.highchartsDS = [];
	
	      if (this.schedaDossierSrvc.saldoDatasource !== null) {
	        for (var index in this.schedaDossierSrvc.saldoDatasource) {
	          var item = this.schedaDossierSrvc.saldoDatasource[index];
	          var date = new Date(item.DataSaldo);
	          var x =
	            this.commonUtilities
	              .decodeMonth(date.getMonth())
	              .substr(0, 3)
	              .toUpperCase() +
	            ' ' +
	            date.getFullYear();
	          var y = item.Saldo;
	
	          currentDataset.push(y);
	
	          var highchartsPoint = [];
	          highchartsPoint.push(
	            Date.UTC(
	              date.getFullYear(),
	              date.getMonth(),
	              date.getDate(),
	              date.getHours(),
	              date.getMinutes(),
	              date.getSeconds()
	            )
	          );
	          highchartsPoint.push(y);
	          this.highchartsDS.push(highchartsPoint);
	
	          this.schedaDossierSrvc.chart.labels.push(x);
	        }
	        this.schedaDossierSrvc.chart.dataset.push(currentDataset);
	      }
	    },
	
	    getDossierMovements: function (input) {
	      this.schedaDossierSrvc.allMovements = new Array();
	      this.schedaDossierSrvc.movimenti = new Array();
	      this.schedaDossierSrvc.datasource = new Array();
	      this.gridOptions.data = new Array();
	
	      var serviceUrl =
	        this.commonUtilities.MF_INFO.CustomerData.url() +
	        'Dossier/GetDossierMovements';
	      var serviceParams = input;
	      var parentThis = this;
	      var successCallback = function (self, data) {
	        if (data !== null) {
	          self.schedaDossierSrvc.allMovements = data;
	          self.schedaDossierSrvc.movimenti = data;
	          self.schedaDossierSrvc.datasource = data;
	
	          self.gridOptions.data = self.schedaDossierSrvc.movimenti;
	          self.resetPagination();
	          self.movementsNotFound =
	            self.schedaDossierSrvc.movimenti.length === 0;
	        }
	        self.internalLoading = false;
	      };
	      var errorCallback = function (self, error) {
	        self.internalLoading = false;
	      };
	      var showLoaderService = false;
	      this.internalLoading = true;
	      this.commonUtilities.executeHttpPostService(
	        serviceUrl,
	        serviceParams,
	        parentThis,
	        showLoaderService,
	        successCallback,
	        errorCallback
	      );
	    },
	
	    getDossierBalancesService: function (input, parent, successCallback) {
	      var serviceUrl =
	        this.commonUtilities.MF_INFO.CustomerData.url() +
	        'Dossier/GetDossierBalances';
	      var serviceParams = input;
	      var parentThis = this;
	      var successCallback = function (self, data) {
	        self.schedaDossierSrvc.saldoDatasource = data;
	        self.getSource();
	      };
	      var showLoaderService = true;
	      this.commonUtilities.executeHttpPostService(
	        serviceUrl,
	        serviceParams,
	        parentThis,
	        showLoaderService,
	        successCallback,
	        null
	      );
	    }
	  };
	  CblSchedaProdottoDossierCtrl.$inject = [
	    '$scope',
	    '$state',
	    '$stateParams',
	    '$filter',
	    'SchedaDossierSrvc',
	    'uiGridConstants',
	    '$sce',
	    'CommonUtilitiesSrvc',
	    'FIN_CONSTANTS',
	    'FinMessaggiFctr',
	    'FinDeskSrvc',
	    'FinLabelSrvc',
	    'FinUserSrvc'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'schedaDossier/schedaDossier.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var SchedaDossierComponent = {
	    bindings: {
	      sceltaDossierState: '@',
	      visualizzaRaccomandazioneState: '@',
	      modificaRaccomandazioneState: '@',
	      nuovaRaccomandazioneState: '@',
	      valutazioneRaccomandazioneState: '@',
	      modificaRichiestaState: '@',
	      nuovaRichiestaState: '@',
	      visualizzaRichiestaState: '@'
	    },
	    controller: CblSchedaProdottoDossierCtrl,
	    controllerAs: 'schedaProdottoDossierCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finanzaSchedaDossier', SchedaDossierComponent);
	})();


/***/ },
/* 41 */
/***/ function(module, exports) {

	(function () {
	  'use strict';
	  angular.module('cbl.finanza.mf').service('SchedaDossierSrvc', [
	    '$http',
	    '$state',
	    'FinUserSrvc',
	    'FIN_CONSTANTS',
	    function ($http, $state, finUserSrvc, CONSTANTS) {
	      // Variabile di input/output
	      this.schedaDossierDTO = {};
	      this.dossierValueDTO = {};
	      this.userService = finUserSrvc;
	
	      this.datasource = null;
	
	      this.datasourceItalia = null;
	
	      this.datasourceEstero = null;
	
	      this.inputFormMovimenti = {
	        startDate: null,
	        endDate: null,
	        isin: '',
	        descrizione: ''
	      };
	
	      this.inputFormGraficoSaldo = {
	        startDate: null,
	        endDate: null
	      };
	
	      this.movimenti = null;
	      this.allMovements = null;
	      this.saldoDatasource = [];
	
	      // Variabili del grafico
	      this.chart = {
	        dataset: [],
	        series: [],
	        labels: [],
	        options: {}
	      };
	
	      /**
	       * @ngdoc method
	       * @name promiseCustomerData
	       * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	       * @description Effettua la chiamata per ricevere il customerdata
	       * @return {Promise} - Ritorna una promise contenente il customerdata
	       */
	      this.promiseCustomerData = function (rapporto) {
	        return $http({
	          method: 'GET',
	          url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
	          params: {
	            rapporto: rapporto,
	            schedaDossier: true
	          }
	        });
	      };
	
	      this.promiseDataRicontrattualizzazione = function (rapporto) {
	        return $http({
	          method: 'GET',
	          url:
	            CONSTANTS.REST_CUSTOMER +
	            CONSTANTS.REST.RICONTRATTUALIZZAZIONE_DOSSIER +
	            rapporto
	        });
	      };
	      this.promiseTotaliConti = function (rapporto) {
	        return $http({
	          method: 'GET',
	          url:
	            CONSTANTS.REST_CUSTOMER +
	            CONSTANTS.REST.TOTALI_CONTI +
	            '/' +
	            rapporto
	        });
	      };
	      this.checkReportButtonIsEnabled = function (ndg) {
	        return $http({
	          method: 'GET',
	          url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.GENERAL.USER,
	          params: {
	            ndg: ndg
	          }
	        });
	      };
	      this.promisereportEffe = function (codicePortafoglio) {
	        return $http({
	          method: 'GET',
	          url:
	            CONSTANTS.REST_ROOT +
	            CONSTANTS.REST.REPORT +
	            '/' +
	            codicePortafoglio
	        });
	      };
	      this.promiseRischioESG = function () {
	        return $http({
	          method: 'GET',
	          url: 'http://localhost:3000/recuperaPunteggioRischioCliente'
	        });
	      };
	    }
	  ]);
	})();


/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.finanza.mf.directive:finanzaSaldoDossier
	 * @restrict E
	 * @scope
	 * @description Componente rappresentante il dettaglio del saldo dossier
	 * @param {String} sceltaDossierState - Nome dello stato per la scelta del dossier
	 * @param {String} visualizzaRaccomandazioneState - Nome dello stato per andare nella sezione di visualizzazione di una raccomandazione
	 * @param {String} modificaRaccomandazioneState - Nome dello stato per andare nella sezione di modifica di una raccomandazione
	 * @param {String} nuovaRaccomandazioneState - Nome dello stato per andare nella sezione di creazione di una raccomandazione
	 * @param {String} rifiutaRaccomandazioneState - Nome dello stato in cui navigare dopo aver rifiutato una raccomandazione
	 * @param {String} accettaRaccomandazioneState - Nome dello stato in cui navigare dopo aver accettato una raccomandazione
	 * @param {String} sceltaDossierState - Nome dello stato in cui è contenuta la lista dei dossiers
	 */
	(function () {
	  'use strict';
	  var statiPratica = [
	    // 'BOZZA',
	    'CONSOLIDATA', //consolidata, accettata, rifiutata, da accettare IB, da accettare OTP, scaduta.
	    // 'PRESENTATA',
	    // 'DAREVISIONARE',
	    'ACCETTATA', //
	    'RIFIUTATA', //
	    // 'ANNULLATA',
	    // 'PRECONTRATTO',
	    // 'VALIDATA',
	    // 'FINANZIATA',
	    // 'INCORSO',
	    // 'DEFINITA',
	    // 'PLAFOND',
	    // 'DAPAGARE',
	    // 'CONCLUSA',
	    // 'SOSPESA',
	    // 'INDELIBERAPAC',
	    // 'INPREDELIBERAPAC',
	    // 'APPROVAZIONEDEROGA',
	    // 'CONTROPROPOSTADEROGA',
	    // 'DAVERIFICARE',
	    // 'AFFIDATA',
	    // 'GESTIONEPOLIZZE',
	    // 'VALUTAZIONE',
	    // 'INTEGRAZIONE',
	    // 'IDENTIFICAZIONEPROSPETTO',
	    'SCADUTA' //
	    // 'INADEGUATA',
	    // 'INACQUISIZIONE'
	  ];
	
	  var ListaRaccomandazioniCtrl = function (
	    $http,
	    $scope,
	    $window,
	    $q,
	    $stateParams,
	    $state,
	    $location,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    uiGridConstants,
	    messaggiSrvc,
	    userSrvc,
	    $uibModal,
	    brioSrvc,
	    modalAlertSrvc,
	    gestioneRaccomandazioneService
	  ) {
	    var self = this;
	    this.$uibModal = $uibModal;
	    this.$http = $http;
	    this.$window = $window;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$location = $location;
	    this.messaggiFctr = messaggiFctr;
	    this.messaggiSrvc = messaggiSrvc;
	    this.userSrvc = userSrvc;
	    this.brioSrvc = brioSrvc;
	    this.CONSTANTS = CONSTANTS;
	    this.modalAlertSrvc = modalAlertSrvc;
	    this.gestioneRaccomandazioneService = gestioneRaccomandazioneService;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.portafoglioTableLabel = [];
	    this.portafoglioTableData = [];
	    this.raccomandazioniTableLabel = [];
	    this.raccomandazioniTableData = [];
	    this.richiesteTableLabel = [];
	    this.richiesteTableData = [];
	    this.listaRegoleStrumento = [];
	    this.raccomandazioniTotalItems = 0;
	    this.richiesteTotalItems = 0;
	    this.pageNumber = 1;
	    this.itemsPerPage = 10;
	    this.statoPratiche = undefined;
	    this.posizione = {};
	    this.inserimentoOrdiniVisibile = false;
	    this.domain = {
	      listaTipologiaStrumento: [],
	      listaStatoRaccomandazione: []
	    };
	    this.spinner = {
	      listaPortafoglio: false,
	      listaRaccomandazioni: false,
	      listaRichieste: false
	    };
	    this.messaggiFctr.chiudiLoaderBrio();
	
	    this.mostra = { consigli: true, tutto: true };
	
	    if (!this.servizio) {
	      this.servizio = '1';
	    }
	
	    sessionStorage.removeItem('isFromSchedaDossier');
	
	    /*
	     * -------------------------------------
	     * START METODI PROMISE PER SERVIZI REST
	     * -------------------------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name promiseCustomerData
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua la chiamata per ricevere il customerdata
	     * @return {Promise} - Ritorna una promise contenente il customerdata
	     */
	    this.promiseCustomerData = function () {
	      return self.$http({
	        method: 'GET',
	        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
	        params: {
	          rapporto: self.$stateParams.finCodiceRapporto
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDominioStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per ricevere la lista delle tipologie strumento
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la select del filtro stato per la lista del saldo portafoglio
	     */
	    this.promiseDominioFiltriStrumento = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'categoriaStrumenti'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDominioFiltri
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per ricevere la lista degli stati possibili di una raccomandazione
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la select del filtro stato per la lista delle raccomandazioni
	     */
	    this.promiseDominioFiltriRaccomandazione = function () {
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          'statiRaccomandazione'
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaRaccomandazioni
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per ricevere la lista delle raccomandazioni associate ad un dossier
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista delle raccomandazioni
	     */
	    this.promiseDatiTabellaRaccomandazioni = function () {
	      self.spinner.listaRaccomandazioni = true;
	      if (!self.mostra.tutto && !self.mostra.consigli) {
	        var defer = $q.defer();
	
	        setTimeout(function () {
	          defer.resolve({
	            data: {
	              result: {
	                listaRisultati: [],
	                numeroRecord: 0
	              }
	            }
	          });
	        }, 100);
	
	        return defer.promise;
	      }
	
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.DOSSIER +
	          self.$stateParams.finCodiceRapporto +
	          '/raccomandazioni',
	        params: {
	          limit: self.itemsPerPage,
	          numeroPagina: self.pageNumber,
	          statoPratiche: self.mostra.tutto
	            ? self.statoPratiche
	            : self.mostra.consigli
	            ? statiPratica
	            : ''
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaRichieste
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per ricevere la lista delle richieste associate ad un dossier
	     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista delle richieste
	     */
	    this.promiseDatiTabellaRichieste = function () {
	      self.spinner.listaRichieste = true;
	      return self.$http({
	        method: 'GET',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          self.$stateParams.finCodiceRapporto +
	          '/richieste',
	        params: {
	          limit: self.itemsPerPage,
	          numeroPagina: self.pageNumber,
	          statoPratiche: self.statoPratiche
	        }
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name promiseDatiTabellaRichieste
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Effettua una chiamata http per eliminare una raccomandazione
	     * @param {Number} idRaccomandazione - Id della raccomandazione da eliminare
	     * @return {Promise} - Ritorna una promise contenente il risultato dell'elimina raccomandazione
	     */
	    this.promiseEliminaRaccomandazione = function (idRaccomandazione) {
	      return self.$http({
	        method: 'DELETE',
	        url:
	          CONSTANTS.REST_ROOT +
	          CONSTANTS.REST.RACCOMANDAZIONE +
	          idRaccomandazione
	      });
	    };
	
	    /*
	     * -----------------------------------
	     * END METODI PROMISE PER SERVIZI REST
	     * -----------------------------------
	     */
	
	    /*
	     * ------------------------
	     * START INIT LABEL TABELLE
	     * ------------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name initLabelTabellaRaccomandazioni
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Crea le label e la struttura della tabella delle raccomandazioni
	     */
	    this.initLabelTabellaRaccomandazioni = function () {
	      self.raccomandazioniTableLabel = [];
	
	      self.userSrvc.abilitazioniPronte.then(function () {
	        self.raccomandazioniTableLabel.push({
	          name: $scope.msg('saldo.dossier.numero.raccomandazione'),
	          field: 'idPratica',
	          width: '*',
	          enableFiltering: false
	        });
	
	        if (
	          self.userSrvc.abilitato(
	            CONSTANTS.ABILITAZIONI.TABELLA_RACCOMNDAZIONI_ESTESA
	          ) ||
	          self.userSrvc.isBpa
	        ) {
	          self.raccomandazioniTableLabel.push({
	            name: $scope.msg('saldo.dossier.idrichiesta'),
	            field: 'idRichiestaOrdine',
	            width: '*',
	            enableFiltering: false
	          });
	        }
	
	        self.raccomandazioniTableLabel.push({
	          name: $scope.msg('saldo.dossier.stato'),
	          field: 'stato',
	          width: '*',
	          filter: {
	            type: uiGridConstants.filter.SELECT,
	            selectOptions: self.domain.listaStatoRaccomandazione
	          }
	        });
	
	        if (
	          self.userSrvc.abilitato(
	            CONSTANTS.ABILITAZIONI.TABELLA_RACCOMNDAZIONI_ESTESA
	          ) ||
	          self.userSrvc.isBpa
	        ) {
	          self.raccomandazioniTableLabel.push({
	            name: $scope.msg('saldo.dossier.canale'),
	            field: 'canale',
	            width: '*',
	            enableFiltering: false
	          });
	        }
	
	        if (
	          self.userSrvc.abilitato(
	            CONSTANTS.ABILITAZIONI.TABELLA_RACCOMNDAZIONI_ESTESA
	          ) ||
	          self.userSrvc.isBpa
	        ) {
	          self.raccomandazioniTableLabel.push({
	            name: $scope.msg('saldo.dossier.presentatore'),
	            field: 'presentatore',
	            width: '*',
	            enableFiltering: false
	          });
	        }
	
	        self.raccomandazioniTableLabel.push({
	          name: $scope.msg('saldo.dossier.data.inserimento'),
	          width: '*',
	          field: 'inserimento',
	          cellFilter: 'date: "dd/MM/yyyy"',
	          enableFiltering: false
	        });
	
	        self.raccomandazioniTableLabel.push({
	          name: $scope.msg('saldo.dossier.data.scadenza'),
	          width: '*',
	          field: 'dataScadenzaRaccomandazione',
	          cellFilter: 'date: "dd/MM/yyyy"',
	          enableFiltering: false
	        });
	
	        self.raccomandazioniTableLabel.push({
	          name: $scope.msg('saldo.dossier.ctv.teorico'),
	          width: '*',
	          cellFilter: 'number : 2',
	          cellClass: 'right',
	          field: 'controvaloreTeorico',
	          enableFiltering: false
	        });
	
	        var cellTemplate =
	          "<i class='fa fa-search fa-2x finIMargin finIPointer' " +
	          "aria-hidden='true' " +
	          ' uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" ' +
	          ' tooltip-placement="left" ' +
	          ' ng-click="grid.appScope.visualizzaRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>' +
	          //
	          "<i class='fa fa-pencil fa-2x finIMargin finIPointer' " +
	          " aria-hidden='true' " +
	          'uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" ' +
	          'tooltip-placement="left" ' +
	          'ng-if="grid.appScope.finTableCtrl.showButtonRaccomandazioni(row.entity.stato, \'modifica\')" ' +
	          'ng-click="grid.appScope.modificaRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>' +
	          //
	          "<i class='fa fa-trash fa-2x finIMargin finIPointer' " +
	          "aria-hidden='true' " +
	          'uib-tooltip="{{grid.appScope.msg(\'tooltip.elimina\')}}" ' +
	          'tooltip-placement="left" ' +
	          'ng-if="grid.appScope.finTableCtrl.showButtonRaccomandazioni(row.entity.stato, \'elimina\')" ' +
	          'ng-click="grid.appScope.eliminaRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>' +
	          //
	          "<i class='fa fa-pencil fa-2x finIMargin finIPointer' " +
	          "aria-hidden='true' " +
	          'uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" ' +
	          'tooltip-placement="left" ' +
	          'ng-if="grid.appScope.finTableCtrl.showButtonRaccomandazioni(row.entity.stato, \'valutazione\')" ' +
	          'ng-click="grid.appScope.valutazioneRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>';
	
	        if (
	          self.userSrvc.abilitato(CONSTANTS.ABILITAZIONI.COPIA_RACCOMANDAZIONE)
	        )
	          cellTemplate +=
	            "<i class='fa fa-files-o fa-2x finIMargin finIPointer'" +
	            " aria-hidden='true' " +
	            'uib-tooltip="{{grid.appScope.msg(\'tooltip.copia\')}}" ' +
	            'tooltip-placement="left" ' +
	            'ng-if="grid.appScope.finTableCtrl.showButtonRaccomandazioni(row.entity.stato, \'copia\') && grid.appScope.abilitatoConsulenza" ' +
	            'ng-click="grid.appScope.copiaRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>';
	        self.raccomandazioniTableLabel.push({
	          field: 'azioni',
	          name: $scope.msg('saldo.dossier.azioni'),
	          width: 150,
	          enableFiltering: false,
	          cellTemplate: cellTemplate
	        });
	      });
	    };
	    this.initLabelTabellaRichieste = function () {
	      self.richiesteTableLabel = [
	        {
	          name: $scope.msg('lista.richieste.id.pratica'),
	          field: 'idPratica',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.richieste.id.raccomandazione'),
	          field: 'idRaccomandazione',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.richieste.codice.dossier'),
	          field: 'codiceDossierTitoli',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.richieste.stato'),
	          field: 'stato',
	          width: '*',
	          filter: {
	            type: uiGridConstants.filter.SELECT,
	            selectOptions: self.domain.listaStatoRaccomandazione
	          }
	        },
	        {
	          name: $scope.msg('lista.richieste.inserimento'),
	          field: 'inserimento',
	          cellFilter: 'date: "dd/MM/yyyy"',
	          width: '*',
	          enableFiltering: false
	        },
	        {
	          name: $scope.msg('lista.richieste.azione'),
	          field: 'azione',
	          width: 100,
	          enableFiltering: false,
	          cellTemplate:
	            "<i class='fa fa-pencil fa-2x finIMargin finIPointer' ng-if=\"row.entity.stato === 'INCORSO' || row.entity.stato === 'CONSOLIDATA' || row.entity.stato === 'DAREVISIONARE' || (row.entity.stato === 'PRESENTATA' && grid.appScope.userSrvc.valutaPratica)\" aria-hidden='true' uib-tooltip=\"{{grid.appScope.msg('tooltip.modifica')}}\" tooltip-placement=\"left\" ng-click=\"grid.appScope.modificaRichiesta({richiesta: row.entity})\"></i>" +
	            '<i class=\'fa fa-search fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaRichiesta({richiesta: row.entity})"></i>'
	        }
	      ];
	    };
	
	    /*
	     * ----------------------
	     * END INIT LABEL TABELLE
	     * ----------------------
	     */
	
	    /*
	     * -----------------------
	     * START METODI CONTROLLER
	     * -----------------------
	     */
	
	    /**
	     * @ngdoc method
	     * @name apriModaleNuovaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Apre e gestisce il risultato della modale iniziativa
	     */
	    this.apriModaleNuovaRaccomandazione = function () {
	      //			Se la banca ha già l'iniziativa settata e il profilo è un promotore non faccio vedere la modale
	      if (self.userSrvc.iniziativaRaccomandazione) {
	        self.$stateParams.finIniziativa =
	          self.userSrvc.iniziativaRaccomandazione;
	        self.nuovaRaccomandazione();
	      } else {
	        self.$uibModal
	          .open({
	            animation: true,
	            templateUrl:
	              CONSTANTS.BASE_ROOT +
	              'widgets/finModali/iniziativa/finModaleIniziativa.html',
	            controller: 'FinModaleIniziativaCtrl',
	            controllerAs: 'modalCtrl',
	            size: 'modal-lg'
	          })
	          .result.then(function (response) {
	            self.$stateParams.finIniziativa = response;
	            self.nuovaRaccomandazione();
	          });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name nuovaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di creazione di un nuovo ordine in modalita acquista
	     */
	    this.nuovaRichiesta = function () {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.a');
	      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name vendita
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Entra nello stato nuova richiesta con modalita acquista
	     */
	    this.acquista = function (itemPortafoglio) {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.a');
	      self.$stateParams.finCodiceStrumento =
	        itemPortafoglio.strumento.codice.trim();
	      self.$stateParams.finIntestatarioStrumento =
	        itemPortafoglio.ndgIntestatario;
	      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name vendita
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Entra nello stato nuova richiesta con modalita vendita
	     */
	    this.vendita = function (itemPortafoglio) {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.d');
	      self.$stateParams.finCodiceStrumento =
	        itemPortafoglio.strumento.codice.trim();
	      self.$stateParams.finIntestatarioStrumento =
	        itemPortafoglio.ndgIntestatario;
	      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name cambio
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Entra nello stato nuova proposta con modalita cambio
	     */
	    this.cambio = function (itemPortafoglio) {
	      self.$stateParams.acqven = $scope.msg('lista.proposte.s');
	      self.$stateParams.finCodiceStrumento =
	        itemPortafoglio.strumento.codice.trim();
	      self.$stateParams.finIntestatarioStrumento =
	        itemPortafoglio.ndgIntestatario;
	      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name modificaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di modifica di una richiesta
	     * @param {Object} richiesta - Richiesta da modificare
	     */
	    this.modificaRichiesta = function (richiesta) {
	      self.$stateParams.finIdRaccomandazione = richiesta.idRaccomandazione;
	      self.$stateParams.finIdRichiesta = richiesta.idPratica;
	      self.$state.go(self.modificaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name visualizzaRichiesta
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di visualizzazione di una richiesta
	     * @param {Object} richiesta - Richiesta da visualizzare
	     */
	    this.visualizzaRichiesta = function (richiesta) {
	      self.$stateParams.finIdRaccomandazione = richiesta.idRaccomandazione;
	      self.$stateParams.finIdRichiesta = richiesta.idPratica;
	      self.$state.go(self.visualizzaRichiestaState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name nuovaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di creazione di una raccomandazione
	     */
	    this.nuovaRaccomandazione = function () {
	      self.$state.go(self.nuovaRaccomandazioneState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name modificaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di modifica di una raccomandazione
	     * @param {Number} idRaccomandazione - Id della raccomandazione da modificare
	     */
	    this.modificaRaccomandazione = function (idRaccomandazione) {
	      self.$stateParams.finIdRaccomandazione = idRaccomandazione;
	      sessionStorage.setItem(
	        'isFromSchedaDossier',
	        !!self.saldoDossierState && self.saldoDossierState === 'schedaDossier'
	      );
	      self.$state.go(self.modificaRaccomandazioneState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name visualizzaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Naviga nello stato di modifica di una raccomandazione
	     * @param {Number} idRaccomandazione - Id della raccomandazione da visualizzare
	     */
	    this.visualizzaRaccomandazione = function (idRaccomandazione) {
	      self.$stateParams.finIdRaccomandazione = idRaccomandazione;
	      sessionStorage.setItem(
	        'isFromSchedaDossier',
	        !!self.saldoDossierState && self.saldoDossierState === 'schedaDossier'
	      );
	      self.$state.go(self.visualizzaRaccomandazioneState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name visualizzaRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Elimina una raccomandazione da un dossier
	     * @param {Number} idRaccomandazione - Id della raccomandazione da eliminare
	     */
	    this.eliminaRaccomandazione = function (idRaccomandazione) {
	      self.spinner.listaRaccomandazioni = true;
	      self
	        .promiseEliminaRaccomandazione(idRaccomandazione)
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            self.$state.go(self.$state.current.name, self.$stateParams, {
	              reload: true
	            });
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner.listaRaccomandazioni = false;
	        });
	    };
	
	    /**
	     * @ngdoc method
	     * @name valutazioneRaccomandazione
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Entra nello stato di valutazione di una raccomandazione
	     * @param {Number} idRaccomandazione - Id della raccomandazione da valutare
	     */
	    this.valutazioneRaccomandazione = function (idRaccomandazione) {
	      self.$stateParams.finIdRaccomandazione = idRaccomandazione;
	      sessionStorage.setItem(
	        'isFromSchedaDossier',
	        !!self.saldoDossierState && self.saldoDossierState === 'schedaDossier'
	      );
	      self.$state.go(self.valutazioneRaccomandazioneState, self.$stateParams);
	    };
	
	    this.copiaRaccomandazione = function (idRaccomandazione) {
	      self.modalAlertSrvc.notify({
	        message: $scope.msg('message.confirm.copia.raccomndazione'),
	        level: 'INFO'
	      });
	
	      setTimeout(function () {
	        self.modalAlertSrvc.modal.result.then(
	          function () {
	            setTimeout(function () {
	              self.eseguiCopiaRaccomandazione(idRaccomandazione);
	            });
	          },
	          function () {}
	        );
	      }, 500);
	    };
	
	    this.eseguiCopiaRaccomandazione = function (idRaccomandazione) {
	      self.spinner.listaRaccomandazioni = true;
	      self
	        .promiseCopiaRaccomandazione(idRaccomandazione)
	        .then(function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.spinner.listaRaccomandazioni = false;
	            return;
	          }
	          self.gestioneRaccomandazioneService.forzaControlli = true;
	          self.$stateParams.finIdRaccomandazione =
	            response.data.result.idPratica;
	          self.$state.go(self.modificaRaccomandazioneState, self.$stateParams);
	        });
	    };
	
	    this.promiseCopiaRaccomandazione = function (idRaccomandazione) {
	      var url =
	        CONSTANTS.REST_ROOT +
	        CONSTANTS.REST.RACCOMANDAZIONE +
	        'raccomandazione/copia/' +
	        idRaccomandazione;
	      return self.$http.post(url, {});
	    };
	
	    /**
	     * @ngdoc method
	     * @name back
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Ritorna alla rotta della sceltaDossier
	     */
	    this.back = function () {
	      self.$state.go(self.sceltaDossierState, self.$stateParams);
	    };
	
	    /**
	     * @ngdoc method
	     * @name aggiornaLista
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Chiama la promise e gestisce i dati per la lista raccomandazioni e richieste
	     */
	    this.aggiornaLista = function () {
	      if (self.servizio === '1' || self.servizio === 1) {
	        self.spinner.listaRaccomandazioni = true;
	        self
	          .promiseDatiTabellaRaccomandazioni()
	          .then(
	            function (response) {
	              if (self.messaggiFctr.processaResponse(response)) {
	                return;
	              }
	              self.raccomandazioniTotalItems =
	                response.data.result.numeroRecord;
	              self.raccomandazioniTableData =
	                response.data.result.listaRisultati;
	            },
	            function (reason) {
	              self.messaggiFctr.processaResponse(reason);
	            }
	          )
	          .finally(function () {
	            self.spinner.listaRaccomandazioni = false;
	          });
	      } else {
	        self.spinner.listaRichieste = true;
	        self
	          .promiseDatiTabellaRichieste()
	          .then(
	            function (response) {
	              if (self.messaggiFctr.processaResponse(response)) {
	                return;
	              }
	              self.richiesteTotalItems = response.data.result.numeroRecord;
	              self.richiesteTableData = response.data.result.listaRisultati;
	            },
	            function (reason) {
	              self.messaggiFctr.processaResponse(reason);
	            }
	          )
	          .finally(function () {
	            self.spinner.listaRichieste = false;
	          });
	      }
	    };
	
	    /**
	     * @ngodc method
	     * @name cambioPaginaTabella
	     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
	     * @description Cambia il numero di pagina e il numero di elementi per pagina
	     */
	    this.cambioPaginaTabella = function (pageNumber, itemsPerPage) {
	      self.itemsPerPage = itemsPerPage;
	      self.pageNumber = pageNumber;
	      self.aggiornaLista();
	    };
	
	    /**
	     * @ngdoc method
	     * @name applicaFiltri
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Applica il filtro STATO della tabella raccomandazioni o richieste
	     * @param {Object} columns - Tutta la struttura delle colonne
	     */
	    this.applicaFiltri = function (columns) {
	      self.statoPratiche = columns[2].filters[0].term;
	      self.aggiornaLista();
	    };
	
	    /**
	     * @ngdoc method
	     * @name checkRegoleStrumento
	     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	     * @description Gestisce l'array del saldoPortafoglio e decide
	     * se mostrare o meno i bottoni di Acquisto, Vendita e Switch
	     */
	    this.checkRegoleStrumento = function () {
	      self.portafoglioTableData.forEach(function (portafoglio) {
	        //				Imposta la proprietà mostraBottoniPortafoglio per ciascun saldo in base alle regole dello strumento
	        portafoglio['mostraBottoni'] = self.listaRegoleStrumento.some(function (
	          regola
	        ) {
	          var ruolo = false;
	          //					Se siamo in brio forkato le logiche cambiano
	          if (self.brioSrvc.brioVersion === 'brio-xc') {
	            //						Se siamo in filiale effettuo un controllo diverso rispetto a promotore
	            if (self.userSrvc.canaleOperativo === 'filialefxc') {
	              ruolo =
	                !regola.ruolo ||
	                regola.ruolo.toLowerCase().trim() === 'filiale';
	            } else {
	              ruolo =
	                !regola.ruolo || regola.ruolo.toLowerCase().trim() === 'brio';
	            }
	          } else {
	            //						Se siamo in brio vecchio controllo su un altro campo
	            ruolo =
	              !regola.ruolo ||
	              regola.ruolo.toLowerCase().trim() ===
	                self.userSrvc.user.app.toLowerCase().trim();
	          }
	          var categoria =
	            (!regola.categoria ||
	              regola.categoria.toLowerCase().trim() ===
	                portafoglio.strumento.categoriaStrumento.codice
	                  .toLowerCase()
	                  .trim()) &&
	            regola.categoria.toLowerCase().trim() !== 'pog';
	          var isin =
	            !regola.isin ||
	            regola.isin.toLowerCase().trim() ===
	              portafoglio.strumento.isin.toLowerCase().trim();
	          var emittente =
	            !regola.emittente ||
	            regola.emittente.toLowerCase().trim() ===
	              portafoglio.strumento.emittente.toLowerCase().trim();
	          return ruolo && categoria && isin && emittente;
	        });
	      });
	    };
	
	    /*
	     * ---------------------
	     * END METODI CONTROLLER
	     * ---------------------
	     */
	
	    /*
	     * ----------------------------
	     * START METODI INIT CONTROLLER
	     * ----------------------------
	     */
	
	    // Chiamo il getDossier per inserire le info nel customerdata
	    self.promiseCustomerData().then(
	      function (response) {
	        if (self.messaggiFctr.processaResponse(response)) {
	          self.posizione = {};
	          return;
	        }
	        self.posizione = response.data;
	      },
	      function (reason) {
	        self.messaggiFctr.processaResponse(reason);
	      }
	    );
	
	    self.userSrvc.abilitazioniPronte.then(function () {
	      if (
	        self.userSrvc.abilitato(
	          CONSTANTS.ABILITAZIONI.FILTRA_RACCOMANDAZIONI
	        ) ||
	        self.userSrvc.isBpa
	      ) {
	        self.mostra.tutto = false;
	      }
	      if (self.servizio === 1 || self.servizio === '1') {
	        $q.all({
	          filtriRaccomandazione: self.promiseDominioFiltriRaccomandazione(),
	          filtriStrumento: self.promiseDominioFiltriStrumento(),
	          raccomandazioni: self.promiseDatiTabellaRaccomandazioni(
	            self.pageNumber
	          ),
	          label: labelSrvc.labelsPronte
	        })
	          .then(
	            function (response) {
	              if (
	                self.messaggiFctr.processaResponse(
	                  response.filtriRaccomandazione
	                ) ||
	                self.messaggiFctr.processaResponse(response.filtriStrumento) ||
	                self.messaggiFctr.processaResponse(response.raccomandazioni)
	              ) {
	                self.domain.listaStatoRaccomandazione = [];
	                self.domain.listaTipologiaStrumento = [];
	                self.raccomandazioniTableData = [];
	                self.initLabelTabellaRaccomandazioni();
	                return;
	              }
	              response.filtriRaccomandazione.data.result.forEach(function (
	                item
	              ) {
	                self.domain.listaStatoRaccomandazione.push({
	                  label: item,
	                  value: item
	                });
	              });
	              response.filtriStrumento.data.result.forEach(function (item) {
	                self.domain.listaTipologiaStrumento.push({
	                  label: item.descrizione,
	                  value: item.descrizione
	                });
	              });
	              self.initLabelTabellaRaccomandazioni();
	              self.raccomandazioniTotalItems =
	                response.raccomandazioni.data.result.numeroRecord;
	              self.raccomandazioniTableData =
	                response.raccomandazioni.data.result.listaRisultati;
	            },
	            function (reason) {
	              self.messaggiFctr.processaResponse(reason.filtriRaccomandazione);
	              self.messaggiFctr.processaResponse(reason.filtriStrumento);
	              self.messaggiFctr.processaResponse(reason.raccomandazioni);
	              self.domain.listaStatoRaccomandazione = [];
	              self.domain.listaTipologiaStrumento = [];
	              self.raccomandazioniTableData = [];
	            }
	          )
	          .finally(function () {
	            self.spinner.listaPortafoglio = false;
	            self.spinner.listaRaccomandazioni = false;
	          });
	      } else {
	        $q.all({
	          richieste: self.promiseDatiTabellaRichieste(),
	          filtriRaccomandazione: self.promiseDominioFiltriRaccomandazione(),
	          filtriStrumento: self.promiseDominioFiltriStrumento(),
	          label: labelSrvc.labelsPronte
	        })
	          .then(
	            function (response) {
	              if (
	                self.messaggiFctr.processaResponse(
	                  response.filtriRaccomandazione
	                ) ||
	                self.messaggiFctr.processaResponse(response.richieste) ||
	                self.messaggiFctr.processaResponse(response.filtriStrumento)
	              ) {
	                self.domain.listaStatoRaccomandazione = [];
	                self.richiesteTableData = [];
	                self.portafoglioTableData = [];
	                self.domain.listaTipologiaStrumento = [];
	                return;
	              }
	              response.filtriRaccomandazione.data.result.forEach(function (
	                item
	              ) {
	                self.domain.listaStatoRaccomandazione.push({
	                  label: item,
	                  value: item
	                });
	              });
	              response.filtriStrumento.data.result.forEach(function (item) {
	                self.domain.listaTipologiaStrumento.push({
	                  label: item.descrizione,
	                  value: item.codice
	                });
	              });
	              self.richiesteTotalItems =
	                response.richieste.data.result.numeroRecord;
	              self.richiesteTableData =
	                response.richieste.data.result.listaRisultati;
	              self.checkRegoleStrumento();
	              self.initLabelTabellaRichieste();
	            },
	            function (reason) {
	              self.messaggiFctr.processaResponse(reason.filtriRaccomandazione);
	              self.messaggiFctr.processaResponse(reason.richieste);
	              self.messaggiFctr.processaResponse(reason.filtriStrumento);
	              self.domain.listaStatoRaccomandazione = [];
	              self.domain.listaTipologiaStrumento = [];
	              self.richiesteTableData = [];
	            }
	          )
	          .finally(function () {
	            self.spinner.listaRichieste = false;
	          });
	      }
	    });
	
	    /*
	     * --------------------------
	     * END METODI INIT CONTROLLER
	     * --------------------------
	     */
	  };
	
	  ListaRaccomandazioniCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$window',
	    '$q',
	    '$stateParams',
	    '$state',
	    '$location',
	    'FIN_CONSTANTS',
	    'FinLabelSrvc',
	    'FinMessaggiFctr',
	    'uiGridConstants',
	    'CblMessageSrvc',
	    'FinUserSrvc',
	    '$uibModal',
	    'FinBrioSrvc',
	    'modalAlertSrvc',
	    'gestioneRaccomandazioneService'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'listaRaccomandazioni/listaRaccomandazioni.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var ListaRaccomandazioniComponent = {
	    bindings: {
	      sceltaDossierState: '@',
	      visualizzaRaccomandazioneState: '@',
	      modificaRaccomandazioneState: '@',
	      nuovaRaccomandazioneState: '@',
	      valutazioneRaccomandazioneState: '@',
	      modificaRichiestaState: '@',
	      nuovaRichiestaState: '@',
	      visualizzaRichiestaState: '@',
	      servizio: '<',
	      abilitatoConsulenza: '<',
	      abilitatoCollocamento: '<',
	      saldoDossierState: '@'
	    },
	    controller: ListaRaccomandazioniCtrl,
	    controllerAs: 'listaRaccomandazioniCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finanzaListaRaccomandazioni', ListaRaccomandazioniComponent);
	})();


/***/ },
/* 43 */
/***/ function(module, exports) {

	(function (window, document, undefined) {
	  var ModalScontoMassivoController = function (
	    $scope,
	    $modalInstance,
	    gestioneRaccomandazioneService,
	    messaggiFctr,
	    labelSrvc,
	    CONSTANTS
	  ) {
	    this.messaggiFctr = messaggiFctr;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.boxconfirm = false;
	
	    this.service = gestioneRaccomandazioneService;
	    this.spinner = false;
	    this.quantitaSconto = null;
	
	    var self = this;
	
	    this.apriSconto = function () {
	      self.spinner = true;
	      self.service
	        .promiseVerificaScontoMassivo(
	          self.service.raccomandazione.idPratica,
	          self.quantitaSconto
	        )
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              self.spinner = false;
	              return;
	            }
	            if (self.service.checkVerifica(response.data)) {
	              // Verifica OK, procedo al salvataggio
	              return self.salvaSconto();
	            }
	            // Apro alert di conferma
	            self.boxconfirm = true;
	
	            self.spinner = false;
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	            self.spinner = false;
	          }
	        );
	    };
	
	    this.salvaSconto = function () {
	      self.spinner = true;
	      self.service
	        .promiseSalvascontoMassivo(
	          self.service.raccomandazione.idPratica,
	          self.quantitaSconto
	        )
	        .then(
	          function (response) {
	            if (self.messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            $modalInstance.close();
	          },
	          function (reason) {
	            self.messaggiFctr.processaResponse(reason);
	          }
	        )
	        .finally(function () {
	          self.spinner = false;
	        });
	    };
	
	    this.close = function () {
	      $modalInstance.dismiss();
	    };
	  };
	
	  ModalScontoMassivoController.$inject = [
	    '$scope',
	    '$uibModalInstance',
	    'gestioneRaccomandazioneService',
	    'FinMessaggiFctr',
	    'FinLabelSrvc',
	    'FIN_CONSTANTS'
	  ];
	
	  angular
	    .module('cbl.finanza.mf')
	    .controller('ModalScontoMassivoController', ModalScontoMassivoController);
	})(window, document);


/***/ },
/* 44 */
/***/ function(module, exports) {

	(function (window, document, undefined) {
	  'use strict';
	  var ModalAlertCtrl = function ($uibModal, modalAlertSrvc, CONSTANTS) {
	    modalAlertSrvc.resetService();
	
	    modalAlertSrvc.promise.then(
	      function () {},
	      function () {},
	      function (message) {
	        // Apro la modale
	
	        var ModalController = function ($scope, $modalInstance) {
	          $scope.confirm = function () {
	            $modalInstance.close();
	          };
	          $scope.cancel = function () {
	            $modalInstance.dismiss();
	          };
	          $scope.message = message;
	        };
	
	        ModalController.$inject = ['$scope', '$modalInstance'];
	
	        modalAlertSrvc.modal = $uibModal.open({
	          animation: true,
	          templateUrl:
	            CONSTANTS.BASE_ROOT +
	            CONSTANTS.COMPONENTS_PATH +
	            'modalAlert/modalAlert.modal.html',
	          size: 'md',
	          controller: ModalController
	        });
	      }
	    );
	  };
	
	  ModalAlertCtrl.$inject = ['$uibModal', 'modalAlertSrvc', 'FIN_CONSTANTS'];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT +
	      CONSTANTS.COMPONENTS_PATH +
	      'modalAlert/modalAlert.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var ModalAlertCmpt = {
	    bindings: {},
	    controller: ModalAlertCtrl,
	    controllerAs: 'modalAlertCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finanzaModalAlert', ModalAlertCmpt);
	})(window, document);


/***/ },
/* 45 */
/***/ function(module, exports) {

	(function (window, document, undefined) {
	  var ModalAlertProposte = function (
	    $scope,
	    $modalInstance,
	    gestioneRaccomandazioneService,
	    messaggiFctr,
	    labelSrvc,
	    CONSTANTS
	  ) {
	    this.messaggiFctr = messaggiFctr;
	    $scope.msg = labelSrvc.getLabel;
	
	    this.service = gestioneRaccomandazioneService;
	
	    this.close = function () {
	      $modalInstance.dismiss();
	    };
	  };
	
	  ModalAlertProposte.$inject = [
	    '$scope',
	    '$uibModalInstance',
	    'gestioneRaccomandazioneService',
	    'FinMessaggiFctr',
	    'FinLabelSrvc',
	    'FIN_CONSTANTS'
	  ];
	
	  angular
	    .module('cbl.finanza.mf')
	    .controller('ModalAlertProposte', ModalAlertProposte);
	})(window, document);


/***/ },
/* 46 */
/***/ function(module, exports) {

	(function (window, document, undefined) {
	  'use strict';
	  var ModalAlertSrvc = function ($q) {
	    this.defer;
	    this.promise;
	
	    this.modal;
	
	    var self = this;
	    this.notify = function (message) {
	      self.defer.notify(message);
	    };
	
	    this.resetService = function () {
	      self.defer = $q.defer();
	      self.promise = self.defer.promise;
	    };
	  };
	
	  ModalAlertSrvc.$inject = ['$q'];
	
	  angular.module('cbl.finanza.mf').service('modalAlertSrvc', ModalAlertSrvc);
	})(window, document);


/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * 
	 */
	(function(undefined) {
		"use strict";
		angular
				.module("cbl.finanza.mf.directives")
				.service(
						"FinUploadSrvc",
						[
								'$q',
								'$http',
								'FinMessaggiFctr',
								'FinLabelSrvc',
								'FIN_CONSTANTS',
								function($q, $http, messaggiFctr, labelSrvc, CONSTANTS) {
									this.upload = null;
									var root = this;
	
									this.getTipo = function(codice) {
										var defer = $q.defer();
										if (this.tipo) {
											defer.resolve(this.tipo);
										} else {
											var self = this;
											$http({
												method : "GET",
												url : CONSTANTS.REST_ROOT + CONSTANTS.REST.TIPO_DOCUMENTO,
												params : {
													categoria : codice
												}
											}).then(function(response) {
												if (messaggiFctr.processaResponse(response)) {
													return;
												}
												defer.resolve(response);
											}, function(reason) {
												messaggiFctr.processaResponse(reason);
												defer.reject(reason);
											});
										}
										return defer.promise;
									};
	
									// Converte la stringa di dati a 64 bit in byteArrays
									this.b64toByteArrays = function(b64Data, sliceSize) {
										sliceSize = sliceSize || 512;
										var byteCharacters = atob(b64Data);
										var byteArrays = [];
	
										for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
											var slice = byteCharacters.slice(offset, offset + sliceSize);
	
											var byteNumbers = new Array(slice.length);
											for (var i = 0; i < slice.length; i++) {
												byteNumbers[i] = slice.charCodeAt(i);
											}
	
											var byteArray = new Uint8Array(byteNumbers);
	
											byteArrays.push(byteArray);
										}
										return byteArrays;
									};
	
									// Genera un oggetto di tipo Blob (per IE) o di tipo File e fa partire il download
									this.download =
											function(strData, fileName) {
												var byteArrays = this.b64toByteArrays(strData);
	
												var isChromium = window.chrome, winNav = window.navigator, vendorName = winNav.vendor, isOpera = winNav.userAgent.indexOf("OPR") > -1, isIEedge =
														winNav.userAgent.indexOf("Edge") > -1, isIOSChrome = winNav.userAgent.match("CriOS");
												var blob = null;
												var blobUrl = null;
												if (isIOSChrome ||
													(isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera === false && isIEedge === false)) {
													// Google Chrome
													blob = new Blob(byteArrays, {
														type : 'application/octet-stream'
													});
													blobUrl = URL.createObjectURL(blob);
													// soluzione per costringere chrome a mostrare nome ed estensione del file
													var a = document.createElement("a");
													document.body.appendChild(a);
													a.style = "display: none";
													a.href = blobUrl;
													a.download = fileName;
													a.click();
													window.URL.revokeObjectURL(fileUrl);
													a.parentNode.removeChild(a);
												} else {
													// non Google Chrome
													// Blob per internet explorer
													if (navigator.msSaveOrOpenBlob) {
														blob = new Blob(byteArrays, {
															type : 'application/octet-stream'
														});
														blobUrl = URL.createObjectURL(blob);
														navigator.msSaveOrOpenBlob(blob, fileName);
													} // File per altri browser
													else {
														var file = new File(byteArrays, fileName, {
															type : 'application/octet-stream;'
														});
														var fileUrl = URL.createObjectURL(file);
														window.open(fileUrl);
													}
												}
											};
	
									this.getFile = function(idViacart, fileName) {
										var defer = $q.defer();
										$http({
											method : "GET",
											url : CONSTANTS.REST_ROOT + CONSTANTS.REST.UPLOAD_DOCUMENTO,
											params : {
												idViacart : idViacart
											}
										}).then(function(response) {
											if (messaggiFctr.processaResponse(response)) {
												defer.reject(response);
											}
											root.download(response.data.result.data, fileName, response.data.result.extension);
											defer.resolve(response);
										}, function(reason) {
											messaggiFctr.processaResponse(reason);
											defer.reject(reason);
										});
										return defer.promise;
									};
	
									this.reset = function() {
										this.upload = null;
									};
	
								} ]);
	}());

/***/ },
/* 48 */
/***/ function(module, exports) {

	(function(window, document, undefined) {
	    var GestioneRaccomandazioneService = function(
	        $q,
	        $http,
	        messaggiFctr,
	        CONSTANTS
	    ) {
	        this.raccomandazione = {};
	        this.messaggiConferma = [];
	        this.forzaControlli = false;
	        this.segnalazioniProposta = [];
	        this.propostaSegnalata = null;
	        this.bloccoAcquisti = false;
	
	        this.promiseAbilitaScontoMassivo = function(idRaccomandazione) {
	            return $http({
	                method: 'GET',
	                url: CONSTANTS.REST_ROOT +
	                    CONSTANTS.REST.SCONTO_MASSIVO +
	                    '/' +
	                    idRaccomandazione +
	                    '/visibilita'
	            });
	        };
	
	        this.promiseVerificaScontoMassivo = function(
	            idRaccomandazione,
	            quantitaSconto
	        ) {
	            return $http.get(
	                CONSTANTS.REST_ROOT +
	                CONSTANTS.REST.SCONTO_MASSIVO +
	                '/' +
	                idRaccomandazione +
	                '/verifica/' +
	                quantitaSconto
	            );
	        };
	
	        this.promiseSalvascontoMassivo = function(
	            idRaccomandazione,
	            quantitaSconto
	        ) {
	            return $http.post(
	                CONSTANTS.REST_ROOT +
	                CONSTANTS.REST.SCONTO_MASSIVO +
	                '/inserisci/' +
	                idRaccomandazione +
	                '/' +
	                quantitaSconto, {}
	            );
	        };
	
	        this.promiseCheckProposte = function(codiceRapporto, idRaccomandazione) {
	            var url =
	                CONSTANTS.REST_ROOT +
	                CONSTANTS.REST.RACCOMANDAZIONE +
	                'raccomandazione/verifica/' +
	                idRaccomandazione +
	                '/' +
	                codiceRapporto;
	            return $http.get(url);
	        };
	
	        this.checkVerifica = function(response) {
	            self.messaggiConferma = [];
	            if (!response.result) {
	                return false;
	            }
	            if (!response.result.listasegnalazioni) {
	                return true;
	            }
	            var result = true;
	            response.result.listasegnalazioni.segnalazione.foreach(function(
	                segnalazione
	            ) {
	                if (segnalazione.descrizione !== 'ESITO OK') {
	                    self.messaggiConferma.push(segnalazione.descrizione);
	                    result = false;
	                }
	            });
	            return result;
	        };
	    };
	
	    GestioneRaccomandazioneService.$inject = [
	        '$q',
	        '$http',
	        'FinMessaggiFctr',
	        'FIN_CONSTANTS'
	    ];
	
	    angular
	        .module('cbl.finanza.mf')
	        .service('gestioneRaccomandazioneService', GestioneRaccomandazioneService);
	})(window, document);

/***/ },
/* 49 */
/***/ function(module, exports) {

	/**
	 *
	 */
	(function () {
	  angular.module('cbl.finanza.mf').factory('FinInserimentoFctr', [
	    'FIN_CONSTANTS',
	    'FinUserSrvc',
	    function (CONSTANTS, userSrvc) {
	      var checkCtvTeorico = function (dettaglioStrumento, propostaOrdine) {
	        // Se si sta trattando un fondo, controllo se la valuta dello strumento è diversa da EURO e in caso faccio la conversione dalla valuta in euro
	        var prezzo;
	        var quotazione =
	          !!propostaOrdine.prezzo && propostaOrdine.prezzo > 0
	            ? propostaOrdine.prezzo
	            : dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo;
	        if (dettaglioStrumento.divisa.trim() !== 'EURO') {
	          prezzo = quotazione / dettaglioStrumento.cambioStorico.prezzo;
	        } else {
	          prezzo = quotazione;
	        }
	
	        //    		Se non è stato inserito niente o 0 calcolo il ctvPrevisto in base alla quantità;
	        if (!propostaOrdine.ctvPrevisto || isNaN(propostaOrdine.ctvPrevisto)) {
	          propostaOrdine.ctvPrevisto = propostaOrdine.quantita * prezzo;
	        }
	        //    		Imposto a 2 decimali il ctv
	        propostaOrdine.ctvPrevisto =
	          Math.round(propostaOrdine.ctvPrevisto * 100) / 100;
	
	        var divisore = calcolaDivisoreQuantita(
	          dettaglioStrumento.qtaMinimaTrattabile
	        );
	
	        var ctv =
	          propostaOrdine.ctvPrevisto *
	          (dettaglioStrumento.categoriaStrumento.codice === 'OBB' ? 100 : 1);
	
	        propostaOrdine.quantita =
	          Math.round((ctv / prezzo) * divisore) / divisore;
	      };
	
	      var convertiCtvDaDivisa = function (dettaglioStrumento, propostaOrdine) {
	        if (dettaglioStrumento.divisa.trim() !== 'EURO') {
	          propostaOrdine.ctvPrevisto =
	            Math.round(
	              (propostaOrdine.ctvPrevistoDiv /
	                dettaglioStrumento.cambioStorico.prezzo) *
	                100
	            ) / 100;
	        } else {
	          propostaOrdine.ctvPrevisto = propostaOrdine.ctvPrevistoDiv;
	        }
	      };
	
	      var convertiCtvInDivisa = function (dettaglioStrumento, propostaOrdine) {
	        if (dettaglioStrumento.divisa.trim() !== 'EURO') {
	          propostaOrdine.ctvPrevistoDiv =
	            Math.round(
	              propostaOrdine.ctvPrevisto *
	                dettaglioStrumento.cambioStorico.prezzo *
	                100
	            ) / 100;
	        } else {
	          propostaOrdine.ctvPrevistoDiv = propostaOrdine.ctvPrevisto;
	        }
	      };
	
	      var checkQuantita = function (
	        dettaglioStrumento,
	        propostaOrdine,
	        acqven,
	        saldoPortafoglio
	      ) {
	        //    		Controllo se c'è contenuto
	        if (!propostaOrdine.quantita || isNaN(propostaOrdine.quantita)) {
	          propostaOrdine.quantita = dettaglioStrumento.qtaMinimaTrattabile;
	        }
	        //    		Rendo la quantita inserita un multiplo del taglio
	        //    		propostaOrdine.quantita = propostaOrdine.quantita - Math.round(propostaOrdine.quantita % (self.dettaglioStrumento.taglioSuccessivo || 1));
	        //    		Se viene inserito un valore minore della qtaMinimaTrattabile viene impostato quest'ultimo valore
	        if (propostaOrdine.quantita < dettaglioStrumento.qtaMinimaTrattabile) {
	          propostaOrdine.quantita = dettaglioStrumento.qtaMinimaTrattabile;
	        }
	        //    		Se siamo in vendita effettuo ulteriori controlli
	        if (acqven === CONSTANTS.OPERAZIONI.VENDITA) {
	          propostaOrdine.quantita = checkVenditaMassima(
	            propostaOrdine.quantita,
	            saldoPortafoglio
	          );
	          propostaOrdine.quantita = checkRimanenzaQuantita(
	            propostaOrdine.quantita,
	            saldoPortafoglio,
	            dettaglioStrumento
	          );
	        }
	
	        var divisore = calcolaDivisoreQuantita(
	          dettaglioStrumento.qtaMinimaTrattabile
	        );
	
	        propostaOrdine.quantita =
	          Math.round(propostaOrdine.quantita * divisore) / divisore || 1;
	
	        // Se si sta trattando un fondo, controllo se la valuta dello strumento è diversa da EURO e in caso faccio la conversione dalla valuta in euro
	        var prezzo;
	        var quotazione =
	          !!propostaOrdine.prezzo && propostaOrdine.prezzo > 0
	            ? propostaOrdine.prezzo
	            : dettaglioStrumento.quotazioneUltimoPrezzoStorico.prezzo;
	        if (dettaglioStrumento.divisa.trim() !== 'EURO') {
	          prezzo = quotazione / dettaglioStrumento.cambioStorico.prezzo;
	        } else {
	          prezzo = quotazione;
	        }
	
	        //    		Aggiorno il controvalore e imposto a 2 decimali
	
	        var baseQta =
	          propostaOrdine.quantita /
	          (dettaglioStrumento.categoriaStrumento.codice === 'OBB' ? 100 : 1);
	
	        propostaOrdine.ctvPrevisto = Math.round(baseQta * prezzo * 100) / 100;
	      };
	
	      var calcolaDivisoreQuantita = function (quantitaMinima) {
	        if (!quantitaMinima) {
	          return 1;
	        }
	
	        var quantitaStr = quantitaMinima.toString();
	        var decimali = quantitaStr.split('.');
	        var nDecimali = decimali[1] ? decimali[1].length : 0;
	        var divisore = Math.pow(10, nDecimali);
	
	        return divisore;
	      };
	
	      var checkVenditaMassima = function (quantita, saldoPortafoglio) {
	        return quantita <= saldoPortafoglio.quantita
	          ? quantita
	          : saldoPortafoglio.quantita;
	      };
	
	      var checkRimanenzaQuantita = function (
	        quantita,
	        saldoPortafoglio,
	        dettaglioStrumento
	      ) {
	        var qtaDisp = saldoPortafoglio.quantita;
	        var qtaMin = dettaglioStrumento.qtaMinimaTrattabile;
	        return qtaDisp - quantita >= 0 &&
	          (qtaDisp - quantita >= qtaMin || qtaDisp - quantita === 0)
	          ? quantita
	          : qtaDisp - qtaMin;
	      };
	
	      var abilitatoCtv = function () {
	        return (
	          userSrvc.isBpa ||
	          userSrvc.abilitato(CONSTANTS.ABILITAZIONI.CTV_TEORICO_ALL)
	        );
	      };
	
	      var disabilitaPrezzoLimite = function (propostaOrdine) {
	        if (userSrvc.isBpa) {
	          userSrvc.configurazioni[CONSTANTS.ABILITAZIONI.DISABILITA_LIMITE] =
	            'SOTME;NEGME;LIB_N';
	        }
	
	        if (
	          !userSrvc.configurazioni[CONSTANTS.ABILITAZIONI.DISABILITA_LIMITE]
	        ) {
	          return false;
	        }
	
	        var operazioniDaDisabilitare = userSrvc.configurazioni[
	          CONSTANTS.ABILITAZIONI.DISABILITA_LIMITE
	        ].split(';');
	
	        operazioniDaDisabilitare.forEach(function (item) {
	          item = item.trim();
	        });
	
	        var result =
	          operazioniDaDisabilitare.indexOf(propostaOrdine.codiceOrdine) > -1;
	
	        if (result) {
	          propostaOrdine.prezzo = 0;
	        }
	
	        return result;
	      };
	
	      return {
	        checkCtvTeorico: checkCtvTeorico,
	        checkQuantita: checkQuantita,
	        convertiCtvInDivisa: convertiCtvInDivisa,
	        convertiCtvDaDivisa: convertiCtvDaDivisa,
	        abilitatoCtv: abilitatoCtv,
	        disabilitaPrezzoLimite: disabilitaPrezzoLimite
	      };
	    }
	  ]);
	})();


/***/ },
/* 50 */
/***/ function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.finanza.mf.directive:finanzaSaldoDossier
	 * @restrict E
	 * @scope
	 * @description Componente rappresentante il dettaglio del saldo dossier
	 * @param {String} sceltaDossierState - Nome dello stato per la scelta del dossier
	 * @param {String} visualizzaRaccomandazioneState - Nome dello stato per andare nella sezione di visualizzazione di una raccomandazione
	 * @param {String} modificaRaccomandazioneState - Nome dello stato per andare nella sezione di modifica di una raccomandazione
	 * @param {String} nuovaRaccomandazioneState - Nome dello stato per andare nella sezione di creazione di una raccomandazione
	 * @param {String} rifiutaRaccomandazioneState - Nome dello stato in cui navigare dopo aver rifiutato una raccomandazione
	 * @param {String} accettaRaccomandazioneState - Nome dello stato in cui navigare dopo aver accettato una raccomandazione
	 * @param {String} sceltaDossierState - Nome dello stato in cui è contenuta la lista dei dossiers
	 */
	(function () {
	  'use strict';
	  var CashflowCtrl = function (
	    $http,
	    $scope,
	    $window,
	    $q,
	    $stateParams,
	    $state,
	    $location,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    uiGridConstants,
	    messaggiSrvc,
	    userSrvc,
	    $uibModal,
	    brioSrvc,
	    service,
	    tableService,
	    deskSrvc
	  ) {
	    var self = this;
	    this.$uibModal = $uibModal;
	    this.$http = $http;
	    this.$window = $window;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$location = $location;
	    this.messaggiFctr = messaggiFctr;
	    this.messaggiSrvc = messaggiSrvc;
	    this.userSrvc = userSrvc;
	    this.brioSrvc = brioSrvc;
	    this.deskSrvc = deskSrvc;
	    this.tableService = tableService;
	    this.posizione = {};
	    this.ndgs = [];
	    this.selectNdg = [];
	    this.selectRapporti = [];
	    this.CONSTANTS = CONSTANTS;
	    this.startDate = new Date();
	    this.endDate = new Date();
	    this.minDate = new Date();
	    this.maxDate = new Date('2099-12-31');
	    this.dataTable = null;
	    this.gridTable = {};
	    this.avvertenze = [];
	
	    this.filterBox = {
	      totaleScadenza: true,
	      cedole: true,
	      rimborsi: true,
	      dividendi: true,
	      strumentiUS: false
	    };
	
	    this.endDate.setFullYear(this.endDate.getFullYear() + 1);
	
	    $scope.msg = labelSrvc.getLabel;
	    this.spinner = {
	      customerData: true,
	      filterNdg: true,
	      cashflow: false
	    };
	    this.messaggiFctr.chiudiLoaderBrio();
	
	    var self = this;
	
	    /*
	     * ----------------------------
	     * START METODI INIT CONTROLLER
	     * ----------------------------
	     */
	    service
	      .promiseCustomerData($stateParams.finRapporto)
	      .then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.posizione = {};
	            return;
	          }
	          self.posizione = response.data;
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	        }
	      )
	      .finally(function () {
	        self.spinner.customerData = false;
	      });
	
	    service
	      .promiseFilterNdg($stateParams.finRapporto)
	      .then(function (response) {
	        if (self.messaggiFctr.processaResponse(response)) {
	          return;
	        }
	        self.ndgs = response.data.result;
	        self.selectNdg = [];
	        self.ndgs.forEach(function (ndg) {
	          self.selectNdg.push({
	            ndg: ndg.ndg,
	            intestazione: ndg.intestazione,
	            selected: true
	          });
	        });
	        self.reloadRapporti();
	      })
	      .finally(function () {
	        self.spinner.filterNdg = false;
	      });
	
	    // Chiamo il getDossier per inserire le info nel customerdata
	
	    labelSrvc.labelsPronte.then(function () {
	      if (self.deskSrvc.isDesk) {
	        self.deskSrvc.aggiungiEntry(
	          labelSrvc.getLabel('dossier.cashflow.titolo')
	        );
	      }
	
	      for (var label in labelSrvc.labels) {
	        if (label.startsWith('cashflow.avvertenze.'))
	          self.avvertenze.push(labelSrvc.getLabel(label));
	      }
	    });
	    /*
	     * --------------------------
	     * END METODI INIT CONTROLLER
	     * --------------------------
	     */
	
	    this.filterCashFlow = function () {
	      self.spinner.cashflow = true;
	      var rapporti = [];
	      self.selectRapporti.forEach(function (rapp) {
	        if (rapp.selected) {
	          rapporti.push(rapp.rapporto);
	        }
	      });
	      if (rapporti.length === 0) {
	        self.messaggiFctr.addMessage({
	          type: 'E',
	          message: 'Nessun rapporto selezionato'
	        });
	        self.spinner.cashflow = false;
	        return;
	      }
	      service
	        .promiseGetCashflow(rapporti, self.startDate, self.endDate)
	        .then(function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            return;
	          }
	          self.dataTable = response.data.result;
	          self.dataTable.forEach(function (item) {
	            if (!item.codiceMovimento) {
	              item.codiceMovimento = 'CED';
	            }
	          });
	          self.loadTable();
	        })
	        .finally(function () {
	          self.spinner.cashflow = false;
	        });
	    };
	
	    this.loadTable = function () {
	      self.gridTable = self.tableService.getTable(
	        self.dataTable,
	        self.filterBox
	      );
	    };
	
	    this.reloadRapporti = function () {
	      var tmpRapporto = self.selectRapporti.concat([]);
	      self.selectRapporti = [];
	      self.selectNdg.forEach(function (ndg) {
	        if (ndg.selected) {
	          self.ndgs
	            .find(function (n) {
	              return n.ndg === ndg.ndg;
	            })
	            .rapporti.forEach(function (rapp) {
	              var indexFind = self.selectRapporti.findIndex(function (rp) {
	                return rp.rapporto === rapp.rapporto;
	              });
	              if (indexFind !== -1) {
	                // Già censito
	                self.selectRapporti[indexFind].intestazione =
	                  ndg.ndg + '/' + self.selectRapporti[indexFind].intestazione;
	              } else {
	                var item = tmpRapporto.find(function (rp) {
	                  return rp.rapporto === rapp.rapporto;
	                });
	                // Inserisco
	                self.selectRapporti.push({
	                  rapporto: rapp.rapporto,
	                  intestazione: ndg.ndg + ' - Rapporto ' + rapp.rapporto,
	                  selected: !!item ? item.selected : false
	                });
	                var dtStipula = new Date(rapp.dataStipula);
	                 self.minDate =
	                  dtStipula.getTime() < self.minDate.getTime()
	                    ? dtStipula
	                    : self.minDate;
	              } 
	            });
	        }
	      });
	    };
	
	    this.getExcel = function () {
	      self.spinner.cashflow = true;
	      this.tableService
	        .excel(self.dataTable, self.filterBox)
	        .then(function () {})
	        .finally(function () {
	          self.spinner.cashflow = false;
	        });
	    };
	
	    this.indietro = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      if (deskSrvc.isDesk) {
	        deskSrvc.popEntry();
	      }
	      $state.go('home.schedaDossierDiv', {
	        ndg: $stateParams.ndg,
	        finCodiceRapporto: $stateParams.finRapporto,
	        finDivisa: $stateParams.finDivisa,
	        finCambio: $stateParams.finCambio,
	        finDecimali: $stateParams.finDecimali
	      });
	    };
	  };
	
	  CashflowCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$window',
	    '$q',
	    '$stateParams',
	    '$state',
	    '$location',
	    'FIN_CONSTANTS',
	    'FinLabelSrvc',
	    'FinMessaggiFctr',
	    'uiGridConstants',
	    'CblMessageSrvc',
	    'FinUserSrvc',
	    '$uibModal',
	    'FinBrioSrvc',
	    'CashflowSrvc',
	    'CashflowTableSrvc',
	    'FinDeskSrvc'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'cashflow/cashflow.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var CashflowComponent = {
	    bindings: {},
	    controller: CashflowCtrl,
	    controllerAs: 'cashflowCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finanzaCahflow', CashflowComponent);
	})();


/***/ },
/* 51 */
/***/ function(module, exports) {

	(function (window, undefined) {
	  'use strict';
	
	  angular.module('cbl.finanza.mf').service('CashflowSrvc', [
	    '$http',
	    '$state',
	    'FinUserSrvc',
	    'FIN_CONSTANTS',
	    function ($http, $state, finUserSrvc, CONSTANTS) {
	      /**
	       * @ngdoc method
	       * @name promiseCustomerData
	       * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	       * @description Effettua la chiamata per ricevere il customerdata
	       * @return {Promise} - Ritorna una promise contenente il customerdata
	       */
	      this.promiseCustomerData = function (rapporto) {
	        return $http({
	          method: 'GET',
	          url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
	          params: {
	            rapporto: rapporto
	          }
	        });
	      };
	
	      this.promiseFilterNdg = function (rapporto) {
	        debugger;
	        return $http({
	          method: 'GET',
	          url:
	            CONSTANTS.REST_ROOT +
	            CONSTANTS.REST.DOSSIER +
	            'ndgDossier/' +
	            rapporto,
	          params: {}
	        });
	      };
	
	      this.promiseGetCashflow = function (rapporti, dataInizio, dataFine) {
	        return $http({
	          method: 'GET',
	          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DOSSIER + 'cashflow',
	          params: {
	            rapporti: rapporti,
	            dataInizio: dataInizio,
	            dataFine: dataFine
	          }
	        });
	      };
	
	      this.elaboraLista = function (lista) {
	        return lista;
	      };
	    }
	  ]);
	})(window);


/***/ },
/* 52 */
/***/ function(module, exports) {

	(function (window, undefined) {
	  'use strict';
	
	  angular.module('cbl.finanza.mf').service('CashflowTableSrvc', [
	    '$http',
	    '$q',
	    'FinMessaggiFctr',
	    'FIN_CONSTANTS',
	    function ($http, $q, messaggiFctr, CONSTANTS) {
	      var codiceCedola = 'CED';
	      var codiceRimborsi = 'RIMB';
	      var codiceDividendi = 'DIV';
	
	      var self = this;
	
	      this.getTable = function (data, filter) {
	        var result = {
	          totaleCedole: 0,
	          totaleRimborsi: 0,
	          totaleDividendi: 0,
	          listePerScadenza: {}
	        };
	
	        if (!data) {
	          return result;
	        }
	
	        data = data.filter(function (item) {
	          return (
	            (!filter.strumentiUS || item.strumentoUS === 'Y') &&
	            ((filter.cedole && item.codiceMovimento === codiceCedola) ||
	              (filter.rimborsi && item.codiceMovimento === codiceRimborsi) ||
	              (filter.dividendi && item.codiceMovimento === codiceDividendi))
	          );
	        });
	
	        data.forEach(function (item) {
	          if (!result.listePerScadenza[item.scadenza]) {
	            result.listePerScadenza[item.scadenza] = { rows: [], totale: 0 };
	          }
	          var totale = item.importoNettoEuro;
	          result.listePerScadenza[item.scadenza].rows.push(item);
	          result.listePerScadenza[item.scadenza].totale =
	            result.listePerScadenza[item.scadenza].totale + totale;
	          switch (item.codiceMovimento) {
	            case codiceCedola:
	              result.totaleCedole += totale;
	              break;
	            case codiceDividendi:
	              result.totaleDividendi += totale;
	              break;
	            case codiceRimborsi:
	              result.totaleRimborsi += totale;
	              break;
	          }
	        });
	
	        return result;
	      };
	
	      this.excel = function (data, filter) {
	        var defer = $q.defer();
	        var input = self.getTable(data, filter);
	
	        $http
	          .post(
	            CONSTANTS.REST_ROOT + CONSTANTS.REST.DOSSIER + 'cashflow',
	            input
	          )
	          .then(function (response) {
	            if (messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            self.download(response.data.result);
	          })
	          .finally(function () {
	            defer.resolve(null);
	          });
	        return defer.promise;
	      };
	
	      this.download = function (allegato) {
	        var byteArrays = self.b64toByteArrays(allegato);
	        var blobType =
	          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	        var fileName = 'export_excel.xlsx';
	
	        var isChromium = window.chrome,
	          winNav = window.navigator,
	          vendorName = winNav.vendor,
	          isOpera = winNav.userAgent.indexOf('OPR') > -1,
	          isIEedge = winNav.userAgent.indexOf('Edge') > -1,
	          isIOSChrome = winNav.userAgent.match('CriOS');
	
	        if (
	          isIOSChrome ||
	          (isChromium !== null &&
	            isChromium !== undefined &&
	            vendorName === 'Google Inc.' &&
	            isOpera == false &&
	            isIEedge == false)
	        ) {
	          // è Google Chrome
	          var blob = new Blob(byteArrays, { type: blobType });
	          var blobUrl = URL.createObjectURL(blob);
	          // soluzione per costringere chrome a mostrare nome ed estensione del file
	          var a = document.createElement('a');
	          document.body.appendChild(a);
	          a.style = 'display: none';
	          a.href = blobUrl;
	          a.download = fileName;
	          a.click();
	          window.URL.revokeObjectURL(fileUrl);
	          a.parentNode.removeChild(a);
	        } else {
	          // non è Google Chrome
	          // Blob per internet explorer
	          if (navigator.msSaveOrOpenBlob) {
	            var blob = new Blob(byteArrays, { type: blobType });
	            var blobUrl = URL.createObjectURL(blob);
	            navigator.msSaveOrOpenBlob(blob, fileName);
	          } // File per altri browser
	          else {
	            var file = new File(byteArrays, fileName, { type: blobType });
	            var fileUrl = URL.createObjectURL(file);
	            window.open(fileUrl);
	          }
	        }
	      };
	
	      this.b64toByteArrays = function (b64Data, sliceSize) {
	        sliceSize = sliceSize || 512;
	        var byteCharacters = atob(b64Data);
	        var byteArrays = [];
	
	        for (
	          var offset = 0;
	          offset < byteCharacters.length;
	          offset += sliceSize
	        ) {
	          var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	          var byteNumbers = new Array(slice.length);
	          for (var i = 0; i < slice.length; i++) {
	            byteNumbers[i] = slice.charCodeAt(i);
	          }
	
	          var byteArray = new Uint8Array(byteNumbers);
	
	          byteArrays.push(byteArray);
	        }
	        return byteArrays;
	      };
	    }
	  ]);
	})(window);


/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name cbl.finanza.mf.directive:finanzaSaldoDossier
	 * @restrict E
	 * @scope
	 * @description Componente rappresentante il dettaglio del saldo dossier
	 * @param {String} sceltaDossierState - Nome dello stato per la scelta del dossier
	 * @param {String} visualizzaRaccomandazioneState - Nome dello stato per andare nella sezione di visualizzazione di una raccomandazione
	 * @param {String} modificaRaccomandazioneState - Nome dello stato per andare nella sezione di modifica di una raccomandazione
	 * @param {String} nuovaRaccomandazioneState - Nome dello stato per andare nella sezione di creazione di una raccomandazione
	 * @param {String} rifiutaRaccomandazioneState - Nome dello stato in cui navigare dopo aver rifiutato una raccomandazione
	 * @param {String} accettaRaccomandazioneState - Nome dello stato in cui navigare dopo aver accettato una raccomandazione
	 * @param {String} sceltaDossierState - Nome dello stato in cui è contenuta la lista dei dossiers
	 */
	(function () {
	  'use strict';
	  var EstrattoContoCtrl = function (
	    $http,
	    $scope,
	    $window,
	    $q,
	    $stateParams,
	    $state,
	    $location,
	    CONSTANTS,
	    labelSrvc,
	    messaggiFctr,
	    uiGridConstants,
	    messaggiSrvc,
	    userSrvc,
	    $uibModal,
	    brioSrvc,
	    service,
	    tableService,
	    deskSrvc,
	    EstrattoContoSrvc,
	    FinUploadSrvc
	  ) {
	    var self = this;
	    this.$uibModal = $uibModal;
	    this.$http = $http;
	    this.$window = $window;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$location = $location;
	    this.messaggiFctr = messaggiFctr;
	    this.messaggiSrvc = messaggiSrvc;
	    this.userSrvc = userSrvc;
	    this.brioSrvc = brioSrvc;
	    this.deskSrvc = deskSrvc;
	    this.tableService = tableService;
	    this.posizione = {};
	    this.ndgs = [];
	    this.selectNdg = [];
	    this.selectRapporti = [];
	    this.CONSTANTS = CONSTANTS;
	    this.startDate = new Date();
	    this.endDate = new Date();
	    this.minDate = new Date();
	    this.dataTable = null;
	    this.gridTable = {};
	    this.avvertenze = [];
	    this.filterBox = {
	      totaleScadenza: true,
	      cedole: true,
	      rimborsi: true,
	      dividendi: true,
	      strumentiUS: false
	    };
	    this.totaliConti = {};
	    this.endDate.setFullYear(this.endDate.getFullYear() + 1);
	    $scope.service = EstrattoContoSrvc;
	    $scope.msg = labelSrvc.getLabel;
	    $scope.estrattoContoFiscale={};
	    $scope.minusvalenzeAccantonate={};
	    $scope.FinUploadSrvc = FinUploadSrvc;
	    $scope.plusMinusperModale = {};
	    $scope.tabellaEstrattoConto = {}
	    this.messaggiFctr.chiudiLoaderBrio();
	    $scope.spinner = {
	      reportMinus: false,
	      exportXls: false
	    };
	    $scope.service.filtriEstrattoContoFiscale = {
	        salIniz:true,
	        salFin:true,
	        plusMinus:true,
	        venditaScaricoPrelievo:false,
	        acquistoCaricoConf:false,
	        espandiTutto: true
	    }
	    //IMPOSTO LA START DATE AL PRIMO GENNAIO DI QUESTO ANNO MENO 5 ANNI
	    this.setStartDate = function(){
	      var today = new Date();
	      var thisYearFirstDay = today.getFullYear()-5+'-01-01';
	      return thisYearFirstDay;
	    }
	    this.setEndDate = function(){
	      var today = new Date();
	      var thisYearLastDay = today.getFullYear()+'-12-31';
	      return thisYearLastDay;
	    }
	    this.startDate=self.setStartDate();
	    this.endDate = self.setEndDate();
	    this.maxDate = new Date('2099-12-31');
	    this.dataMinima = new Date(self.setStartDate());
	    $scope.service.inputFormMovimenti = {
	      dataInizio: new Date(self.startDate),
	      dataFine: new Date(self.endDate),
	    }
	    $scope.numeroRapporto = $stateParams.finCodiceRapporto;
	    this.collapseState =[];
	    this.isStateCorrect = true; 
	    var self = this;
	
	    /*
	     * ----------------------------
	     * START METODI INIT CONTROLLER
	     * ----------------------------
	     */
	    service
	      .promiseCustomerData($stateParams.finCodiceRapporto)
	      .then(
	        function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.posizione = {};
	            return;
	          }
	          self.posizione = response.data;
	        },
	        function (reason) {
	          self.messaggiFctr.processaResponse(reason);
	        }
	      )
	      .finally(function () {
	        self.spinner.customerData = false;
	      });
	
	    service
	      .promiseFilterNdg($stateParams.finCodiceRapporto)
	      .then(function (response) {
	        if (self.messaggiFctr.processaResponse(response)) {
	          return;
	        }
	        self.ndgs = response.data.result;
	        self.selectNdg = [];
	        self.ndgs.forEach(function (ndg) {
	          self.selectNdg.push({
	            ndg: ndg.ndg,
	            intestazione: ndg.intestazione,
	            selected: true
	          });
	        });
	        self.reloadRapporti();
	      })
	      .finally(function () {
	        self.spinner.filterNdg = false;
	      });
	
	      service.promiseTotaliConti($stateParams.finCodiceRapporto)
	      .then(function(response){
	        if(self.messaggiFctr.processaResponse(response)){
	          return;
	        }else{
	          self.totaliConti=response.data.result;
	        }
	      })
	    // Chiamo il getDossier per inserire le info nel customerdata
	
	    labelSrvc.labelsPronte.then(function () {
	      if (self.deskSrvc.isDesk) {
	        self.deskSrvc.aggiungiEntry(
	          labelSrvc.getLabel('dossier.cashflow.titolo')
	        );
	      }
	
	      for (var label in labelSrvc.labels) {
	        if (label.startsWith('cashflow.avvertenze.'))
	          self.avvertenze.push(labelSrvc.getLabel(label));
	      }
	    });
	    /* this.service.inputFormMovimenti.startDate = new Date();
	    this.service.inputFormMovimenti.endDate = new Date(); */
	    /*
	     * --------------------------
	     * END METODI INIT CONTROLLER
	     * --------------------------
	     */
	
	    this.filterCashFlow = function () {
	      self.spinner.cashflow = true;
	      var rapporti = [];
	      self.selectRapporti.forEach(function (rapp) {
	        if (rapp.selected) {
	          rapporti.push(rapp.rapporto);
	        }
	      });
	      if (rapporti.length === 0) {
	        self.messaggiFctr.addMessage({
	          type: 'E',
	          message: 'Nessun rapporto selezionato'
	        });
	        self.spinner.cashflow = false;
	        return;
	      }
	      service
	        .promiseGetCashflow(rapporti, self.startDate, self.endDate)
	        .then(function (response) {
	          if (self.messaggiFctr.processaResponse(response)) {
	            self.spinner.cashflow = false;
	            return;
	          }
	          self.dataTable = response.data.result;
	          self.dataTable.forEach(function (item) {
	            if (!item.codiceMovimento) {
	              item.codiceMovimento = 'CED';
	            }
	          });
	          self.loadTable();
	        })
	        .finally(function () {
	          self.spinner.cashflow = false;
	        });
	    };
	
	    this.loadTable = function () {
	      self.gridTable = self.tableService.getTable(
	        self.dataTable,
	        self.filterBox
	      );
	    };
	
	    this.reloadRapporti = function () {
	      var tmpRapporto = self.selectRapporti.concat([]);
	      self.selectRapporti = [];
	      self.selectNdg.forEach(function (ndg) {
	        if (ndg.selected) {
	          self.ndgs
	            .find(function (n) {
	              return n.ndg === ndg.ndg;
	            })
	            .rapporti.forEach(function (rapp) {
	              var indexFind = self.selectRapporti.findIndex(function (rp) {
	                return rp.rapporto === rapp.rapporto;
	              });
	              if (indexFind !== -1) {
	                // Già censito
	                self.selectRapporti[indexFind].intestazione =
	                  ndg.ndg + '/' + self.selectRapporti[indexFind].intestazione;
	              } else {
	                var item = tmpRapporto.find(function (rp) {
	                  return rp.rapporto === rapp.rapporto;
	                });
	                // Inserisco
	                self.selectRapporti.push({
	                  rapporto: rapp.rapporto,
	                  intestazione: ndg.ndg + ' - Rapporto ' + rapp.rapporto,
	                  selected: !!item ? item.selected : false
	                });
	                var dtStipula = new Date(rapp.dataStipula);
	                self.minDate =
	                  dtStipula.getTime() < self.minDate.getTime()
	                    ? dtStipula
	                    : self.minDate;
	              }
	            });
	        }
	      });
	    };
	
	    this.getExcel = function () {
	      self.spinner.cashflow = true;
	      this.tableService
	        .excel(self.dataTable, self.filterBox)
	        .then(function () {})
	        .finally(function () {
	          self.spinner.cashflow = false;
	        });
	    };
	
	    this.indietro = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      if (deskSrvc.isDesk) {
	        deskSrvc.popEntry();
	      }
	      $state.go('home.schedaDossierDiv', {
	        ndg: $stateParams.ndg,
	        finCodiceRapporto: $stateParams.finCodiceRapporto,
	        finDivisa: $stateParams.finDivisa,
	        finCambio: $stateParams.finCambio,
	        finDecimali: $stateParams.finDecimali
	      });
	    };
	    $scope.loadEstrattoConto = function(){
	     var dataInizioPerConfronto = new Date($scope.service.inputFormMovimenti.dataInizio)
	         .toDateString()
	         .substring(0,15);
	     var dataMinimaPerConfronto = new Date(self.dataMinima)
	          .toDateString()
	          .substring(0,15); 
	     var dataFinePerConfronto = new Date($scope.service.inputFormMovimenti.dataFine)
	          .toDateString()
	          .substring(0,15);
	      $scope.spinner.reportMinus = true;  
	      $scope.startDateRequired = 
	      isNaN( Date.parse($scope.service.inputFormMovimenti.dataInizio)) 
	      || Date.parse(dataInizioPerConfronto) < Date.parse(dataMinimaPerConfronto)
	      || Date.parse($scope.service.inputFormMovimenti.dataInizio) > Date.parse($scope.service.inputFormMovimenti.dataFine)
	      $scope.endDateRequired = 
	      isNaN(Date.parse($scope.service.inputFormMovimenti.dataFine))
	        || Date.parse(dataFinePerConfronto) < Date.parse(dataMinimaPerConfronto)
	        || Date.parse($scope.service.inputFormMovimenti.dataFine) < Date.parse($scope.service.inputFormMovimenti.dataInizio)  
	      ;
	
	      if($scope.startDateRequired || $scope.endDateRequired){
	        $scope.spinner.reportMinus = false;
	        return;
	      }
	      service.promiseGetEstrattoConto(
	        $stateParams.ndg,
	        $stateParams.finCodiceRapporto,
	        $scope.service.inputFormMovimenti.dataInizio.toISOString()
	        .substring(0, 10),
	        $scope.service.inputFormMovimenti.dataFine.toISOString()
	        .substring(0, 10),
	        $scope.service.filtriEstrattoContoFiscale
	        )
	      .then(
	        function(response){
	        if(messaggiFctr.processaResponse(response)){
	          $scope.spinner.reportMinus = false;
	          return;
	        }
	        $scope.spinner.reportMinus = false;
	        self.collapseState=[];
	        $scope.estrattoContoFiscale = response.data.result;
	        $scope.tabellaEstrattoConto.eventi = $scope.estrattoContoFiscale.eventi
	          .map(function(evento){
	            evento.eventoConto.forEach(function(detail){
	              detail.evento = detail.evento.trim();
	              $scope.service.filtriEstrattoContoFiscale.espandiTutto ? self.collapseState.push(true) : self.collapseState.push(false);
	              return detail.evento;  
	            })
	            return evento;
	          });
	          setTimeout(self.collapseAll,500);
	      }).finally(function(){
	        $scope.spinner.reportMinus = false;
	      });
	    }
	    $scope.exportEstrattoConto = function(){
	      $scope.spinner.exportXls = true;
	      var xlsString = $scope.estrattoContoFiscale.xlxs;
	      tableService.download(xlsString,'estrattoContoFiscale.xlxs');
	      $scope.spinner.exportXls = false;    }
	
	    $scope.openPlusMinusModal = function(item,descrizioneIntestatario){
	      if(item.evento === 'PLUS'){
	        /*
	        aggiungo l'intestatario ad ogni oggetto plusMinus
	        per averlo da mostrare nella modale
	        */
	        item.plusMinus.forEach(function(x){
	          x.descrizioneIntestatario = descrizioneIntestatario;
	        });
	        $scope.plusMinusperModale = item;
	        $('#modalePlus').modal('show');
	      }else if(item.evento === 'MINUS'){
	        /*
	        aggiungo l'intestatario ad ogni oggetto plusMinus
	        per averlo da mostrare nella modale
	        */
	        item.plusMinus.forEach(function(x){
	          x.descrizioneIntestatario = descrizioneIntestatario;
	        });
	        $scope.plusMinusperModale = item;
	        $('#modaleMinus').modal('show');
	      }else{
	        return;
	      }
	     }
	     this.filtraEstrattoConto = function(){
	      $scope.tabellaEstrattoConto.eventi.forEach(function(evento){
	        if($scope.service.filtriEstrattoContoFiscale.plusMinus === false){
	          evento.eventoConto = evento.eventoConto.filter(function(detail){
	            return detail.evento !== 'PLUS'
	          })
	          evento.eventoConto = evento.eventoConto.filter(function(detail){
	            return detail.evento !== 'MINUS'
	          })
	        }
	        if($scope.service.filtriEstrattoContoFiscale.venditaScaricoPrelievo === false){
	          evento.eventoConto = evento.eventoConto.filter(function(detail){
	            return detail.evento !== 'SCARICO'
	          })
	          evento.eventoConto = evento.eventoConto.filter(function(detail){
	            return detail.evento !== 'VENDITA'
	          })
	          evento.eventoConto = evento.eventoConto.filter(function(detail){
	            return detail.evento !== 'PRELIEVO'
	          })
	        }
	        if($scope.service.filtriEstrattoContoFiscale.acquistoCaricoConf === false){
	          evento.eventoConto = evento.eventoConto.filter(function(detail){
	            return detail.evento !== 'ACQUISTO'
	          })
	          evento.eventoConto = evento.eventoConto.filter(function(detail){
	            return detail.evento !== 'CARICO'
	          })
	          evento.eventoConto = evento.eventoConto.filter(function(detail){
	            return detail.evento !== 'CONFERIM'
	          })
	        }
	        if($scope.service.filtriEstrattoContoFiscale.salIniz === false){
	          evento.eventoConto = evento.eventoConto.filter(function(detail){
	            return detail.evento !== 'SAL.INIZ'
	          })
	        }
	        if($scope.service.filtriEstrattoContoFiscale.salFin === false){
	          return detail.evento !== 'SAL.FIN'
	        }
	      })
	    };
	    $scope.returnExpandAll = function(){
	      return $scope.service.filtriEstrattoContoFiscale.espandiTutto;
	    }
	    $scope.resetButtons = function(){{
	      $scope.service.filtriEstrattoContoFiscale = {
	        salIniz:true,
	        salFin:true,
	        plusMinus:true,
	        venditaScaricoPrelievo:false,
	        acquistoCaricoConf:false,
	        espandiTutto: true
	    }
	    }}
	    this.collapsePanelDetail = function(number){
	      $('#myDetail_'+number).collapse('toggle') 
	      self.collapseState[number] = !self.collapseState[number];
	    };
	    this.collapseAll = function(){
	      if($scope.service.filtriEstrattoContoFiscale.espandiTutto){
	        $scope.estrattoContoFiscale.eventi.forEach(function(state,index){
	              $('#myDetail_'+index).collapse('show')
	        })    
	      }else{
	        $scope.estrattoContoFiscale.eventi.forEach(function(state,index){
	            $('#myDetail_'+index).collapse('hide');
	        });
	      }
	      
	    }
	  };
	
	  EstrattoContoCtrl.$inject = [
	    '$http',
	    '$scope',
	    '$window',
	    '$q',
	    '$stateParams',
	    '$state',
	    '$location',
	    'FIN_CONSTANTS',
	    'FinLabelSrvc',
	    'FinMessaggiFctr',
	    'uiGridConstants',
	    'CblMessageSrvc',
	    'FinUserSrvc',
	    '$uibModal',
	    'FinBrioSrvc',
	    'EstrattoContoSrvc',
	    'EstrattoContoTableSrvc',
	    'FinDeskSrvc',
	    'FinUploadSrvc'
	  ];
	
	  var TemplateUrl = function (CONSTANTS) {
	    return (
	      CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'estrattoConto/estrattoConto.html'
	    );
	  };
	  TemplateUrl.$inject = ['FIN_CONSTANTS'];
	
	  var CashflowComponent = {
	    bindings: {},
	    controller: EstrattoContoCtrl,
	    controllerAs: 'cashflowCtrl',
	    templateUrl: TemplateUrl
	  };
	
	  angular
	    .module('cbl.finanza.mf')
	    .component('finanzaEstrattoConto', CashflowComponent);
	})();


/***/ },
/* 54 */
/***/ function(module, exports) {

	(function (window, undefined) {
	  'use strict';
	
	  angular.module('cbl.finanza.mf').service('EstrattoContoSrvc', [
	    '$http',
	    '$state',
	    'FinUserSrvc',
	    'FIN_CONSTANTS',
	    function ($http, $state, finUserSrvc, CONSTANTS) {
	      this.filtriEstrattoContoFiscale = [];
	      this.inputFormMovimenti = {};
	
	
	
	      /**
	       * @ngdoc method
	       * @name promiseCustomerData
	       * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
	       * @description Effettua la chiamata per ricevere il customerdata
	       * @return {Promise} - Ritorna una promise contenente il customerdata
	       */
	      this.promiseCustomerData = function (rapporto) {
	        return $http({
	          method: 'GET',
	          url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
	          params: {
	            rapporto: rapporto,
	            schedaDossier:true
	          }
	        });
	      };
	      this.promiseExportReport = function(estrattoContofiscale){
	        return $http({
	          method: 'POST',
	          url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.EXPORT_ESTRATTO_CONTO,
	          data:estrattoContofiscale
	        });
	      }
	      this.promiseFilterNdg = function (rapporto) {
	        debugger;
	        return $http({
	          method: 'GET',
	          url:
	            CONSTANTS.REST_ROOT +
	            CONSTANTS.REST.DOSSIER +
	            'ndgDossier/' +
	            rapporto,
	          
	        });
	      };
	
	      this.promiseGetCashflow = function (rapporti, dataInizio, dataFine) {
	        return $http({
	          method: 'GET',
	          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DOSSIER + 'cashflow',
	          params: {
	            rapporti: rapporti,
	            dataInizio: dataInizio,
	            dataFine: dataFine
	          }
	        });
	      };
	      this.promiseTotaliConti = function(rapporto){
	        return $http({
	          method: 'GET',
	          url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.TOTALI_CONTI +'/'+rapporto
	        });
	      }
	      this.promiseGetEstrattoConto = function(ndg,codiceDossier,dataInizio,dataFine,filtriEstrattoConto){
	        return $http({
	          method:'GET',
	          url:CONSTANTS.REST_ROOT + CONSTANTS.REST.PORTAFOGLIO + '/' + codiceDossier + '/' + ndg,
	          params:{
	            dataInizio:dataInizio,
	            dataFine:dataFine,
	            salIniz:filtriEstrattoConto.salIniz,
	            salFin:filtriEstrattoConto.salFin,
	            plusMinus:filtriEstrattoConto.plusMinus,
	            venditaScaricoPrelievo:filtriEstrattoConto.venditaScaricoPrelievo,
	            acquistoCaricoConf:filtriEstrattoConto.acquistoCaricoConf
	          },
	        })
	      }
	      this.elaboraLista = function (lista) {
	        return lista
	      };
	    }
	  ]);
	})(window);


/***/ },
/* 55 */
/***/ function(module, exports) {

	(function (window, undefined) {
	  'use strict';
	
	  angular.module('cbl.finanza.mf').service('EstrattoContoTableSrvc', [
	    '$http',
	    '$q',
	    'FinMessaggiFctr',
	    'FIN_CONSTANTS',
	    function ($http, $q, messaggiFctr, CONSTANTS) {
	      var codiceCedola = 'CED';
	      var codiceRimborsi = 'RIMB';
	      var codiceDividendi = 'DIV';
	
	      var self = this;
	
	      this.getTable = function (data, filter) {
	        var result = {
	          totaleCedole: 0,
	          totaleRimborsi: 0,
	          totaleDividendi: 0,
	          listePerScadenza: {}
	        };
	
	        if (!data) {
	          return result;
	        }
	
	        data = data.filter(function (item) {
	          return (
	            (!filter.strumentiUS || item.strumentoUS === 'Y') &&
	            ((filter.cedole && item.codiceMovimento === codiceCedola) ||
	              (filter.rimborsi && item.codiceMovimento === codiceRimborsi) ||
	              (filter.dividendi && item.codiceMovimento === codiceDividendi))
	          );
	        });
	
	        data.forEach(function (item) {
	          if (!result.listePerScadenza[item.scadenza]) {
	            result.listePerScadenza[item.scadenza] = { rows: [], totale: 0 };
	          }
	          var totale = item.importoNettoEuro;
	          result.listePerScadenza[item.scadenza].rows.push(item);
	          result.listePerScadenza[item.scadenza].totale =
	            result.listePerScadenza[item.scadenza].totale + totale;
	          switch (item.codiceMovimento) {
	            case codiceCedola:
	              result.totaleCedole += totale;
	              break;
	            case codiceDividendi:
	              result.totaleDividendi += totale;
	              break;
	            case codiceRimborsi:
	              result.totaleRimborsi += totale;
	              break;
	          }
	        });
	
	        return result;
	      };
	
	      this.excel = function (data, filter) {
	        var defer = $q.defer();
	        var input = self.getTable(data, filter);
	
	        $http
	          .post(
	            CONSTANTS.REST_ROOT + CONSTANTS.REST.DOSSIER + 'cashflow',
	            input
	          )
	          .then(function (response) {
	            if (messaggiFctr.processaResponse(response)) {
	              return;
	            }
	            self.download(response.data.result);
	          })
	          .finally(function () {
	            defer.resolve(null);
	          });
	        return defer.promise;
	      };
	
	      this.download = function (allegato) {
	        var byteArrays = self.b64toByteArrays(allegato);
	        var blobType =
	          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	        var fileName = 'export_excel.xlsx';
	
	        var isChromium = window.chrome,
	          winNav = window.navigator,
	          vendorName = winNav.vendor,
	          isOpera = winNav.userAgent.indexOf('OPR') > -1,
	          isIEedge = winNav.userAgent.indexOf('Edge') > -1,
	          isIOSChrome = winNav.userAgent.match('CriOS');
	
	        if (
	          isIOSChrome ||
	          (isChromium !== null &&
	            isChromium !== undefined &&
	            vendorName === 'Google Inc.' &&
	            isOpera == false &&
	            isIEedge == false)
	        ) {
	          // è Google Chrome
	          var blob = new Blob(byteArrays, { type: blobType });
	          var blobUrl = URL.createObjectURL(blob);
	          // soluzione per costringere chrome a mostrare nome ed estensione del file
	          var a = document.createElement('a');
	          document.body.appendChild(a);
	          a.style = 'display: none';
	          a.href = blobUrl;
	          a.download = fileName;
	          a.click();
	          window.URL.revokeObjectURL(fileUrl);
	          a.parentNode.removeChild(a);
	        } else {
	          // non è Google Chrome
	          // Blob per internet explorer
	          if (navigator.msSaveOrOpenBlob) {
	            var blob = new Blob(byteArrays, { type: blobType });
	            var blobUrl = URL.createObjectURL(blob);
	            navigator.msSaveOrOpenBlob(blob, fileName);
	          } // File per altri browser
	          else {
	            var file = new File(byteArrays, fileName, { type: blobType });
	            var fileUrl = URL.createObjectURL(file);
	            window.open(fileUrl);
	          }
	        }
	      };
	
	      this.b64toByteArrays = function (b64Data, sliceSize) {
	        sliceSize = sliceSize || 512;
	        var byteCharacters = atob(b64Data);
	        var byteArrays = [];
	
	        for (
	          var offset = 0;
	          offset < byteCharacters.length;
	          offset += sliceSize
	        ) {
	          var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	          var byteNumbers = new Array(slice.length);
	          for (var i = 0; i < slice.length; i++) {
	            byteNumbers[i] = slice.charCodeAt(i);
	          }
	
	          var byteArray = new Uint8Array(byteNumbers);
	
	          byteArrays.push(byteArray);
	        }
	        return byteArrays;
	      };
	    }
	  ]);
	})(window);


/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 *
	 */
	
	(function(window, undefined) {
	    'use strict';
	    var Route = function($stateProvider, $urlRouterProvider) {
	        var onEnter = [
	            'CblMessageSrvc',
	            function(messaggiSrvc) {
	                messaggiSrvc.reset();
	            }
	        ];
	        var runner = [
	            'FinanzaRunService',
	            '$q',
	            function(runService, $q) {
	                var defer = $q.defer();
	                runService.avvio().then(
	                    function() {
	                        defer.resolve();
	                    },
	                    function() {
	                        defer.resolve();
	                    }
	                );
	
	                return defer.promise;
	            }
	        ];
	        var labelRunner = [
	            'FinanzaRunService',
	            '$q',
	            function(runService, $q) {
	                var defer = $q.defer();
	                runService.avvioLabel().then(
	                    function() {
	                        defer.resolve();
	                    },
	                    function() {
	                        defer.resolve();
	                    }
	                );
	
	                return defer.promise;
	            }
	        ];
	
	        $stateProvider
	            .state('sceltadossier', {
	                url: '/:ndg/:finServizio/scelta-dossier',
	                template: '<finanza-scelta-dossier ' +
	                    'class="wrapper" ' +
	                    'saldo-dossier-state="saldodossier" ' +
	                    'abilita-consulenza-state="abilitaconsulenza"></finanza-scelta-dossier>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Scelta Dossier',
	                    parent: 'schedaCliente'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('saldodossier', {
	                url: '/:ndg/:finServizio/saldodossier/:finCodiceRapporto/',
	                template: '<finanza-saldo-dossier ' +
	                    'class="wrapper" ' +
	                    'scelta-dossier-state="sceltadossier" ' +
	                    'nuova-raccomandazione-state="nuovaraccomandazione" ' +
	                    'modifica-raccomandazione-state="modificaraccomandazione" ' +
	                    'visualizza-raccomandazione-state="visualizzaraccomandazione" ' +
	                    'valutazione-raccomandazione-state="valutazioneraccomandazione" ' +
	                    'modifica-richiesta-state="gestionerichiesta" ' +
	                    'nuova-richiesta-state="nuovoordine" ' +
	                    'visualizza-richiesta-state="visualizzarichiesta"></finanza-saldo-dossier>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Saldo Dossier',
	                    parent: 'sceltadossier'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('schedaDossier', {
	                url: '/scheda-dossier/:ndg/:finCodiceRapporto',
	                template: '<finanza-scheda-dossier class="wrapper"></finanza-scheda-dossier>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Scheda Dossier',
	                    parent: 'schedaCliente'
	                },
	                resolve: {
	                    runner: labelRunner
	                }
	            })
	            .state('abilitaconsulenza', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/abilitaconsulenza',
	                template: '<finanza-abilita-consulenza ' +
	                    'scelta-dossier-state="sceltadossier" ' +
	                    'class="wrapper"></finanza-saldo-dossier>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Abilita Consulenza',
	                    parent: 'sceltadossier'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('nuovaraccomandazione', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/nuova-raccomandazione/:finIniziativa',
	                template: '<finanza-gestione-raccomandazione ' +
	                    'class="wrapper" ' +
	                    'modalita="nuova" ' +
	                    'nuova-proposta-state="nuovaproposta" ' +
	                    'saldo-dossier-state="saldodossier"></finanza-gestione-raccomandazione>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Nuova Raccomandazione',
	                    parent: 'saldodossier'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('modificaraccomandazione', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/modifica-raccomandazione/:finIdRaccomandazione',
	                template: '<finanza-gestione-raccomandazione ' +
	                    'class="wrapper" ' +
	                    'nuova-proposta-state="nuovaproposta" ' +
	                    'modifica-proposta-state="modificaproposta" ' +
	                    'visualizza-proposta-state= "visualizzaproposta" ' +
	                    'gestione-richiesta-state="gestionerichiesta" ' +
	                    'saldo-dossier-state="saldodossier" ' +
	                    'visualizza-raccomandazione-state="visualizzaraccomandazione" ' +
	                    'modalita="modifica"></finanza-gestione-raccomandazione>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Modifica Raccomandazione',
	                    parent: 'saldodossier'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('visualizzaraccomandazione', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/visualizza-raccomandazione/:finIdRaccomandazione/:esterno',
	                template: '<finanza-gestione-raccomandazione ' +
	                    'class="wrapper" ' +
	                    'visualizza-proposta-state="visualizzaproposta" ' +
	                    'saldo-dossier-state="saldodossier" ' +
	                    'modalita="visualizza"></finanza-gestione-raccomandazione>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Visualizza Raccomandazione',
	                    parent: 'saldodossier'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('valutazioneraccomandazione', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/valutazione-raccomandazione/:finIdRaccomandazione',
	                template: '<finanza-gestione-raccomandazione ' +
	                    'class="wrapper" ' +
	                    'nuova-proposta-state="nuovaproposta" ' +
	                    'modifica-proposta-state="modificaproposta" ' +
	                    'visualizza-proposta-state="visualizzaproposta" ' +
	                    'gestione-richiesta-state="gestionerichiesta" ' +
	                    'saldo-dossier-state="saldodossier" ' +
	                    'visualizza-raccomandazione-state="visualizzaraccomandazione" ' +
	                    'modalita="valutazione"></finanza-gestione-raccomandazione>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Valutazione Raccomandazione',
	                    parent: 'saldodossier'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('nuovaproposta', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/nuova-proposta/:finCodiceStrumento/:finIntestatarioStrumento/:acqven/:finIniziativa',
	                template: '<finanza-gestione-proposta ' +
	                    'class="wrapper" ' +
	                    'modifica-raccomandazione-state="modificaraccomandazione" ' +
	                    'modalita="modifica"></finanza-gestione-proposta>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Nuova Proposta',
	                    parent: 'nuovaraccomandazione'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('modificaproposta', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/modifica-proposta/:finIdProposta/:finCodiceStrumento/:finIntestatarioStrumento/:acqven',
	                template: '<finanza-gestione-proposta ' +
	                    'class="wrapper" ' +
	                    'modifica-raccomandazione-state="modificaraccomandazione" ' +
	                    'modalita="visualizza"></finanza-gestione-proposta>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Modifica Proposta',
	                    parent: 'modificaraccomandazione'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('visualizzaproposta', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/visualizzaproposta/:finIdProposta/:finCodiceStrumento/:finIntestatarioStrumento/:acqven',
	                template: '<finanza-gestione-proposta ' +
	                    'class="wrapper" ' +
	                    'modifica-raccomandazione-state="modificaraccomandazione" ' +
	                    'modalita="visualizza"></finanza-gestione-proposta>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Visualizza Proposta',
	                    parent: 'modificaraccomandazione'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('gestionerichiesta', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/gestione-richiesta/:finIdRichiesta/:esterno',
	                template: '<finanza-gestione-richiesta ' +
	                    'class="wrapper" ' +
	                    'gestione-ordine-state="modificaordine" ' +
	                    'visualizza-ordine-state="visualizzaordine" ' +
	                    'visualizza-richiesta-state="visualizzarichiesta" ' +
	                    'modalita="modifica" ' +
	                    'saldo-dossier-state="saldodossier"></finanza-gestione-richiesta>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Gestione richiesta',
	                    parent: 'saldodossier'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('visualizzarichiesta', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/visualizza-richiesta/:finIdRichiesta/:esterno',
	                template: '<finanza-gestione-richiesta ' +
	                    'class="wrapper" ' +
	                    'visualizza-ordine-state="visualizzaordine" ' +
	                    'modalita="visualizza" ' +
	                    'saldo-dossier-state="saldodossier"></finanza-gestione-richiesta>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Gestione richiesta',
	                    parent: 'saldodossier'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('nuovoordine', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/nuovo-ordine/:finCodiceStrumento/:finIntestatarioStrumento/:acqven',
	                template: '<finanza-gestione-ordine ' +
	                    'class="wrapper" ' +
	                    'saldo-dossier-state="saldodossier" ' +
	                    'gestione-richiesta-state="gestionerichiesta" ' +
	                    'modalita="modifica"></finanza-gestione-ordine>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Gestione ordine',
	                    parent: 'gestionerichiesta'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('modificaordine', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/:finIdRichiesta/modifica-ordine/:finIdOrdine/:finCodiceStrumento/:finIntestatarioStrumento/:acqven',
	                template: '<finanza-gestione-ordine ' +
	                    'class="wrapper" ' +
	                    'gestione-richiesta-state="gestionerichiesta" ' +
	                    'modalita="modifica"></finanza-gestione-ordine>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Gestione ordine',
	                    parent: 'gestionerichiesta'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('visualizzaordine', {
	                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/:finIdRichiesta/visualizza-ordine/:finIdOrdine/:finCodiceStrumento/:finIntestatarioStrumento/:acqven',
	                template: '<finanza-gestione-ordine ' +
	                    'class="wrapper" ' +
	                    'visualizza-richiesta-state="visualizzarichiesta" ' +
	                    'modalita="visualizza"></finanza-gestione-ordine>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Gestione ordine',
	                    parent: 'gestionerichiesta'
	                },
	                resolve: {
	                    runner: runner
	                }
	            })
	            .state('cashflow', {
	                url: '/:ndg/:finRapporto/cashflow/:finDivisa/:finCambio/:finDecimali',
	                template: '<finanza-cahflow ' + ' class="wrapper"></finanza-cahflow>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Inquiry estratto conto fiscale',
	                    parent: 'schedaDossier'
	                },
	                resolve: {
	                    runner: labelRunner
	                }
	            })
	            .state('estrattoConto', {
	                url: '/:ndg/:finCodiceRapporto/estrattoConto/:finDivisa/:finCambio/:finDecimali',
	                template: '<finanza-estratto-conto ' +
	                    ' class="wrapper"></finanza-estratto-conto>',
	                onEnter: onEnter,
	                ncyBreadcrumb: {
	                    label: 'Inquiry estratto conto fiscale',
	                    parent: 'schedaDossier'
	                },
	                resolve: {
	                    runner: labelRunner
	                }
	            });
	    };
	
	    Route.$inject = ['$stateProvider', '$urlRouterProvider'];
	
	    angular.module('cbl.finanza.mf').config(Route);
	})(window);

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** brio.bundle.min.js
 **/